import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A country code as defined by ISO 3166-1 alpha-2 */
  CountryCode: { input: string; output: string; }
  CronExpression: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: Date | string; output: Date | string; }
  /** An arbitrary-precision Decimal type */
  Decimal: { input: number; output: number; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: string; output: string; }
  /** A field whose value is a valid decimal degrees latitude number (53.471): https://en.wikipedia.org/wiki/Latitude */
  Latitude: { input: string | number; output: string | number; }
  /** A field whose value is a valid decimal degrees longitude number (53.471): https://en.wikipedia.org/wiki/Longitude */
  Longitude: { input: string | number; output: string | number; }
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: { input: any; output: any; }
  /** A field whose value conforms to the standard postal code formats for United States, United Kingdom, Germany, Canada, France, Italy, Australia, Netherlands, Spain, Denmark, Sweden, Belgium, India, Austria, Portugal, Switzerland or Luxembourg. */
  PostalCode: { input: string; output: string; }
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: { input: string; output: string; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: string; output: string; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: File; output: File; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

/** Information about this GraphQL API */
export type AboutModel = {
  __typename: 'AboutModel';
  author: Scalars['String']['output'];
  contact: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Input for the information about the business-owner account to create */
export type AccountInformationInput = {
  /** The email address of the business owner */
  email: Scalars['EmailAddress']['input'];
  /** First name of the business owner */
  firstName: Scalars['String']['input'];
  /** The last name of the business owner */
  lastName: Scalars['String']['input'];
  /** The password for the created account */
  password: Scalars['String']['input'];
};

/** Filter options to find active coupons */
export type ActiveCouponFilterInput = {
  /** The ID of a branch office */
  branchOfficeId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the company, the coupons should be fetched for */
  companyId: Scalars['String']['input'];
};

/** Model for only active coupons */
export type ActiveCouponModel = {
  __typename: 'ActiveCouponModel';
  /** All currently active coupons */
  activeCoupons?: Maybe<Array<CouponWithPeriodModel>>;
  /** All coupons that are active in future */
  futureActiveCoupons?: Maybe<Array<CouponWithPeriodModel>>;
};

export type ActiveDefectReportGroup = {
  __typename: 'ActiveDefectReportGroup';
  equipment: ActiveDefectReportGroupEquipment;
  latestReportAt: Scalars['DateTime']['output'];
  latestReportCategory: DefectCategory;
  reportCount: Scalars['Int']['output'];
};

export type ActiveDefectReportGroupBranchOffice = {
  __typename: 'ActiveDefectReportGroupBranchOffice';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ActiveDefectReportGroupEquipment = {
  __typename: 'ActiveDefectReportGroupEquipment';
  branchOffice: ActiveDefectReportGroupBranchOffice;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ActiveDefectReportGroupOrderByInput = {
  branchOfficeName?: InputMaybe<SortOrder>;
  equipmentName?: InputMaybe<SortOrder>;
  latestReportAt?: InputMaybe<SortOrder>;
  reportCount?: InputMaybe<SortOrder>;
};

/** Represents an  contract */
export type AdditionalContract = {
  __typename: 'AdditionalContract';
  /** Description of the  contract rate */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the contract */
  id: Scalars['Int']['output'];
  /** Image URL of the  contract */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Name of the  contract rate */
  name: Scalars['String']['output'];
  /** Payment frequencies of the  contract */
  paymentFrequencies: Array<PaymentFrequency>;
  /** Rate codes of the  contract rate */
  rateCodes?: Maybe<Array<RateCode>>;
  /** Term information of the  contract */
  termInformation: TermInformation;
  /** Trial period configuration of the  contract */
  trialPeriodConfig?: Maybe<TrialPeriodConfig>;
};

/** Represents an additional module contract request */
export type AdditionalContractInput = {
  /** Unique ID of the additional module */
  additionalModuleId: Scalars['Int']['input'];
  /** Describes whether a trial period should be booked. The additional module must contain a valid trial period configuration if set to true */
  bookTrialPeriod: Scalars['Boolean']['input'];
  /** Unique ID of the payment frequency of the additional module */
  paymentFrequencyId: Scalars['Int']['input'];
};

export enum AdditionalModulePaymentFrequencyType {
  Free = 'FREE',
  MonthDay = 'MONTH_DAY',
  NonRecurring = 'NON_RECURRING',
  Recurring = 'RECURRING',
  TermBased = 'TERM_BASED'
}

/** Pending changes for customer address data */
export type AddressDataAmendment = {
  __typename: 'AddressDataAmendment';
  /** Additional address information of the customer's address */
  additionalAddressInformation?: Maybe<Scalars['String']['output']>;
  /** Building name */
  buildingName?: Maybe<Scalars['String']['output']>;
  /** City of the customer */
  city: Scalars['String']['output'];
  /** City part of the customer's address */
  cityPart?: Maybe<Scalars['String']['output']>;
  /** Country of the customer */
  countryCode: Scalars['String']['output'];
  /** District of the customer's address */
  district?: Maybe<Scalars['String']['output']>;
  /** Door of the customer's address */
  door?: Maybe<Scalars['String']['output']>;
  /** Floor of the customer's address */
  floor?: Maybe<Scalars['String']['output']>;
  /** Number of the customer's house */
  houseNumber?: Maybe<Scalars['String']['output']>;
  /** Amendment proposal id */
  id?: Maybe<Scalars['Int']['output']>;
  /** Portal of the customer's address */
  portal?: Maybe<Scalars['String']['output']>;
  /** Province for southern Europe/US countries */
  province?: Maybe<Scalars['String']['output']>;
  /** Province code for southern Europe/US countries */
  provinceCode?: Maybe<Scalars['String']['output']>;
  /** Second street line of the customer's address */
  secondStreet?: Maybe<Scalars['String']['output']>;
  /** Stairway of the customer's address */
  stairway?: Maybe<Scalars['String']['output']>;
  /** Street of the customer */
  street: Scalars['String']['output'];
  /** Street block of the customer's address */
  streetBlock?: Maybe<Scalars['String']['output']>;
  /** Street type of the customer's address */
  streetType?: Maybe<Scalars['String']['output']>;
  /** Zip code of the customer */
  zipCode: Scalars['String']['output'];
};

/** Representing customer address data */
export type AddressDataAmendmentInput = {
  /** Additional address information of the customer's address */
  additionalAddressInformation?: InputMaybe<Scalars['String']['input']>;
  /** Building name */
  buildingName?: InputMaybe<Scalars['String']['input']>;
  /** City of the customer */
  city: Scalars['String']['input'];
  /** City part of the customer's address */
  cityPart?: InputMaybe<Scalars['String']['input']>;
  /** Country of the customer (ISO 3166-1) */
  countryCode: Scalars['String']['input'];
  /** District of the customer's address */
  district?: InputMaybe<Scalars['String']['input']>;
  /** Door of the customer's address */
  door?: InputMaybe<Scalars['String']['input']>;
  /** Floor of the customer's address */
  floor?: InputMaybe<Scalars['String']['input']>;
  /** Number of the customer's house */
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  /** Portal of the customer's address */
  portal?: InputMaybe<Scalars['String']['input']>;
  /** Province for southern Europe/US countries */
  province?: InputMaybe<Scalars['String']['input']>;
  /** Province code for southern Europe/US countries */
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  /** Second street line of the customer's address */
  secondStreet?: InputMaybe<Scalars['String']['input']>;
  /** Stairway of the customer's address */
  stairway?: InputMaybe<Scalars['String']['input']>;
  /** Street of the customer */
  street: Scalars['String']['input'];
  /** Street block of the customer's address */
  streetBlock?: InputMaybe<Scalars['String']['input']>;
  /** Street type of the customer's address */
  streetType?: InputMaybe<Scalars['String']['input']>;
  /** Zip code of the customer */
  zipCode: Scalars['String']['input'];
};

export type AffectedRows = {
  __typename: 'AffectedRows';
  count: Scalars['Int']['output'];
};

export type AggregateReceivedPoint = {
  __typename: 'AggregateReceivedPoint';
  _avg?: Maybe<ReceivedPointAvgAggregate>;
  _count?: Maybe<ReceivedPointCountAggregate>;
  _max?: Maybe<ReceivedPointMaxAggregate>;
  _min?: Maybe<ReceivedPointMinAggregate>;
  _sum?: Maybe<ReceivedPointSumAggregate>;
};

export enum AmendmentConfigurationStatus {
  ChangesRequireVerification = 'CHANGES_REQUIRE_VERIFICATION',
  ChangesWithoutVerification = 'CHANGES_WITHOUT_VERIFICATION',
  Read = 'READ'
}

/** Represents successful booking result */
export type AppointmentBooking = {
  __typename: 'AppointmentBooking';
  /** The status of an appointment */
  appointmentStatus: AppointmentStatus;
  /** Unique ID of the appointment booking */
  bookingId: Scalars['Int']['output'];
  /** Status of the appointment booking */
  bookingStatus: BookingStatus;
  /** Category of the appointment booking */
  category?: Maybe<Scalars['String']['output']>;
  /** Description of the appointment booking */
  description?: Maybe<Scalars['String']['output']>;
  /** Duration of the appointment booking in minutes */
  duration?: Maybe<Scalars['Int']['output']>;
  /** End date and time of the appointment booking */
  endDateTime: Scalars['String']['output'];
  /** Image URL assigned to display this appointment booking */
  imgUrl?: Maybe<Scalars['String']['output']>;
  /** Instructors list of the appointment booking */
  instructors?: Maybe<Array<Instructor>>;
  /** The status of a participant */
  participantStatus: ParticipantStatus;
  /** Start date and time of the appointment booking */
  startDateTime: Scalars['String']['output'];
  /** Title of the appointment booking */
  title?: Maybe<Scalars['String']['output']>;
};

/** Appointment booking validation result */
export type AppointmentBookingValidationResult = {
  __typename: 'AppointmentBookingValidationResult';
  /** Status of the booking validation */
  validationStatus: AppointmentBookingValidationStatus;
};

/** Status of the appointment booking validation */
export enum AppointmentBookingValidationStatus {
  Available = 'AVAILABLE',
  BookableAppointmentRestrictionsNotFulfilled = 'BOOKABLE_APPOINTMENT_RESTRICTIONS_NOT_FULFILLED',
  BookingLimitReached = 'BOOKING_LIMIT_REACHED',
  CustomerIdle = 'CUSTOMER_IDLE',
  CustomerInOtherBooking = 'CUSTOMER_IN_OTHER_BOOKING',
  DateTimeAfterLatestBookingDateTime = 'DATE_TIME_AFTER_LATEST_BOOKING_DATE_TIME',
  DateTimeBeforeEarliestBookingDateTime = 'DATE_TIME_BEFORE_EARLIEST_BOOKING_DATE_TIME',
  EndDateTimeNotAfterStartDateTime = 'END_DATE_TIME_NOT_AFTER_START_DATE_TIME',
  NotAvailable = 'NOT_AVAILABLE',
  NoContingent = 'NO_CONTINGENT',
  PastStartDateTime = 'PAST_START_DATE_TIME',
  PeriodDoesNotMatch = 'PERIOD_DOES_NOT_MATCH',
  ResourceNotAvailable = 'RESOURCE_NOT_AVAILABLE',
  StudioClosed = 'STUDIO_CLOSED'
}

/** Sliced result of bookable appointments with pagination info */
export type AppointmentResult = {
  __typename: 'AppointmentResult';
  /** True if there exists a next data slice */
  hasNext: Scalars['Boolean']['output'];
  /** Offset for next query */
  offset?: Maybe<Scalars['String']['output']>;
  /** List of bookable appointments */
  result: Array<BookableAppointment>;
};

/** Bookable appointment slot */
export type AppointmentSlot = {
  __typename: 'AppointmentSlot';
  /** End date time of the bookable appointment slot */
  endDateTime: Scalars['String']['output'];
  /** List of instructors */
  instructors?: Maybe<Array<Instructor>>;
  /** Start date time of the bookable appointment slot */
  startDateTime: Scalars['String']['output'];
};

/** Query parameters to fetch bookable appointment slots */
export type AppointmentSlotFilter = {
  /** Id of the bookable appointment */
  bookableAppointmentId: Scalars['Int']['input'];
  /** Id of the customer */
  customerId?: InputMaybe<Scalars['Int']['input']>;
  /** Days from now on to look ahead. [ 0 .. 6 ]. Defaults to 1 */
  daysAhead?: InputMaybe<Scalars['Int']['input']>;
  /** Class slots are retrieved within the time window from slotWindowStartDate to (slotWindowStartDate + daysAhead) */
  slotWindowStartDate?: InputMaybe<Scalars['String']['input']>;
};

/** Lifecycle state of the appointment */
export enum AppointmentStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Planned = 'PLANNED'
}

export type Balance = {
  __typename: 'Balance';
  company: Company;
  companyId: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BalanceAvgAggregate = {
  __typename: 'BalanceAvgAggregate';
  count?: Maybe<Scalars['Float']['output']>;
};

export type BalanceCompanyIdCustomerIdCompoundUniqueInput = {
  companyId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
};

export type BalanceCountAggregate = {
  __typename: 'BalanceCountAggregate';
  _all: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type BalanceCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<BalanceWhereUniqueInput>>;
};

export type BalanceListRelationFilter = {
  every?: InputMaybe<BalanceWhereInput>;
  none?: InputMaybe<BalanceWhereInput>;
  some?: InputMaybe<BalanceWhereInput>;
};

export type BalanceMaxAggregate = {
  __typename: 'BalanceMaxAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BalanceMinAggregate = {
  __typename: 'BalanceMinAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BalanceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BalanceOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  count?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
};

export enum BalanceScalarFieldEnum {
  CompanyId = 'companyId',
  Count = 'count',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  UpdatedAt = 'updatedAt'
}

export type BalanceScalarWhereInput = {
  AND?: InputMaybe<Array<BalanceScalarWhereInput>>;
  NOT?: InputMaybe<Array<BalanceScalarWhereInput>>;
  OR?: InputMaybe<Array<BalanceScalarWhereInput>>;
  companyId?: InputMaybe<StringFilter>;
  count?: InputMaybe<IntFilter>;
  customerId?: InputMaybe<StringFilter>;
};

export type BalanceSumAggregate = {
  __typename: 'BalanceSumAggregate';
  count?: Maybe<Scalars['Int']['output']>;
};

export type BalanceUpdateManyMutationInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

export type BalanceUpdateManyWithWhereWithoutCustomerInput = {
  data: BalanceUpdateManyMutationInput;
  where: BalanceScalarWhereInput;
};

export type BalanceUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<BalanceWhereUniqueInput>>;
  delete?: InputMaybe<Array<BalanceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BalanceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BalanceWhereUniqueInput>>;
  set?: InputMaybe<Array<BalanceWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<BalanceUpdateManyWithWhereWithoutCustomerInput>>;
};

export type BalanceWhereInput = {
  AND?: InputMaybe<Array<BalanceWhereInput>>;
  NOT?: InputMaybe<Array<BalanceWhereInput>>;
  OR?: InputMaybe<Array<BalanceWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  count?: InputMaybe<IntFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
};

export type BalanceWhereUniqueInput = {
  AND?: InputMaybe<Array<BalanceWhereInput>>;
  NOT?: InputMaybe<Array<BalanceWhereInput>>;
  OR?: InputMaybe<Array<BalanceWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  companyId_customerId?: InputMaybe<BalanceCompanyIdCustomerIdCompoundUniqueInput>;
  count?: InputMaybe<IntFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
};

export type BankAccount = {
  __typename: 'BankAccount';
  accountHolder: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  bic: Scalars['String']['output'];
  iban: Scalars['String']['output'];
};

/** Basic information of a class */
export type BasicClass = {
  __typename: 'BasicClass';
  /** Unique ID of the class */
  id: Scalars['Int']['output'];
  /** image Url */
  imgUrl?: Maybe<Scalars['String']['output']>;
  /** Title of the class */
  title?: Maybe<Scalars['String']['output']>;
};

/** Represents appointment booking request */
export type BookAppointmentInput = {
  /** Unique ID of the bookable appointment */
  bookableAppointmentId: Scalars['Int']['input'];
  /** End date time of the bookable appointment slot */
  endDateTime: Scalars['String']['input'];
  /** Instructor ID list of the bookable appointment slot */
  instructorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Start date time of the bookable appointment slot */
  startDateTime: Scalars['String']['input'];
};

/** Represents successful booking result */
export type BookAppointmentResult = {
  __typename: 'BookAppointmentResult';
  appointmentStatus: AppointmentStatus;
  bookingId: Scalars['Int']['output'];
  bookingStatus: BookingStatus;
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endDateTime: Scalars['String']['output'];
  imgUrl?: Maybe<Scalars['String']['output']>;
  instructors?: Maybe<Array<Instructor>>;
  participantStatus: ParticipantStatus;
  startDateTime: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** Information about a bookable appointment */
export type BookableAppointment = {
  __typename: 'BookableAppointment';
  /** Category of the bookable appointment */
  category?: Maybe<Scalars['String']['output']>;
  /** Description of the bookable appointment */
  description?: Maybe<Scalars['String']['output']>;
  /** Duration of the bookable appointment in minutes */
  duration?: Maybe<Scalars['Int']['output']>;
  /** Unique ID of the bookable appointment */
  id: Scalars['Int']['output'];
  /** Image URL assigned to display this bookable appointment */
  imgUrl?: Maybe<Scalars['String']['output']>;
  /** Title of the bookable appointment */
  title?: Maybe<Scalars['String']['output']>;
};

/** Data of one booking entry for a customer */
export type BookingEntry = {
  __typename: 'BookingEntry';
  amount?: Maybe<Money>;
  /** Classification of the charge */
  chargeType: ChargeType;
  /** Description of the booking */
  description?: Maybe<Scalars['String']['output']>;
  /** Date to booking is/was to be paid (ISO date) */
  dueDate: Scalars['String']['output'];
  /** The internal id of the entry */
  id: Scalars['Int']['output'];
  /** Whether or not the booking was transferred into an installment plan */
  installmentPlan: Scalars['Boolean']['output'];
  openAmount?: Maybe<Money>;
  /** Start date of the service period (if applicable) */
  paidPeriodFrom?: Maybe<Scalars['String']['output']>;
  /** End date of the service period (if applicable) */
  paidPeriodTo?: Maybe<Scalars['String']['output']>;
};

export enum BookingStatus {
  Booked = 'BOOKED',
  BookedWithConfirmationRequired = 'BOOKED_WITH_CONFIRMATION_REQUIRED',
  Canceled = 'CANCELED'
}

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BranchOffice = {
  __typename: 'BranchOffice';
  _count: BranchOfficeCount;
  averageRating: Scalars['Float']['output'];
  challenge: Array<Challenge>;
  challenges?: Maybe<Array<Challenge>>;
  city: Scalars['String']['output'];
  company: Company;
  companyId: Scalars['String']['output'];
  countRatings: Scalars['Float']['output'];
  countryCode: Scalars['CountryCode']['output'];
  coupons?: Maybe<Array<Coupon>>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * TODO (GYM-DEALS Integration): Backward compatibility. Remove this property for major release.
   * @deprecated Use 'BranchOfficeCrmConfig.crmStudioId`
   */
  crmApiId?: Maybe<Scalars['String']['output']>;
  crmConfig?: Maybe<BranchOfficeCrmConfig>;
  customerClassBookings?: Maybe<Array<CustomerClassBooking>>;
  description?: Maybe<Scalars['String']['output']>;
  equipments?: Maybe<Array<Equipment>>;
  houseNumber: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  images?: Maybe<Array<BranchOfficeImage>>;
  latitude: Scalars['Decimal']['output'];
  longitude: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  news?: Maybe<Array<News>>;
  postalCode: Scalars['PostalCode']['output'];
  ratings?: Maybe<Array<BranchOfficeRating>>;
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  utilizations?: Maybe<Array<BranchOfficeUtilization>>;
};


export type BranchOfficeAverageRatingArgs = {
  onlyQuestionRelated?: Scalars['Boolean']['input'];
};


export type BranchOfficeCountRatingsArgs = {
  onlyQuestionRelated?: Scalars['Boolean']['input'];
};


export type BranchOfficeImagesArgs = {
  cursor?: InputMaybe<BranchOfficeImageWhereUniqueInput>;
  distinct?: InputMaybe<Array<BranchOfficeImageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BranchOfficeImageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BranchOfficeImageWhereInput>;
};

export type BranchOfficeApiKeyBatch = {
  __typename: 'BranchOfficeApiKeyBatch';
  failures: Array<BranchOfficeApiKeyFailure>;
  successes: Array<BranchOfficeApiKeySuccess>;
};

export type BranchOfficeApiKeyCreateManyInput = {
  apiKey: Scalars['String']['input'];
  studioId: Scalars['String']['input'];
};

export type BranchOfficeApiKeyFailure = {
  __typename: 'BranchOfficeApiKeyFailure';
  detail?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  studioId: Scalars['String']['output'];
};

export type BranchOfficeApiKeySuccess = {
  __typename: 'BranchOfficeApiKeySuccess';
  note?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studioId: Scalars['String']['output'];
};

export type BranchOfficeAvgAggregate = {
  __typename: 'BranchOfficeAvgAggregate';
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
};

export type BranchOfficeCompany_Crm_Api_UniqueCompoundUniqueInput = {
  companyId: Scalars['String']['input'];
  crmApiId: Scalars['String']['input'];
};

export type BranchOfficeCount = {
  __typename: 'BranchOfficeCount';
  challenges: Scalars['Int']['output'];
  coupons: Scalars['Int']['output'];
  customerClassBookings: Scalars['Int']['output'];
  equipments: Scalars['Int']['output'];
  images: Scalars['Int']['output'];
  news: Scalars['Int']['output'];
  ratings: Scalars['Int']['output'];
  utilizations: Scalars['Int']['output'];
};

export type BranchOfficeCountAggregate = {
  __typename: 'BranchOfficeCountAggregate';
  _all: Scalars['Int']['output'];
  city: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  countryCode: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  /** @deprecated Use 'BranchOfficeCrmConfig.crmStudioId` */
  crmApiId: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  houseNumber: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  latitude: Scalars['Int']['output'];
  longitude: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  postalCode: Scalars['Int']['output'];
  state: Scalars['Int']['output'];
  street: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating a branch office */
export type BranchOfficeCreateInput = {
  challenges?: InputMaybe<ChallengeCreateNestedManyWithoutBranchOfficeInput>;
  city: Scalars['String']['input'];
  /** Optionally connect the branch office to a specific company */
  company?: InputMaybe<CompanyCreateNestedOneWithoutBranchOfficesInput>;
  countryCode: Scalars['CountryCode']['input'];
  crmApiId?: InputMaybe<Scalars['String']['input']>;
  /** The CRM studio ID */
  crmStudioId?: InputMaybe<Scalars['String']['input']>;
  customerClassBookings?: InputMaybe<CustomerClassBookingCreateNestedManyWithoutBranchOfficeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  equipments?: InputMaybe<EquipmentCreateNestedManyWithoutBranchOfficeInput>;
  houseNumber: Scalars['String']['input'];
  images?: InputMaybe<BranchOfficeImageCreateNestedManyWithoutBranchOfficeInput>;
  latitude: Scalars['Decimal']['input'];
  longitude: Scalars['Decimal']['input'];
  name: Scalars['String']['input'];
  news?: InputMaybe<NewsCreateNestedManyWithoutBranchOfficesInput>;
  postalCode: Scalars['PostalCode']['input'];
  ratings?: InputMaybe<BranchOfficeRatingCreateNestedManyWithoutBranchOfficeInput>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  utilizations?: InputMaybe<BranchOfficeUtilizationCreateNestedManyWithoutBranchOfficeInput>;
};

export type BranchOfficeCreateNestedManyWithoutNewsInput = {
  connect?: InputMaybe<Array<BranchOfficeWhereUniqueInput>>;
};

export type BranchOfficeCreateNestedOneWithoutChallengesInput = {
  connect?: InputMaybe<BranchOfficeWhereUniqueInput>;
};

export type BranchOfficeCreateNestedOneWithoutEquipmentsInput = {
  connect?: InputMaybe<BranchOfficeWhereUniqueInput>;
};

export type BranchOfficeCreateNestedOneWithoutImagesInput = {
  connect: BranchOfficeWhereUniqueInput;
};

export type BranchOfficeCrmConfig = {
  __typename: 'BranchOfficeCrmConfig';
  _count: BranchOfficeCrmConfigCount;
  branchOffice: BranchOffice;
  branchOfficeId: Scalars['UUID']['output'];
  companyCrmConfig: CompanyCrmConfig;
  companyId: Scalars['String']['output'];
  crmStudioId: Scalars['String']['output'];
  /** The CRM tenant name */
  crmTenant: Scalars['String']['output'];
  customerCrmConfigs?: Maybe<Array<CustomerCrmConfig>>;
};

export type BranchOfficeCrmConfigCompanyIdCrmStudioIdCompoundUniqueInput = {
  companyId: Scalars['String']['input'];
  crmStudioId: Scalars['String']['input'];
};

export type BranchOfficeCrmConfigCount = {
  __typename: 'BranchOfficeCrmConfigCount';
  customerCrmConfigs: Scalars['Int']['output'];
};

export type BranchOfficeCrmConfigCountAggregate = {
  __typename: 'BranchOfficeCrmConfigCountAggregate';
  _all: Scalars['Int']['output'];
  branchOfficeId: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  crmStudioId: Scalars['Int']['output'];
  crmTenant: Scalars['Int']['output'];
};

export type BranchOfficeCrmConfigCreateNestedManyWithoutCompanyCrmConfigInput = {
  connect?: InputMaybe<Array<BranchOfficeCrmConfigWhereUniqueInput>>;
};

export type BranchOfficeCrmConfigCrmTenantCrmStudioIdCompoundUniqueInput = {
  crmStudioId: Scalars['String']['input'];
  crmTenant: Scalars['String']['input'];
};

export type BranchOfficeCrmConfigListRelationFilter = {
  every?: InputMaybe<BranchOfficeCrmConfigWhereInput>;
  none?: InputMaybe<BranchOfficeCrmConfigWhereInput>;
  some?: InputMaybe<BranchOfficeCrmConfigWhereInput>;
};

export type BranchOfficeCrmConfigMaxAggregate = {
  __typename: 'BranchOfficeCrmConfigMaxAggregate';
  branchOfficeId?: Maybe<Scalars['UUID']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  crmStudioId?: Maybe<Scalars['String']['output']>;
  crmTenant?: Maybe<Scalars['String']['output']>;
};

export type BranchOfficeCrmConfigMinAggregate = {
  __typename: 'BranchOfficeCrmConfigMinAggregate';
  branchOfficeId?: Maybe<Scalars['UUID']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  crmStudioId?: Maybe<Scalars['String']['output']>;
  crmTenant?: Maybe<Scalars['String']['output']>;
};

export type BranchOfficeCrmConfigNullableRelationFilter = {
  is?: InputMaybe<BranchOfficeCrmConfigWhereInput>;
  isNot?: InputMaybe<BranchOfficeCrmConfigWhereInput>;
};

export type BranchOfficeCrmConfigOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BranchOfficeCrmConfigOrderByWithRelationInput = {
  branchOffice?: InputMaybe<BranchOfficeOrderByWithRelationInput>;
  branchOfficeId?: InputMaybe<SortOrder>;
  companyCrmConfig?: InputMaybe<CompanyCrmConfigOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  crmStudioId?: InputMaybe<SortOrder>;
  crmTenant?: InputMaybe<SortOrder>;
  customerCrmConfigs?: InputMaybe<CustomerCrmConfigOrderByRelationAggregateInput>;
  encryptedStudioCredentials?: InputMaybe<SortOrderInput>;
};

export type BranchOfficeCrmConfigRelationFilter = {
  is?: InputMaybe<BranchOfficeCrmConfigWhereInput>;
  isNot?: InputMaybe<BranchOfficeCrmConfigWhereInput>;
};

export enum BranchOfficeCrmConfigScalarFieldEnum {
  BranchOfficeId = 'branchOfficeId',
  CompanyId = 'companyId',
  CrmStudioId = 'crmStudioId',
  CrmTenant = 'crmTenant',
  EncryptedStudioCredentials = 'encryptedStudioCredentials'
}

export type BranchOfficeCrmConfigUpdateOneRequiredWithoutCustomerCrmConfigsNestedInput = {
  connect?: InputMaybe<BranchOfficeCrmConfigWhereUniqueInput>;
};

export type BranchOfficeCrmConfigUpdateOneWithoutBranchOfficeNestedInput = {
  connect?: InputMaybe<BranchOfficeCrmConfigWhereUniqueInput>;
  delete?: InputMaybe<BranchOfficeCrmConfigWhereInput>;
  disconnect?: InputMaybe<BranchOfficeCrmConfigWhereInput>;
};

export type BranchOfficeCrmConfigWhereInput = {
  AND?: InputMaybe<Array<BranchOfficeCrmConfigWhereInput>>;
  NOT?: InputMaybe<Array<BranchOfficeCrmConfigWhereInput>>;
  OR?: InputMaybe<Array<BranchOfficeCrmConfigWhereInput>>;
  branchOffice?: InputMaybe<BranchOfficeRelationFilter>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  companyCrmConfig?: InputMaybe<CompanyCrmConfigRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  crmStudioId?: InputMaybe<StringFilter>;
  crmTenant?: InputMaybe<StringFilter>;
  customerCrmConfigs?: InputMaybe<CustomerCrmConfigListRelationFilter>;
  encryptedStudioCredentials?: InputMaybe<BytesNullableFilter>;
};

export type BranchOfficeCrmConfigWhereUniqueInput = {
  AND?: InputMaybe<Array<BranchOfficeCrmConfigWhereInput>>;
  NOT?: InputMaybe<Array<BranchOfficeCrmConfigWhereInput>>;
  OR?: InputMaybe<Array<BranchOfficeCrmConfigWhereInput>>;
  branchOffice?: InputMaybe<BranchOfficeRelationFilter>;
  branchOfficeId?: InputMaybe<Scalars['UUID']['input']>;
  companyCrmConfig?: InputMaybe<CompanyCrmConfigRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  companyIdCrmStudioId?: InputMaybe<BranchOfficeCrmConfigCompanyIdCrmStudioIdCompoundUniqueInput>;
  crmStudioId?: InputMaybe<StringFilter>;
  crmTenant?: InputMaybe<StringFilter>;
  crmTenantCrmStudioId?: InputMaybe<BranchOfficeCrmConfigCrmTenantCrmStudioIdCompoundUniqueInput>;
  customerCrmConfigs?: InputMaybe<CustomerCrmConfigListRelationFilter>;
  encryptedStudioCredentials?: InputMaybe<BytesNullableFilter>;
};

export type BranchOfficeEdge = {
  __typename: 'BranchOfficeEdge';
  cursor: PaginatedBranchOfficeCursor;
  node: BranchOffice;
};

export type BranchOfficeImage = {
  __typename: 'BranchOfficeImage';
  branchOffice: BranchOffice;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** The url of the uploaded image */
  imageUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BranchOfficeImageCountAggregate = {
  __typename: 'BranchOfficeImageCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Custom input for creating a branch office image */
export type BranchOfficeImageCreateInput = {
  branchOffice: BranchOfficeCreateNestedOneWithoutImagesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  image: ImageInput;
  s3Key?: InputMaybe<Scalars['String']['input']>;
};

export type BranchOfficeImageCreateNestedManyWithoutBranchOfficeInput = {
  connect?: InputMaybe<Array<BranchOfficeImageWhereUniqueInput>>;
};

export type BranchOfficeImageListRelationFilter = {
  every?: InputMaybe<BranchOfficeImageWhereInput>;
  none?: InputMaybe<BranchOfficeImageWhereInput>;
  some?: InputMaybe<BranchOfficeImageWhereInput>;
};

export type BranchOfficeImageMaxAggregate = {
  __typename: 'BranchOfficeImageMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BranchOfficeImageMinAggregate = {
  __typename: 'BranchOfficeImageMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BranchOfficeImageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BranchOfficeImageOrderByWithRelationInput = {
  branchOffice?: InputMaybe<BranchOfficeOrderByWithRelationInput>;
  branchOfficeId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  s3Key?: InputMaybe<SortOrderInput>;
};

export enum BranchOfficeImageScalarFieldEnum {
  BranchOfficeId = 'branchOfficeId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Id = 'id',
  ImageUrl = 'imageUrl',
  S3Key = 's3Key',
  UpdatedAt = 'updatedAt'
}

export type BranchOfficeImageScalarWhereInput = {
  AND?: InputMaybe<Array<BranchOfficeImageScalarWhereInput>>;
  NOT?: InputMaybe<Array<BranchOfficeImageScalarWhereInput>>;
  OR?: InputMaybe<Array<BranchOfficeImageScalarWhereInput>>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  imageUrl?: InputMaybe<StringFilter>;
  s3Key?: InputMaybe<StringNullableFilter>;
};

export type BranchOfficeImageUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
};

export type BranchOfficeImageUpdateManyWithWhereWithoutBranchOfficeInput = {
  data: BranchOfficeImageUpdateManyMutationInput;
  where: BranchOfficeImageScalarWhereInput;
};

export type BranchOfficeImageUpdateManyWithoutBranchOfficeNestedInput = {
  connect?: InputMaybe<Array<BranchOfficeImageWhereUniqueInput>>;
  delete?: InputMaybe<Array<BranchOfficeImageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BranchOfficeImageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BranchOfficeImageWhereUniqueInput>>;
  set?: InputMaybe<Array<BranchOfficeImageWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<BranchOfficeImageUpdateManyWithWhereWithoutBranchOfficeInput>>;
};

export type BranchOfficeImageWhereInput = {
  AND?: InputMaybe<Array<BranchOfficeImageWhereInput>>;
  NOT?: InputMaybe<Array<BranchOfficeImageWhereInput>>;
  OR?: InputMaybe<Array<BranchOfficeImageWhereInput>>;
  branchOffice?: InputMaybe<BranchOfficeRelationFilter>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  imageUrl?: InputMaybe<StringFilter>;
  s3Key?: InputMaybe<StringNullableFilter>;
};

export type BranchOfficeImageWhereUniqueInput = {
  AND?: InputMaybe<Array<BranchOfficeImageWhereInput>>;
  NOT?: InputMaybe<Array<BranchOfficeImageWhereInput>>;
  OR?: InputMaybe<Array<BranchOfficeImageWhereInput>>;
  branchOffice?: InputMaybe<BranchOfficeRelationFilter>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<StringFilter>;
  s3Key?: InputMaybe<StringNullableFilter>;
};

export type BranchOfficeListRelationFilter = {
  every?: InputMaybe<BranchOfficeWhereInput>;
  none?: InputMaybe<BranchOfficeWhereInput>;
  some?: InputMaybe<BranchOfficeWhereInput>;
};

export type BranchOfficeLocationCompoundUniqueInput = {
  city: Scalars['String']['input'];
  countryCode: Scalars['CountryCode']['input'];
  houseNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  postalCode: Scalars['PostalCode']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type BranchOfficeMaxAggregate = {
  __typename: 'BranchOfficeMaxAggregate';
  city?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['CountryCode']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use 'BranchOfficeCrmConfig.crmStudioId` */
  crmApiId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['PostalCode']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BranchOfficeMinAggregate = {
  __typename: 'BranchOfficeMinAggregate';
  city?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['CountryCode']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use 'BranchOfficeCrmConfig.crmStudioId` */
  crmApiId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['PostalCode']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BranchOfficeNullableRelationFilter = {
  is?: InputMaybe<BranchOfficeWhereInput>;
  isNot?: InputMaybe<BranchOfficeWhereInput>;
};

export type BranchOfficeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BranchOfficeOrderByWithRelationInput = {
  challenges?: InputMaybe<ChallengeOrderByRelationAggregateInput>;
  city?: InputMaybe<SortOrder>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  coupons?: InputMaybe<CouponOrderByRelationAggregateInput>;
  crmApiId?: InputMaybe<SortOrderInput>;
  crmConfig?: InputMaybe<BranchOfficeCrmConfigOrderByWithRelationInput>;
  customerClassBookings?: InputMaybe<CustomerClassBookingOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrderInput>;
  equipments?: InputMaybe<EquipmentOrderByRelationAggregateInput>;
  houseNumber?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  images?: InputMaybe<BranchOfficeImageOrderByRelationAggregateInput>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  news?: InputMaybe<NewsOrderByRelationAggregateInput>;
  postalCode?: InputMaybe<SortOrder>;
  ratings?: InputMaybe<BranchOfficeRatingOrderByRelationAggregateInput>;
  state?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
  utilizations?: InputMaybe<BranchOfficeUtilizationOrderByRelationAggregateInput>;
};

export type BranchOfficeRanking = {
  __typename: 'BranchOfficeRanking';
  /** The name of the branch office */
  name: Scalars['String']['output'];
  /** The customers rank within the branch office */
  rank: Scalars['Float']['output'];
};

export type BranchOfficeRating = {
  __typename: 'BranchOfficeRating';
  branchOffice: BranchOffice;
  /** The identifier of the branch office being rated */
  branchOfficeId: Scalars['UUID']['output'];
  /** Optional text comment provided by the customer */
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  /** The identifier of the customer who submitted the rating */
  customerId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** The star rating given by the customer (1 - 10) */
  rating: Scalars['Int']['output'];
  ratingQuestion?: Maybe<RatingQuestion>;
  /** The identifier of the specific rating question (nullable for general ratings) */
  ratingQuestionId?: Maybe<Scalars['UUID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BranchOfficeRatingAvgAggregate = {
  __typename: 'BranchOfficeRatingAvgAggregate';
  rating?: Maybe<Scalars['Float']['output']>;
};

export type BranchOfficeRatingCountAggregate = {
  __typename: 'BranchOfficeRatingCountAggregate';
  _all: Scalars['Int']['output'];
  branchOfficeId: Scalars['Int']['output'];
  comment: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  rating: Scalars['Int']['output'];
  ratingQuestionId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating one branch office rating */
export type BranchOfficeRatingCreateManyInput = {
  branchOfficeId: Scalars['UUID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
  ratingQuestionId?: InputMaybe<Scalars['UUID']['input']>;
};

export type BranchOfficeRatingCreateNestedManyWithoutBranchOfficeInput = {
  connect?: InputMaybe<Array<BranchOfficeRatingWhereUniqueInput>>;
};

export type BranchOfficeRatingCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<BranchOfficeRatingWhereUniqueInput>>;
};

export type BranchOfficeRatingCreateNestedManyWithoutRatingQuestionInput = {
  connect?: InputMaybe<Array<BranchOfficeRatingWhereUniqueInput>>;
};

export type BranchOfficeRatingEdge = {
  __typename: 'BranchOfficeRatingEdge';
  cursor: PaginatedBranchOfficeRatingCursor;
  node: BranchOfficeRating;
};

export type BranchOfficeRatingListRelationFilter = {
  every?: InputMaybe<BranchOfficeRatingWhereInput>;
  none?: InputMaybe<BranchOfficeRatingWhereInput>;
  some?: InputMaybe<BranchOfficeRatingWhereInput>;
};

export type BranchOfficeRatingMaxAggregate = {
  __typename: 'BranchOfficeRatingMaxAggregate';
  branchOfficeId?: Maybe<Scalars['UUID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingQuestionId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BranchOfficeRatingMinAggregate = {
  __typename: 'BranchOfficeRatingMinAggregate';
  branchOfficeId?: Maybe<Scalars['UUID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingQuestionId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BranchOfficeRatingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BranchOfficeRatingOrderByWithRelationInput = {
  branchOffice?: InputMaybe<BranchOfficeOrderByWithRelationInput>;
  branchOfficeId?: InputMaybe<SortOrder>;
  comment?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
  ratingQuestion?: InputMaybe<RatingQuestionOrderByWithRelationInput>;
  ratingQuestionId?: InputMaybe<SortOrderInput>;
};

export enum BranchOfficeRatingScalarFieldEnum {
  BranchOfficeId = 'branchOfficeId',
  Comment = 'comment',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  Rating = 'rating',
  RatingQuestionId = 'ratingQuestionId',
  UpdatedAt = 'updatedAt'
}

export type BranchOfficeRatingScalarWhereInput = {
  AND?: InputMaybe<Array<BranchOfficeRatingScalarWhereInput>>;
  NOT?: InputMaybe<Array<BranchOfficeRatingScalarWhereInput>>;
  OR?: InputMaybe<Array<BranchOfficeRatingScalarWhereInput>>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  rating?: InputMaybe<IntFilter>;
  ratingQuestionId?: InputMaybe<UuidNullableFilter>;
};

export type BranchOfficeRatingSumAggregate = {
  __typename: 'BranchOfficeRatingSumAggregate';
  rating?: Maybe<Scalars['Int']['output']>;
};

export type BranchOfficeRatingUpdateManyMutationInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
};

export type BranchOfficeRatingUpdateManyWithWhereWithoutBranchOfficeInput = {
  data: BranchOfficeRatingUpdateManyMutationInput;
  where: BranchOfficeRatingScalarWhereInput;
};

export type BranchOfficeRatingUpdateManyWithWhereWithoutCustomerInput = {
  data: BranchOfficeRatingUpdateManyMutationInput;
  where: BranchOfficeRatingScalarWhereInput;
};

export type BranchOfficeRatingUpdateManyWithoutBranchOfficeNestedInput = {
  connect?: InputMaybe<Array<BranchOfficeRatingWhereUniqueInput>>;
  delete?: InputMaybe<Array<BranchOfficeRatingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BranchOfficeRatingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BranchOfficeRatingWhereUniqueInput>>;
  set?: InputMaybe<Array<BranchOfficeRatingWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<BranchOfficeRatingUpdateManyWithWhereWithoutBranchOfficeInput>>;
};

export type BranchOfficeRatingUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<BranchOfficeRatingWhereUniqueInput>>;
  delete?: InputMaybe<Array<BranchOfficeRatingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BranchOfficeRatingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BranchOfficeRatingWhereUniqueInput>>;
  set?: InputMaybe<Array<BranchOfficeRatingWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<BranchOfficeRatingUpdateManyWithWhereWithoutCustomerInput>>;
};

export type BranchOfficeRatingWhereInput = {
  AND?: InputMaybe<Array<BranchOfficeRatingWhereInput>>;
  NOT?: InputMaybe<Array<BranchOfficeRatingWhereInput>>;
  OR?: InputMaybe<Array<BranchOfficeRatingWhereInput>>;
  branchOffice?: InputMaybe<BranchOfficeRelationFilter>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  rating?: InputMaybe<IntFilter>;
  ratingQuestion?: InputMaybe<RatingQuestionNullableRelationFilter>;
  ratingQuestionId?: InputMaybe<UuidNullableFilter>;
};

export type BranchOfficeRatingWhereUniqueInput = {
  AND?: InputMaybe<Array<BranchOfficeRatingWhereInput>>;
  NOT?: InputMaybe<Array<BranchOfficeRatingWhereInput>>;
  OR?: InputMaybe<Array<BranchOfficeRatingWhereInput>>;
  branchOffice?: InputMaybe<BranchOfficeRelationFilter>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  rating?: InputMaybe<IntFilter>;
  ratingQuestion?: InputMaybe<RatingQuestionNullableRelationFilter>;
  ratingQuestionId?: InputMaybe<UuidNullableFilter>;
};

export type BranchOfficeRelationFilter = {
  is?: InputMaybe<BranchOfficeWhereInput>;
  isNot?: InputMaybe<BranchOfficeWhereInput>;
};

export enum BranchOfficeScalarFieldEnum {
  City = 'city',
  CompanyId = 'companyId',
  CountryCode = 'countryCode',
  CreatedAt = 'createdAt',
  CrmApiId = 'crmApiId',
  Description = 'description',
  HouseNumber = 'houseNumber',
  Id = 'id',
  Latitude = 'latitude',
  Longitude = 'longitude',
  Name = 'name',
  PostalCode = 'postalCode',
  State = 'state',
  Street = 'street',
  UpdatedAt = 'updatedAt'
}

export type BranchOfficeScalarWhereInput = {
  AND?: InputMaybe<Array<BranchOfficeScalarWhereInput>>;
  NOT?: InputMaybe<Array<BranchOfficeScalarWhereInput>>;
  OR?: InputMaybe<Array<BranchOfficeScalarWhereInput>>;
  city?: InputMaybe<StringFilter>;
  companyId?: InputMaybe<StringFilter>;
  countryCode?: InputMaybe<StringFilter>;
  crmApiId?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  latitude?: InputMaybe<DecimalFilter>;
  longitude?: InputMaybe<DecimalFilter>;
  name?: InputMaybe<StringFilter>;
  postalCode?: InputMaybe<StringFilter>;
  state?: InputMaybe<StringFilter>;
  street?: InputMaybe<StringFilter>;
};

export type BranchOfficeSumAggregate = {
  __typename: 'BranchOfficeSumAggregate';
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
};

export type BranchOfficeTopRating = {
  __typename: 'BranchOfficeTopRating';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  overallTotalRating: Scalars['Float']['output'];
};

/** Custom input type for unique identifier of branch offices */
export type BranchOfficeUniqueInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type BranchOfficeUpdateInput = {
  challenges?: InputMaybe<ChallengeUpdateManyWithoutBranchOfficeNestedInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<CompanyUpdateOneRequiredWithoutBranchOfficesNestedInput>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  coupons?: InputMaybe<CouponUpdateManyWithoutBranchOfficesNestedInput>;
  crmApiId?: InputMaybe<Scalars['String']['input']>;
  crmConfig?: InputMaybe<BranchOfficeCrmConfigUpdateOneWithoutBranchOfficeNestedInput>;
  customerClassBookings?: InputMaybe<CustomerClassBookingUpdateManyWithoutBranchOfficeNestedInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  equipments?: InputMaybe<EquipmentUpdateManyWithoutBranchOfficeNestedInput>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  images?: InputMaybe<BranchOfficeImageUpdateManyWithoutBranchOfficeNestedInput>;
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  news?: InputMaybe<NewsUpdateManyWithoutBranchOfficesNestedInput>;
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  ratings?: InputMaybe<BranchOfficeRatingUpdateManyWithoutBranchOfficeNestedInput>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  utilizations?: InputMaybe<BranchOfficeUtilizationUpdateManyWithoutBranchOfficeNestedInput>;
};

export type BranchOfficeUpdateManyMutationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  crmApiId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type BranchOfficeUpdateManyWithWhereWithoutCouponsInput = {
  data: BranchOfficeUpdateManyMutationInput;
  where: BranchOfficeScalarWhereInput;
};

export type BranchOfficeUpdateManyWithoutCouponsNestedInput = {
  connect?: InputMaybe<Array<BranchOfficeWhereUniqueInput>>;
  delete?: InputMaybe<Array<BranchOfficeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BranchOfficeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BranchOfficeWhereUniqueInput>>;
  set?: InputMaybe<Array<BranchOfficeWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<BranchOfficeUpdateManyWithWhereWithoutCouponsInput>>;
};

export type BranchOfficeUpdateOneRequiredWithoutEquipmentsNestedInput = {
  connect?: InputMaybe<BranchOfficeWhereUniqueInput>;
};

export type BranchOfficeUtilization = {
  __typename: 'BranchOfficeUtilization';
  _count: BranchOfficeUtilizationCount;
  /** Relation to the studio (CASCADE = all data deleted with studio) */
  branchOffice: BranchOffice;
  /** Reference to the studio / branch_office */
  branchOfficeId: Scalars['String']['output'];
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Date of the snapshot (date only, no time) */
  date: Scalars['DateTime']['output'];
  /** Unique identifier of the daily snapshot */
  id: Scalars['UUID']['output'];
  /** All time slots for this day */
  slots?: Maybe<Array<BranchOfficeUtilizationSlot>>;
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
};

export type BranchOfficeUtilizationBranchOfficeIdDateCompoundUniqueInput = {
  branchOfficeId: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
};

export type BranchOfficeUtilizationCount = {
  __typename: 'BranchOfficeUtilizationCount';
  slots: Scalars['Int']['output'];
};

export type BranchOfficeUtilizationCountAggregate = {
  __typename: 'BranchOfficeUtilizationCountAggregate';
  _all: Scalars['Int']['output'];
  branchOfficeId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  date: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type BranchOfficeUtilizationCreateNestedManyWithoutBranchOfficeInput = {
  connect?: InputMaybe<Array<BranchOfficeUtilizationWhereUniqueInput>>;
};

export type BranchOfficeUtilizationListRelationFilter = {
  every?: InputMaybe<BranchOfficeUtilizationWhereInput>;
  none?: InputMaybe<BranchOfficeUtilizationWhereInput>;
  some?: InputMaybe<BranchOfficeUtilizationWhereInput>;
};

export type BranchOfficeUtilizationMaxAggregate = {
  __typename: 'BranchOfficeUtilizationMaxAggregate';
  branchOfficeId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BranchOfficeUtilizationMinAggregate = {
  __typename: 'BranchOfficeUtilizationMinAggregate';
  branchOfficeId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BranchOfficeUtilizationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BranchOfficeUtilizationRelationFilter = {
  is?: InputMaybe<BranchOfficeUtilizationWhereInput>;
  isNot?: InputMaybe<BranchOfficeUtilizationWhereInput>;
};

export type BranchOfficeUtilizationScalarWhereInput = {
  AND?: InputMaybe<Array<BranchOfficeUtilizationScalarWhereInput>>;
  NOT?: InputMaybe<Array<BranchOfficeUtilizationScalarWhereInput>>;
  OR?: InputMaybe<Array<BranchOfficeUtilizationScalarWhereInput>>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
};

export type BranchOfficeUtilizationSlot = {
  __typename: 'BranchOfficeUtilizationSlot';
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** End time of the slot (e.g. "07:00") */
  endTime: Scalars['String']['output'];
  /** Normalized hour (0–23), used for forecasting and aggregation */
  hour: Scalars['Int']['output'];
  /** Unique identifier of the slot */
  id: Scalars['UUID']['output'];
  /** Qualitative level of utilization (LOW / MEDIUM / HIGH) */
  level: Scalars['String']['output'];
  /** Utilization percentage for this time slot (0–100) */
  percentage: Scalars['Int']['output'];
  /** Start time of the slot (e.g. "06:00") */
  startTime: Scalars['String']['output'];
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** Relation to the daily snapshot (CASCADE = slots are deleted with the day) */
  utilization: BranchOfficeUtilization;
  /** Reference to the daily utilization snapshot (studio + date) */
  utilizationId: Scalars['String']['output'];
};

export type BranchOfficeUtilizationSlotAvgAggregate = {
  __typename: 'BranchOfficeUtilizationSlotAvgAggregate';
  hour?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type BranchOfficeUtilizationSlotCountAggregate = {
  __typename: 'BranchOfficeUtilizationSlotCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  endTime: Scalars['Int']['output'];
  hour: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  level: Scalars['Int']['output'];
  percentage: Scalars['Int']['output'];
  startTime: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  utilizationId: Scalars['Int']['output'];
};

export type BranchOfficeUtilizationSlotListRelationFilter = {
  every?: InputMaybe<BranchOfficeUtilizationSlotWhereInput>;
  none?: InputMaybe<BranchOfficeUtilizationSlotWhereInput>;
  some?: InputMaybe<BranchOfficeUtilizationSlotWhereInput>;
};

export type BranchOfficeUtilizationSlotMaxAggregate = {
  __typename: 'BranchOfficeUtilizationSlotMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  hour?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  utilizationId?: Maybe<Scalars['String']['output']>;
};

export type BranchOfficeUtilizationSlotMinAggregate = {
  __typename: 'BranchOfficeUtilizationSlotMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  hour?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  utilizationId?: Maybe<Scalars['String']['output']>;
};

export type BranchOfficeUtilizationSlotSumAggregate = {
  __typename: 'BranchOfficeUtilizationSlotSumAggregate';
  hour?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
};

export type BranchOfficeUtilizationSlotWhereInput = {
  AND?: InputMaybe<Array<BranchOfficeUtilizationSlotWhereInput>>;
  NOT?: InputMaybe<Array<BranchOfficeUtilizationSlotWhereInput>>;
  OR?: InputMaybe<Array<BranchOfficeUtilizationSlotWhereInput>>;
  endTime?: InputMaybe<StringFilter>;
  hour?: InputMaybe<IntFilter>;
  id?: InputMaybe<UuidFilter>;
  level?: InputMaybe<StringFilter>;
  percentage?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<StringFilter>;
  utilization?: InputMaybe<BranchOfficeUtilizationRelationFilter>;
  utilizationId?: InputMaybe<UuidFilter>;
};

export type BranchOfficeUtilizationUpdateManyMutationInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type BranchOfficeUtilizationUpdateManyWithWhereWithoutBranchOfficeInput = {
  data: BranchOfficeUtilizationUpdateManyMutationInput;
  where: BranchOfficeUtilizationScalarWhereInput;
};

export type BranchOfficeUtilizationUpdateManyWithoutBranchOfficeNestedInput = {
  connect?: InputMaybe<Array<BranchOfficeUtilizationWhereUniqueInput>>;
  delete?: InputMaybe<Array<BranchOfficeUtilizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BranchOfficeUtilizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BranchOfficeUtilizationWhereUniqueInput>>;
  set?: InputMaybe<Array<BranchOfficeUtilizationWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<BranchOfficeUtilizationUpdateManyWithWhereWithoutBranchOfficeInput>>;
};

export type BranchOfficeUtilizationWhereInput = {
  AND?: InputMaybe<Array<BranchOfficeUtilizationWhereInput>>;
  NOT?: InputMaybe<Array<BranchOfficeUtilizationWhereInput>>;
  OR?: InputMaybe<Array<BranchOfficeUtilizationWhereInput>>;
  branchOffice?: InputMaybe<BranchOfficeRelationFilter>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  slots?: InputMaybe<BranchOfficeUtilizationSlotListRelationFilter>;
};

export type BranchOfficeUtilizationWhereUniqueInput = {
  AND?: InputMaybe<Array<BranchOfficeUtilizationWhereInput>>;
  NOT?: InputMaybe<Array<BranchOfficeUtilizationWhereInput>>;
  OR?: InputMaybe<Array<BranchOfficeUtilizationWhereInput>>;
  branchOffice?: InputMaybe<BranchOfficeRelationFilter>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  branchOfficeId_date?: InputMaybe<BranchOfficeUtilizationBranchOfficeIdDateCompoundUniqueInput>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  slots?: InputMaybe<BranchOfficeUtilizationSlotListRelationFilter>;
};

export type BranchOfficeWhereInput = {
  AND?: InputMaybe<Array<BranchOfficeWhereInput>>;
  NOT?: InputMaybe<Array<BranchOfficeWhereInput>>;
  OR?: InputMaybe<Array<BranchOfficeWhereInput>>;
  challenges?: InputMaybe<ChallengeListRelationFilter>;
  city?: InputMaybe<StringFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  countryCode?: InputMaybe<StringFilter>;
  coupons?: InputMaybe<CouponListRelationFilter>;
  crmApiId?: InputMaybe<StringNullableFilter>;
  crmConfig?: InputMaybe<BranchOfficeCrmConfigNullableRelationFilter>;
  customerClassBookings?: InputMaybe<CustomerClassBookingListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  equipments?: InputMaybe<EquipmentListRelationFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  images?: InputMaybe<BranchOfficeImageListRelationFilter>;
  latitude?: InputMaybe<DecimalFilter>;
  longitude?: InputMaybe<DecimalFilter>;
  name?: InputMaybe<StringFilter>;
  news?: InputMaybe<NewsListRelationFilter>;
  postalCode?: InputMaybe<StringFilter>;
  ratings?: InputMaybe<BranchOfficeRatingListRelationFilter>;
  state?: InputMaybe<StringFilter>;
  street?: InputMaybe<StringFilter>;
  utilizations?: InputMaybe<BranchOfficeUtilizationListRelationFilter>;
};

export type BranchOfficeWhereUniqueInput = {
  AND?: InputMaybe<Array<BranchOfficeWhereInput>>;
  NOT?: InputMaybe<Array<BranchOfficeWhereInput>>;
  OR?: InputMaybe<Array<BranchOfficeWhereInput>>;
  challenges?: InputMaybe<ChallengeListRelationFilter>;
  city?: InputMaybe<StringFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  company_crm_api_unique?: InputMaybe<BranchOfficeCompany_Crm_Api_UniqueCompoundUniqueInput>;
  countryCode?: InputMaybe<StringFilter>;
  coupons?: InputMaybe<CouponListRelationFilter>;
  crmApiId?: InputMaybe<StringNullableFilter>;
  crmConfig?: InputMaybe<BranchOfficeCrmConfigNullableRelationFilter>;
  customerClassBookings?: InputMaybe<CustomerClassBookingListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  equipments?: InputMaybe<EquipmentListRelationFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  images?: InputMaybe<BranchOfficeImageListRelationFilter>;
  latitude?: InputMaybe<DecimalFilter>;
  location?: InputMaybe<BranchOfficeLocationCompoundUniqueInput>;
  longitude?: InputMaybe<DecimalFilter>;
  name?: InputMaybe<StringFilter>;
  news?: InputMaybe<NewsListRelationFilter>;
  postalCode?: InputMaybe<StringFilter>;
  ratings?: InputMaybe<BranchOfficeRatingListRelationFilter>;
  state?: InputMaybe<StringFilter>;
  street?: InputMaybe<StringFilter>;
  utilizations?: InputMaybe<BranchOfficeUtilizationListRelationFilter>;
};

export type BytesNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<NestedBytesNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CalculationRule = {
  __typename: 'CalculationRule';
  company: Company;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  points: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type CalculationRuleAvgAggregate = {
  __typename: 'CalculationRuleAvgAggregate';
  points?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CalculationRuleCompanyIdPointsValueCompoundUniqueInput = {
  points: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
};

export type CalculationRuleCountAggregate = {
  __typename: 'CalculationRuleCountAggregate';
  _all: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type CalculationRuleListRelationFilter = {
  every?: InputMaybe<CalculationRuleWhereInput>;
  none?: InputMaybe<CalculationRuleWhereInput>;
  some?: InputMaybe<CalculationRuleWhereInput>;
};

export type CalculationRuleMaxAggregate = {
  __typename: 'CalculationRuleMaxAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CalculationRuleMinAggregate = {
  __typename: 'CalculationRuleMinAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CalculationRuleOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CalculationRuleOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  id?: InputMaybe<SortOrder>;
  points?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export enum CalculationRuleScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Points = 'points',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type CalculationRuleSumAggregate = {
  __typename: 'CalculationRuleSumAggregate';
  points?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CalculationRuleWhereInput = {
  AND?: InputMaybe<Array<CalculationRuleWhereInput>>;
  NOT?: InputMaybe<Array<CalculationRuleWhereInput>>;
  OR?: InputMaybe<Array<CalculationRuleWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  points?: InputMaybe<IntFilter>;
  value?: InputMaybe<FloatFilter>;
};

export type CalculationRuleWhereUniqueInput = {
  AND?: InputMaybe<Array<CalculationRuleWhereInput>>;
  NOT?: InputMaybe<Array<CalculationRuleWhereInput>>;
  OR?: InputMaybe<Array<CalculationRuleWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId_points_value?: InputMaybe<CalculationRuleCompanyIdPointsValueCompoundUniqueInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  points?: InputMaybe<IntFilter>;
  value?: InputMaybe<FloatFilter>;
};

export type Challenge = {
  __typename: 'Challenge';
  _count: ChallengeCount;
  active: Scalars['Boolean']['output'];
  branchOffice?: Maybe<BranchOffice>;
  branchOfficeId?: Maybe<Scalars['String']['output']>;
  company: Company;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerChallenges?: Maybe<Array<CustomerChallenge>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The indicator of whether the challenge can still be joined or not */
  joinable: Scalars['Boolean']['output'];
  /** The maximum number of participants */
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  periods?: Maybe<Array<ChallengePeriod>>;
  pointsCredit: Scalars['Int']['output'];
  /** Indicator that a challenge of type PASSIVE_POINTS_CHALLENGE has been stopped */
  stoppedAt?: Maybe<Scalars['DateTime']['output']>;
  trainingGoal: Scalars['Int']['output'];
  /** The type of challenge. (COMMUNITY_CHALLENGE or PASSIVE_POINTS_CHALLENGE) */
  type: ChallengeType;
  updatedAt: Scalars['DateTime']['output'];
};


export type ChallengeCustomerChallengesArgs = {
  cursor?: InputMaybe<CustomerChallengeWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerChallengeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerChallengeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerChallengeWhereInput>;
};


export type ChallengePeriodsArgs = {
  cursor?: InputMaybe<ChallengePeriodWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChallengePeriodScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChallengePeriodOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChallengePeriodWhereInput>;
};

export type ChallengeAvgAggregate = {
  __typename: 'ChallengeAvgAggregate';
  maxParticipants?: Maybe<Scalars['Float']['output']>;
  pointsCredit?: Maybe<Scalars['Float']['output']>;
  trainingGoal?: Maybe<Scalars['Float']['output']>;
};

export type ChallengeCount = {
  __typename: 'ChallengeCount';
  customerChallenges: Scalars['Int']['output'];
  periods: Scalars['Int']['output'];
};

export type ChallengeCountAggregate = {
  __typename: 'ChallengeCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  branchOfficeId: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['Int']['output'];
  joinable: Scalars['Int']['output'];
  maxParticipants: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  pointsCredit: Scalars['Int']['output'];
  stoppedAt: Scalars['Int']['output'];
  trainingGoal: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for challenge creation */
export type ChallengeCreateInput = {
  branchOffice?: InputMaybe<BranchOfficeCreateNestedOneWithoutChallengesInput>;
  /** Optional parameter to connect a challenge to a specific company */
  company?: InputMaybe<CompanyCreateNestedOneWithoutChallengesInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Configure the challenge image by uploading an image or specify and image URL */
  image?: InputMaybe<ChallengeImageInput>;
  maxParticipants?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** The period the challenge is active in. */
  period: CreateChallengePeriodInput;
  pointsCredit: Scalars['Int']['input'];
  trainingGoal: Scalars['Int']['input'];
};

export type ChallengeCreateNestedManyWithoutBranchOfficeInput = {
  connect?: InputMaybe<Array<ChallengeWhereUniqueInput>>;
};

export type ChallengeCreateNestedOneWithoutPeriodsInput = {
  connect?: InputMaybe<ChallengeWhereUniqueInput>;
};

/** Input for the challenge image */
export type ChallengeImageInput = {
  /** Upload a new challenge image */
  fileUpload?: InputMaybe<Scalars['Upload']['input']>;
  /** The URL of an image */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeListRelationFilter = {
  every?: InputMaybe<ChallengeWhereInput>;
  none?: InputMaybe<ChallengeWhereInput>;
  some?: InputMaybe<ChallengeWhereInput>;
};

export type ChallengeMaxAggregate = {
  __typename: 'ChallengeMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  branchOfficeId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  joinable?: Maybe<Scalars['Boolean']['output']>;
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pointsCredit?: Maybe<Scalars['Int']['output']>;
  stoppedAt?: Maybe<Scalars['DateTime']['output']>;
  trainingGoal?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<ChallengeType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ChallengeMinAggregate = {
  __typename: 'ChallengeMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  branchOfficeId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  joinable?: Maybe<Scalars['Boolean']['output']>;
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pointsCredit?: Maybe<Scalars['Int']['output']>;
  stoppedAt?: Maybe<Scalars['DateTime']['output']>;
  trainingGoal?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<ChallengeType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ChallengeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ChallengeOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  branchOffice?: InputMaybe<BranchOfficeOrderByWithRelationInput>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  customerChallenges?: InputMaybe<CustomerChallengeOrderByRelationAggregateInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  joinable?: InputMaybe<SortOrder>;
  maxParticipants?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  periods?: InputMaybe<ChallengePeriodOrderByRelationAggregateInput>;
  pointsCredit?: InputMaybe<SortOrder>;
  trainingGoal?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ChallengePeriod = {
  __typename: 'ChallengePeriod';
  _count: ChallengePeriodCount;
  activeFrom: Scalars['DateTime']['output'];
  activeUntil: Scalars['DateTime']['output'];
  challenge: Challenge;
  challengeId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** The current number of joined participants for the challenge at this period */
  participants: Scalars['Int']['output'];
  redemptions?: Maybe<Array<CustomerChallenge>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ChallengePeriodAvgAggregate = {
  __typename: 'ChallengePeriodAvgAggregate';
  participants?: Maybe<Scalars['Float']['output']>;
};

export type ChallengePeriodCount = {
  __typename: 'ChallengePeriodCount';
  redemptions: Scalars['Int']['output'];
};

export type ChallengePeriodCountAggregate = {
  __typename: 'ChallengePeriodCountAggregate';
  _all: Scalars['Int']['output'];
  activeFrom: Scalars['Int']['output'];
  activeUntil: Scalars['Int']['output'];
  challengeId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  participants: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating challenge periods */
export type ChallengePeriodCreateInput = {
  activeFrom: Scalars['DateTime']['input'];
  activeUntil: Scalars['DateTime']['input'];
  challenge: ChallengeCreateNestedOneWithoutPeriodsInput;
  participants?: InputMaybe<Scalars['Int']['input']>;
  redemptions?: InputMaybe<CustomerChallengeCreateNestedManyWithoutPeriodInput>;
};

export type ChallengePeriodListRelationFilter = {
  every?: InputMaybe<ChallengePeriodWhereInput>;
  none?: InputMaybe<ChallengePeriodWhereInput>;
  some?: InputMaybe<ChallengePeriodWhereInput>;
};

export type ChallengePeriodMaxAggregate = {
  __typename: 'ChallengePeriodMaxAggregate';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  challengeId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  participants?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ChallengePeriodMinAggregate = {
  __typename: 'ChallengePeriodMinAggregate';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  challengeId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  participants?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ChallengePeriodOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ChallengePeriodOrderByWithRelationInput = {
  activeFrom?: InputMaybe<SortOrder>;
  activeUntil?: InputMaybe<SortOrder>;
  challenge?: InputMaybe<ChallengeOrderByWithRelationInput>;
  challengeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  participants?: InputMaybe<SortOrder>;
  redemptions?: InputMaybe<CustomerChallengeOrderByRelationAggregateInput>;
};

export type ChallengePeriodRelationFilter = {
  is?: InputMaybe<ChallengePeriodWhereInput>;
  isNot?: InputMaybe<ChallengePeriodWhereInput>;
};

export enum ChallengePeriodScalarFieldEnum {
  ActiveFrom = 'activeFrom',
  ActiveUntil = 'activeUntil',
  ChallengeId = 'challengeId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Participants = 'participants',
  UpdatedAt = 'updatedAt'
}

export type ChallengePeriodSumAggregate = {
  __typename: 'ChallengePeriodSumAggregate';
  participants?: Maybe<Scalars['Int']['output']>;
};

export type ChallengePeriodUpdateInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeUntil?: InputMaybe<Scalars['DateTime']['input']>;
  challenge?: InputMaybe<ChallengeUpdateOneRequiredWithoutPeriodsNestedInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  participants?: InputMaybe<Scalars['Int']['input']>;
  redemptions?: InputMaybe<CustomerChallengeUpdateManyWithoutPeriodNestedInput>;
};

export type ChallengePeriodWhereInput = {
  AND?: InputMaybe<Array<ChallengePeriodWhereInput>>;
  NOT?: InputMaybe<Array<ChallengePeriodWhereInput>>;
  OR?: InputMaybe<Array<ChallengePeriodWhereInput>>;
  activeFrom?: InputMaybe<DateTimeFilter>;
  activeUntil?: InputMaybe<DateTimeFilter>;
  challenge?: InputMaybe<ChallengeRelationFilter>;
  challengeId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  participants?: InputMaybe<IntFilter>;
  redemptions?: InputMaybe<CustomerChallengeListRelationFilter>;
};

export type ChallengePeriodWhereUniqueInput = {
  AND?: InputMaybe<Array<ChallengePeriodWhereInput>>;
  NOT?: InputMaybe<Array<ChallengePeriodWhereInput>>;
  OR?: InputMaybe<Array<ChallengePeriodWhereInput>>;
  activeFrom?: InputMaybe<DateTimeFilter>;
  activeUntil?: InputMaybe<DateTimeFilter>;
  challenge?: InputMaybe<ChallengeRelationFilter>;
  challengeId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  participants?: InputMaybe<IntFilter>;
  redemptions?: InputMaybe<CustomerChallengeListRelationFilter>;
};

export type ChallengeRelationFilter = {
  is?: InputMaybe<ChallengeWhereInput>;
  isNot?: InputMaybe<ChallengeWhereInput>;
};

export enum ChallengeScalarFieldEnum {
  Active = 'active',
  BranchOfficeId = 'branchOfficeId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Id = 'id',
  ImageUrl = 'imageUrl',
  Joinable = 'joinable',
  MaxParticipants = 'maxParticipants',
  Name = 'name',
  PointsCredit = 'pointsCredit',
  StoppedAt = 'stoppedAt',
  TrainingGoal = 'trainingGoal',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type ChallengeScalarWhereInput = {
  AND?: InputMaybe<Array<ChallengeScalarWhereInput>>;
  NOT?: InputMaybe<Array<ChallengeScalarWhereInput>>;
  OR?: InputMaybe<Array<ChallengeScalarWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  joinable?: InputMaybe<BoolFilter>;
  maxParticipants?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  pointsCredit?: InputMaybe<IntFilter>;
  trainingGoal?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumChallengeTypeFilter>;
};

export enum ChallengeStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED'
}

export type ChallengeSumAggregate = {
  __typename: 'ChallengeSumAggregate';
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  pointsCredit?: Maybe<Scalars['Int']['output']>;
  trainingGoal?: Maybe<Scalars['Int']['output']>;
};

export enum ChallengeType {
  CommunityChallenge = 'COMMUNITY_CHALLENGE',
  PassivePointsChallenge = 'PASSIVE_POINTS_CHALLENGE'
}

export type ChallengeUpdateInput = {
  pointsCredit?: InputMaybe<Scalars['Int']['input']>;
  trainingGoal?: InputMaybe<Scalars['Int']['input']>;
};

export type ChallengeUpdateManyMutationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  joinable?: InputMaybe<Scalars['Boolean']['input']>;
  maxParticipants?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pointsCredit?: InputMaybe<Scalars['Int']['input']>;
  trainingGoal?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ChallengeType>;
};

export type ChallengeUpdateManyWithWhereWithoutBranchOfficeInput = {
  data: ChallengeUpdateManyMutationInput;
  where: ChallengeScalarWhereInput;
};

export type ChallengeUpdateManyWithoutBranchOfficeNestedInput = {
  connect?: InputMaybe<Array<ChallengeWhereUniqueInput>>;
  delete?: InputMaybe<Array<ChallengeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChallengeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChallengeWhereUniqueInput>>;
  set?: InputMaybe<Array<ChallengeWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<ChallengeUpdateManyWithWhereWithoutBranchOfficeInput>>;
};

export type ChallengeUpdateOneRequiredWithoutPeriodsNestedInput = {
  connect?: InputMaybe<ChallengeWhereUniqueInput>;
};

export type ChallengeWhereInput = {
  AND?: InputMaybe<Array<ChallengeWhereInput>>;
  NOT?: InputMaybe<Array<ChallengeWhereInput>>;
  OR?: InputMaybe<Array<ChallengeWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  branchOffice?: InputMaybe<BranchOfficeNullableRelationFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  customerChallenges?: InputMaybe<CustomerChallengeListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  joinable?: InputMaybe<BoolFilter>;
  maxParticipants?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  periods?: InputMaybe<ChallengePeriodListRelationFilter>;
  pointsCredit?: InputMaybe<IntFilter>;
  trainingGoal?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumChallengeTypeFilter>;
};

export type ChallengeWhereUniqueInput = {
  AND?: InputMaybe<Array<ChallengeWhereInput>>;
  NOT?: InputMaybe<Array<ChallengeWhereInput>>;
  OR?: InputMaybe<Array<ChallengeWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  branchOffice?: InputMaybe<BranchOfficeNullableRelationFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  customerChallenges?: InputMaybe<CustomerChallengeListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  joinable?: InputMaybe<BoolFilter>;
  maxParticipants?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  periods?: InputMaybe<ChallengePeriodListRelationFilter>;
  pointsCredit?: InputMaybe<IntFilter>;
  trainingGoal?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumChallengeTypeFilter>;
};

/** Custom type for changing point system of company */
export type ChangePointSystemInput = {
  id: Scalars['String']['input'];
  /** Must be set to change from VISIT BASED to VALUE BASED */
  valueBasedInput?: InputMaybe<ChangeToValueBasedInput>;
  /** Must be set to change from VALUE BASED to VISIT BASED */
  visitBasedInput?: InputMaybe<ChangeToVisitBasedInput>;
};

/** Custom input to change system type to PERCENTAGE */
export type ChangeToPercentageInput = {
  calculationRule: CustomCalculationRuleInput;
};

/** Custom input to change system type to STAGGERED */
export type ChangeToStaggeredInput = {
  /** The new calculation rules for the new system type STAGGERED (up to 5 rules) */
  calculationRules: Array<CustomCalculationRuleInput>;
};

/** Input to change to value based system type (PERCENTAGE or STAGGERED). Only one of PERCENTAGE or STAGGERED input can be set! */
export type ChangeToValueBasedInput = {
  /** Must be set for change from VISIT BASED or VALUE BASED (STAGGERED) to VALUE BASED (PERCENTAGE) system type */
  percentageInput?: InputMaybe<ChangeToPercentageInput>;
  /** Must be set for change to STAGGERED system type */
  staggeredInput?: InputMaybe<ChangeToStaggeredInput>;
};

/** Custom input to change system type to VISIT BASED */
export type ChangeToVisitBasedInput = {
  /** Point amount per visit */
  pointsPerVisit?: Scalars['Float']['input'];
  scanLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents the classification of the charge */
export enum ChargeType {
  AdditionalCharge = 'ADDITIONAL_CHARGE',
  AddressInquiryFee = 'ADDRESS_INQUIRY_FEE',
  BalanceCredit = 'BALANCE_CREDIT',
  BalanceDebit = 'BALANCE_DEBIT',
  BenefitDebtClaim = 'BENEFIT_DEBT_CLAIM',
  BonusPeriodCharge = 'BONUS_PERIOD_CHARGE',
  CancelationFee = 'CANCELATION_FEE',
  CardReplacementFee = 'CARD_REPLACEMENT_FEE',
  ChargedBackFee = 'CHARGED_BACK_FEE',
  ChargeDiscount = 'CHARGE_DISCOUNT',
  ConsumptionCreditRecharge = 'CONSUMPTION_CREDIT_RECHARGE',
  ContractIdlePeriodCharge = 'CONTRACT_IDLE_PERIOD_CHARGE',
  Credit = 'CREDIT',
  CreditAdjustment = 'CREDIT_ADJUSTMENT',
  DamageCompensation = 'DAMAGE_COMPENSATION',
  DebitAdjustment = 'DEBIT_ADJUSTMENT',
  DebtClaimAbandonment = 'DEBT_CLAIM_ABANDONMENT',
  DebtClaimConversion = 'DEBT_CLAIM_CONVERSION',
  DebtClaimReduction = 'DEBT_CLAIM_REDUCTION',
  DebtClaimReversal = 'DEBT_CLAIM_REVERSAL',
  DunningFee = 'DUNNING_FEE',
  FlatFee = 'FLAT_FEE',
  IdlePeriodCharge = 'IDLE_PERIOD_CHARGE',
  MembershipCharge = 'MEMBERSHIP_CHARGE',
  NoShowFee = 'NO_SHOW_FEE',
  RefundCompensation = 'REFUND_COMPENSATION',
  ReturnedBottleDeposit = 'RETURNED_BOTTLE_DEPOSIT',
  SalesDirectDebit = 'SALES_DIRECT_DEBIT',
  SalesNonDirectDebit = 'SALES_NON_DIRECT_DEBIT',
  StarterPackage = 'STARTER_PACKAGE',
  TransactionFee = 'TRANSACTION_FEE',
  TrialPeriodCharge = 'TRIAL_PERIOD_CHARGE'
}

export type CheckInHistoryFilterInput = {
  /** The from date of the time span */
  fromDate?: InputMaybe<Scalars['String']['input']>;
  /** Offset from last request */
  offset?: InputMaybe<Scalars['String']['input']>;
  /** Desired size of data chunk. [ 10 .. 100 ]. Defaults to 50 */
  sliceSize?: InputMaybe<Scalars['Int']['input']>;
  /** The to date of the time span, should not be greater than 365 days from the start date. */
  toDate?: InputMaybe<Scalars['String']['input']>;
};

/** Input for checkIn/Out events */
export type CheckInOutInput = {
  /** The unique identifier of the device */
  deviceId: Scalars['String']['input'];
  /** Die richtung (ENTRY, EXIT - CHECK_IN, CHECK_OUT) */
  direction: Direction;
};

/** true false for check in check out */
export type CheckInOutResult = {
  __typename: 'CheckInOutResult';
  /** Details of failure for check-in/out */
  details?: Maybe<Scalars['String']['output']>;
  /** Indicates whether a check-in/out operation was successfully */
  success: Scalars['Boolean']['output'];
};

/** The class information */
export type Class = {
  __typename: 'Class';
  /** Whether the class is bookable */
  bookable: Scalars['Boolean']['output'];
  /** Category of the class */
  category?: Maybe<Scalars['String']['output']>;
  /** Description of the class */
  description?: Maybe<Scalars['String']['output']>;
  /** Duration of the class in minutes */
  duration?: Maybe<Scalars['Int']['output']>;
  /** Unique ID of the class */
  id: Scalars['Int']['output'];
  /** Image URL for the class */
  imgUrl?: Maybe<Scalars['String']['output']>;
  /** Title of the class */
  title?: Maybe<Scalars['String']['output']>;
  /** Defines whether a class is held in studio or virtually */
  type?: Maybe<Scalars['String']['output']>;
};

/** Available classes for studio */
export type ClassResult = {
  __typename: 'ClassResult';
  /** Whether there is a next page */
  hasNext: Scalars['Boolean']['output'];
  /** Offset for next query */
  offset?: Maybe<Scalars['String']['output']>;
  /** List of classes */
  result: Array<Class>;
};

/** Class slot information including booking details */
export type ClassSlot = {
  __typename: 'ClassSlot';
  /** Additional participants added by operator */
  additionalParticipants: Scalars['Int']['output'];
  /** Current booked participants */
  bookedParticipants?: Maybe<Scalars['Int']['output']>;
  /** Basic class information */
  classInformation?: Maybe<BasicClass>;
  /** Earliest booking date and time with zone */
  earliestBookingDateTime?: Maybe<Scalars['String']['output']>;
  /** Class slot end date and time with zone */
  endDateTime?: Maybe<Scalars['String']['output']>;
  /** Unique ID of a class slot */
  id: Scalars['Int']['output'];
  /** Image URL assigned to display this class */
  imgUrl?: Maybe<Scalars['String']['output']>;
  /** List of instructors */
  instructors?: Maybe<Array<Instructor>>;
  /** Latest booking date and time with zone */
  latestBookingDateTime?: Maybe<Scalars['String']['output']>;
  /** Location of the class slot */
  location?: Maybe<Location>;
  /** Maximum participants allowed */
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  /** Maximum waiting list participants allowed */
  maxWaitingListParticipants?: Maybe<Scalars['Int']['output']>;
  /** Class slot start date and time with zone */
  startDateTime?: Maybe<Scalars['String']['output']>;
  /** Current waiting list participants */
  waitingListParticipants?: Maybe<Scalars['Int']['output']>;
};

export type ClassSlotFilterInput = {
  /** Days from now on to look ahead. [ 0 .. 6 ]. Defaults to 1 */
  daysAhead?: InputMaybe<Scalars['Int']['input']>;
  /** Offset from last request */
  offset?: InputMaybe<Scalars['String']['input']>;
  /** Desired size of data chunk. [ 10 .. 100 ]. Defaults to 50 */
  sliceSize?: InputMaybe<Scalars['Int']['input']>;
  /** Class slots are retrieved within the time window from slotWindowStartDate to (slotWindowStartDate + daysAhead) */
  slotWindowStartDate?: InputMaybe<Scalars['String']['input']>;
};

/** Sliced result of class slots with pagination info */
export type ClassSlotResult = {
  __typename: 'ClassSlotResult';
  /** True if there exists a next data slice */
  hasNext: Scalars['Boolean']['output'];
  /** Offset for next query */
  offset: Scalars['String']['output'];
  /** List of class slots */
  result: Array<ClassSlot>;
};

export type Company = {
  __typename: 'Company';
  _count: CompanyCount;
  /** TODO (GYM-DEALS Integration): HideField for backward compatibility -> See register-company.input.ts and company.service.ts */
  appConnectionName: Scalars['String']['output'];
  balances?: Maybe<Array<Balance>>;
  branchOffices?: Maybe<Array<BranchOffice>>;
  calculationRules?: Maybe<Array<CalculationRule>>;
  challenges?: Maybe<Array<Challenge>>;
  city: Scalars['String']['output'];
  countryCode: Scalars['CountryCode']['output'];
  coupons?: Maybe<Array<Coupon>>;
  createdAt: Scalars['DateTime']['output'];
  crmConfig?: Maybe<CompanyCrmConfig>;
  customers?: Maybe<Array<Customer>>;
  description?: Maybe<Scalars['String']['output']>;
  email: Scalars['EmailAddress']['output'];
  employees?: Maybe<Array<Employee>>;
  houseNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integrationType: IntegrationType;
  /** THe latitude of the company */
  latitude?: Maybe<Scalars['Decimal']['output']>;
  levels?: Maybe<Array<Level>>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The longitude of the company */
  longitude?: Maybe<Scalars['Decimal']['output']>;
  /** TODO (GYM-DEALS Integration): HideField for backward compatibility -> See register-company.input.ts and company.service.ts */
  managementConnectionName: Scalars['String']['output'];
  mobileAppVariant: MobileAppVariant;
  name: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  partnerChallenges?: Maybe<Array<PartnerChallenge>>;
  partners?: Maybe<Array<Partner>>;
  pointSystem?: Maybe<PointSystem>;
  popups?: Maybe<Array<Popup>>;
  postalCode: Scalars['PostalCode']['output'];
  promotions?: Maybe<Array<Promotion>>;
  pushNotifications?: Maybe<Array<PushNotification>>;
  ratingQuestions?: Maybe<Array<RatingQuestion>>;
  receivedPoints?: Maybe<Array<ReceivedPoint>>;
  referralConfig?: Maybe<CompanyReferralConfig>;
  rewards?: Maybe<Array<Reward>>;
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  /** Indicates whether this company is using the studio app */
  studioApp: Scalars['Boolean']['output'];
  /** The timezone of the company */
  timeZone: Scalars['TimeZone']['output'];
  trainingPlans?: Maybe<Array<TrainingPlan>>;
  updatedAt: Scalars['DateTime']['output'];
  visible: Scalars['Boolean']['output'];
};


export type Company_CountArgs = {
  onlyActiveRewards?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyCouponsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<CouponType>;
};


export type CompanyPromotionsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  filterInput?: InputMaybe<LocationFilterInput>;
};


export type CompanyRewardsArgs = {
  sortOrder?: InputMaybe<SortOrder>;
  status?: InputMaybe<RewardStatus>;
};

export type CompanyAvgAggregate = {
  __typename: 'CompanyAvgAggregate';
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
};

export type CompanyCount = {
  __typename: 'CompanyCount';
  balances: Scalars['Int']['output'];
  branchOffices: Scalars['Int']['output'];
  calculationRules: Scalars['Int']['output'];
  challenges: Scalars['Int']['output'];
  coupons: Scalars['Int']['output'];
  customers: Scalars['Int']['output'];
  employees: Scalars['Int']['output'];
  levels: Scalars['Int']['output'];
  partnerChallenges: Scalars['Int']['output'];
  partners: Scalars['Int']['output'];
  popups: Scalars['Int']['output'];
  promotions: Scalars['Int']['output'];
  pushNotifications: Scalars['Int']['output'];
  ratingQuestions: Scalars['Int']['output'];
  receivedPoints: Scalars['Int']['output'];
  rewards: Scalars['Int']['output'];
  trainingPlans: Scalars['Int']['output'];
};

export type CompanyCountAggregate = {
  __typename: 'CompanyCountAggregate';
  _all: Scalars['Int']['output'];
  appConnectionName: Scalars['Int']['output'];
  city: Scalars['Int']['output'];
  countryCode: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  houseNumber: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  integrationType: Scalars['Int']['output'];
  latitude: Scalars['Int']['output'];
  logoUrl: Scalars['Int']['output'];
  longitude: Scalars['Int']['output'];
  managementConnectionName: Scalars['Int']['output'];
  mobileAppVariant: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  organizationName: Scalars['Int']['output'];
  postalCode: Scalars['Int']['output'];
  state: Scalars['Int']['output'];
  street: Scalars['Int']['output'];
  studioApp: Scalars['Int']['output'];
  timeZone: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  visible: Scalars['Int']['output'];
};

export type CompanyCreateNestedManyWithoutPartnersInput = {
  connect?: InputMaybe<Array<CompanyWhereUniqueInput>>;
};

export type CompanyCreateNestedOneWithoutBranchOfficesInput = {
  connect?: InputMaybe<CompanyWhereUniqueInput>;
};

/** Non nullable company connect type */
export type CompanyCreateNestedOneWithoutChallengesInput = {
  connect: CompanyWhereUniqueInput;
};

export type CompanyCreateNestedOneWithoutCouponsInput = {
  connect: CompanyWhereUniqueInput;
};

/** Non nullable company connect type */
export type CompanyCreateNestedOneWithoutCrmConfigInput = {
  connect: CompanyWhereUniqueInput;
};

export type CompanyCreateNestedOneWithoutCustomersInput = {
  connect?: InputMaybe<CompanyWhereUniqueInput>;
};

export type CompanyCreateNestedOneWithoutPopupsInput = {
  connect: CompanyWhereUniqueInput;
};

/** Non nullable company connect input */
export type CompanyCreateNestedOneWithoutPushNotificationsInput = {
  connect: CompanyWhereUniqueInput;
};

export type CompanyCreateNestedOneWithoutReferralConfigInput = {
  connect: CompanyWhereUniqueInput;
};

export type CompanyCrmConfig = {
  __typename: 'CompanyCrmConfig';
  _count: CompanyCrmConfigCount;
  /** The API URL of the crm system */
  apiUrl: Scalars['String']['output'];
  branchOfficeCrmConfigs?: Maybe<Array<BranchOfficeCrmConfig>>;
  company: Company;
  companyId: Scalars['String']['output'];
  /** The CRM tenant name */
  crmTenant: Scalars['String']['output'];
  customerCrmConfigs?: Maybe<Array<CustomerCrmConfig>>;
  /** The URL to which redemption events (of rewards, coupon, etc.) are sent in order to store them in the CRM (e.g. for magicline it is a message bird URL). */
  redemptionTransmissionUrl?: Maybe<Scalars['String']['output']>;
};

export type CompanyCrmConfigCount = {
  __typename: 'CompanyCrmConfigCount';
  branchOfficeCrmConfigs: Scalars['Int']['output'];
  customerCrmConfigs: Scalars['Int']['output'];
};

export type CompanyCrmConfigCountAggregate = {
  __typename: 'CompanyCrmConfigCountAggregate';
  _all: Scalars['Int']['output'];
  apiUrl: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  crmTenant: Scalars['Int']['output'];
  redemptionTransmissionUrl: Scalars['Int']['output'];
};

/** Create input for company crm config */
export type CompanyCrmConfigCreateInput = {
  /** The api key for magicline */
  apiKey: Scalars['String']['input'];
  apiUrl: Scalars['String']['input'];
  branchOfficeCrmConfigs?: InputMaybe<BranchOfficeCrmConfigCreateNestedManyWithoutCompanyCrmConfigInput>;
  company: CompanyCreateNestedOneWithoutCrmConfigInput;
  crmTenant: Scalars['String']['input'];
  customerCrmConfigs?: InputMaybe<CustomerCrmConfigCreateNestedManyWithoutCompanyCrmConfigInput>;
  redemptionTransmissionUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyCrmConfigCrmTenantCompanyIdCompoundUniqueInput = {
  crmTenant: Scalars['String']['input'];
};

export type CompanyCrmConfigMaxAggregate = {
  __typename: 'CompanyCrmConfigMaxAggregate';
  apiUrl?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  crmTenant?: Maybe<Scalars['String']['output']>;
  redemptionTransmissionUrl?: Maybe<Scalars['String']['output']>;
};

export type CompanyCrmConfigMinAggregate = {
  __typename: 'CompanyCrmConfigMinAggregate';
  apiUrl?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  crmTenant?: Maybe<Scalars['String']['output']>;
  redemptionTransmissionUrl?: Maybe<Scalars['String']['output']>;
};

export type CompanyCrmConfigNullableRelationFilter = {
  is?: InputMaybe<CompanyCrmConfigWhereInput>;
  isNot?: InputMaybe<CompanyCrmConfigWhereInput>;
};

export type CompanyCrmConfigOrderByWithRelationInput = {
  apiUrl?: InputMaybe<SortOrder>;
  branchOfficeCrmConfigs?: InputMaybe<BranchOfficeCrmConfigOrderByRelationAggregateInput>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  crmTenant?: InputMaybe<SortOrder>;
  customerCrmConfigs?: InputMaybe<CustomerCrmConfigOrderByRelationAggregateInput>;
  redemptionTransmissionUrl?: InputMaybe<SortOrderInput>;
};

export type CompanyCrmConfigRelationFilter = {
  is?: InputMaybe<CompanyCrmConfigWhereInput>;
  isNot?: InputMaybe<CompanyCrmConfigWhereInput>;
};

export enum CompanyCrmConfigScalarFieldEnum {
  ApiUrl = 'apiUrl',
  CompanyId = 'companyId',
  CrmTenant = 'crmTenant',
  RedemptionTransmissionUrl = 'redemptionTransmissionUrl'
}

/** Update input for company crm config */
export type CompanyCrmConfigUpdateInput = {
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  crmTenant?: InputMaybe<Scalars['String']['input']>;
  redemptionTransmissionUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyCrmConfigUpdateOneRequiredWithoutCustomerCrmConfigsNestedInput = {
  connect?: InputMaybe<CompanyCrmConfigWhereUniqueInput>;
};

export type CompanyCrmConfigWhereInput = {
  AND?: InputMaybe<Array<CompanyCrmConfigWhereInput>>;
  NOT?: InputMaybe<Array<CompanyCrmConfigWhereInput>>;
  OR?: InputMaybe<Array<CompanyCrmConfigWhereInput>>;
  apiUrl?: InputMaybe<StringFilter>;
  branchOfficeCrmConfigs?: InputMaybe<BranchOfficeCrmConfigListRelationFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  crmTenant?: InputMaybe<StringFilter>;
  customerCrmConfigs?: InputMaybe<CustomerCrmConfigListRelationFilter>;
  redemptionTransmissionUrl?: InputMaybe<StringNullableFilter>;
};

export type CompanyCrmConfigWhereUniqueInput = {
  AND?: InputMaybe<Array<CompanyCrmConfigWhereInput>>;
  NOT?: InputMaybe<Array<CompanyCrmConfigWhereInput>>;
  OR?: InputMaybe<Array<CompanyCrmConfigWhereInput>>;
  apiUrl?: InputMaybe<StringFilter>;
  branchOfficeCrmConfigs?: InputMaybe<BranchOfficeCrmConfigListRelationFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  crmTenant?: InputMaybe<StringFilter>;
  crmTenant_companyId?: InputMaybe<CompanyCrmConfigCrmTenantCompanyIdCompoundUniqueInput>;
  customerCrmConfigs?: InputMaybe<CustomerCrmConfigListRelationFilter>;
  redemptionTransmissionUrl?: InputMaybe<StringNullableFilter>;
};

/** Input for the company information */
export type CompanyInformationInput = {
  city: Scalars['String']['input'];
  countryCode: Scalars['CountryCode']['input'];
  email: Scalars['EmailAddress']['input'];
  houseNumber: Scalars['String']['input'];
  /** The industry id of the company */
  industryId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  postalCode: Scalars['PostalCode']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type CompanyListRelationFilter = {
  every?: InputMaybe<CompanyWhereInput>;
  none?: InputMaybe<CompanyWhereInput>;
  some?: InputMaybe<CompanyWhereInput>;
};

export type CompanyLocationCompoundUniqueInput = {
  city: Scalars['String']['input'];
  countryCode: Scalars['CountryCode']['input'];
  houseNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  postalCode: Scalars['PostalCode']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type CompanyLogo = {
  __typename: 'CompanyLogo';
  logoUrl?: Maybe<Scalars['String']['output']>;
};

/** Input for company logo. */
export type CompanyLogoInput = {
  /** Upload a new logo as file */
  fileUpload?: InputMaybe<Scalars['Upload']['input']>;
  /** The url of an existing hosted logo */
  fileUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyMaxAggregate = {
  __typename: 'CompanyMaxAggregate';
  appConnectionName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['CountryCode']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  integrationType?: Maybe<IntegrationType>;
  latitude?: Maybe<Scalars['Decimal']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  managementConnectionName?: Maybe<Scalars['String']['output']>;
  mobileAppVariant?: Maybe<MobileAppVariant>;
  name?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['PostalCode']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  studioApp?: Maybe<Scalars['Boolean']['output']>;
  timeZone?: Maybe<Scalars['TimeZone']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visible?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyMinAggregate = {
  __typename: 'CompanyMinAggregate';
  appConnectionName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['CountryCode']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  integrationType?: Maybe<IntegrationType>;
  latitude?: Maybe<Scalars['Decimal']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  managementConnectionName?: Maybe<Scalars['String']['output']>;
  mobileAppVariant?: Maybe<MobileAppVariant>;
  name?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['PostalCode']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  studioApp?: Maybe<Scalars['Boolean']['output']>;
  timeZone?: Maybe<Scalars['TimeZone']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visible?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CompanyOrderByWithRelationInput = {
  balances?: InputMaybe<BalanceOrderByRelationAggregateInput>;
  branchOffices?: InputMaybe<BranchOfficeOrderByRelationAggregateInput>;
  calculationRules?: InputMaybe<CalculationRuleOrderByRelationAggregateInput>;
  challenges?: InputMaybe<ChallengeOrderByRelationAggregateInput>;
  city?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  coupons?: InputMaybe<CouponOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  crmConfig?: InputMaybe<CompanyCrmConfigOrderByWithRelationInput>;
  customers?: InputMaybe<CustomerOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrder>;
  employees?: InputMaybe<EmployeeOrderByRelationAggregateInput>;
  houseNumber?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  integrationType?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrderInput>;
  logoUrl?: InputMaybe<SortOrderInput>;
  longitude?: InputMaybe<SortOrderInput>;
  mobileAppVariant?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organizationName?: InputMaybe<SortOrder>;
  partnerChallenges?: InputMaybe<PartnerChallengeOrderByRelationAggregateInput>;
  partners?: InputMaybe<PartnerOrderByRelationAggregateInput>;
  pointSystem?: InputMaybe<PointSystemOrderByWithRelationInput>;
  popups?: InputMaybe<PopupOrderByRelationAggregateInput>;
  postalCode?: InputMaybe<SortOrder>;
  promotions?: InputMaybe<PromotionOrderByRelationAggregateInput>;
  pushNotifications?: InputMaybe<PushNotificationOrderByRelationAggregateInput>;
  ratingQuestions?: InputMaybe<RatingQuestionOrderByRelationAggregateInput>;
  receivedPoints?: InputMaybe<ReceivedPointOrderByRelationAggregateInput>;
  referralConfig?: InputMaybe<CompanyReferralConfigOrderByWithRelationInput>;
  rewards?: InputMaybe<RewardOrderByRelationAggregateInput>;
  state?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
  studioApp?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
  trainingPlans?: InputMaybe<TrainingPlanOrderByRelationAggregateInput>;
  visible?: InputMaybe<SortOrder>;
};

export type CompanyRanking = {
  __typename: 'CompanyRanking';
  /** The name of the company */
  name: Scalars['String']['output'];
  /** The customers rank within the company */
  rank: Scalars['Float']['output'];
};

export type CompanyReferralConfig = {
  __typename: 'CompanyReferralConfig';
  /** Indicator for this whether the company does currently support friend referrals or not */
  active: Scalars['Boolean']['output'];
  company: Company;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** The link to the 'friends' page / instructions from the company including in the social sharing */
  link: Scalars['String']['output'];
  /** The points credit which the referring customer receives after successful registration of the referred customer */
  pointsCredit: Scalars['Int']['output'];
  /** The text sent to the referred customer by social sharing */
  text?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CompanyReferralConfigAvgAggregate = {
  __typename: 'CompanyReferralConfigAvgAggregate';
  pointsCredit?: Maybe<Scalars['Float']['output']>;
};

export type CompanyReferralConfigCountAggregate = {
  __typename: 'CompanyReferralConfigCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  link: Scalars['Int']['output'];
  pointsCredit: Scalars['Int']['output'];
  text: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating a company referral config */
export type CompanyReferralConfigCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally, specify the company for which the referral config is to be created */
  company?: InputMaybe<CompanyCreateNestedOneWithoutReferralConfigInput>;
  link: Scalars['String']['input'];
  pointsCredit: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyReferralConfigMaxAggregate = {
  __typename: 'CompanyReferralConfigMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  pointsCredit?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyReferralConfigMinAggregate = {
  __typename: 'CompanyReferralConfigMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  pointsCredit?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyReferralConfigNullableRelationFilter = {
  is?: InputMaybe<CompanyReferralConfigWhereInput>;
  isNot?: InputMaybe<CompanyReferralConfigWhereInput>;
};

export type CompanyReferralConfigOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  pointsCredit?: InputMaybe<SortOrder>;
  text?: InputMaybe<SortOrderInput>;
};

export enum CompanyReferralConfigScalarFieldEnum {
  Active = 'active',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Link = 'link',
  PointsCredit = 'pointsCredit',
  Text = 'text',
  UpdatedAt = 'updatedAt'
}

export type CompanyReferralConfigSumAggregate = {
  __typename: 'CompanyReferralConfigSumAggregate';
  pointsCredit?: Maybe<Scalars['Int']['output']>;
};

/** Input for updating a company referral config */
export type CompanyReferralConfigUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  pointsCredit?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyReferralConfigWhereInput = {
  AND?: InputMaybe<Array<CompanyReferralConfigWhereInput>>;
  NOT?: InputMaybe<Array<CompanyReferralConfigWhereInput>>;
  OR?: InputMaybe<Array<CompanyReferralConfigWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  link?: InputMaybe<StringFilter>;
  pointsCredit?: InputMaybe<IntFilter>;
  text?: InputMaybe<StringNullableFilter>;
};

export type CompanyReferralConfigWhereUniqueInput = {
  AND?: InputMaybe<Array<CompanyReferralConfigWhereInput>>;
  NOT?: InputMaybe<Array<CompanyReferralConfigWhereInput>>;
  OR?: InputMaybe<Array<CompanyReferralConfigWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  link?: InputMaybe<StringFilter>;
  pointsCredit?: InputMaybe<IntFilter>;
  text?: InputMaybe<StringNullableFilter>;
};

export type CompanyRelationFilter = {
  is?: InputMaybe<CompanyWhereInput>;
  isNot?: InputMaybe<CompanyWhereInput>;
};

export enum CompanyScalarFieldEnum {
  AppConnectionName = 'appConnectionName',
  City = 'city',
  CountryCode = 'countryCode',
  CreatedAt = 'createdAt',
  Description = 'description',
  Email = 'email',
  Franchise = 'franchise',
  HouseNumber = 'houseNumber',
  Id = 'id',
  IntegrationType = 'integrationType',
  Latitude = 'latitude',
  LogoUrl = 'logoUrl',
  Longitude = 'longitude',
  ManagementConnectionName = 'managementConnectionName',
  MobileAppVariant = 'mobileAppVariant',
  Name = 'name',
  OrganizationName = 'organizationName',
  PostalCode = 'postalCode',
  State = 'state',
  Street = 'street',
  StudioApp = 'studioApp',
  TimeZone = 'timeZone',
  UpdatedAt = 'updatedAt',
  Visible = 'visible'
}

export type CompanySumAggregate = {
  __typename: 'CompanySumAggregate';
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
};

/** Unique identifier of company */
export type CompanyUniqueInput = {
  /** The unique identifier of the company */
  id: Scalars['String']['input'];
};

export type CompanyUpdateOneRequiredWithoutBranchOfficesNestedInput = {
  connect?: InputMaybe<CompanyWhereUniqueInput>;
};

export type CompanyUpdateOneRequiredWithoutCouponsNestedInput = {
  connect?: InputMaybe<CompanyWhereUniqueInput>;
};

export type CompanyUpdateOneRequiredWithoutCustomersNestedInput = {
  connect?: InputMaybe<CompanyWhereUniqueInput>;
};

export type CompanyUpdateOneRequiredWithoutPointSystemNestedInput = {
  connect?: InputMaybe<CompanyWhereUniqueInput>;
};

export type CompanyUpdateOneRequiredWithoutReceivedPointsNestedInput = {
  connect?: InputMaybe<CompanyWhereUniqueInput>;
};

export type CompanyUpdateOneRequiredWithoutRewardsNestedInput = {
  connect?: InputMaybe<CompanyWhereUniqueInput>;
};

export enum CompanyUserType {
  BusinessOwner = 'BUSINESS_OWNER',
  Employee = 'EMPLOYEE'
}

export type CompanyWhereInput = {
  AND?: InputMaybe<Array<CompanyWhereInput>>;
  NOT?: InputMaybe<Array<CompanyWhereInput>>;
  OR?: InputMaybe<Array<CompanyWhereInput>>;
  balances?: InputMaybe<BalanceListRelationFilter>;
  branchOffices?: InputMaybe<BranchOfficeListRelationFilter>;
  calculationRules?: InputMaybe<CalculationRuleListRelationFilter>;
  challenges?: InputMaybe<ChallengeListRelationFilter>;
  city?: InputMaybe<StringFilter>;
  countryCode?: InputMaybe<StringFilter>;
  coupons?: InputMaybe<CouponListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  crmConfig?: InputMaybe<CompanyCrmConfigNullableRelationFilter>;
  customers?: InputMaybe<CustomerListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  employees?: InputMaybe<EmployeeListRelationFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  integrationType?: InputMaybe<EnumIntegrationTypeFilter>;
  latitude?: InputMaybe<DecimalNullableFilter>;
  logoUrl?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<DecimalNullableFilter>;
  mobileAppVariant?: InputMaybe<EnumMobileAppVariantFilter>;
  name?: InputMaybe<StringFilter>;
  organizationName?: InputMaybe<StringFilter>;
  partnerChallenges?: InputMaybe<PartnerChallengeListRelationFilter>;
  partners?: InputMaybe<PartnerListRelationFilter>;
  pointSystem?: InputMaybe<PointSystemNullableRelationFilter>;
  popups?: InputMaybe<PopupListRelationFilter>;
  postalCode?: InputMaybe<StringFilter>;
  promotions?: InputMaybe<PromotionListRelationFilter>;
  pushNotifications?: InputMaybe<PushNotificationListRelationFilter>;
  ratingQuestions?: InputMaybe<RatingQuestionListRelationFilter>;
  receivedPoints?: InputMaybe<ReceivedPointListRelationFilter>;
  referralConfig?: InputMaybe<CompanyReferralConfigNullableRelationFilter>;
  rewards?: InputMaybe<RewardListRelationFilter>;
  state?: InputMaybe<StringFilter>;
  street?: InputMaybe<StringFilter>;
  studioApp?: InputMaybe<BoolFilter>;
  timeZone?: InputMaybe<StringFilter>;
  trainingPlans?: InputMaybe<TrainingPlanListRelationFilter>;
  visible?: InputMaybe<BoolFilter>;
};

export type CompanyWhereUniqueInput = {
  AND?: InputMaybe<Array<CompanyWhereInput>>;
  NOT?: InputMaybe<Array<CompanyWhereInput>>;
  OR?: InputMaybe<Array<CompanyWhereInput>>;
  balances?: InputMaybe<BalanceListRelationFilter>;
  branchOffices?: InputMaybe<BranchOfficeListRelationFilter>;
  calculationRules?: InputMaybe<CalculationRuleListRelationFilter>;
  challenges?: InputMaybe<ChallengeListRelationFilter>;
  city?: InputMaybe<StringFilter>;
  countryCode?: InputMaybe<StringFilter>;
  coupons?: InputMaybe<CouponListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  crmConfig?: InputMaybe<CompanyCrmConfigNullableRelationFilter>;
  customers?: InputMaybe<CustomerListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  employees?: InputMaybe<EmployeeListRelationFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<EnumIntegrationTypeFilter>;
  latitude?: InputMaybe<DecimalNullableFilter>;
  location?: InputMaybe<CompanyLocationCompoundUniqueInput>;
  logoUrl?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<DecimalNullableFilter>;
  mobileAppVariant?: InputMaybe<EnumMobileAppVariantFilter>;
  name?: InputMaybe<StringFilter>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  partnerChallenges?: InputMaybe<PartnerChallengeListRelationFilter>;
  partners?: InputMaybe<PartnerListRelationFilter>;
  pointSystem?: InputMaybe<PointSystemNullableRelationFilter>;
  popups?: InputMaybe<PopupListRelationFilter>;
  postalCode?: InputMaybe<StringFilter>;
  promotions?: InputMaybe<PromotionListRelationFilter>;
  pushNotifications?: InputMaybe<PushNotificationListRelationFilter>;
  ratingQuestions?: InputMaybe<RatingQuestionListRelationFilter>;
  receivedPoints?: InputMaybe<ReceivedPointListRelationFilter>;
  referralConfig?: InputMaybe<CompanyReferralConfigNullableRelationFilter>;
  rewards?: InputMaybe<RewardListRelationFilter>;
  state?: InputMaybe<StringFilter>;
  street?: InputMaybe<StringFilter>;
  studioApp?: InputMaybe<BoolFilter>;
  timeZone?: InputMaybe<StringFilter>;
  trainingPlans?: InputMaybe<TrainingPlanListRelationFilter>;
  visible?: InputMaybe<BoolFilter>;
};

export type Contact = {
  __typename: 'Contact';
  id: Scalars['ID']['output'];
  requestId?: Maybe<Scalars['String']['output']>;
};

/** Pending changes for customer contact data */
export type ContactDataAmendment = {
  __typename: 'ContactDataAmendment';
  /** Email address of the customer */
  email?: Maybe<Scalars['EmailAddress']['output']>;
  /** Amendment proposal id */
  id?: Maybe<Scalars['Int']['output']>;
  /** Business phone number of the customer */
  phoneBusiness?: Maybe<Scalars['String']['output']>;
  /** Business mobile phone number of the customer */
  phoneBusinessMobile?: Maybe<Scalars['String']['output']>;
  /** Private phone number of the customer */
  phonePrivate?: Maybe<Scalars['String']['output']>;
  /** Private mobile phone number of the customer */
  phonePrivateMobile?: Maybe<Scalars['String']['output']>;
};

/** Representing customer contact data */
export type ContactDataAmendmentInput = {
  /** Email address of the customer */
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** Business phone number of the customer */
  phoneBusiness?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** Business mobile phone number of the customer */
  phoneBusinessMobile?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** Private phone number of the customer */
  phonePrivate?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** Private mobile phone number of the customer */
  phonePrivateMobile?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type ContactSupportInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

/** Contract information */
export type Contract = {
  __typename: 'Contract';
  cancellationDate?: Maybe<Scalars['String']['output']>;
  cancellationPeriod?: Maybe<TimePeriod>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancellationReceiptDate?: Maybe<Scalars['String']['output']>;
  cancelled: Scalars['Boolean']['output'];
  contractStatus: ContractStatus;
  createdDate: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  extensionTerm: TimePeriod;
  flatFeeContracts?: Maybe<Array<SubContract>>;
  id: Scalars['Int']['output'];
  lastPossibleCancellationDate: Scalars['String']['output'];
  moduleContracts?: Maybe<Array<SubContract>>;
  /** @deprecated Deprecated in API spec */
  price: Scalars['Float']['output'];
  priceDetails: PriceDetails;
  /** Rate codes of the  contract rate */
  rateCodes?: Maybe<Array<RateCode>>;
  rateName: Scalars['String']['output'];
  signedDocumentUrl?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  term: TimePeriod;
  thirdPartyId?: Maybe<Scalars['String']['output']>;
};

export type ContractInput = {
  status: ContractStatus;
};

/** Represents available status for contracts */
export enum ContractStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type Coupon = {
  __typename: 'Coupon';
  _count: CouponCount;
  active: Scalars['Boolean']['output'];
  branchOffices?: Maybe<Array<BranchOffice>>;
  company: Company;
  /** The */
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  imageTemplate?: Maybe<ImageTemplate>;
  imageTemplateId?: Maybe<Scalars['UUID']['output']>;
  /** The maximum number of possible redemptions for the coupon */
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  periods?: Maybe<Array<CouponPeriod>>;
  pointsCredit?: Maybe<Scalars['Int']['output']>;
  /** The indicator of whether the coupon can still be redeemd or not */
  redeemable: Scalars['Boolean']['output'];
  redemptions?: Maybe<Array<RedeemedCoupon>>;
  /** The method that is used to transmission the reward redemtion to the company */
  transmissionMethod?: Maybe<TransmissionMethod>;
  type: CouponType;
  updatedAt: Scalars['DateTime']['output'];
};

export type CouponAvgAggregate = {
  __typename: 'CouponAvgAggregate';
  maxRedemptions?: Maybe<Scalars['Float']['output']>;
  pointsCredit?: Maybe<Scalars['Float']['output']>;
};

export type CouponCount = {
  __typename: 'CouponCount';
  branchOffices: Scalars['Int']['output'];
  periods: Scalars['Int']['output'];
  redemptions: Scalars['Int']['output'];
};

export type CouponCountAggregate = {
  __typename: 'CouponCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageTemplateId: Scalars['Int']['output'];
  maxRedemptions: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  pointsCredit: Scalars['Int']['output'];
  redeemable: Scalars['Int']['output'];
  transmissionMethod: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creation of addition coupons */
export type CouponCreateInput = {
  /** The ID's of the branch offices this coupon should be configured for. If not set, the coupon is available for all branch offices of the company */
  branchOfficeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional parameter to configure coupon for specific company */
  companyId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageTemplate?: InputMaybe<ImageTemplateCreateNestedOneWithoutCouponsInput>;
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** The period the coupon is active in */
  period: CreateCouponPeriodInput;
  pointsCredit?: InputMaybe<Scalars['Int']['input']>;
  /** The type of the coupon (ADDITION, MULTIPLICATION) */
  type: LimitedCouponType;
};

export type CouponCreateNestedManyWithoutImageTemplateInput = {
  connect?: InputMaybe<Array<CouponWhereUniqueInput>>;
};

export type CouponCreateNestedOneWithoutPeriodsInput = {
  connect?: InputMaybe<CouponWhereUniqueInput>;
};

export type CouponListRelationFilter = {
  every?: InputMaybe<CouponWhereInput>;
  none?: InputMaybe<CouponWhereInput>;
  some?: InputMaybe<CouponWhereInput>;
};

export type CouponMaxAggregate = {
  __typename: 'CouponMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageTemplateId?: Maybe<Scalars['UUID']['output']>;
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pointsCredit?: Maybe<Scalars['Int']['output']>;
  redeemable?: Maybe<Scalars['Boolean']['output']>;
  transmissionMethod?: Maybe<TransmissionMethod>;
  type?: Maybe<CouponType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CouponMinAggregate = {
  __typename: 'CouponMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageTemplateId?: Maybe<Scalars['UUID']['output']>;
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pointsCredit?: Maybe<Scalars['Int']['output']>;
  redeemable?: Maybe<Scalars['Boolean']['output']>;
  transmissionMethod?: Maybe<TransmissionMethod>;
  type?: Maybe<CouponType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CouponOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CouponOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  branchOffices?: InputMaybe<BranchOfficeOrderByRelationAggregateInput>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imageTemplate?: InputMaybe<ImageTemplateOrderByWithRelationInput>;
  maxRedemptions?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  periods?: InputMaybe<CouponPeriodOrderByRelationAggregateInput>;
  pointsCredit?: InputMaybe<SortOrderInput>;
  redeemable?: InputMaybe<SortOrder>;
  redemptions?: InputMaybe<RedeemedCouponOrderByRelationAggregateInput>;
  transmissionMethod?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
};

export type CouponPeriod = {
  __typename: 'CouponPeriod';
  _count: CouponPeriodCount;
  activeFrom: Scalars['DateTime']['output'];
  activeUntil: Scalars['DateTime']['output'];
  coupon: Coupon;
  couponId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** The number of redemptions of an coupon at this period */
  redemptionCount: Scalars['Int']['output'];
  redemptions?: Maybe<Array<RedeemedCoupon>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CouponPeriodAvgAggregate = {
  __typename: 'CouponPeriodAvgAggregate';
  redemptionCount?: Maybe<Scalars['Float']['output']>;
};

export type CouponPeriodCount = {
  __typename: 'CouponPeriodCount';
  redemptions: Scalars['Int']['output'];
};

export type CouponPeriodCountAggregate = {
  __typename: 'CouponPeriodCountAggregate';
  _all: Scalars['Int']['output'];
  activeFrom: Scalars['Int']['output'];
  activeUntil: Scalars['Int']['output'];
  couponId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  redemptionCount: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating coupon periods */
export type CouponPeriodCreateInput = {
  activeFrom: Scalars['DateTime']['input'];
  activeUntil: Scalars['DateTime']['input'];
  coupon: CouponCreateNestedOneWithoutPeriodsInput;
  redemptionCount?: InputMaybe<Scalars['Int']['input']>;
  redemptions?: InputMaybe<RedeemedCouponCreateNestedManyWithoutPeriodInput>;
};

export type CouponPeriodListRelationFilter = {
  every?: InputMaybe<CouponPeriodWhereInput>;
  none?: InputMaybe<CouponPeriodWhereInput>;
  some?: InputMaybe<CouponPeriodWhereInput>;
};

export type CouponPeriodMaxAggregate = {
  __typename: 'CouponPeriodMaxAggregate';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  couponId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  redemptionCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CouponPeriodMinAggregate = {
  __typename: 'CouponPeriodMinAggregate';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  couponId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  redemptionCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CouponPeriodNullableRelationFilter = {
  is?: InputMaybe<CouponPeriodWhereInput>;
  isNot?: InputMaybe<CouponPeriodWhereInput>;
};

export type CouponPeriodOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CouponPeriodOrderByWithRelationInput = {
  activeFrom?: InputMaybe<SortOrder>;
  activeUntil?: InputMaybe<SortOrder>;
  coupon?: InputMaybe<CouponOrderByWithRelationInput>;
  couponId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  redemptionCount?: InputMaybe<SortOrder>;
  redemptions?: InputMaybe<RedeemedCouponOrderByRelationAggregateInput>;
};

export enum CouponPeriodScalarFieldEnum {
  ActiveFrom = 'activeFrom',
  ActiveUntil = 'activeUntil',
  CompanyId = 'companyId',
  CouponId = 'couponId',
  CreatedAt = 'createdAt',
  Id = 'id',
  RedemptionCount = 'redemptionCount',
  UpdatedAt = 'updatedAt'
}

export type CouponPeriodScalarWhereInput = {
  AND?: InputMaybe<Array<CouponPeriodScalarWhereInput>>;
  NOT?: InputMaybe<Array<CouponPeriodScalarWhereInput>>;
  OR?: InputMaybe<Array<CouponPeriodScalarWhereInput>>;
  activeFrom?: InputMaybe<DateTimeFilter>;
  activeUntil?: InputMaybe<DateTimeFilter>;
  couponId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  redemptionCount?: InputMaybe<IntFilter>;
};

export type CouponPeriodSumAggregate = {
  __typename: 'CouponPeriodSumAggregate';
  redemptionCount?: Maybe<Scalars['Int']['output']>;
};

/** Input for updating a coupon period */
export type CouponPeriodUpdateInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeUntil?: InputMaybe<Scalars['DateTime']['input']>;
  redemptionCount?: InputMaybe<Scalars['Int']['input']>;
  redemptions?: InputMaybe<RedeemedCouponUpdateManyWithoutPeriodNestedInput>;
};

export type CouponPeriodUpdateManyMutationInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeUntil?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  redemptionCount?: InputMaybe<Scalars['Int']['input']>;
};

export type CouponPeriodUpdateManyWithWhereWithoutCouponInput = {
  data: CouponPeriodUpdateManyMutationInput;
  where: CouponPeriodScalarWhereInput;
};

export type CouponPeriodUpdateManyWithoutCouponNestedInput = {
  connect?: InputMaybe<Array<CouponPeriodWhereUniqueInput>>;
  delete?: InputMaybe<Array<CouponPeriodWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CouponPeriodScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CouponPeriodWhereUniqueInput>>;
  set?: InputMaybe<Array<CouponPeriodWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<CouponPeriodUpdateManyWithWhereWithoutCouponInput>>;
};

export type CouponPeriodWhereInput = {
  AND?: InputMaybe<Array<CouponPeriodWhereInput>>;
  NOT?: InputMaybe<Array<CouponPeriodWhereInput>>;
  OR?: InputMaybe<Array<CouponPeriodWhereInput>>;
  activeFrom?: InputMaybe<DateTimeFilter>;
  activeUntil?: InputMaybe<DateTimeFilter>;
  coupon?: InputMaybe<CouponRelationFilter>;
  couponId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  redemptionCount?: InputMaybe<IntFilter>;
  redemptions?: InputMaybe<RedeemedCouponListRelationFilter>;
};

export type CouponPeriodWhereUniqueInput = {
  AND?: InputMaybe<Array<CouponPeriodWhereInput>>;
  NOT?: InputMaybe<Array<CouponPeriodWhereInput>>;
  OR?: InputMaybe<Array<CouponPeriodWhereInput>>;
  activeFrom?: InputMaybe<DateTimeFilter>;
  activeUntil?: InputMaybe<DateTimeFilter>;
  coupon?: InputMaybe<CouponRelationFilter>;
  couponId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  redemptionCount?: InputMaybe<IntFilter>;
  redemptions?: InputMaybe<RedeemedCouponListRelationFilter>;
};

export type CouponRelationFilter = {
  is?: InputMaybe<CouponWhereInput>;
  isNot?: InputMaybe<CouponWhereInput>;
};

export enum CouponScalarFieldEnum {
  Active = 'active',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  ImageTemplateId = 'imageTemplateId',
  MaxRedemptions = 'maxRedemptions',
  Name = 'name',
  PointsCredit = 'pointsCredit',
  Redeemable = 'redeemable',
  TransmissionMethod = 'transmissionMethod',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type CouponScalarWhereInput = {
  AND?: InputMaybe<Array<CouponScalarWhereInput>>;
  NOT?: InputMaybe<Array<CouponScalarWhereInput>>;
  OR?: InputMaybe<Array<CouponScalarWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  maxRedemptions?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  pointsCredit?: InputMaybe<IntNullableFilter>;
  redeemable?: InputMaybe<BoolFilter>;
  transmissionMethod?: InputMaybe<EnumTransmissionMethodNullableFilter>;
  type?: InputMaybe<EnumCouponTypeFilter>;
};

/** Enum of status of coupons  */
export enum CouponState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum CouponStatus {
  Active = 'ACTIVE',
  Used = 'USED'
}

export type CouponSumAggregate = {
  __typename: 'CouponSumAggregate';
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  pointsCredit?: Maybe<Scalars['Int']['output']>;
};

export enum CouponType {
  Addition = 'ADDITION',
  Multiplication = 'MULTIPLICATION',
  Promotional = 'PROMOTIONAL',
  Welcome = 'WELCOME'
}

/** Input of unique identifier of a coupon */
export type CouponUniqueInput = {
  id: Scalars['String']['input'];
};

export type CouponUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  branchOffices?: InputMaybe<BranchOfficeUpdateManyWithoutCouponsNestedInput>;
  company?: InputMaybe<CompanyUpdateOneRequiredWithoutCouponsNestedInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageTemplate?: InputMaybe<ImageTemplateUpdateOneWithoutCouponsNestedInput>;
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  periods?: InputMaybe<CouponPeriodUpdateManyWithoutCouponNestedInput>;
  pointsCredit?: InputMaybe<Scalars['Int']['input']>;
  redeemable?: InputMaybe<Scalars['Boolean']['input']>;
  redemptions?: InputMaybe<RedeemedCouponUpdateManyWithoutCouponNestedInput>;
  transmissionMethod?: InputMaybe<TransmissionMethod>;
  type?: InputMaybe<CouponType>;
};

export type CouponUpdateManyMutationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pointsCredit?: InputMaybe<Scalars['Int']['input']>;
  redeemable?: InputMaybe<Scalars['Boolean']['input']>;
  transmissionMethod?: InputMaybe<TransmissionMethod>;
  type?: InputMaybe<CouponType>;
};

export type CouponUpdateManyWithWhereWithoutBranchOfficesInput = {
  data: CouponUpdateManyMutationInput;
  where: CouponScalarWhereInput;
};

export type CouponUpdateManyWithWhereWithoutImageTemplateInput = {
  data: CouponUpdateManyMutationInput;
  where: CouponScalarWhereInput;
};

export type CouponUpdateManyWithoutBranchOfficesNestedInput = {
  connect?: InputMaybe<Array<CouponWhereUniqueInput>>;
  delete?: InputMaybe<Array<CouponWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CouponScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CouponWhereUniqueInput>>;
  set?: InputMaybe<Array<CouponWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<CouponUpdateManyWithWhereWithoutBranchOfficesInput>>;
};

export type CouponUpdateManyWithoutImageTemplateNestedInput = {
  connect?: InputMaybe<Array<CouponWhereUniqueInput>>;
  delete?: InputMaybe<Array<CouponWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CouponScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CouponWhereUniqueInput>>;
  set?: InputMaybe<Array<CouponWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<CouponUpdateManyWithWhereWithoutImageTemplateInput>>;
};

export type CouponWhereInput = {
  AND?: InputMaybe<Array<CouponWhereInput>>;
  NOT?: InputMaybe<Array<CouponWhereInput>>;
  OR?: InputMaybe<Array<CouponWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  branchOffices?: InputMaybe<BranchOfficeListRelationFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  imageTemplate?: InputMaybe<ImageTemplateNullableRelationFilter>;
  maxRedemptions?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  periods?: InputMaybe<CouponPeriodListRelationFilter>;
  pointsCredit?: InputMaybe<IntNullableFilter>;
  redeemable?: InputMaybe<BoolFilter>;
  redemptions?: InputMaybe<RedeemedCouponListRelationFilter>;
  transmissionMethod?: InputMaybe<EnumTransmissionMethodNullableFilter>;
  type?: InputMaybe<EnumCouponTypeFilter>;
};

export type CouponWhereUniqueInput = {
  AND?: InputMaybe<Array<CouponWhereInput>>;
  NOT?: InputMaybe<Array<CouponWhereInput>>;
  OR?: InputMaybe<Array<CouponWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  branchOffices?: InputMaybe<BranchOfficeListRelationFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageTemplate?: InputMaybe<ImageTemplateNullableRelationFilter>;
  maxRedemptions?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  periods?: InputMaybe<CouponPeriodListRelationFilter>;
  pointsCredit?: InputMaybe<IntNullableFilter>;
  redeemable?: InputMaybe<BoolFilter>;
  redemptions?: InputMaybe<RedeemedCouponListRelationFilter>;
  transmissionMethod?: InputMaybe<EnumTransmissionMethodNullableFilter>;
  type?: InputMaybe<EnumCouponTypeFilter>;
};

/** Custom type representing a coupon with a period */
export type CouponWithPeriodModel = {
  __typename: 'CouponWithPeriodModel';
  _count: CouponCount;
  active: Scalars['Boolean']['output'];
  branchOffices?: Maybe<Array<BranchOffice>>;
  company: Company;
  /** The */
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  imageTemplate?: Maybe<ImageTemplate>;
  imageTemplateId?: Maybe<Scalars['UUID']['output']>;
  /** The maximum number of possible redemptions for the coupon */
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  period?: Maybe<CouponPeriod>;
  pointsCredit?: Maybe<Scalars['Int']['output']>;
  /** The indicator of whether the coupon can still be redeemd or not */
  redeemable: Scalars['Boolean']['output'];
  redemptions?: Maybe<Array<RedeemedCoupon>>;
  /** The method that is used to transmission the reward redemtion to the company */
  transmissionMethod?: Maybe<TransmissionMethod>;
  type: CouponType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Create input for a challenge period */
export type CreateChallengePeriodInput = {
  activeFrom: Scalars['DateTime']['input'];
  activeUntil: Scalars['DateTime']['input'];
};

/** Input for creating coupon periods */
export type CreateCouponPeriodInput = {
  activeFrom: Scalars['DateTime']['input'];
  activeUntil: Scalars['DateTime']['input'];
};

export type CreateOrChangeCalculationRuleInput = {
  /** Create a VALUE BASED calculation rule. */
  valueBasedInput?: InputMaybe<ChangeToValueBasedInput>;
  /** Create a VISIT BASED calculation rule. */
  visitBasedInput?: InputMaybe<ChangeToVisitBasedInput>;
};

export type CreatePartnerChallengeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activityType: PartnerChallengeActivityType;
  checkInRequired?: InputMaybe<Scalars['Boolean']['input']>;
  companyIds: Array<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  goalUnit: Scalars['String']['input'];
  goalValue: Scalars['Float']['input'];
  image?: InputMaybe<ChallengeImageInput>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  joinable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  partner: PartnerCreateNestedOneWithoutChallengeInput;
  period: CreatePartnerChallengePeriodInput;
  type: PartnerChallengeType;
  verificationType: PartnerChallengeVerificationType;
  winnerCount?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePartnerChallengePeriodInput = {
  activeFrom: Scalars['DateTime']['input'];
  activeUntil: Scalars['DateTime']['input'];
  reward?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating promotion period */
export type CreatePromotionPeriodInput = {
  activeFrom: Scalars['DateTime']['input'];
  activeUntil: Scalars['DateTime']['input'];
};

/** Custom input to create rewards */
export type CreateRewardInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageKey?: InputMaybe<Scalars['String']['input']>;
  imageTemplate?: InputMaybe<ImageTemplateCreateNestedOneWithoutRewardsInput>;
  name: Scalars['String']['input'];
  requiredPoints: Scalars['Int']['input'];
  saving?: InputMaybe<Scalars['Float']['input']>;
  transmissionMethod?: InputMaybe<TransmissionMethod>;
};

export type CrmCustomer = {
  __typename: 'CrmCustomer';
  birthDate: Scalars['String']['output'];
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  houseNumber: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  street: Scalars['String']['output'];
  studioId: Scalars['String']['output'];
};

export type CrmCustomerWhereUniqueInput = {
  birthDate: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  studioId: Scalars['String']['input'];
};

export enum CronInterval {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

/** Input type for calculation rule with picked fields from original model */
export type CustomCalculationRuleInput = {
  points: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
};

export type Customer = {
  __typename: 'Customer';
  _count: CustomerCount;
  balances?: Maybe<Array<Balance>>;
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  branchOfficeRatings?: Maybe<Array<BranchOfficeRating>>;
  challenges?: Maybe<Array<CustomerChallenge>>;
  city?: Maybe<Scalars['String']['output']>;
  classesBookings?: Maybe<Array<CustomerClassBooking>>;
  company: Company;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  crmConfig?: Maybe<CustomerCrmConfig>;
  defectReports?: Maybe<Array<DefectReport>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['EmailAddress']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  friendships?: Maybe<Array<Friendship>>;
  friendshipsInitiated?: Maybe<Array<Friendship>>;
  friendshipsReceived?: Maybe<Array<Friendship>>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  partnerChallenges?: Maybe<Array<CustomerPartnerChallenge>>;
  partnerOrders?: Maybe<Array<CustomerPartnerOrder>>;
  postalCode?: Maybe<Scalars['String']['output']>;
  pushToken?: Maybe<Scalars['String']['output']>;
  receivedFriendRequests?: Maybe<Array<FriendRequest>>;
  receivedPoints?: Maybe<Array<ReceivedPoint>>;
  redeemedCoupons?: Maybe<Array<RedeemedCoupon>>;
  redeemedPartnerRewards?: Maybe<Array<RedeemedPartnerReward>>;
  redeemedPoints?: Maybe<Array<RedeemedPoint>>;
  referrals?: Maybe<Array<CustomerReferral>>;
  sentFriendRequests?: Maybe<Array<FriendRequest>>;
  state?: Maybe<Scalars['String']['output']>;
  statistic?: Maybe<CustomerStatistic>;
  street?: Maybe<Scalars['String']['output']>;
  trainingPlans?: Maybe<Array<TrainingPlan>>;
  updatedAt: Scalars['DateTime']['output'];
  workoutSessions?: Maybe<Array<WorkoutSession>>;
};


export type CustomerBalancesArgs = {
  sortOrder?: InputMaybe<SortOrder>;
};


export type CustomerFriendshipsInitiatedArgs = {
  cursor?: InputMaybe<FriendshipWhereUniqueInput>;
  distinct?: InputMaybe<Array<FriendshipScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FriendshipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FriendshipWhereInput>;
};


export type CustomerFriendshipsReceivedArgs = {
  cursor?: InputMaybe<FriendshipWhereUniqueInput>;
  distinct?: InputMaybe<Array<FriendshipScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FriendshipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FriendshipWhereInput>;
};


export type CustomerReceivedFriendRequestsArgs = {
  cursor?: InputMaybe<FriendRequestWhereUniqueInput>;
  distinct?: InputMaybe<Array<FriendRequestScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FriendRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FriendRequestWhereInput>;
};


export type CustomerSentFriendRequestsArgs = {
  cursor?: InputMaybe<FriendRequestWhereUniqueInput>;
  distinct?: InputMaybe<Array<FriendRequestScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FriendRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FriendRequestWhereInput>;
};

/** Customer's access code */
export type CustomerAccessCode = {
  __typename: 'CustomerAccessCode';
  /** Access code content that should be rendered in a format defined by the format property */
  content: Scalars['String']['output'];
  /** Access code expiry date and time with zone (ISO-8601) */
  expiresAt?: Maybe<Scalars['String']['output']>;
  /** Represents an access code format the content should be encoded into or decoded from */
  format: CustomerAccessCodeFormat;
};

/** Represents an access code format the content should be encoded into or decoded from */
export enum CustomerAccessCodeFormat {
  QrCode = 'QR_CODE'
}

/** Information about customers achievements */
export type CustomerAchievement = {
  __typename: 'CustomerAchievement';
  company: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** name of reward or coupon */
  name: Scalars['String']['output'];
};

/** Customer address data including amendment information */
export type CustomerAddressData = {
  __typename: 'CustomerAddressData';
  /** Additional address information of the customer's address */
  additionalAddressInformation?: Maybe<Scalars['String']['output']>;
  /** Status of the amendment configuration */
  amendmentConfigurationStatus: AmendmentConfigurationStatus;
  /** Building name */
  buildingName?: Maybe<Scalars['String']['output']>;
  /** City of the customer */
  city: Scalars['String']['output'];
  /** City part of the customer's address */
  cityPart?: Maybe<Scalars['String']['output']>;
  /** Country of the customer */
  countryCode: Scalars['String']['output'];
  /** District of the customer's address */
  district?: Maybe<Scalars['String']['output']>;
  /** Door of the customer's address */
  door?: Maybe<Scalars['String']['output']>;
  /** Floor of the customer's address */
  floor?: Maybe<Scalars['String']['output']>;
  /** Number of the customer's house */
  houseNumber?: Maybe<Scalars['String']['output']>;
  /** Pending amendment */
  pendingAmendment?: Maybe<AddressDataAmendment>;
  /** Portal of the customer's address */
  portal?: Maybe<Scalars['String']['output']>;
  /** Province for southern Europe/US countries */
  province?: Maybe<Scalars['String']['output']>;
  /** Province code for southern Europe/US countries */
  provinceCode?: Maybe<Scalars['String']['output']>;
  /** Second street line of the customer's address */
  secondStreet?: Maybe<Scalars['String']['output']>;
  /** Stairway of the customer's address */
  stairway?: Maybe<Scalars['String']['output']>;
  /** Street of the customer */
  street: Scalars['String']['output'];
  /** Street block of the customer's address */
  streetBlock?: Maybe<Scalars['String']['output']>;
  /** Street type of the customer's address */
  streetType?: Maybe<Scalars['String']['output']>;
  /** Zip code of the customer */
  zipCode: Scalars['String']['output'];
};

export type CustomerChallenge = {
  __typename: 'CustomerChallenge';
  challenge: Challenge;
  challengeId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isFinished: Scalars['Boolean']['output'];
  period: ChallengePeriod;
  periodId: Scalars['String']['output'];
  progress: Scalars['Int']['output'];
  receivedPoint?: Maybe<ReceivedPoint>;
  status: ChallengeStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerChallengeAvgAggregate = {
  __typename: 'CustomerChallengeAvgAggregate';
  progress?: Maybe<Scalars['Float']['output']>;
};

export type CustomerChallengeChallengeIdCustomerIdPeriodIdCompoundUniqueInput = {
  challengeId: Scalars['UUID']['input'];
  customerId: Scalars['String']['input'];
  periodId: Scalars['String']['input'];
};

export type CustomerChallengeCountAggregate = {
  __typename: 'CustomerChallengeCountAggregate';
  _all: Scalars['Int']['output'];
  challengeId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isFinished: Scalars['Int']['output'];
  periodId: Scalars['Int']['output'];
  progress: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CustomerChallengeCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<CustomerChallengeWhereUniqueInput>>;
};

export type CustomerChallengeCreateNestedManyWithoutPeriodInput = {
  connect?: InputMaybe<Array<CustomerChallengeWhereUniqueInput>>;
};

export type CustomerChallengeListRelationFilter = {
  every?: InputMaybe<CustomerChallengeWhereInput>;
  none?: InputMaybe<CustomerChallengeWhereInput>;
  some?: InputMaybe<CustomerChallengeWhereInput>;
};

export type CustomerChallengeMaxAggregate = {
  __typename: 'CustomerChallengeMaxAggregate';
  challengeId?: Maybe<Scalars['UUID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isFinished?: Maybe<Scalars['Boolean']['output']>;
  periodId?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ChallengeStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerChallengeMinAggregate = {
  __typename: 'CustomerChallengeMinAggregate';
  challengeId?: Maybe<Scalars['UUID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isFinished?: Maybe<Scalars['Boolean']['output']>;
  periodId?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ChallengeStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerChallengeNullableRelationFilter = {
  is?: InputMaybe<CustomerChallengeWhereInput>;
  isNot?: InputMaybe<CustomerChallengeWhereInput>;
};

export type CustomerChallengeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerChallengeOrderByWithRelationInput = {
  challenge?: InputMaybe<ChallengeOrderByWithRelationInput>;
  challengeId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isFinished?: InputMaybe<SortOrder>;
  period?: InputMaybe<ChallengePeriodOrderByWithRelationInput>;
  periodId?: InputMaybe<SortOrder>;
  progress?: InputMaybe<SortOrder>;
  receivedPoint?: InputMaybe<ReceivedPointOrderByWithRelationInput>;
  status?: InputMaybe<SortOrder>;
};

export enum CustomerChallengeScalarFieldEnum {
  ChallengeId = 'challengeId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  IsFinished = 'isFinished',
  PeriodId = 'periodId',
  Progress = 'progress',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type CustomerChallengeScalarWhereInput = {
  AND?: InputMaybe<Array<CustomerChallengeScalarWhereInput>>;
  NOT?: InputMaybe<Array<CustomerChallengeScalarWhereInput>>;
  OR?: InputMaybe<Array<CustomerChallengeScalarWhereInput>>;
  challengeId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isFinished?: InputMaybe<BoolFilter>;
  periodId?: InputMaybe<UuidFilter>;
  progress?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumChallengeStatusFilter>;
};

export type CustomerChallengeSumAggregate = {
  __typename: 'CustomerChallengeSumAggregate';
  progress?: Maybe<Scalars['Int']['output']>;
};

export type CustomerChallengeUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isFinished?: InputMaybe<Scalars['Boolean']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ChallengeStatus>;
};

export type CustomerChallengeUpdateManyWithWhereWithoutCustomerInput = {
  data: CustomerChallengeUpdateManyMutationInput;
  where: CustomerChallengeScalarWhereInput;
};

export type CustomerChallengeUpdateManyWithWhereWithoutPeriodInput = {
  data: CustomerChallengeUpdateManyMutationInput;
  where: CustomerChallengeScalarWhereInput;
};

export type CustomerChallengeUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CustomerChallengeWhereUniqueInput>>;
  delete?: InputMaybe<Array<CustomerChallengeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CustomerChallengeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CustomerChallengeWhereUniqueInput>>;
  set?: InputMaybe<Array<CustomerChallengeWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<CustomerChallengeUpdateManyWithWhereWithoutCustomerInput>>;
};

export type CustomerChallengeUpdateManyWithoutPeriodNestedInput = {
  connect?: InputMaybe<Array<CustomerChallengeWhereUniqueInput>>;
  delete?: InputMaybe<Array<CustomerChallengeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CustomerChallengeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CustomerChallengeWhereUniqueInput>>;
  set?: InputMaybe<Array<CustomerChallengeWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<CustomerChallengeUpdateManyWithWhereWithoutPeriodInput>>;
};

export type CustomerChallengeUpdateOneWithoutReceivedPointNestedInput = {
  connect?: InputMaybe<CustomerChallengeWhereUniqueInput>;
  delete?: InputMaybe<CustomerChallengeWhereInput>;
  disconnect?: InputMaybe<CustomerChallengeWhereInput>;
};

export type CustomerChallengeWhereInput = {
  AND?: InputMaybe<Array<CustomerChallengeWhereInput>>;
  NOT?: InputMaybe<Array<CustomerChallengeWhereInput>>;
  OR?: InputMaybe<Array<CustomerChallengeWhereInput>>;
  challenge?: InputMaybe<ChallengeRelationFilter>;
  challengeId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isFinished?: InputMaybe<BoolFilter>;
  period?: InputMaybe<ChallengePeriodRelationFilter>;
  periodId?: InputMaybe<UuidFilter>;
  progress?: InputMaybe<IntFilter>;
  receivedPoint?: InputMaybe<ReceivedPointNullableRelationFilter>;
  status?: InputMaybe<EnumChallengeStatusFilter>;
};

export type CustomerChallengeWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerChallengeWhereInput>>;
  NOT?: InputMaybe<Array<CustomerChallengeWhereInput>>;
  OR?: InputMaybe<Array<CustomerChallengeWhereInput>>;
  challenge?: InputMaybe<ChallengeRelationFilter>;
  challengeId?: InputMaybe<UuidFilter>;
  challengeId_customerId_periodId?: InputMaybe<CustomerChallengeChallengeIdCustomerIdPeriodIdCompoundUniqueInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isFinished?: InputMaybe<BoolFilter>;
  period?: InputMaybe<ChallengePeriodRelationFilter>;
  periodId?: InputMaybe<UuidFilter>;
  progress?: InputMaybe<IntFilter>;
  receivedPoint?: InputMaybe<ReceivedPointNullableRelationFilter>;
  status?: InputMaybe<EnumChallengeStatusFilter>;
};

export type CustomerCheckInHistoryResult = {
  __typename: 'CustomerCheckInHistoryResult';
  /** True if there exists a next data slice */
  hasNext: Scalars['Boolean']['output'];
  /** Offset for next query */
  offset: Scalars['String']['output'];
  /** List of customer check ins */
  result: Array<CustomerCheckin>;
};

/** Data of one checkin entry for a customer */
export type CustomerCheckin = {
  __typename: 'CustomerCheckin';
  /** Check in time of the studio visit in ISO-8601 */
  checkInDateTime: Scalars['String']['output'];
  /** Check out time of the studio visit ISO-8601 */
  checkOutDateTime?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the studio visit */
  checkinId: Scalars['Int']['output'];
  /** Studio ID of the checkin studio */
  studioId: Scalars['Int']['output'];
  /** Studio name of the checkin studio */
  studioName: Scalars['String']['output'];
};

/** Represents booked classes (courses) in magicline per customer */
export type CustomerClassBooking = {
  __typename: 'CustomerClassBooking';
  branchOffice: BranchOffice;
  /** The unique identifier of the class in magicline */
  classId: Scalars['Int']['output'];
  /** The unique identifier of the booked class slot */
  classSlotId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  /** The end date of the class */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /** A description of the location */
  locationDescription?: Maybe<Scalars['String']['output']>;
  /** The name of the location where this course takes place */
  locationName?: Maybe<Scalars['String']['output']>;
  /** The start date of the class */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the class */
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerClassBookingAvgAggregate = {
  __typename: 'CustomerClassBookingAvgAggregate';
  classId?: Maybe<Scalars['Float']['output']>;
  classSlotId?: Maybe<Scalars['Float']['output']>;
};

export type CustomerClassBookingCountAggregate = {
  __typename: 'CustomerClassBookingCountAggregate';
  _all: Scalars['Int']['output'];
  classId: Scalars['Int']['output'];
  classSlotId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  endDate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  locationDescription: Scalars['Int']['output'];
  locationName: Scalars['Int']['output'];
  startDate: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating a customer class booking representing a class in magicline */
export type CustomerClassBookingCreateInput = {
  classId: Scalars['Int']['input'];
  classSlotId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerClassBookingCreateNestedManyWithoutBranchOfficeInput = {
  connect?: InputMaybe<Array<CustomerClassBookingWhereUniqueInput>>;
};

export type CustomerClassBookingCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<CustomerClassBookingWhereUniqueInput>>;
};

export type CustomerClassBookingCustom = {
  __typename: 'CustomerClassBookingCustom';
  branchOffice: BranchOffice;
  /** The unique identifier of the class in magicline */
  classId: Scalars['Int']['output'];
  /** The unique identifier of the booked class slot */
  classSlotId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  /** The end date of the class */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /** Optional image url */
  imgUrl?: Maybe<Scalars['String']['output']>;
  /** A description of the location */
  locationDescription?: Maybe<Scalars['String']['output']>;
  /** The name of the location where this course takes place */
  locationName?: Maybe<Scalars['String']['output']>;
  /** The start date of the class */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the class */
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerClassBookingListRelationFilter = {
  every?: InputMaybe<CustomerClassBookingWhereInput>;
  none?: InputMaybe<CustomerClassBookingWhereInput>;
  some?: InputMaybe<CustomerClassBookingWhereInput>;
};

export type CustomerClassBookingMaxAggregate = {
  __typename: 'CustomerClassBookingMaxAggregate';
  classId?: Maybe<Scalars['Int']['output']>;
  classSlotId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  locationDescription?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerClassBookingMinAggregate = {
  __typename: 'CustomerClassBookingMinAggregate';
  classId?: Maybe<Scalars['Int']['output']>;
  classSlotId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  locationDescription?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerClassBookingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerClassBookingOrderByWithRelationInput = {
  branchOffice?: InputMaybe<BranchOfficeOrderByWithRelationInput>;
  branchOfficeId?: InputMaybe<SortOrder>;
  classId?: InputMaybe<SortOrder>;
  classSlotId?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  locationDescription?: InputMaybe<SortOrderInput>;
  locationName?: InputMaybe<SortOrderInput>;
  startDate?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
};

export enum CustomerClassBookingScalarFieldEnum {
  BranchOfficeId = 'branchOfficeId',
  ClassId = 'classId',
  ClassSlotId = 'classSlotId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  EndDate = 'endDate',
  Id = 'id',
  LocationDescription = 'locationDescription',
  LocationName = 'locationName',
  StartDate = 'startDate',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type CustomerClassBookingScalarWhereInput = {
  AND?: InputMaybe<Array<CustomerClassBookingScalarWhereInput>>;
  NOT?: InputMaybe<Array<CustomerClassBookingScalarWhereInput>>;
  OR?: InputMaybe<Array<CustomerClassBookingScalarWhereInput>>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  classId?: InputMaybe<IntFilter>;
  classSlotId?: InputMaybe<IntFilter>;
  customerId?: InputMaybe<StringFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  locationDescription?: InputMaybe<StringNullableFilter>;
  locationName?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type CustomerClassBookingSumAggregate = {
  __typename: 'CustomerClassBookingSumAggregate';
  classId?: Maybe<Scalars['Int']['output']>;
  classSlotId?: Maybe<Scalars['Int']['output']>;
};

export type CustomerClassBookingUpdateManyMutationInput = {
  classId?: InputMaybe<Scalars['Int']['input']>;
  classSlotId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerClassBookingUpdateManyWithWhereWithoutBranchOfficeInput = {
  data: CustomerClassBookingUpdateManyMutationInput;
  where: CustomerClassBookingScalarWhereInput;
};

export type CustomerClassBookingUpdateManyWithWhereWithoutCustomerInput = {
  data: CustomerClassBookingUpdateManyMutationInput;
  where: CustomerClassBookingScalarWhereInput;
};

export type CustomerClassBookingUpdateManyWithoutBranchOfficeNestedInput = {
  connect?: InputMaybe<Array<CustomerClassBookingWhereUniqueInput>>;
  delete?: InputMaybe<Array<CustomerClassBookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CustomerClassBookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CustomerClassBookingWhereUniqueInput>>;
  set?: InputMaybe<Array<CustomerClassBookingWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<CustomerClassBookingUpdateManyWithWhereWithoutBranchOfficeInput>>;
};

export type CustomerClassBookingUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CustomerClassBookingWhereUniqueInput>>;
  delete?: InputMaybe<Array<CustomerClassBookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CustomerClassBookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CustomerClassBookingWhereUniqueInput>>;
  set?: InputMaybe<Array<CustomerClassBookingWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<CustomerClassBookingUpdateManyWithWhereWithoutCustomerInput>>;
};

export type CustomerClassBookingWhereInput = {
  AND?: InputMaybe<Array<CustomerClassBookingWhereInput>>;
  NOT?: InputMaybe<Array<CustomerClassBookingWhereInput>>;
  OR?: InputMaybe<Array<CustomerClassBookingWhereInput>>;
  branchOffice?: InputMaybe<BranchOfficeRelationFilter>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  classId?: InputMaybe<IntFilter>;
  classSlotId?: InputMaybe<IntFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  locationDescription?: InputMaybe<StringNullableFilter>;
  locationName?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type CustomerClassBookingWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerClassBookingWhereInput>>;
  NOT?: InputMaybe<Array<CustomerClassBookingWhereInput>>;
  OR?: InputMaybe<Array<CustomerClassBookingWhereInput>>;
  branchOffice?: InputMaybe<BranchOfficeRelationFilter>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  classId?: InputMaybe<IntFilter>;
  classSlotId?: InputMaybe<IntFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationDescription?: InputMaybe<StringNullableFilter>;
  locationName?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type CustomerCompanyScopedEmailCompoundUniqueInput = {
  companyId: Scalars['String']['input'];
  email: Scalars['EmailAddress']['input'];
};

/** Customer contact data including amendment information */
export type CustomerContactData = {
  __typename: 'CustomerContactData';
  /** Status of the amendment configuration */
  amendmentConfigurationStatus: AmendmentConfigurationStatus;
  /** Email address of the customer */
  email?: Maybe<Scalars['String']['output']>;
  /** Pending amendment */
  pendingAmendment?: Maybe<ContactDataAmendment>;
  /** Business phone number of the customer */
  phoneBusiness?: Maybe<Scalars['String']['output']>;
  /** Business mobile phone number of the customer */
  phoneBusinessMobile?: Maybe<Scalars['String']['output']>;
  /** Private phone number of the customer */
  phonePrivate?: Maybe<Scalars['String']['output']>;
  /** Private mobile phone number of the customer */
  phonePrivateMobile?: Maybe<Scalars['String']['output']>;
};

export type CustomerCount = {
  __typename: 'CustomerCount';
  balances: Scalars['Int']['output'];
  branchOfficeRatings: Scalars['Int']['output'];
  challenges: Scalars['Int']['output'];
  classesBookings: Scalars['Int']['output'];
  defectReports: Scalars['Int']['output'];
  friendshipsInitiated: Scalars['Int']['output'];
  friendshipsReceived: Scalars['Int']['output'];
  partnerChallenges: Scalars['Int']['output'];
  partnerOrders: Scalars['Int']['output'];
  receivedFriendRequests: Scalars['Int']['output'];
  receivedPoints: Scalars['Int']['output'];
  redeemedCoupons: Scalars['Int']['output'];
  redeemedPartnerRewards: Scalars['Int']['output'];
  redeemedPoints: Scalars['Int']['output'];
  referrals: Scalars['Int']['output'];
  sentFriendRequests: Scalars['Int']['output'];
  trainingPlans: Scalars['Int']['output'];
  workoutSessions: Scalars['Int']['output'];
};

export type CustomerCountAggregate = {
  __typename: 'CustomerCountAggregate';
  _all: Scalars['Int']['output'];
  birthDate: Scalars['Int']['output'];
  city: Scalars['Int']['output'];
  countryCode: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  houseNumber: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  postalCode: Scalars['Int']['output'];
  pushToken: Scalars['Int']['output'];
  state: Scalars['Int']['output'];
  street: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CustomerCreateInput = {
  balances?: InputMaybe<BalanceCreateNestedManyWithoutCustomerInput>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  branchOfficeRatings?: InputMaybe<BranchOfficeRatingCreateNestedManyWithoutCustomerInput>;
  challenges?: InputMaybe<CustomerChallengeCreateNestedManyWithoutCustomerInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  classesBookings?: InputMaybe<CustomerClassBookingCreateNestedManyWithoutCustomerInput>;
  company: CompanyCreateNestedOneWithoutCustomersInput;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  crmConfig?: InputMaybe<CustomerCrmConfigCreateNestedOneWithoutCustomerInput>;
  defectReports?: InputMaybe<DefectReportCreateNestedManyWithoutReporterInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['EmailAddress']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  friendshipsInitiated?: InputMaybe<FriendshipCreateNestedManyWithoutParticipantAInput>;
  friendshipsReceived?: InputMaybe<FriendshipCreateNestedManyWithoutParticipantBInput>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  partnerChallenges?: InputMaybe<CustomerPartnerChallengeCreateNestedManyWithoutCustomerInput>;
  partnerOrders?: InputMaybe<CustomerPartnerOrderCreateNestedManyWithoutCustomerInput>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  receivedFriendRequests?: InputMaybe<FriendRequestCreateNestedManyWithoutReceiverInput>;
  receivedPoints?: InputMaybe<ReceivedPointCreateNestedManyWithoutCustomerInput>;
  redeemedCoupons?: InputMaybe<RedeemedCouponCreateNestedManyWithoutCustomerInput>;
  redeemedPartnerRewards?: InputMaybe<RedeemedPartnerRewardCreateNestedManyWithoutCustomerInput>;
  redeemedPoints?: InputMaybe<RedeemedPointCreateNestedManyWithoutCustomerInput>;
  referrals?: InputMaybe<CustomerReferralCreateNestedManyWithoutCustomerInput>;
  sentFriendRequests?: InputMaybe<FriendRequestCreateNestedManyWithoutSenderInput>;
  state?: InputMaybe<Scalars['String']['input']>;
  statistic?: InputMaybe<CustomerStatisticCreateNestedOneWithoutCustomerInput>;
  street?: InputMaybe<Scalars['String']['input']>;
  trainingPlans?: InputMaybe<TrainingPlanCreateNestedManyWithoutCustomerInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workoutSessions?: InputMaybe<WorkoutSessionCreateNestedManyWithoutCustomerInput>;
};

/** Non nullable customer connect type */
export type CustomerCreateNestedOneWithoutCrmConfigInput = {
  connect: CustomerWhereUniqueInput;
};

export type CustomerCreateNestedOneWithoutRedeemedPointsInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
};

export type CustomerCreateNestedOneWithoutReferralsInput = {
  connect: CustomerWhereUniqueInput;
};

export type CustomerCrmConfig = {
  __typename: 'CustomerCrmConfig';
  branchOfficeCrmConfig: BranchOfficeCrmConfig;
  companyCrmConfig: CompanyCrmConfig;
  /** The unique identifier in the crm system */
  crmCustomerId: Scalars['String']['output'];
  /** The identifier of studio the customer is registered at */
  crmStudioId: Scalars['String']['output'];
  /** The CRM tenant name */
  crmTenant: Scalars['String']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
};

export type CustomerCrmConfigCompanyIdCrmCustomerIdCompoundUniqueInput = {
  crmCustomerId: Scalars['String']['input'];
};

export type CustomerCrmConfigCountAggregate = {
  __typename: 'CustomerCrmConfigCountAggregate';
  _all: Scalars['Int']['output'];
  crmCustomerId: Scalars['Int']['output'];
  crmStudioId: Scalars['Int']['output'];
  crmTenant: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
};

/** Create input for customer crm config */
export type CustomerCrmConfigCreateInput = {
  crmCustomerId: Scalars['String']['input'];
  /** The CRM studio ID */
  crmStudioId: Scalars['String']['input'];
  /** Connect a customer */
  customer: CustomerCreateNestedOneWithoutCrmConfigInput;
};

export type CustomerCrmConfigCreateNestedManyWithoutCompanyCrmConfigInput = {
  connect?: InputMaybe<Array<CustomerCrmConfigWhereUniqueInput>>;
};

export type CustomerCrmConfigCreateNestedOneWithoutCustomerInput = {
  connect?: InputMaybe<CustomerCrmConfigWhereUniqueInput>;
};

export type CustomerCrmConfigCrmTenantCrmCustomerIdCompoundUniqueInput = {
  crmCustomerId: Scalars['String']['input'];
  crmTenant: Scalars['String']['input'];
};

export type CustomerCrmConfigListRelationFilter = {
  every?: InputMaybe<CustomerCrmConfigWhereInput>;
  none?: InputMaybe<CustomerCrmConfigWhereInput>;
  some?: InputMaybe<CustomerCrmConfigWhereInput>;
};

export type CustomerCrmConfigMaxAggregate = {
  __typename: 'CustomerCrmConfigMaxAggregate';
  crmCustomerId?: Maybe<Scalars['String']['output']>;
  crmStudioId?: Maybe<Scalars['String']['output']>;
  crmTenant?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
};

export type CustomerCrmConfigMinAggregate = {
  __typename: 'CustomerCrmConfigMinAggregate';
  crmCustomerId?: Maybe<Scalars['String']['output']>;
  crmStudioId?: Maybe<Scalars['String']['output']>;
  crmTenant?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
};

export type CustomerCrmConfigNullableRelationFilter = {
  is?: InputMaybe<CustomerCrmConfigWhereInput>;
  isNot?: InputMaybe<CustomerCrmConfigWhereInput>;
};

export type CustomerCrmConfigOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerCrmConfigOrderByWithRelationInput = {
  branchOfficeCrmConfig?: InputMaybe<BranchOfficeCrmConfigOrderByWithRelationInput>;
  companyCrmConfig?: InputMaybe<CompanyCrmConfigOrderByWithRelationInput>;
  crmCustomerId?: InputMaybe<SortOrder>;
  crmStudioId?: InputMaybe<SortOrder>;
  crmTenant?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
};

export enum CustomerCrmConfigScalarFieldEnum {
  CompanyId = 'companyId',
  CrmCustomerId = 'crmCustomerId',
  CrmStudioId = 'crmStudioId',
  CrmTenant = 'crmTenant',
  CustomerId = 'customerId'
}

/** Input for updating a customer crm config */
export type CustomerCrmConfigUpdateInput = {
  branchOfficeCrmConfig?: InputMaybe<BranchOfficeCrmConfigUpdateOneRequiredWithoutCustomerCrmConfigsNestedInput>;
  companyCrmConfig?: InputMaybe<CompanyCrmConfigUpdateOneRequiredWithoutCustomerCrmConfigsNestedInput>;
  crmCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCrmConfigUpdateOneWithoutCustomerNestedInput = {
  connect?: InputMaybe<CustomerCrmConfigWhereUniqueInput>;
  delete?: InputMaybe<CustomerCrmConfigWhereInput>;
  disconnect?: InputMaybe<CustomerCrmConfigWhereInput>;
};

export type CustomerCrmConfigWhereInput = {
  AND?: InputMaybe<Array<CustomerCrmConfigWhereInput>>;
  NOT?: InputMaybe<Array<CustomerCrmConfigWhereInput>>;
  OR?: InputMaybe<Array<CustomerCrmConfigWhereInput>>;
  branchOfficeCrmConfig?: InputMaybe<BranchOfficeCrmConfigRelationFilter>;
  companyCrmConfig?: InputMaybe<CompanyCrmConfigRelationFilter>;
  crmCustomerId?: InputMaybe<StringFilter>;
  crmStudioId?: InputMaybe<StringFilter>;
  crmTenant?: InputMaybe<StringFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
};

export type CustomerCrmConfigWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerCrmConfigWhereInput>>;
  NOT?: InputMaybe<Array<CustomerCrmConfigWhereInput>>;
  OR?: InputMaybe<Array<CustomerCrmConfigWhereInput>>;
  branchOfficeCrmConfig?: InputMaybe<BranchOfficeCrmConfigRelationFilter>;
  companyCrmConfig?: InputMaybe<CompanyCrmConfigRelationFilter>;
  companyIdCrmCustomerId?: InputMaybe<CustomerCrmConfigCompanyIdCrmCustomerIdCompoundUniqueInput>;
  crmCustomerId?: InputMaybe<StringFilter>;
  crmStudioId?: InputMaybe<StringFilter>;
  crmTenant?: InputMaybe<StringFilter>;
  crmTenantCrmCustomerId?: InputMaybe<CustomerCrmConfigCrmTenantCrmCustomerIdCompoundUniqueInput>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerEdge = {
  __typename: 'CustomerEdge';
  cursor: PaginatedCustomerCursor;
  node: Customer;
};

export type CustomerListRelationFilter = {
  every?: InputMaybe<CustomerWhereInput>;
  none?: InputMaybe<CustomerWhereInput>;
  some?: InputMaybe<CustomerWhereInput>;
};

/** Customer master data with amendment configuration status */
export type CustomerMasterData = {
  __typename: 'CustomerMasterData';
  /** Status of the amendment configuration */
  amendmentConfigurationStatus: AmendmentConfigurationStatus;
  /** Birth country of the customer (ISO 3166-1) */
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  /** Title of the customer */
  customerTitle: CustomerTitle;
  /** Birthday of the customer in YYYY-MM-DD format */
  dateOfBirth: Scalars['String']['output'];
  /** First name of the customer */
  firstName: Scalars['String']['output'];
  /** Gender of the customer */
  gender: Gender;
  /** Surname of the customer */
  lastName: Scalars['String']['output'];
  /** Pending amendment */
  pendingAmendment?: Maybe<MasterDataAmendment>;
};

export type CustomerMaxAggregate = {
  __typename: 'CustomerMaxAggregate';
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  pushToken?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerMinAggregate = {
  __typename: 'CustomerMinAggregate';
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  pushToken?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerNullableRelationFilter = {
  is?: InputMaybe<CustomerWhereInput>;
  isNot?: InputMaybe<CustomerWhereInput>;
};

export type CustomerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerOrderByWithRelationInput = {
  balances?: InputMaybe<BalanceOrderByRelationAggregateInput>;
  birthDate?: InputMaybe<SortOrderInput>;
  branchOfficeRatings?: InputMaybe<BranchOfficeRatingOrderByRelationAggregateInput>;
  challenges?: InputMaybe<CustomerChallengeOrderByRelationAggregateInput>;
  city?: InputMaybe<SortOrderInput>;
  classesBookings?: InputMaybe<CustomerClassBookingOrderByRelationAggregateInput>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  crmConfig?: InputMaybe<CustomerCrmConfigOrderByWithRelationInput>;
  defectReports?: InputMaybe<DefectReportOrderByRelationAggregateInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrderInput>;
  friendshipsInitiated?: InputMaybe<FriendshipOrderByRelationAggregateInput>;
  friendshipsReceived?: InputMaybe<FriendshipOrderByRelationAggregateInput>;
  houseNumber?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrderInput>;
  partnerChallenges?: InputMaybe<CustomerPartnerChallengeOrderByRelationAggregateInput>;
  partnerOrders?: InputMaybe<CustomerPartnerOrderOrderByRelationAggregateInput>;
  postalCode?: InputMaybe<SortOrderInput>;
  pushToken?: InputMaybe<SortOrderInput>;
  receivedFriendRequests?: InputMaybe<FriendRequestOrderByRelationAggregateInput>;
  receivedPoints?: InputMaybe<ReceivedPointOrderByRelationAggregateInput>;
  redeemedCoupons?: InputMaybe<RedeemedCouponOrderByRelationAggregateInput>;
  redeemedPartnerRewards?: InputMaybe<RedeemedPartnerRewardOrderByRelationAggregateInput>;
  redeemedPoints?: InputMaybe<RedeemedPointOrderByRelationAggregateInput>;
  referrals?: InputMaybe<CustomerReferralOrderByRelationAggregateInput>;
  sentFriendRequests?: InputMaybe<FriendRequestOrderByRelationAggregateInput>;
  state?: InputMaybe<SortOrderInput>;
  statistic?: InputMaybe<CustomerStatisticOrderByWithRelationInput>;
  street?: InputMaybe<SortOrderInput>;
  trainingPlans?: InputMaybe<TrainingPlanOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  workoutSessions?: InputMaybe<WorkoutSessionOrderByRelationAggregateInput>;
};

export type CustomerPartnerChallenge = {
  __typename: 'CustomerPartnerChallenge';
  _count: CustomerPartnerChallengeCount;
  activities?: Maybe<Array<CustomerPartnerChallengeActivity>>;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isFinished: Scalars['Boolean']['output'];
  isWinner: Scalars['Boolean']['output'];
  lastActivityDate?: Maybe<Scalars['DateTime']['output']>;
  partnerChallengePeriod: PartnerChallengePeriod;
  partnerChallengePeriodId: Scalars['UUID']['output'];
  progress: Scalars['Float']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  status: ChallengeStatus;
  totalDuration: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type CustomerPartnerChallengeActivitiesArgs = {
  cursor?: InputMaybe<CustomerPartnerChallengeActivityWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerPartnerChallengeActivityScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerPartnerChallengeActivityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerPartnerChallengeActivityWhereInput>;
};

export type CustomerPartnerChallengeActivity = {
  __typename: 'CustomerPartnerChallengeActivity';
  createdAt: Scalars['DateTime']['output'];
  customerPartnerChallenge: CustomerPartnerChallenge;
  customerPartnerChallengeId: Scalars['UUID']['output'];
  date: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type CustomerPartnerChallengeActivityAvgAggregate = {
  __typename: 'CustomerPartnerChallengeActivityAvgAggregate';
  duration?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CustomerPartnerChallengeActivityCountAggregate = {
  __typename: 'CustomerPartnerChallengeActivityCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerPartnerChallengeId: Scalars['Int']['output'];
  date: Scalars['Int']['output'];
  duration: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type CustomerPartnerChallengeActivityListRelationFilter = {
  every?: InputMaybe<CustomerPartnerChallengeActivityWhereInput>;
  none?: InputMaybe<CustomerPartnerChallengeActivityWhereInput>;
  some?: InputMaybe<CustomerPartnerChallengeActivityWhereInput>;
};

export type CustomerPartnerChallengeActivityMaxAggregate = {
  __typename: 'CustomerPartnerChallengeActivityMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerPartnerChallengeId?: Maybe<Scalars['UUID']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CustomerPartnerChallengeActivityMinAggregate = {
  __typename: 'CustomerPartnerChallengeActivityMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerPartnerChallengeId?: Maybe<Scalars['UUID']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CustomerPartnerChallengeActivityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerPartnerChallengeActivityOrderByWithRelationInput = {
  customerPartnerChallenge?: InputMaybe<CustomerPartnerChallengeOrderByWithRelationInput>;
  customerPartnerChallengeId?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export enum CustomerPartnerChallengeActivityScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerPartnerChallengeId = 'customerPartnerChallengeId',
  Date = 'date',
  Duration = 'duration',
  Id = 'id',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type CustomerPartnerChallengeActivitySumAggregate = {
  __typename: 'CustomerPartnerChallengeActivitySumAggregate';
  duration?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CustomerPartnerChallengeActivityWhereInput = {
  AND?: InputMaybe<Array<CustomerPartnerChallengeActivityWhereInput>>;
  NOT?: InputMaybe<Array<CustomerPartnerChallengeActivityWhereInput>>;
  OR?: InputMaybe<Array<CustomerPartnerChallengeActivityWhereInput>>;
  customerPartnerChallenge?: InputMaybe<CustomerPartnerChallengeRelationFilter>;
  customerPartnerChallengeId?: InputMaybe<UuidFilter>;
  date?: InputMaybe<DateTimeFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  value?: InputMaybe<FloatFilter>;
};

export type CustomerPartnerChallengeActivityWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerPartnerChallengeActivityWhereInput>>;
  NOT?: InputMaybe<Array<CustomerPartnerChallengeActivityWhereInput>>;
  OR?: InputMaybe<Array<CustomerPartnerChallengeActivityWhereInput>>;
  customerPartnerChallenge?: InputMaybe<CustomerPartnerChallengeRelationFilter>;
  customerPartnerChallengeId?: InputMaybe<UuidFilter>;
  date?: InputMaybe<DateTimeFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  value?: InputMaybe<FloatFilter>;
};

export type CustomerPartnerChallengeAvgAggregate = {
  __typename: 'CustomerPartnerChallengeAvgAggregate';
  progress?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  totalDuration?: Maybe<Scalars['Float']['output']>;
};

export type CustomerPartnerChallengeCount = {
  __typename: 'CustomerPartnerChallengeCount';
  activities: Scalars['Int']['output'];
};

export type CustomerPartnerChallengeCountAggregate = {
  __typename: 'CustomerPartnerChallengeCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  finishedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isFinished: Scalars['Int']['output'];
  isWinner: Scalars['Int']['output'];
  lastActivityDate: Scalars['Int']['output'];
  partnerChallengePeriodId: Scalars['Int']['output'];
  progress: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  totalDuration: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CustomerPartnerChallengeCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<CustomerPartnerChallengeWhereUniqueInput>>;
};

export type CustomerPartnerChallengeCreateNestedManyWithoutPartnerChallengePeriodInput = {
  connect?: InputMaybe<Array<CustomerPartnerChallengeWhereUniqueInput>>;
};

export type CustomerPartnerChallengeListRelationFilter = {
  every?: InputMaybe<CustomerPartnerChallengeWhereInput>;
  none?: InputMaybe<CustomerPartnerChallengeWhereInput>;
  some?: InputMaybe<CustomerPartnerChallengeWhereInput>;
};

export type CustomerPartnerChallengeMaxAggregate = {
  __typename: 'CustomerPartnerChallengeMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isFinished?: Maybe<Scalars['Boolean']['output']>;
  isWinner?: Maybe<Scalars['Boolean']['output']>;
  lastActivityDate?: Maybe<Scalars['DateTime']['output']>;
  partnerChallengePeriodId?: Maybe<Scalars['UUID']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ChallengeStatus>;
  totalDuration?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerPartnerChallengeMinAggregate = {
  __typename: 'CustomerPartnerChallengeMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isFinished?: Maybe<Scalars['Boolean']['output']>;
  isWinner?: Maybe<Scalars['Boolean']['output']>;
  lastActivityDate?: Maybe<Scalars['DateTime']['output']>;
  partnerChallengePeriodId?: Maybe<Scalars['UUID']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ChallengeStatus>;
  totalDuration?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerPartnerChallengeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerPartnerChallengeOrderByWithRelationInput = {
  activities?: InputMaybe<CustomerPartnerChallengeActivityOrderByRelationAggregateInput>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  finishedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isFinished?: InputMaybe<SortOrder>;
  isWinner?: InputMaybe<SortOrder>;
  lastActivityDate?: InputMaybe<SortOrderInput>;
  partnerChallengePeriod?: InputMaybe<PartnerChallengePeriodOrderByWithRelationInput>;
  partnerChallengePeriodId?: InputMaybe<SortOrder>;
  progress?: InputMaybe<SortOrder>;
  rank?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  totalDuration?: InputMaybe<SortOrder>;
};

export type CustomerPartnerChallengePartnerChallengePeriodIdCustomerIdCompoundUniqueInput = {
  customerId: Scalars['String']['input'];
  partnerChallengePeriodId: Scalars['UUID']['input'];
};

export type CustomerPartnerChallengeRelationFilter = {
  is?: InputMaybe<CustomerPartnerChallengeWhereInput>;
  isNot?: InputMaybe<CustomerPartnerChallengeWhereInput>;
};

export enum CustomerPartnerChallengeScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  FinishedAt = 'finishedAt',
  Id = 'id',
  IsFinished = 'isFinished',
  IsWinner = 'isWinner',
  LastActivityDate = 'lastActivityDate',
  PartnerChallengePeriodId = 'partnerChallengePeriodId',
  Progress = 'progress',
  Rank = 'rank',
  Status = 'status',
  TotalDuration = 'totalDuration',
  UpdatedAt = 'updatedAt'
}

export type CustomerPartnerChallengeScalarWhereInput = {
  AND?: InputMaybe<Array<CustomerPartnerChallengeScalarWhereInput>>;
  NOT?: InputMaybe<Array<CustomerPartnerChallengeScalarWhereInput>>;
  OR?: InputMaybe<Array<CustomerPartnerChallengeScalarWhereInput>>;
  customerId?: InputMaybe<StringFilter>;
  finishedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isFinished?: InputMaybe<BoolFilter>;
  isWinner?: InputMaybe<BoolFilter>;
  lastActivityDate?: InputMaybe<DateTimeNullableFilter>;
  partnerChallengePeriodId?: InputMaybe<UuidFilter>;
  progress?: InputMaybe<FloatFilter>;
  rank?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<EnumChallengeStatusFilter>;
  totalDuration?: InputMaybe<IntFilter>;
};

export type CustomerPartnerChallengeSumAggregate = {
  __typename: 'CustomerPartnerChallengeSumAggregate';
  progress?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  totalDuration?: Maybe<Scalars['Int']['output']>;
};

export type CustomerPartnerChallengeUpdateManyMutationInput = {
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isFinished?: InputMaybe<Scalars['Boolean']['input']>;
  isWinner?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityDate?: InputMaybe<Scalars['DateTime']['input']>;
  progress?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ChallengeStatus>;
  totalDuration?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerPartnerChallengeUpdateManyWithWhereWithoutCustomerInput = {
  data: CustomerPartnerChallengeUpdateManyMutationInput;
  where: CustomerPartnerChallengeScalarWhereInput;
};

export type CustomerPartnerChallengeUpdateManyWithWhereWithoutPartnerChallengePeriodInput = {
  data: CustomerPartnerChallengeUpdateManyMutationInput;
  where: CustomerPartnerChallengeScalarWhereInput;
};

export type CustomerPartnerChallengeUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CustomerPartnerChallengeWhereUniqueInput>>;
  delete?: InputMaybe<Array<CustomerPartnerChallengeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CustomerPartnerChallengeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CustomerPartnerChallengeWhereUniqueInput>>;
  set?: InputMaybe<Array<CustomerPartnerChallengeWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<CustomerPartnerChallengeUpdateManyWithWhereWithoutCustomerInput>>;
};

export type CustomerPartnerChallengeUpdateManyWithoutPartnerChallengePeriodNestedInput = {
  connect?: InputMaybe<Array<CustomerPartnerChallengeWhereUniqueInput>>;
  delete?: InputMaybe<Array<CustomerPartnerChallengeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CustomerPartnerChallengeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CustomerPartnerChallengeWhereUniqueInput>>;
  set?: InputMaybe<Array<CustomerPartnerChallengeWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<CustomerPartnerChallengeUpdateManyWithWhereWithoutPartnerChallengePeriodInput>>;
};

export type CustomerPartnerChallengeWhereInput = {
  AND?: InputMaybe<Array<CustomerPartnerChallengeWhereInput>>;
  NOT?: InputMaybe<Array<CustomerPartnerChallengeWhereInput>>;
  OR?: InputMaybe<Array<CustomerPartnerChallengeWhereInput>>;
  activities?: InputMaybe<CustomerPartnerChallengeActivityListRelationFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  finishedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isFinished?: InputMaybe<BoolFilter>;
  isWinner?: InputMaybe<BoolFilter>;
  lastActivityDate?: InputMaybe<DateTimeNullableFilter>;
  partnerChallengePeriod?: InputMaybe<PartnerChallengePeriodRelationFilter>;
  partnerChallengePeriodId?: InputMaybe<UuidFilter>;
  progress?: InputMaybe<FloatFilter>;
  rank?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<EnumChallengeStatusFilter>;
  totalDuration?: InputMaybe<IntFilter>;
};

export type CustomerPartnerChallengeWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerPartnerChallengeWhereInput>>;
  NOT?: InputMaybe<Array<CustomerPartnerChallengeWhereInput>>;
  OR?: InputMaybe<Array<CustomerPartnerChallengeWhereInput>>;
  activities?: InputMaybe<CustomerPartnerChallengeActivityListRelationFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  finishedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isFinished?: InputMaybe<BoolFilter>;
  isWinner?: InputMaybe<BoolFilter>;
  lastActivityDate?: InputMaybe<DateTimeNullableFilter>;
  partnerChallengePeriod?: InputMaybe<PartnerChallengePeriodRelationFilter>;
  partnerChallengePeriodId?: InputMaybe<UuidFilter>;
  partnerChallengePeriodId_customerId?: InputMaybe<CustomerPartnerChallengePartnerChallengePeriodIdCustomerIdCompoundUniqueInput>;
  progress?: InputMaybe<FloatFilter>;
  rank?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<EnumChallengeStatusFilter>;
  totalDuration?: InputMaybe<IntFilter>;
};

export type CustomerPartnerOrder = {
  __typename: 'CustomerPartnerOrder';
  customer: Customer;
  id: Scalars['UUID']['output'];
  /** The paid amount of the customer's order with discount */
  orderAmountPaid: Scalars['Float']['output'];
  /** The total amount of the customer's order from the partner (without discount) */
  orderAmountTotal: Scalars['Float']['output'];
  /** The received discount for the order */
  orderDiscount: Scalars['Float']['output'];
  redeemedPartnerReward: RedeemedPartnerReward;
  redeemedPartnerRewardId: Scalars['UUID']['output'];
};

export type CustomerPartnerOrderAvgAggregate = {
  __typename: 'CustomerPartnerOrderAvgAggregate';
  orderAmountPaid?: Maybe<Scalars['Float']['output']>;
  orderAmountTotal?: Maybe<Scalars['Float']['output']>;
  orderDiscount?: Maybe<Scalars['Float']['output']>;
};

export type CustomerPartnerOrderCountAggregate = {
  __typename: 'CustomerPartnerOrderCountAggregate';
  _all: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderAmountPaid: Scalars['Int']['output'];
  orderAmountTotal: Scalars['Int']['output'];
  orderDiscount: Scalars['Int']['output'];
  redeemedPartnerRewardId: Scalars['Int']['output'];
};

/** Input for creating a customer partner order */
export type CustomerPartnerOrderCreateInput = {
  /** The used discount code */
  discountCode: Scalars['String']['input'];
  orderAmountPaid?: InputMaybe<Scalars['Float']['input']>;
  orderAmountTotal?: InputMaybe<Scalars['Float']['input']>;
  orderDiscount?: InputMaybe<Scalars['Float']['input']>;
};

export type CustomerPartnerOrderCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<CustomerPartnerOrderWhereUniqueInput>>;
};

export type CustomerPartnerOrderListRelationFilter = {
  every?: InputMaybe<CustomerPartnerOrderWhereInput>;
  none?: InputMaybe<CustomerPartnerOrderWhereInput>;
  some?: InputMaybe<CustomerPartnerOrderWhereInput>;
};

export type CustomerPartnerOrderMaxAggregate = {
  __typename: 'CustomerPartnerOrderMaxAggregate';
  id?: Maybe<Scalars['UUID']['output']>;
  orderAmountPaid?: Maybe<Scalars['Float']['output']>;
  orderAmountTotal?: Maybe<Scalars['Float']['output']>;
  orderDiscount?: Maybe<Scalars['Float']['output']>;
  redeemedPartnerRewardId?: Maybe<Scalars['UUID']['output']>;
};

export type CustomerPartnerOrderMinAggregate = {
  __typename: 'CustomerPartnerOrderMinAggregate';
  id?: Maybe<Scalars['UUID']['output']>;
  orderAmountPaid?: Maybe<Scalars['Float']['output']>;
  orderAmountTotal?: Maybe<Scalars['Float']['output']>;
  orderDiscount?: Maybe<Scalars['Float']['output']>;
  redeemedPartnerRewardId?: Maybe<Scalars['UUID']['output']>;
};

export type CustomerPartnerOrderNullableRelationFilter = {
  is?: InputMaybe<CustomerPartnerOrderWhereInput>;
  isNot?: InputMaybe<CustomerPartnerOrderWhereInput>;
};

export type CustomerPartnerOrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerPartnerOrderOrderByWithRelationInput = {
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  id?: InputMaybe<SortOrder>;
  orderAmountPaid?: InputMaybe<SortOrder>;
  orderAmountTotal?: InputMaybe<SortOrder>;
  orderDiscount?: InputMaybe<SortOrder>;
  redeemedPartnerReward?: InputMaybe<RedeemedPartnerRewardOrderByWithRelationInput>;
};

export enum CustomerPartnerOrderScalarFieldEnum {
  CustomerId = 'customerId',
  Id = 'id',
  OrderAmountPaid = 'orderAmountPaid',
  OrderAmountTotal = 'orderAmountTotal',
  OrderDiscount = 'orderDiscount',
  RedeemedPartnerRewardId = 'redeemedPartnerRewardId'
}

export type CustomerPartnerOrderScalarWhereInput = {
  AND?: InputMaybe<Array<CustomerPartnerOrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<CustomerPartnerOrderScalarWhereInput>>;
  OR?: InputMaybe<Array<CustomerPartnerOrderScalarWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  orderAmountPaid?: InputMaybe<FloatFilter>;
  orderAmountTotal?: InputMaybe<FloatFilter>;
  orderDiscount?: InputMaybe<FloatFilter>;
};

export type CustomerPartnerOrderSumAggregate = {
  __typename: 'CustomerPartnerOrderSumAggregate';
  orderAmountPaid?: Maybe<Scalars['Float']['output']>;
  orderAmountTotal?: Maybe<Scalars['Float']['output']>;
  orderDiscount?: Maybe<Scalars['Float']['output']>;
};

export type CustomerPartnerOrderUpdateManyMutationInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  orderAmountPaid?: InputMaybe<Scalars['Float']['input']>;
  orderAmountTotal?: InputMaybe<Scalars['Float']['input']>;
  orderDiscount?: InputMaybe<Scalars['Float']['input']>;
};

export type CustomerPartnerOrderUpdateManyWithWhereWithoutCustomerInput = {
  data: CustomerPartnerOrderUpdateManyMutationInput;
  where: CustomerPartnerOrderScalarWhereInput;
};

export type CustomerPartnerOrderUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CustomerPartnerOrderWhereUniqueInput>>;
  delete?: InputMaybe<Array<CustomerPartnerOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CustomerPartnerOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CustomerPartnerOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<CustomerPartnerOrderWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<CustomerPartnerOrderUpdateManyWithWhereWithoutCustomerInput>>;
};

export type CustomerPartnerOrderWhereInput = {
  AND?: InputMaybe<Array<CustomerPartnerOrderWhereInput>>;
  NOT?: InputMaybe<Array<CustomerPartnerOrderWhereInput>>;
  OR?: InputMaybe<Array<CustomerPartnerOrderWhereInput>>;
  customer?: InputMaybe<CustomerRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  orderAmountPaid?: InputMaybe<FloatFilter>;
  orderAmountTotal?: InputMaybe<FloatFilter>;
  orderDiscount?: InputMaybe<FloatFilter>;
  redeemedPartnerReward?: InputMaybe<RedeemedPartnerRewardRelationFilter>;
};

export type CustomerPartnerOrderWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerPartnerOrderWhereInput>>;
  NOT?: InputMaybe<Array<CustomerPartnerOrderWhereInput>>;
  OR?: InputMaybe<Array<CustomerPartnerOrderWhereInput>>;
  customer?: InputMaybe<CustomerRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  orderAmountPaid?: InputMaybe<FloatFilter>;
  orderAmountTotal?: InputMaybe<FloatFilter>;
  orderDiscount?: InputMaybe<FloatFilter>;
  redeemedPartnerReward?: InputMaybe<RedeemedPartnerRewardRelationFilter>;
};

/** Customer payment data with amendment configuration status */
export type CustomerPaymentData = {
  __typename: 'CustomerPaymentData';
  /** The account holder of the bank account */
  accountHolder?: Maybe<Scalars['String']['output']>;
  /** Status of the amendment configuration */
  amendmentConfigurationStatus: AmendmentConfigurationStatus;
  /** Name of the bank */
  bankName?: Maybe<Scalars['String']['output']>;
  /** BIC of the client's account */
  bic?: Maybe<Scalars['String']['output']>;
  /** IBAN of the client's account */
  iban?: Maybe<Scalars['String']['output']>;
  /** Pending amendment */
  pendingAmendment?: Maybe<PaymentDataAmendment>;
  /** Is customer signature required to make amendment */
  requireSignature?: Maybe<Scalars['Boolean']['output']>;
};

/** The customer rank object */
export type CustomerRanking = {
  __typename: 'CustomerRanking';
  /** The customer ranking within the branch office */
  branchOffice: BranchOfficeRanking;
  /** The customer ranking within the company */
  company: CompanyRanking;
};

export type CustomerReferral = {
  __typename: 'CustomerReferral';
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** The birth date of the referred user */
  referredBirthDate: Scalars['DateTime']['output'];
  /** The email of the referred friend */
  referredEmail: Scalars['EmailAddress']['output'];
  /** The first name of the referred user */
  referredFirstName: Scalars['String']['output'];
  /** The last name of the referred user */
  referredLastName: Scalars['String']['output'];
  /** The ID of the studio the referred customer will be registered at */
  referredStudioId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerReferralCountAggregate = {
  __typename: 'CustomerReferralCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  referredBirthDate: Scalars['Int']['output'];
  referredEmail: Scalars['Int']['output'];
  referredFirstName: Scalars['Int']['output'];
  referredLastName: Scalars['Int']['output'];
  referredStudioId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating a customer referral */
export type CustomerReferralCreateInput = {
  /** Optionally, specify the customer for which the referral is to be created */
  customer?: InputMaybe<CustomerCreateNestedOneWithoutReferralsInput>;
  referredBirthDate: Scalars['DateTime']['input'];
  referredEmail: Scalars['EmailAddress']['input'];
  referredFirstName: Scalars['String']['input'];
  referredLastName: Scalars['String']['input'];
  referredStudioId: Scalars['String']['input'];
};

export type CustomerReferralCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<CustomerReferralWhereUniqueInput>>;
};

export type CustomerReferralListRelationFilter = {
  every?: InputMaybe<CustomerReferralWhereInput>;
  none?: InputMaybe<CustomerReferralWhereInput>;
  some?: InputMaybe<CustomerReferralWhereInput>;
};

export type CustomerReferralMaxAggregate = {
  __typename: 'CustomerReferralMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  referredBirthDate?: Maybe<Scalars['DateTime']['output']>;
  referredEmail?: Maybe<Scalars['EmailAddress']['output']>;
  referredFirstName?: Maybe<Scalars['String']['output']>;
  referredLastName?: Maybe<Scalars['String']['output']>;
  referredStudioId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerReferralMinAggregate = {
  __typename: 'CustomerReferralMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  referredBirthDate?: Maybe<Scalars['DateTime']['output']>;
  referredEmail?: Maybe<Scalars['EmailAddress']['output']>;
  referredFirstName?: Maybe<Scalars['String']['output']>;
  referredLastName?: Maybe<Scalars['String']['output']>;
  referredStudioId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerReferralOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomerReferralOrderByWithRelationInput = {
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  referredBirthDate?: InputMaybe<SortOrder>;
  referredEmail?: InputMaybe<SortOrder>;
  referredFirstName?: InputMaybe<SortOrder>;
  referredLastName?: InputMaybe<SortOrder>;
  referredStudioId?: InputMaybe<SortOrder>;
};

export type CustomerReferralReferredUserUniqueCompoundUniqueInput = {
  referredBirthDate: Scalars['DateTime']['input'];
  referredEmail: Scalars['EmailAddress']['input'];
  referredFirstName: Scalars['String']['input'];
  referredLastName: Scalars['String']['input'];
  referredStudioId: Scalars['String']['input'];
};

export enum CustomerReferralScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  ReferredBirthDate = 'referredBirthDate',
  ReferredEmail = 'referredEmail',
  ReferredFirstName = 'referredFirstName',
  ReferredLastName = 'referredLastName',
  ReferredStudioId = 'referredStudioId',
  UpdatedAt = 'updatedAt'
}

export type CustomerReferralScalarWhereInput = {
  AND?: InputMaybe<Array<CustomerReferralScalarWhereInput>>;
  NOT?: InputMaybe<Array<CustomerReferralScalarWhereInput>>;
  OR?: InputMaybe<Array<CustomerReferralScalarWhereInput>>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  referredBirthDate?: InputMaybe<DateTimeFilter>;
  referredEmail?: InputMaybe<StringFilter>;
  referredFirstName?: InputMaybe<StringFilter>;
  referredLastName?: InputMaybe<StringFilter>;
  referredStudioId?: InputMaybe<StringFilter>;
};

export type CustomerReferralUpdateManyMutationInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  referredBirthDate?: InputMaybe<Scalars['DateTime']['input']>;
  referredEmail?: InputMaybe<Scalars['EmailAddress']['input']>;
  referredFirstName?: InputMaybe<Scalars['String']['input']>;
  referredLastName?: InputMaybe<Scalars['String']['input']>;
  referredStudioId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerReferralUpdateManyWithWhereWithoutCustomerInput = {
  data: CustomerReferralUpdateManyMutationInput;
  where: CustomerReferralScalarWhereInput;
};

export type CustomerReferralUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CustomerReferralWhereUniqueInput>>;
  delete?: InputMaybe<Array<CustomerReferralWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CustomerReferralScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CustomerReferralWhereUniqueInput>>;
  set?: InputMaybe<Array<CustomerReferralWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<CustomerReferralUpdateManyWithWhereWithoutCustomerInput>>;
};

export type CustomerReferralWhereInput = {
  AND?: InputMaybe<Array<CustomerReferralWhereInput>>;
  NOT?: InputMaybe<Array<CustomerReferralWhereInput>>;
  OR?: InputMaybe<Array<CustomerReferralWhereInput>>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  referredBirthDate?: InputMaybe<DateTimeFilter>;
  referredEmail?: InputMaybe<StringFilter>;
  referredFirstName?: InputMaybe<StringFilter>;
  referredLastName?: InputMaybe<StringFilter>;
  referredStudioId?: InputMaybe<StringFilter>;
};

export type CustomerReferralWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerReferralWhereInput>>;
  NOT?: InputMaybe<Array<CustomerReferralWhereInput>>;
  OR?: InputMaybe<Array<CustomerReferralWhereInput>>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  referredBirthDate?: InputMaybe<DateTimeFilter>;
  referredEmail?: InputMaybe<Scalars['EmailAddress']['input']>;
  referredFirstName?: InputMaybe<StringFilter>;
  referredLastName?: InputMaybe<StringFilter>;
  referredStudioId?: InputMaybe<StringFilter>;
  referredUserUnique?: InputMaybe<CustomerReferralReferredUserUniqueCompoundUniqueInput>;
};

export type CustomerRelationFilter = {
  is?: InputMaybe<CustomerWhereInput>;
  isNot?: InputMaybe<CustomerWhereInput>;
};

export enum CustomerScalarFieldEnum {
  BirthDate = 'birthDate',
  City = 'city',
  CompanyId = 'companyId',
  CountryCode = 'countryCode',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Email = 'email',
  FirstName = 'firstName',
  HouseNumber = 'houseNumber',
  Id = 'id',
  LastName = 'lastName',
  PostalCode = 'postalCode',
  PushToken = 'pushToken',
  State = 'state',
  Street = 'street',
  UpdatedAt = 'updatedAt'
}

/** Possible states of customer */
export enum CustomerStateEnum {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type CustomerStatistic = {
  __typename: 'CustomerStatistic';
  challengePoints: Scalars['Int']['output'];
  couponPoints: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  referralPoints: Scalars['Int']['output'];
  savedMoney: Scalars['Float']['output'];
  totalPoints: Scalars['Int']['output'];
  trainingPoints: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerStatisticAvgAggregate = {
  __typename: 'CustomerStatisticAvgAggregate';
  challengePoints?: Maybe<Scalars['Float']['output']>;
  couponPoints?: Maybe<Scalars['Float']['output']>;
  referralPoints?: Maybe<Scalars['Float']['output']>;
  savedMoney?: Maybe<Scalars['Float']['output']>;
  totalPoints?: Maybe<Scalars['Float']['output']>;
  trainingPoints?: Maybe<Scalars['Float']['output']>;
};

export type CustomerStatisticCountAggregate = {
  __typename: 'CustomerStatisticCountAggregate';
  _all: Scalars['Int']['output'];
  challengePoints: Scalars['Int']['output'];
  couponPoints: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  referralPoints: Scalars['Int']['output'];
  savedMoney: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  trainingPoints: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CustomerStatisticCreateNestedOneWithoutCustomerInput = {
  connect?: InputMaybe<CustomerStatisticWhereUniqueInput>;
};

export type CustomerStatisticMaxAggregate = {
  __typename: 'CustomerStatisticMaxAggregate';
  challengePoints?: Maybe<Scalars['Int']['output']>;
  couponPoints?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  referralPoints?: Maybe<Scalars['Int']['output']>;
  savedMoney?: Maybe<Scalars['Float']['output']>;
  totalPoints?: Maybe<Scalars['Int']['output']>;
  trainingPoints?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerStatisticMinAggregate = {
  __typename: 'CustomerStatisticMinAggregate';
  challengePoints?: Maybe<Scalars['Int']['output']>;
  couponPoints?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  referralPoints?: Maybe<Scalars['Int']['output']>;
  savedMoney?: Maybe<Scalars['Float']['output']>;
  totalPoints?: Maybe<Scalars['Int']['output']>;
  trainingPoints?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerStatisticNullableRelationFilter = {
  is?: InputMaybe<CustomerStatisticWhereInput>;
  isNot?: InputMaybe<CustomerStatisticWhereInput>;
};

export type CustomerStatisticOrderByWithRelationInput = {
  challengePoints?: InputMaybe<SortOrder>;
  couponPoints?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  id?: InputMaybe<SortOrder>;
  referralPoints?: InputMaybe<SortOrder>;
  savedMoney?: InputMaybe<SortOrder>;
  totalPoints?: InputMaybe<SortOrder>;
  trainingPoints?: InputMaybe<SortOrder>;
};

export enum CustomerStatisticScalarFieldEnum {
  ChallengePoints = 'challengePoints',
  CompanyId = 'companyId',
  CouponPoints = 'couponPoints',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  ReferralPoints = 'referralPoints',
  SavedMoney = 'savedMoney',
  TotalPoints = 'totalPoints',
  TrainingPoints = 'trainingPoints',
  UpdatedAt = 'updatedAt'
}

export type CustomerStatisticSumAggregate = {
  __typename: 'CustomerStatisticSumAggregate';
  challengePoints?: Maybe<Scalars['Int']['output']>;
  couponPoints?: Maybe<Scalars['Int']['output']>;
  referralPoints?: Maybe<Scalars['Int']['output']>;
  savedMoney?: Maybe<Scalars['Float']['output']>;
  totalPoints?: Maybe<Scalars['Int']['output']>;
  trainingPoints?: Maybe<Scalars['Int']['output']>;
};

export type CustomerStatisticUpdateOneWithoutCustomerNestedInput = {
  connect?: InputMaybe<CustomerStatisticWhereUniqueInput>;
  delete?: InputMaybe<CustomerStatisticWhereInput>;
  disconnect?: InputMaybe<CustomerStatisticWhereInput>;
};

export type CustomerStatisticWhereInput = {
  AND?: InputMaybe<Array<CustomerStatisticWhereInput>>;
  NOT?: InputMaybe<Array<CustomerStatisticWhereInput>>;
  OR?: InputMaybe<Array<CustomerStatisticWhereInput>>;
  challengePoints?: InputMaybe<IntFilter>;
  couponPoints?: InputMaybe<IntFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  referralPoints?: InputMaybe<IntFilter>;
  savedMoney?: InputMaybe<FloatFilter>;
  totalPoints?: InputMaybe<IntFilter>;
  trainingPoints?: InputMaybe<IntFilter>;
};

export type CustomerStatisticWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerStatisticWhereInput>>;
  NOT?: InputMaybe<Array<CustomerStatisticWhereInput>>;
  OR?: InputMaybe<Array<CustomerStatisticWhereInput>>;
  challengePoints?: InputMaybe<IntFilter>;
  couponPoints?: InputMaybe<IntFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  referralPoints?: InputMaybe<IntFilter>;
  savedMoney?: InputMaybe<FloatFilter>;
  totalPoints?: InputMaybe<IntFilter>;
  trainingPoints?: InputMaybe<IntFilter>;
};

export enum CustomerTitle {
  Dr = 'DR',
  None = 'NONE',
  Prof = 'PROF'
}

export type CustomerTopRanking = {
  __typename: 'CustomerTopRanking';
  email: Scalars['EmailAddress']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  receivedPointsTotal: Scalars['Float']['output'];
  redeemedPointsTotal: Scalars['Float']['output'];
};

/** Information about customers training overview */
export type CustomerTrainingOverview = {
  __typename: 'CustomerTrainingOverview';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Information about customers series */
export type CustomerTrainingSeries = {
  __typename: 'CustomerTrainingSeries';
  trainingsCount?: Maybe<Scalars['Float']['output']>;
  weekCount?: Maybe<Scalars['Float']['output']>;
};

export type CustomerTransactionPaginationInput = {
  /** Offset from last request */
  offset?: InputMaybe<Scalars['String']['input']>;
  /** Desired size of data chunk. [ 10 .. 50 ]. Defaults to 10 */
  sliceSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Slice of booking entries */
export type CustomerTransactionResult = {
  __typename: 'CustomerTransactionResult';
  /** True if there exists next data slice */
  hasNext: Scalars['Boolean']['output'];
  /** Offset for next query (last ID of the booking entry) */
  offset: Scalars['String']['output'];
  /** List of booking entries */
  result: Array<BookingEntry>;
};

export type CustomerUpdateInput = {
  balances?: InputMaybe<BalanceUpdateManyWithoutCustomerNestedInput>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  branchOfficeRatings?: InputMaybe<BranchOfficeRatingUpdateManyWithoutCustomerNestedInput>;
  challenges?: InputMaybe<CustomerChallengeUpdateManyWithoutCustomerNestedInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  classesBookings?: InputMaybe<CustomerClassBookingUpdateManyWithoutCustomerNestedInput>;
  company?: InputMaybe<CompanyUpdateOneRequiredWithoutCustomersNestedInput>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  crmConfig?: InputMaybe<CustomerCrmConfigUpdateOneWithoutCustomerNestedInput>;
  defectReports?: InputMaybe<DefectReportUpdateManyWithoutReporterNestedInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  friendshipsInitiated?: InputMaybe<FriendshipUpdateManyWithoutParticipantANestedInput>;
  friendshipsReceived?: InputMaybe<FriendshipUpdateManyWithoutParticipantBNestedInput>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  partnerChallenges?: InputMaybe<CustomerPartnerChallengeUpdateManyWithoutCustomerNestedInput>;
  partnerOrders?: InputMaybe<CustomerPartnerOrderUpdateManyWithoutCustomerNestedInput>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  receivedFriendRequests?: InputMaybe<FriendRequestUpdateManyWithoutReceiverNestedInput>;
  receivedPoints?: InputMaybe<ReceivedPointUpdateManyWithoutCustomerNestedInput>;
  redeemedCoupons?: InputMaybe<RedeemedCouponUpdateManyWithoutCustomerNestedInput>;
  redeemedPartnerRewards?: InputMaybe<RedeemedPartnerRewardUpdateManyWithoutCustomerNestedInput>;
  redeemedPoints?: InputMaybe<RedeemedPointUpdateManyWithoutCustomerNestedInput>;
  referrals?: InputMaybe<CustomerReferralUpdateManyWithoutCustomerNestedInput>;
  sentFriendRequests?: InputMaybe<FriendRequestUpdateManyWithoutSenderNestedInput>;
  state?: InputMaybe<Scalars['String']['input']>;
  statistic?: InputMaybe<CustomerStatisticUpdateOneWithoutCustomerNestedInput>;
  street?: InputMaybe<Scalars['String']['input']>;
  trainingPlans?: InputMaybe<TrainingPlanUpdateManyWithoutCustomerNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workoutSessions?: InputMaybe<WorkoutSessionUpdateManyWithoutCustomerNestedInput>;
};

export type CustomerUpdateOneRequiredWithoutReceivedPointsNestedInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
};

export type CustomerUpdateOneRequiredWithoutRedeemedPointsNestedInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
};

export type CustomerUpdateOneRequiredWithoutWorkoutSessionsNestedInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
};

export type CustomerWhereInput = {
  AND?: InputMaybe<Array<CustomerWhereInput>>;
  NOT?: InputMaybe<Array<CustomerWhereInput>>;
  OR?: InputMaybe<Array<CustomerWhereInput>>;
  balances?: InputMaybe<BalanceListRelationFilter>;
  birthDate?: InputMaybe<DateTimeNullableFilter>;
  branchOfficeRatings?: InputMaybe<BranchOfficeRatingListRelationFilter>;
  challenges?: InputMaybe<CustomerChallengeListRelationFilter>;
  city?: InputMaybe<StringNullableFilter>;
  classesBookings?: InputMaybe<CustomerClassBookingListRelationFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  countryCode?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  crmConfig?: InputMaybe<CustomerCrmConfigNullableRelationFilter>;
  defectReports?: InputMaybe<DefectReportListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  friendshipsInitiated?: InputMaybe<FriendshipListRelationFilter>;
  friendshipsReceived?: InputMaybe<FriendshipListRelationFilter>;
  houseNumber?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  partnerChallenges?: InputMaybe<CustomerPartnerChallengeListRelationFilter>;
  partnerOrders?: InputMaybe<CustomerPartnerOrderListRelationFilter>;
  postalCode?: InputMaybe<StringNullableFilter>;
  pushToken?: InputMaybe<StringNullableFilter>;
  receivedFriendRequests?: InputMaybe<FriendRequestListRelationFilter>;
  receivedPoints?: InputMaybe<ReceivedPointListRelationFilter>;
  redeemedCoupons?: InputMaybe<RedeemedCouponListRelationFilter>;
  redeemedPartnerRewards?: InputMaybe<RedeemedPartnerRewardListRelationFilter>;
  redeemedPoints?: InputMaybe<RedeemedPointListRelationFilter>;
  referrals?: InputMaybe<CustomerReferralListRelationFilter>;
  sentFriendRequests?: InputMaybe<FriendRequestListRelationFilter>;
  state?: InputMaybe<StringNullableFilter>;
  statistic?: InputMaybe<CustomerStatisticNullableRelationFilter>;
  street?: InputMaybe<StringNullableFilter>;
  trainingPlans?: InputMaybe<TrainingPlanListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workoutSessions?: InputMaybe<WorkoutSessionListRelationFilter>;
};

export type CustomerWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerWhereInput>>;
  NOT?: InputMaybe<Array<CustomerWhereInput>>;
  OR?: InputMaybe<Array<CustomerWhereInput>>;
  balances?: InputMaybe<BalanceListRelationFilter>;
  birthDate?: InputMaybe<DateTimeNullableFilter>;
  branchOfficeRatings?: InputMaybe<BranchOfficeRatingListRelationFilter>;
  challenges?: InputMaybe<CustomerChallengeListRelationFilter>;
  city?: InputMaybe<StringNullableFilter>;
  classesBookings?: InputMaybe<CustomerClassBookingListRelationFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  companyScopedEmail?: InputMaybe<CustomerCompanyScopedEmailCompoundUniqueInput>;
  countryCode?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  crmConfig?: InputMaybe<CustomerCrmConfigNullableRelationFilter>;
  defectReports?: InputMaybe<DefectReportListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  friendshipsInitiated?: InputMaybe<FriendshipListRelationFilter>;
  friendshipsReceived?: InputMaybe<FriendshipListRelationFilter>;
  houseNumber?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<StringNullableFilter>;
  partnerChallenges?: InputMaybe<CustomerPartnerChallengeListRelationFilter>;
  partnerOrders?: InputMaybe<CustomerPartnerOrderListRelationFilter>;
  postalCode?: InputMaybe<StringNullableFilter>;
  pushToken?: InputMaybe<StringNullableFilter>;
  receivedFriendRequests?: InputMaybe<FriendRequestListRelationFilter>;
  receivedPoints?: InputMaybe<ReceivedPointListRelationFilter>;
  redeemedCoupons?: InputMaybe<RedeemedCouponListRelationFilter>;
  redeemedPartnerRewards?: InputMaybe<RedeemedPartnerRewardListRelationFilter>;
  redeemedPoints?: InputMaybe<RedeemedPointListRelationFilter>;
  referrals?: InputMaybe<CustomerReferralListRelationFilter>;
  sentFriendRequests?: InputMaybe<FriendRequestListRelationFilter>;
  state?: InputMaybe<StringNullableFilter>;
  statistic?: InputMaybe<CustomerStatisticNullableRelationFilter>;
  street?: InputMaybe<StringNullableFilter>;
  trainingPlans?: InputMaybe<TrainingPlanListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workoutSessions?: InputMaybe<WorkoutSessionListRelationFilter>;
};

export type DateGroupedCount = {
  __typename: 'DateGroupedCount';
  count: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type DecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

/** Specifies which type of defect a user has reported. */
export enum DefectCategory {
  BrokenParts = 'BROKEN_PARTS',
  Electrical = 'ELECTRICAL',
  Hygiene = 'HYGIENE',
  LooseParts = 'LOOSE_PARTS',
  Mechanical = 'MECHANICAL',
  Noise = 'NOISE',
  Other = 'OTHER',
  Software = 'SOFTWARE'
}

export type DefectReport = {
  __typename: 'DefectReport';
  category: DefectCategory;
  createdAt: Scalars['DateTime']['output'];
  equipment: Equipment;
  equipmentId: Scalars['String']['output'];
  fixedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  reporter?: Maybe<Customer>;
  reporterId?: Maybe<Scalars['String']['output']>;
};

export type DefectReportCountAggregate = {
  __typename: 'DefectReportCountAggregate';
  _all: Scalars['Int']['output'];
  category: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  equipmentId: Scalars['Int']['output'];
  fixedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['Int']['output'];
  reporterId: Scalars['Int']['output'];
};

export type DefectReportCreateInput = {
  category: DefectCategory;
  equipment: EquipmentCreateNestedOneWithoutDefectReportsInput;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type DefectReportCreateNestedManyWithoutEquipmentInput = {
  connect?: InputMaybe<Array<DefectReportWhereUniqueInput>>;
};

export type DefectReportCreateNestedManyWithoutReporterInput = {
  connect?: InputMaybe<Array<DefectReportWhereUniqueInput>>;
};

export type DefectReportListRelationFilter = {
  every?: InputMaybe<DefectReportWhereInput>;
  none?: InputMaybe<DefectReportWhereInput>;
  some?: InputMaybe<DefectReportWhereInput>;
};

export type DefectReportMaxAggregate = {
  __typename: 'DefectReportMaxAggregate';
  category?: Maybe<DefectCategory>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  equipmentId?: Maybe<Scalars['String']['output']>;
  fixedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  reporterId?: Maybe<Scalars['String']['output']>;
};

export type DefectReportMinAggregate = {
  __typename: 'DefectReportMinAggregate';
  category?: Maybe<DefectCategory>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  equipmentId?: Maybe<Scalars['String']['output']>;
  fixedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  reporterId?: Maybe<Scalars['String']['output']>;
};

export type DefectReportOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DefectReportOrderByWithRelationInput = {
  category?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  equipment?: InputMaybe<EquipmentOrderByWithRelationInput>;
  equipmentId?: InputMaybe<SortOrder>;
  fixedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrderInput>;
  reporter?: InputMaybe<CustomerOrderByWithRelationInput>;
  reporterId?: InputMaybe<SortOrderInput>;
};

export enum DefectReportScalarFieldEnum {
  Category = 'category',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  EquipmentId = 'equipmentId',
  FixedAt = 'fixedAt',
  Id = 'id',
  Message = 'message',
  ReporterId = 'reporterId'
}

export type DefectReportScalarWhereInput = {
  AND?: InputMaybe<Array<DefectReportScalarWhereInput>>;
  NOT?: InputMaybe<Array<DefectReportScalarWhereInput>>;
  OR?: InputMaybe<Array<DefectReportScalarWhereInput>>;
  category?: InputMaybe<EnumDefectCategoryFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  equipmentId?: InputMaybe<UuidFilter>;
  fixedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  message?: InputMaybe<StringNullableFilter>;
  reporterId?: InputMaybe<StringNullableFilter>;
};

export type DefectReportUpdateManyMutationInput = {
  category?: InputMaybe<DefectCategory>;
  fixedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type DefectReportUpdateManyWithWhereWithoutEquipmentInput = {
  data: DefectReportUpdateManyMutationInput;
  where: DefectReportScalarWhereInput;
};

export type DefectReportUpdateManyWithWhereWithoutReporterInput = {
  data: DefectReportUpdateManyMutationInput;
  where: DefectReportScalarWhereInput;
};

export type DefectReportUpdateManyWithoutEquipmentNestedInput = {
  connect?: InputMaybe<Array<DefectReportWhereUniqueInput>>;
  delete?: InputMaybe<Array<DefectReportWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DefectReportScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DefectReportWhereUniqueInput>>;
  set?: InputMaybe<Array<DefectReportWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<DefectReportUpdateManyWithWhereWithoutEquipmentInput>>;
};

export type DefectReportUpdateManyWithoutReporterNestedInput = {
  connect?: InputMaybe<Array<DefectReportWhereUniqueInput>>;
  delete?: InputMaybe<Array<DefectReportWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DefectReportScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DefectReportWhereUniqueInput>>;
  set?: InputMaybe<Array<DefectReportWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<DefectReportUpdateManyWithWhereWithoutReporterInput>>;
};

export type DefectReportWhereInput = {
  AND?: InputMaybe<Array<DefectReportWhereInput>>;
  NOT?: InputMaybe<Array<DefectReportWhereInput>>;
  OR?: InputMaybe<Array<DefectReportWhereInput>>;
  category?: InputMaybe<EnumDefectCategoryFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  equipment?: InputMaybe<EquipmentRelationFilter>;
  equipmentId?: InputMaybe<UuidFilter>;
  fixedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  message?: InputMaybe<StringNullableFilter>;
  reporter?: InputMaybe<CustomerNullableRelationFilter>;
  reporterId?: InputMaybe<StringNullableFilter>;
};

export type DefectReportWhereUniqueInput = {
  AND?: InputMaybe<Array<DefectReportWhereInput>>;
  NOT?: InputMaybe<Array<DefectReportWhereInput>>;
  OR?: InputMaybe<Array<DefectReportWhereInput>>;
  category?: InputMaybe<EnumDefectCategoryFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  equipment?: InputMaybe<EquipmentRelationFilter>;
  equipmentId?: InputMaybe<UuidFilter>;
  fixedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<StringNullableFilter>;
  reporter?: InputMaybe<CustomerNullableRelationFilter>;
  reporterId?: InputMaybe<StringNullableFilter>;
};

export enum Direction {
  Entry = 'ENTRY',
  Exit = 'EXIT'
}

/** Input for disable challenges */
export type DisableChallengeInput = {
  /** Only needs to be set to finally disable a passive points challenge */
  finalDisable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisablePartnerChallengeInput = {
  /** The ID of the period that is ending. */
  periodId: Scalars['ID']['input'];
};

export type Employee = {
  __typename: 'Employee';
  _count: EmployeeCount;
  company: Company;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['EmailAddress']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invitationAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  status: EmployeeStatus;
  statusHistory?: Maybe<Array<StatusHistory>>;
  updatedAt: Scalars['DateTime']['output'];
  userType: CompanyUserType;
};

export type EmployeeCount = {
  __typename: 'EmployeeCount';
  statusHistory: Scalars['Int']['output'];
};

export type EmployeeCountAggregate = {
  __typename: 'EmployeeCountAggregate';
  _all: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  invitationAcceptedAt: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userType: Scalars['Int']['output'];
};

export type EmployeeEmployeeIdentifierCompoundUniqueInput = {
  companyId: Scalars['String']['input'];
  email: Scalars['EmailAddress']['input'];
};

/** Input of employee identifier with optional field companyId */
export type EmployeeIdentifierInput = {
  /** The ID of the company the employee is member of */
  companyId?: InputMaybe<Scalars['String']['input']>;
  /** The EMail address of the employee to be delted */
  email: Scalars['EmailAddress']['input'];
};

export type EmployeeListRelationFilter = {
  every?: InputMaybe<EmployeeWhereInput>;
  none?: InputMaybe<EmployeeWhereInput>;
  some?: InputMaybe<EmployeeWhereInput>;
};

export type EmployeeMaxAggregate = {
  __typename: 'EmployeeMaxAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invitationAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EmployeeStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<CompanyUserType>;
};

export type EmployeeMinAggregate = {
  __typename: 'EmployeeMinAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invitationAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EmployeeStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<CompanyUserType>;
};

export type EmployeeNullableRelationFilter = {
  is?: InputMaybe<EmployeeWhereInput>;
  isNot?: InputMaybe<EmployeeWhereInput>;
};

export type EmployeeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EmployeeOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrderInput>;
  lastName?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  statusHistory?: InputMaybe<StatusHistoryOrderByRelationAggregateInput>;
  userType?: InputMaybe<SortOrder>;
};

export enum EmployeeScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  InvitationAcceptedAt = 'invitationAcceptedAt',
  LastName = 'lastName',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UserType = 'userType'
}

export enum EmployeeStatus {
  Invited = 'INVITED',
  Registered = 'REGISTERED'
}

/** Unique input to identify an employee */
export type EmployeeUniqueInput = {
  /** The unique combination of email address and company id */
  employeeIdentifier: EmployeeEmployeeIdentifierCompoundUniqueInput;
};

export type EmployeeUpdateOneWithoutStatusHistoryNestedInput = {
  connect?: InputMaybe<EmployeeWhereUniqueInput>;
  delete?: InputMaybe<EmployeeWhereInput>;
  disconnect?: InputMaybe<EmployeeWhereInput>;
};

export type EmployeeWhereInput = {
  AND?: InputMaybe<Array<EmployeeWhereInput>>;
  NOT?: InputMaybe<Array<EmployeeWhereInput>>;
  OR?: InputMaybe<Array<EmployeeWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringNullableFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumEmployeeStatusFilter>;
  statusHistory?: InputMaybe<StatusHistoryListRelationFilter>;
  userType?: InputMaybe<EnumCompanyUserTypeFilter>;
};

export type EmployeeWhereUniqueInput = {
  AND?: InputMaybe<Array<EmployeeWhereInput>>;
  NOT?: InputMaybe<Array<EmployeeWhereInput>>;
  OR?: InputMaybe<Array<EmployeeWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  employeeIdentifier?: InputMaybe<EmployeeEmployeeIdentifierCompoundUniqueInput>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumEmployeeStatusFilter>;
  statusHistory?: InputMaybe<StatusHistoryListRelationFilter>;
  userType?: InputMaybe<EnumCompanyUserTypeFilter>;
};

export type EnumChallengeStatusFilter = {
  equals?: InputMaybe<ChallengeStatus>;
  in?: InputMaybe<Array<ChallengeStatus>>;
  not?: InputMaybe<NestedEnumChallengeStatusFilter>;
  notIn?: InputMaybe<Array<ChallengeStatus>>;
};

export type EnumChallengeTypeFilter = {
  equals?: InputMaybe<ChallengeType>;
  in?: InputMaybe<Array<ChallengeType>>;
  not?: InputMaybe<NestedEnumChallengeTypeFilter>;
  notIn?: InputMaybe<Array<ChallengeType>>;
};

export type EnumCompanyUserTypeFilter = {
  equals?: InputMaybe<CompanyUserType>;
  in?: InputMaybe<Array<CompanyUserType>>;
  not?: InputMaybe<NestedEnumCompanyUserTypeFilter>;
  notIn?: InputMaybe<Array<CompanyUserType>>;
};

export type EnumCouponStatusFilter = {
  equals?: InputMaybe<CouponStatus>;
  in?: InputMaybe<Array<CouponStatus>>;
  not?: InputMaybe<NestedEnumCouponStatusFilter>;
  notIn?: InputMaybe<Array<CouponStatus>>;
};

export type EnumCouponTypeFilter = {
  equals?: InputMaybe<CouponType>;
  in?: InputMaybe<Array<CouponType>>;
  not?: InputMaybe<NestedEnumCouponTypeFilter>;
  notIn?: InputMaybe<Array<CouponType>>;
};

export type EnumCronIntervalNullableFilter = {
  equals?: InputMaybe<CronInterval>;
  in?: InputMaybe<Array<CronInterval>>;
  not?: InputMaybe<NestedEnumCronIntervalNullableFilter>;
  notIn?: InputMaybe<Array<CronInterval>>;
};

export type EnumDefectCategoryFilter = {
  equals?: InputMaybe<DefectCategory>;
  in?: InputMaybe<Array<DefectCategory>>;
  not?: InputMaybe<NestedEnumDefectCategoryFilter>;
  notIn?: InputMaybe<Array<DefectCategory>>;
};

export type EnumEmployeeStatusFilter = {
  equals?: InputMaybe<EmployeeStatus>;
  in?: InputMaybe<Array<EmployeeStatus>>;
  not?: InputMaybe<NestedEnumEmployeeStatusFilter>;
  notIn?: InputMaybe<Array<EmployeeStatus>>;
};

export type EnumEquipmentStatusFilter = {
  equals?: InputMaybe<EquipmentStatus>;
  in?: InputMaybe<Array<EquipmentStatus>>;
  not?: InputMaybe<NestedEnumEquipmentStatusFilter>;
  notIn?: InputMaybe<Array<EquipmentStatus>>;
};

export type EnumEquipmentTypeFilter = {
  equals?: InputMaybe<EquipmentType>;
  in?: InputMaybe<Array<EquipmentType>>;
  not?: InputMaybe<NestedEnumEquipmentTypeFilter>;
  notIn?: InputMaybe<Array<EquipmentType>>;
};

export type EnumFriendRequestStatusFilter = {
  equals?: InputMaybe<FriendRequestStatus>;
  in?: InputMaybe<Array<FriendRequestStatus>>;
  not?: InputMaybe<NestedEnumFriendRequestStatusFilter>;
  notIn?: InputMaybe<Array<FriendRequestStatus>>;
};

export type EnumIntegrationTypeFilter = {
  equals?: InputMaybe<IntegrationType>;
  in?: InputMaybe<Array<IntegrationType>>;
  not?: InputMaybe<NestedEnumIntegrationTypeFilter>;
  notIn?: InputMaybe<Array<IntegrationType>>;
};

export type EnumLevelConditionTypeFilter = {
  equals?: InputMaybe<LevelConditionType>;
  in?: InputMaybe<Array<LevelConditionType>>;
  not?: InputMaybe<NestedEnumLevelConditionTypeFilter>;
  notIn?: InputMaybe<Array<LevelConditionType>>;
};

export type EnumMobileAppVariantFilter = {
  equals?: InputMaybe<MobileAppVariant>;
  in?: InputMaybe<Array<MobileAppVariant>>;
  not?: InputMaybe<NestedEnumMobileAppVariantFilter>;
  notIn?: InputMaybe<Array<MobileAppVariant>>;
};

export type EnumMuscleGroupFilter = {
  equals?: InputMaybe<MuscleGroup>;
  in?: InputMaybe<Array<MuscleGroup>>;
  not?: InputMaybe<NestedEnumMuscleGroupFilter>;
  notIn?: InputMaybe<Array<MuscleGroup>>;
};

export type EnumPartnerChallengeActivityTypeFilter = {
  equals?: InputMaybe<PartnerChallengeActivityType>;
  in?: InputMaybe<Array<PartnerChallengeActivityType>>;
  not?: InputMaybe<NestedEnumPartnerChallengeActivityTypeFilter>;
  notIn?: InputMaybe<Array<PartnerChallengeActivityType>>;
};

export type EnumPartnerChallengeTypeFilter = {
  equals?: InputMaybe<PartnerChallengeType>;
  in?: InputMaybe<Array<PartnerChallengeType>>;
  not?: InputMaybe<NestedEnumPartnerChallengeTypeFilter>;
  notIn?: InputMaybe<Array<PartnerChallengeType>>;
};

export type EnumPartnerChallengeVerificationTypeFilter = {
  equals?: InputMaybe<PartnerChallengeVerificationType>;
  in?: InputMaybe<Array<PartnerChallengeVerificationType>>;
  not?: InputMaybe<NestedEnumPartnerChallengeVerificationTypeFilter>;
  notIn?: InputMaybe<Array<PartnerChallengeVerificationType>>;
};

export type EnumPartnerOfferTypeFilter = {
  equals?: InputMaybe<PartnerOfferType>;
  in?: InputMaybe<Array<PartnerOfferType>>;
  not?: InputMaybe<NestedEnumPartnerOfferTypeFilter>;
  notIn?: InputMaybe<Array<PartnerOfferType>>;
};

export type EnumPushNotificationSendTypeFilter = {
  equals?: InputMaybe<PushNotificationSendType>;
  in?: InputMaybe<Array<PushNotificationSendType>>;
  not?: InputMaybe<NestedEnumPushNotificationSendTypeFilter>;
  notIn?: InputMaybe<Array<PushNotificationSendType>>;
};

export type EnumPushNotificationStatusFilter = {
  equals?: InputMaybe<PushNotificationStatus>;
  in?: InputMaybe<Array<PushNotificationStatus>>;
  not?: InputMaybe<NestedEnumPushNotificationStatusFilter>;
  notIn?: InputMaybe<Array<PushNotificationStatus>>;
};

export type EnumReceivedPointSourceTypeFilter = {
  equals?: InputMaybe<ReceivedPointSourceType>;
  in?: InputMaybe<Array<ReceivedPointSourceType>>;
  not?: InputMaybe<NestedEnumReceivedPointSourceTypeFilter>;
  notIn?: InputMaybe<Array<ReceivedPointSourceType>>;
};

export type EnumShopTypeFilter = {
  equals?: InputMaybe<ShopType>;
  in?: InputMaybe<Array<ShopType>>;
  not?: InputMaybe<NestedEnumShopTypeFilter>;
  notIn?: InputMaybe<Array<ShopType>>;
};

export type EnumSystemTypeFilter = {
  equals?: InputMaybe<SystemType>;
  in?: InputMaybe<Array<SystemType>>;
  not?: InputMaybe<NestedEnumSystemTypeFilter>;
  notIn?: InputMaybe<Array<SystemType>>;
};

export type EnumTransmissionMethodFilter = {
  equals?: InputMaybe<TransmissionMethod>;
  in?: InputMaybe<Array<TransmissionMethod>>;
  not?: InputMaybe<NestedEnumTransmissionMethodFilter>;
  notIn?: InputMaybe<Array<TransmissionMethod>>;
};

export type EnumTransmissionMethodNullableFilter = {
  equals?: InputMaybe<TransmissionMethod>;
  in?: InputMaybe<Array<TransmissionMethod>>;
  not?: InputMaybe<NestedEnumTransmissionMethodNullableFilter>;
  notIn?: InputMaybe<Array<TransmissionMethod>>;
};

export type Equipment = {
  __typename: 'Equipment';
  _count: EquipmentCount;
  branchOffice: BranchOffice;
  branchOfficeId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  defectReports?: Maybe<Array<DefectReport>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastDefectAt?: Maybe<Scalars['DateTime']['output']>;
  manufacturer: Scalars['String']['output'];
  name: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
  status: EquipmentStatus;
  statusHistory?: Maybe<Array<StatusHistory>>;
  type: EquipmentType;
  updatedAt: Scalars['DateTime']['output'];
};


export type EquipmentStatusHistoryArgs = {
  orderBy?: InputMaybe<Array<StatusHistoryOrderByWithRelationInput>>;
};

export type EquipmentCount = {
  __typename: 'EquipmentCount';
  defectReports: Scalars['Int']['output'];
  statusHistory: Scalars['Int']['output'];
};

export type EquipmentCountAggregate = {
  __typename: 'EquipmentCountAggregate';
  _all: Scalars['Int']['output'];
  branchOfficeId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['Int']['output'];
  lastDefectAt: Scalars['Int']['output'];
  manufacturer: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  serialNumber: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for equipment creation */
export type EquipmentCreateInput = {
  branchOffice: BranchOfficeCreateNestedOneWithoutEquipmentsInput;
  defectReports?: InputMaybe<DefectReportCreateNestedManyWithoutEquipmentInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Configure the equipment image by uploading an image or specify and image URL */
  image?: InputMaybe<EquipmentImageInput>;
  lastDefectAt?: InputMaybe<Scalars['DateTime']['input']>;
  manufacturer: Scalars['String']['input'];
  name: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  status: EquipmentStatus;
  statusHistory?: InputMaybe<StatusHistoryCreateNestedManyWithoutEquipmentInput>;
  type: EquipmentType;
};

export type EquipmentCreateNestedManyWithoutBranchOfficeInput = {
  connect?: InputMaybe<Array<EquipmentWhereUniqueInput>>;
};

export type EquipmentCreateNestedOneWithoutDefectReportsInput = {
  connect: EquipmentWhereUniqueInput;
};

export type EquipmentEdge = {
  __typename: 'EquipmentEdge';
  cursor: PaginatedEquipmentCursor;
  node: Equipment;
};

/** Input for the equipment image */
export type EquipmentImageInput = {
  /** Upload a new equipment image */
  fileUpload?: InputMaybe<Scalars['Upload']['input']>;
  /** The URL of an image */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type EquipmentListRelationFilter = {
  every?: InputMaybe<EquipmentWhereInput>;
  none?: InputMaybe<EquipmentWhereInput>;
  some?: InputMaybe<EquipmentWhereInput>;
};

export type EquipmentMaxAggregate = {
  __typename: 'EquipmentMaxAggregate';
  branchOfficeId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastDefectAt?: Maybe<Scalars['DateTime']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EquipmentStatus>;
  type?: Maybe<EquipmentType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EquipmentMinAggregate = {
  __typename: 'EquipmentMinAggregate';
  branchOfficeId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastDefectAt?: Maybe<Scalars['DateTime']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EquipmentStatus>;
  type?: Maybe<EquipmentType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EquipmentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EquipmentOrderByWithRelationInput = {
  branchOffice?: InputMaybe<BranchOfficeOrderByWithRelationInput>;
  branchOfficeId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defectReports?: InputMaybe<DefectReportOrderByRelationAggregateInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  lastDefectAt?: InputMaybe<SortOrderInput>;
  manufacturer?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  statusHistory?: InputMaybe<StatusHistoryOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
};

export type EquipmentRelationFilter = {
  is?: InputMaybe<EquipmentWhereInput>;
  isNot?: InputMaybe<EquipmentWhereInput>;
};

export enum EquipmentScalarFieldEnum {
  BranchOfficeId = 'branchOfficeId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  ImageUrl = 'imageUrl',
  LastDefectAt = 'lastDefectAt',
  Manufacturer = 'manufacturer',
  Name = 'name',
  SerialNumber = 'serialNumber',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type EquipmentScalarWhereInput = {
  AND?: InputMaybe<Array<EquipmentScalarWhereInput>>;
  NOT?: InputMaybe<Array<EquipmentScalarWhereInput>>;
  OR?: InputMaybe<Array<EquipmentScalarWhereInput>>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  lastDefectAt?: InputMaybe<DateTimeNullableFilter>;
  manufacturer?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  serialNumber?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumEquipmentStatusFilter>;
  type?: InputMaybe<EnumEquipmentTypeFilter>;
};

/** Describes the status of each studio equipment. */
export enum EquipmentStatus {
  Defect = 'DEFECT',
  InMaintenance = 'IN_MAINTENANCE',
  Ok = 'OK'
}

export type EquipmentStatusChangeInput = {
  branchOffice?: InputMaybe<BranchOfficeUpdateOneRequiredWithoutEquipmentsNestedInput>;
  changedBy?: InputMaybe<EmployeeUpdateOneWithoutStatusHistoryNestedInput>;
  comment: Scalars['String']['input'];
  defectReports?: InputMaybe<DefectReportUpdateManyWithoutEquipmentNestedInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  equipment?: InputMaybe<EquipmentUpdateOneRequiredWithoutStatusHistoryNestedInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  lastDefectAt?: InputMaybe<Scalars['DateTime']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newStatus?: InputMaybe<EquipmentStatus>;
  oldStatus?: InputMaybe<EquipmentStatus>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  status: EquipmentStatus;
  statusHistory?: InputMaybe<StatusHistoryUpdateManyWithoutEquipmentNestedInput>;
  type?: InputMaybe<EquipmentType>;
};

/** The available types of studio equipment. */
export enum EquipmentType {
  Accessory = 'ACCESSORY',
  Cardio = 'CARDIO',
  FreeWeight = 'FREE_WEIGHT',
  Functional = 'FUNCTIONAL',
  Other = 'OTHER',
  StrengthMachine = 'STRENGTH_MACHINE'
}

export type EquipmentUpdateInput = {
  branchOffice?: InputMaybe<BranchOfficeUpdateOneRequiredWithoutEquipmentsNestedInput>;
  defectReports?: InputMaybe<DefectReportUpdateManyWithoutEquipmentNestedInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  lastDefectAt?: InputMaybe<Scalars['DateTime']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EquipmentStatus>;
  statusHistory?: InputMaybe<StatusHistoryUpdateManyWithoutEquipmentNestedInput>;
  type?: InputMaybe<EquipmentType>;
};

export type EquipmentUpdateManyMutationInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  lastDefectAt?: InputMaybe<Scalars['DateTime']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EquipmentStatus>;
  type?: InputMaybe<EquipmentType>;
};

export type EquipmentUpdateManyWithWhereWithoutBranchOfficeInput = {
  data: EquipmentUpdateManyMutationInput;
  where: EquipmentScalarWhereInput;
};

export type EquipmentUpdateManyWithoutBranchOfficeNestedInput = {
  connect?: InputMaybe<Array<EquipmentWhereUniqueInput>>;
  delete?: InputMaybe<Array<EquipmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EquipmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EquipmentWhereUniqueInput>>;
  set?: InputMaybe<Array<EquipmentWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<EquipmentUpdateManyWithWhereWithoutBranchOfficeInput>>;
};

export type EquipmentUpdateOneRequiredWithoutStatusHistoryNestedInput = {
  connect?: InputMaybe<EquipmentWhereUniqueInput>;
};

export type EquipmentWhereInput = {
  AND?: InputMaybe<Array<EquipmentWhereInput>>;
  NOT?: InputMaybe<Array<EquipmentWhereInput>>;
  OR?: InputMaybe<Array<EquipmentWhereInput>>;
  branchOffice?: InputMaybe<BranchOfficeRelationFilter>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defectReports?: InputMaybe<DefectReportListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  lastDefectAt?: InputMaybe<DateTimeNullableFilter>;
  manufacturer?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  serialNumber?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumEquipmentStatusFilter>;
  statusHistory?: InputMaybe<StatusHistoryListRelationFilter>;
  type?: InputMaybe<EnumEquipmentTypeFilter>;
};

export type EquipmentWhereUniqueInput = {
  AND?: InputMaybe<Array<EquipmentWhereInput>>;
  NOT?: InputMaybe<Array<EquipmentWhereInput>>;
  OR?: InputMaybe<Array<EquipmentWhereInput>>;
  branchOffice?: InputMaybe<BranchOfficeRelationFilter>;
  branchOfficeId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defectReports?: InputMaybe<DefectReportListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  lastDefectAt?: InputMaybe<DateTimeNullableFilter>;
  manufacturer?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  serialNumber?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumEquipmentStatusFilter>;
  statusHistory?: InputMaybe<StatusHistoryListRelationFilter>;
  type?: InputMaybe<EnumEquipmentTypeFilter>;
};

export type Exercise = {
  __typename: 'Exercise';
  _count: ExerciseCount;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  muscleGroup: MuscleGroup;
  planExercises?: Maybe<Array<TrainingPlanExercise>>;
  translations?: Maybe<Array<ExerciseTranslation>>;
  updatedAt: Scalars['DateTime']['output'];
  workoutSets?: Maybe<Array<WorkoutSet>>;
};

export type ExerciseCount = {
  __typename: 'ExerciseCount';
  planExercises: Scalars['Int']['output'];
  translations: Scalars['Int']['output'];
  workoutSets: Scalars['Int']['output'];
};

export type ExerciseCountAggregate = {
  __typename: 'ExerciseCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['Int']['output'];
  muscleGroup: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ExerciseCreateNestedOneWithoutWorkoutSetsInput = {
  connect?: InputMaybe<ExerciseWhereUniqueInput>;
};

export type ExerciseMaxAggregate = {
  __typename: 'ExerciseMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  muscleGroup?: Maybe<MuscleGroup>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ExerciseMinAggregate = {
  __typename: 'ExerciseMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  muscleGroup?: Maybe<MuscleGroup>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ExerciseOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  muscleGroup?: InputMaybe<SortOrder>;
  planExercises?: InputMaybe<TrainingPlanExerciseOrderByRelationAggregateInput>;
  translations?: InputMaybe<ExerciseTranslationOrderByRelationAggregateInput>;
  workoutSets?: InputMaybe<WorkoutSetOrderByRelationAggregateInput>;
};

export type ExerciseRelationFilter = {
  is?: InputMaybe<ExerciseWhereInput>;
  isNot?: InputMaybe<ExerciseWhereInput>;
};

export enum ExerciseScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  ImageUrl = 'imageUrl',
  MuscleGroup = 'muscleGroup',
  UpdatedAt = 'updatedAt'
}

export type ExerciseTranslation = {
  __typename: 'ExerciseTranslation';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  exercise: Exercise;
  exerciseId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ExerciseTranslationCountAggregate = {
  __typename: 'ExerciseTranslationCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  exerciseId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ExerciseTranslationListRelationFilter = {
  every?: InputMaybe<ExerciseTranslationWhereInput>;
  none?: InputMaybe<ExerciseTranslationWhereInput>;
  some?: InputMaybe<ExerciseTranslationWhereInput>;
};

export type ExerciseTranslationMaxAggregate = {
  __typename: 'ExerciseTranslationMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exerciseId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ExerciseTranslationMinAggregate = {
  __typename: 'ExerciseTranslationMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exerciseId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ExerciseTranslationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ExerciseTranslationWhereInput = {
  AND?: InputMaybe<Array<ExerciseTranslationWhereInput>>;
  NOT?: InputMaybe<Array<ExerciseTranslationWhereInput>>;
  OR?: InputMaybe<Array<ExerciseTranslationWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  exercise?: InputMaybe<ExerciseRelationFilter>;
  exerciseId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  language?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ExerciseUpdateOneRequiredWithoutWorkoutSetsNestedInput = {
  connect?: InputMaybe<ExerciseWhereUniqueInput>;
};

export type ExerciseWhereInput = {
  AND?: InputMaybe<Array<ExerciseWhereInput>>;
  NOT?: InputMaybe<Array<ExerciseWhereInput>>;
  OR?: InputMaybe<Array<ExerciseWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  muscleGroup?: InputMaybe<EnumMuscleGroupFilter>;
  planExercises?: InputMaybe<TrainingPlanExerciseListRelationFilter>;
  translations?: InputMaybe<ExerciseTranslationListRelationFilter>;
  workoutSets?: InputMaybe<WorkoutSetListRelationFilter>;
};

export type ExerciseWhereUniqueInput = {
  AND?: InputMaybe<Array<ExerciseWhereInput>>;
  NOT?: InputMaybe<Array<ExerciseWhereInput>>;
  OR?: InputMaybe<Array<ExerciseWhereInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  muscleGroup?: InputMaybe<EnumMuscleGroupFilter>;
  planExercises?: InputMaybe<TrainingPlanExerciseListRelationFilter>;
  translations?: InputMaybe<ExerciseTranslationListRelationFilter>;
  workoutSets?: InputMaybe<WorkoutSetListRelationFilter>;
};

/** Represents an additional module extension */
export type Extension = {
  __typename: 'Extension';
  /** Cancelation period for the extension if applicable */
  extensionCancelationPeriod?: Maybe<Term>;
  /** Extension type */
  extensionType: ExtensionType;
  /** Term for the extension if applicable */
  termExtension?: Maybe<Term>;
};

/** Represents the type of an extension (NEW or TERM_EXTENSION) */
export enum ExtensionType {
  New = 'NEW',
  TermExtension = 'TERM_EXTENSION'
}

export type Fee = {
  __typename: 'Fee';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type Friend = {
  __typename: 'Friend';
  email: Scalars['EmailAddress']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  receivedPoints?: Maybe<Array<FriendReceivedPoint>>;
  redeemedPoints?: Maybe<Array<FriendRedeemedPoint>>;
  statistic?: Maybe<FriendStatistic>;
};

export type FriendReceivedPoint = {
  __typename: 'FriendReceivedPoint';
  count?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  friend: Friend;
  id: Scalars['UUID']['output'];
  sourceType: ReceivedPointSourceType;
  updatedAt: Scalars['DateTime']['output'];
};

export type FriendRedeemedPoint = {
  __typename: 'FriendRedeemedPoint';
  createdAt: Scalars['DateTime']['output'];
  friend: Friend;
  id: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FriendRequest = {
  __typename: 'FriendRequest';
  /** Timestamp when the friend request was created. */
  createdAt: Scalars['DateTime']['output'];
  friendship?: Maybe<Friendship>;
  id: Scalars['UUID']['output'];
  receiver: Customer;
  /** Email address of the receiver at the time of request. */
  receiverEmail: Scalars['EmailAddress']['output'];
  /** ID of the customer who received the friend request. */
  receiverId: Scalars['String']['output'];
  sender: Customer;
  /** Email address of the sender at the time of request. */
  senderEmail: Scalars['EmailAddress']['output'];
  /** ID of the customer who sent the friend request. */
  senderId: Scalars['String']['output'];
  /** Current status of the friend request (PENDING, ACCEPTED, DECLINED). */
  status: FriendRequestStatus;
  /** Timestamp when the friend request was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type FriendRequestCountAggregate = {
  __typename: 'FriendRequestCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  receiverEmail: Scalars['Int']['output'];
  receiverId: Scalars['Int']['output'];
  senderEmail: Scalars['Int']['output'];
  senderId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type FriendRequestCreateNestedManyWithoutReceiverInput = {
  connect?: InputMaybe<Array<FriendRequestWhereUniqueInput>>;
};

export type FriendRequestCreateNestedManyWithoutSenderInput = {
  connect?: InputMaybe<Array<FriendRequestWhereUniqueInput>>;
};

export type FriendRequestListRelationFilter = {
  every?: InputMaybe<FriendRequestWhereInput>;
  none?: InputMaybe<FriendRequestWhereInput>;
  some?: InputMaybe<FriendRequestWhereInput>;
};

export type FriendRequestMaxAggregate = {
  __typename: 'FriendRequestMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  receiverEmail?: Maybe<Scalars['EmailAddress']['output']>;
  receiverId?: Maybe<Scalars['String']['output']>;
  senderEmail?: Maybe<Scalars['EmailAddress']['output']>;
  senderId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FriendRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FriendRequestMinAggregate = {
  __typename: 'FriendRequestMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  receiverEmail?: Maybe<Scalars['EmailAddress']['output']>;
  receiverId?: Maybe<Scalars['String']['output']>;
  senderEmail?: Maybe<Scalars['EmailAddress']['output']>;
  senderId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FriendRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FriendRequestOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FriendRequestOrderByWithRelationInput = {
  friendship?: InputMaybe<FriendshipOrderByWithRelationInput>;
  id?: InputMaybe<SortOrder>;
  receiver?: InputMaybe<CustomerOrderByWithRelationInput>;
  receiverEmail?: InputMaybe<SortOrder>;
  receiverId?: InputMaybe<SortOrder>;
  sender?: InputMaybe<CustomerOrderByWithRelationInput>;
  senderEmail?: InputMaybe<SortOrder>;
  senderId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type FriendRequestRelationFilter = {
  is?: InputMaybe<FriendRequestWhereInput>;
  isNot?: InputMaybe<FriendRequestWhereInput>;
};

export enum FriendRequestScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  ReceiverEmail = 'receiverEmail',
  ReceiverId = 'receiverId',
  SenderEmail = 'senderEmail',
  SenderId = 'senderId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type FriendRequestScalarWhereInput = {
  AND?: InputMaybe<Array<FriendRequestScalarWhereInput>>;
  NOT?: InputMaybe<Array<FriendRequestScalarWhereInput>>;
  OR?: InputMaybe<Array<FriendRequestScalarWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  receiverEmail?: InputMaybe<StringFilter>;
  receiverId?: InputMaybe<StringFilter>;
  senderEmail?: InputMaybe<StringFilter>;
  senderId?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumFriendRequestStatusFilter>;
};

export enum FriendRequestStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type FriendRequestUpdateManyMutationInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  receiverEmail?: InputMaybe<Scalars['EmailAddress']['input']>;
  senderEmail?: InputMaybe<Scalars['EmailAddress']['input']>;
  status?: InputMaybe<FriendRequestStatus>;
};

export type FriendRequestUpdateManyWithWhereWithoutReceiverInput = {
  data: FriendRequestUpdateManyMutationInput;
  where: FriendRequestScalarWhereInput;
};

export type FriendRequestUpdateManyWithWhereWithoutSenderInput = {
  data: FriendRequestUpdateManyMutationInput;
  where: FriendRequestScalarWhereInput;
};

export type FriendRequestUpdateManyWithoutReceiverNestedInput = {
  connect?: InputMaybe<Array<FriendRequestWhereUniqueInput>>;
  delete?: InputMaybe<Array<FriendRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FriendRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FriendRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<FriendRequestWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<FriendRequestUpdateManyWithWhereWithoutReceiverInput>>;
};

export type FriendRequestUpdateManyWithoutSenderNestedInput = {
  connect?: InputMaybe<Array<FriendRequestWhereUniqueInput>>;
  delete?: InputMaybe<Array<FriendRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FriendRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FriendRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<FriendRequestWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<FriendRequestUpdateManyWithWhereWithoutSenderInput>>;
};

export type FriendRequestWhereInput = {
  AND?: InputMaybe<Array<FriendRequestWhereInput>>;
  NOT?: InputMaybe<Array<FriendRequestWhereInput>>;
  OR?: InputMaybe<Array<FriendRequestWhereInput>>;
  friendship?: InputMaybe<FriendshipNullableRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  receiver?: InputMaybe<CustomerRelationFilter>;
  receiverEmail?: InputMaybe<StringFilter>;
  receiverId?: InputMaybe<StringFilter>;
  sender?: InputMaybe<CustomerRelationFilter>;
  senderEmail?: InputMaybe<StringFilter>;
  senderId?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumFriendRequestStatusFilter>;
};

export type FriendRequestWhereUniqueInput = {
  AND?: InputMaybe<Array<FriendRequestWhereInput>>;
  NOT?: InputMaybe<Array<FriendRequestWhereInput>>;
  OR?: InputMaybe<Array<FriendRequestWhereInput>>;
  friendship?: InputMaybe<FriendshipNullableRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  receiver?: InputMaybe<CustomerRelationFilter>;
  receiverEmail?: InputMaybe<StringFilter>;
  receiverId?: InputMaybe<StringFilter>;
  sender?: InputMaybe<CustomerRelationFilter>;
  senderEmail?: InputMaybe<StringFilter>;
  senderId?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumFriendRequestStatusFilter>;
};

export type FriendStatistic = {
  __typename: 'FriendStatistic';
  challengePoints: Scalars['Int']['output'];
  couponPoints: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  friend: Friend;
  id: Scalars['UUID']['output'];
  savedMoney: Scalars['Float']['output'];
  totalPoints: Scalars['Int']['output'];
  trainingPoints: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Friendship = {
  __typename: 'Friendship';
  /** Timestamp when the friendship was created. */
  createdAt: Scalars['DateTime']['output'];
  friend: Friend;
  friendRequest: FriendRequest;
  /** ID of the friend request that initiated this friendship. */
  friendRequestId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  participantA: Customer;
  /** ID of the first participant in the friendship (sorted lexicographically). */
  participantAId: Scalars['String']['output'];
  participantB: Customer;
  /** ID of the second participant in the friendship (sorted lexicographically). */
  participantBId: Scalars['String']['output'];
  /** Timestamp when the friendship was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type FriendshipCountAggregate = {
  __typename: 'FriendshipCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  friendRequestId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  participantAId: Scalars['Int']['output'];
  participantBId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type FriendshipCreateNestedManyWithoutParticipantAInput = {
  connect?: InputMaybe<Array<FriendshipWhereUniqueInput>>;
};

export type FriendshipCreateNestedManyWithoutParticipantBInput = {
  connect?: InputMaybe<Array<FriendshipWhereUniqueInput>>;
};

export type FriendshipListRelationFilter = {
  every?: InputMaybe<FriendshipWhereInput>;
  none?: InputMaybe<FriendshipWhereInput>;
  some?: InputMaybe<FriendshipWhereInput>;
};

export type FriendshipMaxAggregate = {
  __typename: 'FriendshipMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  friendRequestId?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  participantAId?: Maybe<Scalars['String']['output']>;
  participantBId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FriendshipMinAggregate = {
  __typename: 'FriendshipMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  friendRequestId?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  participantAId?: Maybe<Scalars['String']['output']>;
  participantBId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FriendshipNullableRelationFilter = {
  is?: InputMaybe<FriendshipWhereInput>;
  isNot?: InputMaybe<FriendshipWhereInput>;
};

export type FriendshipOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FriendshipOrderByWithRelationInput = {
  friendRequest?: InputMaybe<FriendRequestOrderByWithRelationInput>;
  friendRequestId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  participantA?: InputMaybe<CustomerOrderByWithRelationInput>;
  participantAId?: InputMaybe<SortOrder>;
  participantB?: InputMaybe<CustomerOrderByWithRelationInput>;
  participantBId?: InputMaybe<SortOrder>;
};

export enum FriendshipScalarFieldEnum {
  CreatedAt = 'createdAt',
  FriendRequestId = 'friendRequestId',
  Id = 'id',
  ParticipantAId = 'participantAId',
  ParticipantBId = 'participantBId',
  UpdatedAt = 'updatedAt'
}

export type FriendshipScalarWhereInput = {
  AND?: InputMaybe<Array<FriendshipScalarWhereInput>>;
  NOT?: InputMaybe<Array<FriendshipScalarWhereInput>>;
  OR?: InputMaybe<Array<FriendshipScalarWhereInput>>;
  friendRequestId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  participantAId?: InputMaybe<StringFilter>;
  participantBId?: InputMaybe<StringFilter>;
};

export type FriendshipUniqueFriendshipBetweenUsersCompoundUniqueInput = {
  participantAId: Scalars['String']['input'];
  participantBId: Scalars['String']['input'];
};

export type FriendshipUpdateManyMutationInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type FriendshipUpdateManyWithWhereWithoutParticipantAInput = {
  data: FriendshipUpdateManyMutationInput;
  where: FriendshipScalarWhereInput;
};

export type FriendshipUpdateManyWithWhereWithoutParticipantBInput = {
  data: FriendshipUpdateManyMutationInput;
  where: FriendshipScalarWhereInput;
};

export type FriendshipUpdateManyWithoutParticipantANestedInput = {
  connect?: InputMaybe<Array<FriendshipWhereUniqueInput>>;
  delete?: InputMaybe<Array<FriendshipWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FriendshipScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FriendshipWhereUniqueInput>>;
  set?: InputMaybe<Array<FriendshipWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<FriendshipUpdateManyWithWhereWithoutParticipantAInput>>;
};

export type FriendshipUpdateManyWithoutParticipantBNestedInput = {
  connect?: InputMaybe<Array<FriendshipWhereUniqueInput>>;
  delete?: InputMaybe<Array<FriendshipWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FriendshipScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FriendshipWhereUniqueInput>>;
  set?: InputMaybe<Array<FriendshipWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<FriendshipUpdateManyWithWhereWithoutParticipantBInput>>;
};

export type FriendshipWhereInput = {
  AND?: InputMaybe<Array<FriendshipWhereInput>>;
  NOT?: InputMaybe<Array<FriendshipWhereInput>>;
  OR?: InputMaybe<Array<FriendshipWhereInput>>;
  friendRequest?: InputMaybe<FriendRequestRelationFilter>;
  friendRequestId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  participantA?: InputMaybe<CustomerRelationFilter>;
  participantAId?: InputMaybe<StringFilter>;
  participantB?: InputMaybe<CustomerRelationFilter>;
  participantBId?: InputMaybe<StringFilter>;
};

export type FriendshipWhereUniqueInput = {
  AND?: InputMaybe<Array<FriendshipWhereInput>>;
  NOT?: InputMaybe<Array<FriendshipWhereInput>>;
  OR?: InputMaybe<Array<FriendshipWhereInput>>;
  friendRequest?: InputMaybe<FriendRequestRelationFilter>;
  friendRequestId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  participantA?: InputMaybe<CustomerRelationFilter>;
  participantAId?: InputMaybe<StringFilter>;
  participantB?: InputMaybe<CustomerRelationFilter>;
  participantBId?: InputMaybe<StringFilter>;
  uniqueFriendshipBetweenUsers?: InputMaybe<FriendshipUniqueFriendshipBetweenUsersCompoundUniqueInput>;
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Unisex = 'UNISEX'
}

export type Gym = {
  __typename: 'Gym';
  accessDevices: Array<GymAccessDevice>;
  /** The name of the gym */
  name: Scalars['String']['output'];
};

export type GymAccessDevice = {
  __typename: 'GymAccessDevice';
  /** Access device can open entry */
  canOpenEntry: Scalars['Boolean']['output'];
  /** Access device can open exit */
  canOpenExit: Scalars['Boolean']['output'];
  /** The unique identfier of the access device */
  id: Scalars['String']['output'];
};

export type IdlePeriodsEntity = {
  __typename: 'IdlePeriodsEntity';
  documentUrl: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  fee: Fee;
  id: Scalars['Float']['output'];
  reason: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

/** Input for setting an image */
export type ImageInput = {
  /** A new file upload */
  fileUpload?: InputMaybe<Scalars['Upload']['input']>;
  /** The URL of an image */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ImageTemplate = {
  __typename: 'ImageTemplate';
  _count: ImageTemplateCount;
  coupons?: Maybe<Array<Coupon>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  imageKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rewards?: Maybe<Array<Reward>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ImageTemplateCount = {
  __typename: 'ImageTemplateCount';
  coupons: Scalars['Int']['output'];
  rewards: Scalars['Int']['output'];
};

export type ImageTemplateCountAggregate = {
  __typename: 'ImageTemplateCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageKey: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ImageTemplateCreateInput = {
  coupons?: InputMaybe<CouponCreateNestedManyWithoutImageTemplateInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  rewards?: InputMaybe<RewardCreateNestedManyWithoutImageTemplateInput>;
};

export type ImageTemplateCreateNestedOneWithoutCouponsInput = {
  connect?: InputMaybe<ImageTemplateWhereUniqueInput>;
};

export type ImageTemplateCreateNestedOneWithoutRewardsInput = {
  connect?: InputMaybe<ImageTemplateWhereUniqueInput>;
};

export type ImageTemplateMaxAggregate = {
  __typename: 'ImageTemplateMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageKey?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ImageTemplateMinAggregate = {
  __typename: 'ImageTemplateMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageKey?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ImageTemplateNullableRelationFilter = {
  is?: InputMaybe<ImageTemplateWhereInput>;
  isNot?: InputMaybe<ImageTemplateWhereInput>;
};

export type ImageTemplateOrderByWithRelationInput = {
  coupons?: InputMaybe<CouponOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  imageKey?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  rewards?: InputMaybe<RewardOrderByRelationAggregateInput>;
};

export enum ImageTemplateScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  ImageKey = 'imageKey',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type ImageTemplateUpdateInput = {
  coupons?: InputMaybe<CouponUpdateManyWithoutImageTemplateNestedInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageKey?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<RewardUpdateManyWithoutImageTemplateNestedInput>;
};

export type ImageTemplateUpdateOneWithoutCouponsNestedInput = {
  connect?: InputMaybe<ImageTemplateWhereUniqueInput>;
  delete?: InputMaybe<ImageTemplateWhereInput>;
  disconnect?: InputMaybe<ImageTemplateWhereInput>;
};

export type ImageTemplateUpdateOneWithoutRewardsNestedInput = {
  connect?: InputMaybe<ImageTemplateWhereUniqueInput>;
  delete?: InputMaybe<ImageTemplateWhereInput>;
  disconnect?: InputMaybe<ImageTemplateWhereInput>;
};

export type ImageTemplateWhereInput = {
  AND?: InputMaybe<Array<ImageTemplateWhereInput>>;
  NOT?: InputMaybe<Array<ImageTemplateWhereInput>>;
  OR?: InputMaybe<Array<ImageTemplateWhereInput>>;
  coupons?: InputMaybe<CouponListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  imageKey?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  rewards?: InputMaybe<RewardListRelationFilter>;
};

export type ImageTemplateWhereUniqueInput = {
  AND?: InputMaybe<Array<ImageTemplateWhereInput>>;
  NOT?: InputMaybe<Array<ImageTemplateWhereInput>>;
  OR?: InputMaybe<Array<ImageTemplateWhereInput>>;
  coupons?: InputMaybe<CouponListRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageKey?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  rewards?: InputMaybe<RewardListRelationFilter>;
};

/** Basic instructor information */
export type Instructor = {
  __typename: 'Instructor';
  /** Instructor's first name */
  firstName: Scalars['String']['output'];
  /** Unique ID of the instructor */
  id: Scalars['Int']['output'];
  /** Instructor's last name */
  lastName: Scalars['String']['output'];
  /** Public name shown to customers */
  publicName?: Maybe<Scalars['String']['output']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Specifies how the company integrates with our platform. */
export enum IntegrationType {
  Crm = 'CRM',
  QrCode = 'QR_CODE'
}

export type Level = {
  __typename: 'Level';
  _count: LevelCount;
  company: Company;
  companyId: Scalars['String']['output'];
  conditions?: Maybe<Array<LevelCondition>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LevelAvgAggregate = {
  __typename: 'LevelAvgAggregate';
  order?: Maybe<Scalars['Float']['output']>;
};

export type LevelCompanyOrderCompoundUniqueInput = {
  order: Scalars['Int']['input'];
};

export type LevelCondition = {
  __typename: 'LevelCondition';
  id: Scalars['UUID']['output'];
  level: Level;
  levelId: Scalars['UUID']['output'];
  type: LevelConditionType;
  value: Scalars['Int']['output'];
};

export type LevelConditionAvgAggregate = {
  __typename: 'LevelConditionAvgAggregate';
  value?: Maybe<Scalars['Float']['output']>;
};

export type LevelConditionCountAggregate = {
  __typename: 'LevelConditionCountAggregate';
  _all: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  levelId: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type LevelConditionCreateInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  level: LevelCreateNestedOneWithoutConditionsInput;
  type?: InputMaybe<LevelConditionType>;
  value: Scalars['Int']['input'];
};

export type LevelConditionCreateManyInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  levelId: Scalars['UUID']['input'];
  type?: InputMaybe<LevelConditionType>;
  value: Scalars['Int']['input'];
};

export type LevelConditionCreateManyLevelInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<LevelConditionType>;
  value: Scalars['Int']['input'];
};

export type LevelConditionListRelationFilter = {
  every?: InputMaybe<LevelConditionWhereInput>;
  none?: InputMaybe<LevelConditionWhereInput>;
  some?: InputMaybe<LevelConditionWhereInput>;
};

export type LevelConditionMaxAggregate = {
  __typename: 'LevelConditionMaxAggregate';
  id?: Maybe<Scalars['UUID']['output']>;
  levelId?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<LevelConditionType>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type LevelConditionMinAggregate = {
  __typename: 'LevelConditionMinAggregate';
  id?: Maybe<Scalars['UUID']['output']>;
  levelId?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<LevelConditionType>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type LevelConditionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LevelConditionOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  level?: InputMaybe<LevelOrderByWithRelationInput>;
  levelId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export enum LevelConditionScalarFieldEnum {
  Id = 'id',
  LevelId = 'levelId',
  Type = 'type',
  Value = 'value'
}

export type LevelConditionSumAggregate = {
  __typename: 'LevelConditionSumAggregate';
  value?: Maybe<Scalars['Int']['output']>;
};

export enum LevelConditionType {
  Points = 'POINTS'
}

export type LevelConditionUniqueConditionTypeCompoundUniqueInput = {
  levelId: Scalars['UUID']['input'];
  type: LevelConditionType;
};

export type LevelConditionUpdateInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type LevelConditionWhereInput = {
  AND?: InputMaybe<Array<LevelConditionWhereInput>>;
  NOT?: InputMaybe<Array<LevelConditionWhereInput>>;
  OR?: InputMaybe<Array<LevelConditionWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  level?: InputMaybe<LevelRelationFilter>;
  levelId?: InputMaybe<UuidFilter>;
  type?: InputMaybe<EnumLevelConditionTypeFilter>;
  value?: InputMaybe<IntFilter>;
};

export type LevelConditionWhereUniqueInput = {
  AND?: InputMaybe<Array<LevelConditionWhereInput>>;
  NOT?: InputMaybe<Array<LevelConditionWhereInput>>;
  OR?: InputMaybe<Array<LevelConditionWhereInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  level?: InputMaybe<LevelRelationFilter>;
  levelId?: InputMaybe<UuidFilter>;
  type?: InputMaybe<EnumLevelConditionTypeFilter>;
  uniqueConditionType?: InputMaybe<LevelConditionUniqueConditionTypeCompoundUniqueInput>;
  value?: InputMaybe<IntFilter>;
};

export type LevelConfigurationCreateInput = {
  conditions: Array<LevelConditionCreateManyLevelInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type LevelCount = {
  __typename: 'LevelCount';
  conditions: Scalars['Int']['output'];
};

export type LevelCountAggregate = {
  __typename: 'LevelCountAggregate';
  _all: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type LevelCreateNestedOneWithoutConditionsInput = {
  connect?: InputMaybe<LevelWhereUniqueInput>;
};

export type LevelMaxAggregate = {
  __typename: 'LevelMaxAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LevelMinAggregate = {
  __typename: 'LevelMinAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LevelOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  conditions?: InputMaybe<LevelConditionOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type LevelRelationFilter = {
  is?: InputMaybe<LevelWhereInput>;
  isNot?: InputMaybe<LevelWhereInput>;
};

export enum LevelScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  Order = 'order',
  UpdatedAt = 'updatedAt'
}

export type LevelSumAggregate = {
  __typename: 'LevelSumAggregate';
  order?: Maybe<Scalars['Int']['output']>;
};

export type LevelUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LevelWhereInput = {
  AND?: InputMaybe<Array<LevelWhereInput>>;
  NOT?: InputMaybe<Array<LevelWhereInput>>;
  OR?: InputMaybe<Array<LevelWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  conditions?: InputMaybe<LevelConditionListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
};

export type LevelWhereUniqueInput = {
  AND?: InputMaybe<Array<LevelWhereInput>>;
  NOT?: InputMaybe<Array<LevelWhereInput>>;
  OR?: InputMaybe<Array<LevelWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyOrder?: InputMaybe<LevelCompanyOrderCompoundUniqueInput>;
  conditions?: InputMaybe<LevelConditionListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
};

/** A subset of CouponType (ADDITION, MULTIPLICATION) */
export enum LimitedCouponType {
  Addition = 'ADDITION',
  Multiplication = 'MULTIPLICATION'
}

/** Custom input to create received points from local stores */
export type LocalStoreReceivedPointCreateInput = {
  valueBasedInput?: InputMaybe<LocalStoreValueBasedInput>;
  visitBasedInput?: InputMaybe<VisitBasedInput>;
};

export type LocalStoreValueBasedInput = {
  amount: Scalars['Float']['input'];
  transactionNumber: Scalars['Float']['input'];
};

/** Represents location data */
export type Location = {
  __typename: 'Location';
  /** Description of the location */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the location */
  id: Scalars['Int']['output'];
  /** Name of the location */
  name?: Maybe<Scalars['String']['output']>;
};

/** Custom input type to filter by current location */
export type LocationFilterInput = {
  /** Latitude of current position */
  latitude: Scalars['Latitude']['input'];
  /** Longitude of current position */
  longitude: Scalars['Longitude']['input'];
  /** The radius promotions should be found in. given in kilometers */
  radius: Scalars['Float']['input'];
};

/** Model for created Jobs of management client */
export type ManagementJobModel = {
  __typename: 'ManagementJobModel';
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Pending amendment for customer master data */
export type MasterDataAmendment = {
  __typename: 'MasterDataAmendment';
  /** Birth country of the customer (ISO 3166-1) */
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  /** Title of the customer */
  customerTitle: CustomerTitle;
  /** Birthday of the customer in YYYY-MM-DD format */
  dateOfBirth: Scalars['String']['output'];
  /** First name of the customer */
  firstName: Scalars['String']['output'];
  /** Gender of the customer */
  gender: Gender;
  /** Amendment proposal id */
  id?: Maybe<Scalars['Int']['output']>;
  /** Surname of the customer */
  lastName: Scalars['String']['output'];
};

export type MasterDataAmendmentInput = {
  /** Birth country of the customer (ISO 3166-1) */
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** Title of the customer */
  customerTitle: CustomerTitle;
  /** Birthday of the customer in YYYY-MM-DD format */
  dateOfBirth: Scalars['String']['input'];
  /** First name of the customer */
  firstName: Scalars['String']['input'];
  /** Gender of the customer */
  gender: Gender;
  /** Surname of the customer */
  lastName: Scalars['String']['input'];
};

/**
 * Represents the type of mobile application associated with a company.
 * This can be either our main platform or a custom white-label version.
 */
export enum MobileAppVariant {
  FranchisePlatform = 'FRANCHISE_PLATFORM',
  Platform = 'PLATFORM',
  WhiteLabel = 'WHITE_LABEL'
}

/** Represents financial data */
export type Money = {
  __typename: 'Money';
  /** Amount of the finance data tuple */
  amount: Scalars['Float']['output'];
  /** Currency of the finance data tuple (ISO 4217) */
  currency: Scalars['String']['output'];
};

export enum Month {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER'
}

/** The month day of a month day to price mapping */
export type MonthDay = {
  __typename: 'MonthDay';
  /** Day of the month */
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  /** Month of the mapping */
  month?: Maybe<Month>;
  /** Numeric value of the month */
  monthValue?: Maybe<Scalars['Int']['output']>;
};

/** Represents a mapping from a month day to a price for an additional module */
export type MonthDayToPrice = {
  __typename: 'MonthDayToPrice';
  /** Month day mapping */
  monthDay: MonthDay;
  /** Price for this month day */
  price: Money;
};

export enum MuscleGroup {
  Abs = 'ABS',
  Back = 'BACK',
  Biceps = 'BICEPS',
  Calves = 'CALVES',
  Cardio = 'CARDIO',
  Chest = 'CHEST',
  Core = 'CORE',
  FullBody = 'FULL_BODY',
  Hamstrings = 'HAMSTRINGS',
  Lats = 'LATS',
  Legs = 'LEGS',
  Quads = 'QUADS',
  Shoulders = 'SHOULDERS',
  Triceps = 'TRICEPS',
  UpperChest = 'UPPER_CHEST'
}

export type Mutation = {
  __typename: 'Mutation';
  acceptFriendRequest: FriendRequest;
  activatePassivePointsChallenge: Challenge;
  bookAppointment: BookAppointmentResult;
  cancelFriendship: Friendship;
  changeCustomerState: Customer;
  changeEquipmentStatus: StatusHistory;
  changePointSystem: PointSystem;
  changeVisibility: Company;
  checkInOut: CheckInOutResult;
  contactSupport: Contact;
  copyTrainingPlan: TrainingPlan;
  createAddressDataAmendment: AddressDataAmendment;
  createBranchOffice: BranchOffice;
  createBranchOfficeApiKeys: BranchOfficeApiKeyBatch;
  createBranchOfficeImage: BranchOfficeImage;
  /** Use this endpoint to create a challenge of type COMMUNITY_CHALLENGE */
  createChallenge: Challenge;
  createChallengePeriod: ChallengePeriod;
  /** @deprecated Endpoint should not be used anymore because it is outdated. Will be removed soon. */
  createCompanyCrmConfig: CompanyCrmConfig;
  createCompanyReferralConfig: CompanyReferralConfig;
  createContactDataAmendment: ContactDataAmendment;
  /** Use this endpoint to create coupons of type MULTIPLICATION and ADDITION */
  createCoupon: Coupon;
  createCouponPeriod: CouponPeriod;
  createCustomer: Customer;
  createCustomerClassBooking: CustomerClassBookingCustom;
  createCustomerCrmConfig: CustomerCrmConfig;
  createCustomerPartnerOrder: CustomerPartnerOrder;
  createCustomerReferral: CustomerReferral;
  createDefectReport: DefectReport;
  createEquipment: Equipment;
  createImageTemplate: ImageTemplate;
  createLevelCondition: LevelCondition;
  createLevelConfiguration: Array<Level>;
  createLocalStorePoint: ReceivedPoint;
  createManuallyReceivedPoint: ReceivedPoint;
  createManyBranchOfficeRatings: Array<BranchOfficeRating>;
  createManyLevelConditions: Array<LevelCondition>;
  createMasterDataAmendment: MasterDataAmendment;
  createNews: News;
  createOrChangeCalculationRule: Array<CalculationRule>;
  createPartner: Partner;
  createPartnerChallenge: PartnerChallenge;
  createPartnerChallengePeriod: PartnerChallengePeriod;
  createPartnerOffer: PartnerOffer;
  createPartnerReward: PartnerReward;
  createPaymentDataAmendment: PaymentDataAmendment;
  createPointSystem: PointSystem;
  createPointSystemType: PointSystemType;
  createPopup: Popup;
  createPopupPeriod: PopupPeriod;
  createPromotion: Promotion;
  createPromotionPeriod: PromotionPeriod;
  /** Create a promotional coupon */
  createPromotionalCoupon: Coupon;
  /**
   * Push notifications of type IMMEDIATE will be sent out immediately after creation.
   *     For Push notifications of type RECURRING and SCHEDULED_ONCE, scheduler will be created to sent out the notification at expression date
   */
  createPushNotification: PushNotification;
  createRatingQuestion: RatingQuestion;
  createRatingQuestions: Array<RatingQuestion>;
  createRedeemedPartnerReward: RedeemedPartnerReward;
  createRedeemedPoint: RedeemedPoint;
  createReward: Reward;
  createTrainingPlan: TrainingPlan;
  /** Use this endpoint only for creating coupons of type WELCOME. For other coupons use the 'createCoupon' endpoint */
  createWelcomeCoupon: Coupon;
  createWorkoutSession: WorkoutSession;
  createWorkoutSet: WorkoutSet;
  declineFriendRequest: FriendRequest;
  deleteBranchOffice: BranchOffice;
  deleteBranchOfficeImage: BranchOfficeImage;
  deleteBranchOfficeRating: BranchOfficeRating;
  deleteCalculationRule: CalculationRule;
  deleteChallenge: Challenge;
  deleteChallengePeriod: ChallengePeriod;
  deleteCompany: Company;
  deleteCompanyCrmConfig: CompanyCrmConfig;
  deleteCoupon: Coupon;
  deleteCouponPeriod: CouponPeriod;
  deleteCustomerCrmConfig: CustomerCrmConfig;
  deleteCustomerReferral: CustomerReferral;
  /** Triggered every day by the customer-handler lambda function to delete all customers that marked as deleted for 30 days */
  deleteCustomers?: Maybe<AffectedRows>;
  deleteEmployee: Employee;
  deleteEquipment: Equipment;
  deleteFriendRequest: FriendRequest;
  deleteImageTemplate: ImageTemplate;
  deleteLevel: Level;
  deleteLevelCondition: LevelCondition;
  deleteManyBranchOfficeUtilization: AffectedRows;
  deleteNews: News;
  deletePartner: Partner;
  deletePartnerChallenge: PartnerChallenge;
  deletePartnerChallengePeriod: PartnerChallengePeriod;
  deletePartnerOffer: PartnerOffer;
  deletePointSystem: PointSystem;
  deletePointSystemType: PointSystemType;
  deletePopup: Popup;
  deletePopupPeriod: PopupPeriod;
  deletePromotion: Promotion;
  deletePromotionPeriod: PromotionPeriod;
  deletePushNotification: PushNotification;
  deleteRatingQuestion: RatingQuestion;
  deleteReceivedPoint: ReceivedPoint;
  deleteRedeemedPoint: RedeemedPoint;
  deleteReward: Reward;
  deleteTrainingPlan: TrainingPlan;
  deleteWorkoutSession: WorkoutSession;
  deleteWorkoutSet: WorkoutSet;
  /** Only used from the schedule-handler-lambda to disable challenges at the specified period end */
  disableChallenge: Challenge;
  disableCoupon: Coupon;
  /** Only used from the schedule-handler-lambda to disable challenges at the specified period end */
  disablePartnerChallenge: PartnerChallenge;
  disablePopup: Popup;
  disablePushNotification: PushNotification;
  /**
   * Enable a challenge at the period begin.
   *      Only used from schedule-handler-lambda.
   */
  enableChallenge: Challenge;
  enableCoupon: Coupon;
  /**
   * Enable a partner challenge at the period begin.
   *      Only used from schedule-handler-lambda.
   */
  enablePartnerChallenge: PartnerChallenge;
  enablePopup: Popup;
  /** Invite a employee into a organization */
  inviteEmployee: Employee;
  joinPartnerChallenge: CustomerPartnerChallenge;
  markDefectReportFixed: DefectReport;
  purchaseAdditionalContract: PurchaseAdditionalContractResult;
  redeemChallenge: CustomerChallenge;
  redeemCoupon: RedeemedCoupon;
  registerCompany: Company;
  registerInvitedEmployee: Employee;
  removeEquipmentImage: Equipment;
  resendVerificationMail: ManagementJobModel;
  sendFriendRequest: FriendRequest;
  sendPasswordChangeEmail: Employee;
  sendPushNotification: PushNotification;
  softDeleteEquipment: Equipment;
  startRegistrationFlow: RegistrationFlowModel;
  /**
   * Use this mutation to stop a challenge of type PASSIVE_POINTS_CHALLENGE.
   *      The latest disable scheduler will be updated with the flag 'finalDisable' = true, to finally disable this challenge at the next execution of the disable scheduler at the end of the month.
   *      The challenge will not be disabled immediately, but will be disabled the next time the updated schedule runs!
   */
  stopPassivePointsChallenge: Challenge;
  switchCouponStatus: Coupon;
  /** Switch the status of reward to deleted (set deletedAt date) or active (set deletedAt to null) */
  switchRewardStatus: Reward;
  updateBranchOffice: BranchOffice;
  updateChallenge: Challenge;
  updateChallengeImage: Challenge;
  updateChallengePeriod: ChallengePeriod;
  /** @deprecated Updating customer challenges is now handled as part of the createReceivedPoint process and must no longer be performed in any other way. */
  updateChallenges: Array<CustomerChallenge>;
  updateCompany: Company;
  updateCompanyCrmConfig: CompanyCrmConfig;
  updateCompanyLogo: Company;
  updateCompanyReferralConfig: CompanyReferralConfig;
  updateCoupon: Coupon;
  updateCouponPeriod: CouponPeriod;
  updateCustomer: Customer;
  updateCustomerCrmConfig: CustomerCrmConfig;
  updateEmployee: Employee;
  updateEquipment: Equipment;
  updateEquipmentImage: Equipment;
  updateImageTemplate: ImageTemplate;
  updateLevel: Level;
  updateLevelCondition: LevelCondition;
  updatePartnerChallenge: PartnerChallenge;
  updatePartnerChallengeImage: PartnerChallenge;
  updatePartnerChallengePeriod: PartnerChallengePeriod;
  updatePartnerChallengeProgress: PartnerChallenge;
  updatePartnerOffer: PartnerOffer;
  updatePointSystem: PointSystem;
  updatePointSystemType: PointSystemType;
  updatePopupPeriod: PopupPeriod;
  updatePopupPeriodStatistic: PopupPeriod;
  updatePromotionPeriod: PromotionPeriod;
  updateRatingQuestionActiveStatus: RatingQuestion;
  updateReceivedPoint: ReceivedPoint;
  updateRedeemedPoint: RedeemedPoint;
  updateReward: Reward;
  updateTrainingPlan: TrainingPlan;
  updateWorkoutSession: WorkoutSession;
  updateWorkoutSet: WorkoutSet;
  upsertBranchOfficeUtilization?: Maybe<Scalars['Void']['output']>;
  validateAppointmentBooking: AppointmentBookingValidationResult;
};


export type MutationAcceptFriendRequestArgs = {
  where: FriendRequestWhereUniqueInput;
};


export type MutationActivatePassivePointsChallengeArgs = {
  data: PassivePointsChallengeActivateInput;
};


export type MutationBookAppointmentArgs = {
  branchOfficeId: Scalars['String']['input'];
  data: BookAppointmentInput;
};


export type MutationCancelFriendshipArgs = {
  where: CustomerWhereUniqueInput;
};


export type MutationChangeCustomerStateArgs = {
  customerId: Scalars['String']['input'];
  state: CustomerStateEnum;
};


export type MutationChangeEquipmentStatusArgs = {
  data: EquipmentStatusChangeInput;
  where: EquipmentWhereUniqueInput;
};


export type MutationChangePointSystemArgs = {
  input: ChangePointSystemInput;
};


export type MutationChangeVisibilityArgs = {
  visible: Scalars['Boolean']['input'];
};


export type MutationCheckInOutArgs = {
  branchOfficeId: Scalars['String']['input'];
  data: CheckInOutInput;
};


export type MutationContactSupportArgs = {
  data: ContactSupportInput;
};


export type MutationCopyTrainingPlanArgs = {
  where: TrainingPlanWhereUniqueInput;
};


export type MutationCreateAddressDataAmendmentArgs = {
  data: AddressDataAmendmentInput;
};


export type MutationCreateBranchOfficeArgs = {
  data: BranchOfficeCreateInput;
};


export type MutationCreateBranchOfficeApiKeysArgs = {
  companyId: Scalars['String']['input'];
  data: Array<BranchOfficeApiKeyCreateManyInput>;
};


export type MutationCreateBranchOfficeImageArgs = {
  data: BranchOfficeImageCreateInput;
};


export type MutationCreateChallengeArgs = {
  data: ChallengeCreateInput;
};


export type MutationCreateChallengePeriodArgs = {
  data: ChallengePeriodCreateInput;
};


export type MutationCreateCompanyCrmConfigArgs = {
  data: CompanyCrmConfigCreateInput;
};


export type MutationCreateCompanyReferralConfigArgs = {
  data: CompanyReferralConfigCreateInput;
};


export type MutationCreateContactDataAmendmentArgs = {
  data: ContactDataAmendmentInput;
};


export type MutationCreateCouponArgs = {
  data: CouponCreateInput;
};


export type MutationCreateCouponPeriodArgs = {
  data: CouponPeriodCreateInput;
};


export type MutationCreateCustomerArgs = {
  data: CustomerCreateInput;
};


export type MutationCreateCustomerClassBookingArgs = {
  branchOfficeId: Scalars['String']['input'];
  data: CustomerClassBookingCreateInput;
};


export type MutationCreateCustomerCrmConfigArgs = {
  data: CustomerCrmConfigCreateInput;
};


export type MutationCreateCustomerPartnerOrderArgs = {
  data: CustomerPartnerOrderCreateInput;
};


export type MutationCreateCustomerReferralArgs = {
  data: CustomerReferralCreateInput;
};


export type MutationCreateDefectReportArgs = {
  data: DefectReportCreateInput;
};


export type MutationCreateEquipmentArgs = {
  data: EquipmentCreateInput;
};


export type MutationCreateImageTemplateArgs = {
  data: ImageTemplateCreateInput;
};


export type MutationCreateLevelConditionArgs = {
  data: LevelConditionCreateInput;
};


export type MutationCreateLevelConfigurationArgs = {
  data: Array<LevelConfigurationCreateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateLocalStorePointArgs = {
  createInput: LocalStoreReceivedPointCreateInput;
};


export type MutationCreateManuallyReceivedPointArgs = {
  count: Scalars['Float']['input'];
  customer: CustomerWhereUniqueInput;
};


export type MutationCreateManyBranchOfficeRatingsArgs = {
  data: Array<BranchOfficeRatingCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyLevelConditionsArgs = {
  data: Array<LevelConditionCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateMasterDataAmendmentArgs = {
  data: MasterDataAmendmentInput;
};


export type MutationCreateNewsArgs = {
  data: NewsCreateInput;
};


export type MutationCreateOrChangeCalculationRuleArgs = {
  data: CreateOrChangeCalculationRuleInput;
};


export type MutationCreatePartnerArgs = {
  data: PartnerCreateInput;
};


export type MutationCreatePartnerChallengeArgs = {
  data: CreatePartnerChallengeInput;
};


export type MutationCreatePartnerChallengePeriodArgs = {
  data: PartnerChallengePeriodCreateInput;
};


export type MutationCreatePartnerOfferArgs = {
  data: PartnerOfferCreateInput;
};


export type MutationCreatePartnerRewardArgs = {
  data: PartnerRewardCreateInput;
};


export type MutationCreatePaymentDataAmendmentArgs = {
  data: PaymentDataAmendmentInput;
};


export type MutationCreatePointSystemArgs = {
  createInput: PointSystemCreateInput;
};


export type MutationCreatePointSystemTypeArgs = {
  data: PointSystemTypeCreateInput;
};


export type MutationCreatePopupArgs = {
  data: PopupCreateInput;
};


export type MutationCreatePopupPeriodArgs = {
  data: PopupPeriodCreateNextInput;
};


export type MutationCreatePromotionArgs = {
  data: PromotionCreateInput;
};


export type MutationCreatePromotionPeriodArgs = {
  data: PromotionPeriodCreateInput;
};


export type MutationCreatePromotionalCouponArgs = {
  data: PromotionalCouponCreateInput;
};


export type MutationCreatePushNotificationArgs = {
  data: PushNotificationCreateInput;
};


export type MutationCreateRatingQuestionArgs = {
  data: RatingQuestionCreateInput;
};


export type MutationCreateRatingQuestionsArgs = {
  data: Array<RatingQuestionCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateRedeemedPartnerRewardArgs = {
  data: RedeemedPartnerRewardCreateInput;
};


export type MutationCreateRedeemedPointArgs = {
  data: RedeemedPointCreateInput;
};


export type MutationCreateRewardArgs = {
  data: CreateRewardInput;
};


export type MutationCreateTrainingPlanArgs = {
  data: TrainingPlanCreateInput;
};


export type MutationCreateWelcomeCouponArgs = {
  data: WelcomeCouponCreateInput;
};


export type MutationCreateWorkoutSessionArgs = {
  data: WorkoutSessionCreateInput;
};


export type MutationCreateWorkoutSetArgs = {
  data: WorkoutSetCreateInput;
};


export type MutationDeclineFriendRequestArgs = {
  where: FriendRequestWhereUniqueInput;
};


export type MutationDeleteBranchOfficeArgs = {
  where: BranchOfficeUniqueInput;
};


export type MutationDeleteBranchOfficeImageArgs = {
  where: BranchOfficeImageWhereUniqueInput;
};


export type MutationDeleteBranchOfficeRatingArgs = {
  where: BranchOfficeRatingWhereUniqueInput;
};


export type MutationDeleteCalculationRuleArgs = {
  where: CalculationRuleWhereUniqueInput;
};


export type MutationDeleteChallengeArgs = {
  where: ChallengeWhereUniqueInput;
};


export type MutationDeleteChallengePeriodArgs = {
  where: ChallengePeriodWhereUniqueInput;
};


export type MutationDeleteCompanyArgs = {
  where: CompanyWhereUniqueInput;
};


export type MutationDeleteCompanyCrmConfigArgs = {
  where: CompanyCrmConfigWhereUniqueInput;
};


export type MutationDeleteCouponArgs = {
  where: CouponWhereUniqueInput;
};


export type MutationDeleteCouponPeriodArgs = {
  where: CouponPeriodWhereUniqueInput;
};


export type MutationDeleteCustomerCrmConfigArgs = {
  where: CustomerCrmConfigWhereUniqueInput;
};


export type MutationDeleteCustomerReferralArgs = {
  where: CustomerReferralWhereUniqueInput;
};


export type MutationDeleteCustomersArgs = {
  customerIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteEmployeeArgs = {
  where: EmployeeIdentifierInput;
};


export type MutationDeleteEquipmentArgs = {
  where: EquipmentWhereUniqueInput;
};


export type MutationDeleteFriendRequestArgs = {
  where: FriendRequestWhereUniqueInput;
};


export type MutationDeleteImageTemplateArgs = {
  where: ImageTemplateWhereUniqueInput;
};


export type MutationDeleteLevelArgs = {
  where: LevelWhereUniqueInput;
};


export type MutationDeleteLevelConditionArgs = {
  where: LevelConditionWhereUniqueInput;
};


export type MutationDeleteManyBranchOfficeUtilizationArgs = {
  where?: InputMaybe<BranchOfficeUtilizationWhereInput>;
};


export type MutationDeleteNewsArgs = {
  where: NewsWhereUniqueInput;
};


export type MutationDeletePartnerArgs = {
  where: PartnerWhereUniqueInput;
};


export type MutationDeletePartnerChallengeArgs = {
  where: PartnerChallengeWhereUniqueInput;
};


export type MutationDeletePartnerChallengePeriodArgs = {
  where: PartnerChallengePeriodWhereUniqueInput;
};


export type MutationDeletePartnerOfferArgs = {
  where: PartnerOfferWhereUniqueInput;
};


export type MutationDeletePointSystemArgs = {
  where: PointSystemWhereUniqueInput;
};


export type MutationDeletePointSystemTypeArgs = {
  where: PointSystemTypeWhereUniqueInput;
};


export type MutationDeletePopupArgs = {
  where: PopupWhereUniqueInput;
};


export type MutationDeletePopupPeriodArgs = {
  where: PopupPeriodWhereUniqueInput;
};


export type MutationDeletePromotionArgs = {
  where: PromotionWhereUniqueInput;
};


export type MutationDeletePromotionPeriodArgs = {
  where: PromotionPeriodWhereUniqueInput;
};


export type MutationDeletePushNotificationArgs = {
  where: PushNotificationWhereUniqueInput;
};


export type MutationDeleteRatingQuestionArgs = {
  where: RatingQuestionWhereUniqueInput;
};


export type MutationDeleteReceivedPointArgs = {
  where: ReceivedPointWhereUniqueInput;
};


export type MutationDeleteRedeemedPointArgs = {
  where: RedeemedPointWhereUniqueInput;
};


export type MutationDeleteRewardArgs = {
  where: RewardWhereUniqueInput;
};


export type MutationDeleteTrainingPlanArgs = {
  where: TrainingPlanWhereUniqueInput;
};


export type MutationDeleteWorkoutSessionArgs = {
  where: WorkoutSessionWhereUniqueInput;
};


export type MutationDeleteWorkoutSetArgs = {
  where: WorkoutSetWhereUniqueInput;
};


export type MutationDisableChallengeArgs = {
  data?: InputMaybe<DisableChallengeInput>;
  where: ChallengeWhereUniqueInput;
};


export type MutationDisableCouponArgs = {
  where: CouponWhereUniqueInput;
};


export type MutationDisablePartnerChallengeArgs = {
  data: DisablePartnerChallengeInput;
  where: PartnerChallengeWhereUniqueInput;
};


export type MutationDisablePopupArgs = {
  where: PopupWhereUniqueInput;
};


export type MutationDisablePushNotificationArgs = {
  pushNotificationId: Scalars['String']['input'];
};


export type MutationEnableChallengeArgs = {
  where: ChallengeWhereUniqueInput;
};


export type MutationEnableCouponArgs = {
  where: CouponWhereUniqueInput;
};


export type MutationEnablePartnerChallengeArgs = {
  where: PartnerChallengeWhereUniqueInput;
};


export type MutationEnablePopupArgs = {
  where: PopupWhereUniqueInput;
};


export type MutationInviteEmployeeArgs = {
  email: Scalars['String']['input'];
};


export type MutationJoinPartnerChallengeArgs = {
  where: PartnerChallengeWhereUniqueInput;
};


export type MutationMarkDefectReportFixedArgs = {
  where: DefectReportWhereUniqueInput;
};


export type MutationPurchaseAdditionalContractArgs = {
  data: AdditionalContractInput;
};


export type MutationRedeemChallengeArgs = {
  challengeId: Scalars['String']['input'];
};


export type MutationRedeemCouponArgs = {
  couponId: Scalars['String']['input'];
};


export type MutationRegisterCompanyArgs = {
  registerInput: RegisterCompanyInput;
};


export type MutationRegisterInvitedEmployeeArgs = {
  data: RegisterEmployeeInput;
  where: EmployeeUniqueInput;
};


export type MutationRemoveEquipmentImageArgs = {
  where: EquipmentWhereUniqueInput;
};


export type MutationResendVerificationMailArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSendFriendRequestArgs = {
  receiverEmail: Scalars['EmailAddress']['input'];
};


export type MutationSendPushNotificationArgs = {
  pushNotificationId: Scalars['String']['input'];
  studioIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSoftDeleteEquipmentArgs = {
  where: EquipmentWhereUniqueInput;
};


export type MutationStartRegistrationFlowArgs = {
  accountInformation: AccountInformationInput;
  companyInformation: CompanyInformationInput;
};


export type MutationStopPassivePointsChallengeArgs = {
  where: ChallengeWhereUniqueInput;
};


export type MutationSwitchCouponStatusArgs = {
  data: SwitchCouponStatusInput;
  where: CouponUniqueInput;
};


export type MutationSwitchRewardStatusArgs = {
  input: SwitchRewardStatusInput;
};


export type MutationUpdateBranchOfficeArgs = {
  data: BranchOfficeUpdateInput;
  where: BranchOfficeWhereUniqueInput;
};


export type MutationUpdateChallengeArgs = {
  data: ChallengeUpdateInput;
  where: ChallengeWhereUniqueInput;
};


export type MutationUpdateChallengeImageArgs = {
  data: ChallengeImageInput;
  where: ChallengeWhereUniqueInput;
};


export type MutationUpdateChallengePeriodArgs = {
  data: ChallengePeriodUpdateInput;
  where: ChallengePeriodWhereUniqueInput;
};


export type MutationUpdateChallengesArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationUpdateCompanyArgs = {
  data: UpdateCompanyInput;
  where?: InputMaybe<CompanyUniqueInput>;
};


export type MutationUpdateCompanyCrmConfigArgs = {
  data: CompanyCrmConfigUpdateInput;
  where: CompanyCrmConfigWhereUniqueInput;
};


export type MutationUpdateCompanyLogoArgs = {
  input: CompanyLogoInput;
};


export type MutationUpdateCompanyReferralConfigArgs = {
  data: CompanyReferralConfigUpdateInput;
  where: CompanyReferralConfigWhereUniqueInput;
};


export type MutationUpdateCouponArgs = {
  data: CouponUpdateInput;
  where: CouponWhereUniqueInput;
};


export type MutationUpdateCouponPeriodArgs = {
  data: CouponPeriodUpdateInput;
  where: CouponPeriodWhereUniqueInput;
};


export type MutationUpdateCustomerArgs = {
  data: CustomerUpdateInput;
  where: CustomerWhereUniqueInput;
};


export type MutationUpdateCustomerCrmConfigArgs = {
  data: CustomerCrmConfigUpdateInput;
  where: CustomerCrmConfigWhereUniqueInput;
};


export type MutationUpdateEmployeeArgs = {
  data: UpdateEmployeeInput;
  where?: InputMaybe<EmployeeUniqueInput>;
};


export type MutationUpdateEquipmentArgs = {
  data: EquipmentUpdateInput;
  where: EquipmentWhereUniqueInput;
};


export type MutationUpdateEquipmentImageArgs = {
  data: EquipmentImageInput;
  where: EquipmentWhereUniqueInput;
};


export type MutationUpdateImageTemplateArgs = {
  data: ImageTemplateUpdateInput;
  where: ImageTemplateWhereUniqueInput;
};


export type MutationUpdateLevelArgs = {
  data: LevelUpdateInput;
  where: LevelWhereUniqueInput;
};


export type MutationUpdateLevelConditionArgs = {
  data: LevelConditionUpdateInput;
  where: LevelConditionWhereUniqueInput;
};


export type MutationUpdatePartnerChallengeArgs = {
  data: PartnerChallengeUpdateInput;
  where: PartnerChallengeWhereUniqueInput;
};


export type MutationUpdatePartnerChallengeImageArgs = {
  data: PartnerChallengeImageInput;
  where: PartnerChallengeWhereUniqueInput;
};


export type MutationUpdatePartnerChallengePeriodArgs = {
  data: PartnerChallengePeriodUpdateInput;
  where: PartnerChallengePeriodWhereUniqueInput;
};


export type MutationUpdatePartnerChallengeProgressArgs = {
  data: UpdatePartnerChallengeProgressInput;
  where: PartnerChallengeWhereUniqueInput;
};


export type MutationUpdatePartnerOfferArgs = {
  data: PartnerOfferUpdateInput;
  where: PartnerOfferWhereUniqueInput;
};


export type MutationUpdatePointSystemArgs = {
  data: PointSystemUpdateInput;
  where: PointSystemWhereUniqueInput;
};


export type MutationUpdatePointSystemTypeArgs = {
  data: PointSystemTypeUpdateInput;
  where: PointSystemTypeWhereUniqueInput;
};


export type MutationUpdatePopupPeriodArgs = {
  data: PopupPeriodUpdateInput;
  where: PopupPeriodWhereUniqueInput;
};


export type MutationUpdatePopupPeriodStatisticArgs = {
  data: PopupPeriodStatisticUpdateInput;
  where: PopupPeriodWhereUniqueInput;
};


export type MutationUpdatePromotionPeriodArgs = {
  data: PromotionPeriodUpdateInput;
  where: PromotionPeriodUniqueInput;
};


export type MutationUpdateRatingQuestionActiveStatusArgs = {
  data: RatingQuestionActiveStatusUpdateInput;
  where: RatingQuestionWhereUniqueInput;
};


export type MutationUpdateReceivedPointArgs = {
  data: ReceivedPointUpdateInput;
  where: ReceivedPointWhereUniqueInput;
};


export type MutationUpdateRedeemedPointArgs = {
  data: RedeemedPointUpdateInput;
  where: RedeemedPointWhereUniqueInput;
};


export type MutationUpdateRewardArgs = {
  data: RewardUpdateInput;
  where: RewardWhereUniqueInput;
};


export type MutationUpdateTrainingPlanArgs = {
  data: TrainingPlanUpdateInput;
  where: TrainingPlanWhereUniqueInput;
};


export type MutationUpdateWorkoutSessionArgs = {
  data: WorkoutSessionUpdateInput;
  where: WorkoutSessionWhereUniqueInput;
};


export type MutationUpdateWorkoutSetArgs = {
  data: WorkoutSetUpdateInput;
  where: WorkoutSetWhereUniqueInput;
};


export type MutationUpsertBranchOfficeUtilizationArgs = {
  data: Array<UpsertBranchOfficeUtilizationInput>;
};


export type MutationValidateAppointmentBookingArgs = {
  branchOfficeId: Scalars['String']['input'];
  data: ValidateAppointmentBookingInput;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBytesNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<NestedBytesNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedDecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

/** Custom input for nested creation of employee by registering a company */
export type NestedEmployeeCreateWithoutCompanyInput = {
  email: Scalars['EmailAddress']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type NestedEnumChallengeStatusFilter = {
  equals?: InputMaybe<ChallengeStatus>;
  in?: InputMaybe<Array<ChallengeStatus>>;
  not?: InputMaybe<NestedEnumChallengeStatusFilter>;
  notIn?: InputMaybe<Array<ChallengeStatus>>;
};

export type NestedEnumChallengeTypeFilter = {
  equals?: InputMaybe<ChallengeType>;
  in?: InputMaybe<Array<ChallengeType>>;
  not?: InputMaybe<NestedEnumChallengeTypeFilter>;
  notIn?: InputMaybe<Array<ChallengeType>>;
};

export type NestedEnumCompanyUserTypeFilter = {
  equals?: InputMaybe<CompanyUserType>;
  in?: InputMaybe<Array<CompanyUserType>>;
  not?: InputMaybe<NestedEnumCompanyUserTypeFilter>;
  notIn?: InputMaybe<Array<CompanyUserType>>;
};

export type NestedEnumCouponStatusFilter = {
  equals?: InputMaybe<CouponStatus>;
  in?: InputMaybe<Array<CouponStatus>>;
  not?: InputMaybe<NestedEnumCouponStatusFilter>;
  notIn?: InputMaybe<Array<CouponStatus>>;
};

export type NestedEnumCouponTypeFilter = {
  equals?: InputMaybe<CouponType>;
  in?: InputMaybe<Array<CouponType>>;
  not?: InputMaybe<NestedEnumCouponTypeFilter>;
  notIn?: InputMaybe<Array<CouponType>>;
};

export type NestedEnumCronIntervalNullableFilter = {
  equals?: InputMaybe<CronInterval>;
  in?: InputMaybe<Array<CronInterval>>;
  not?: InputMaybe<NestedEnumCronIntervalNullableFilter>;
  notIn?: InputMaybe<Array<CronInterval>>;
};

export type NestedEnumDefectCategoryFilter = {
  equals?: InputMaybe<DefectCategory>;
  in?: InputMaybe<Array<DefectCategory>>;
  not?: InputMaybe<NestedEnumDefectCategoryFilter>;
  notIn?: InputMaybe<Array<DefectCategory>>;
};

export type NestedEnumEmployeeStatusFilter = {
  equals?: InputMaybe<EmployeeStatus>;
  in?: InputMaybe<Array<EmployeeStatus>>;
  not?: InputMaybe<NestedEnumEmployeeStatusFilter>;
  notIn?: InputMaybe<Array<EmployeeStatus>>;
};

export type NestedEnumEquipmentStatusFilter = {
  equals?: InputMaybe<EquipmentStatus>;
  in?: InputMaybe<Array<EquipmentStatus>>;
  not?: InputMaybe<NestedEnumEquipmentStatusFilter>;
  notIn?: InputMaybe<Array<EquipmentStatus>>;
};

export type NestedEnumEquipmentTypeFilter = {
  equals?: InputMaybe<EquipmentType>;
  in?: InputMaybe<Array<EquipmentType>>;
  not?: InputMaybe<NestedEnumEquipmentTypeFilter>;
  notIn?: InputMaybe<Array<EquipmentType>>;
};

export type NestedEnumFriendRequestStatusFilter = {
  equals?: InputMaybe<FriendRequestStatus>;
  in?: InputMaybe<Array<FriendRequestStatus>>;
  not?: InputMaybe<NestedEnumFriendRequestStatusFilter>;
  notIn?: InputMaybe<Array<FriendRequestStatus>>;
};

export type NestedEnumIntegrationTypeFilter = {
  equals?: InputMaybe<IntegrationType>;
  in?: InputMaybe<Array<IntegrationType>>;
  not?: InputMaybe<NestedEnumIntegrationTypeFilter>;
  notIn?: InputMaybe<Array<IntegrationType>>;
};

export type NestedEnumLevelConditionTypeFilter = {
  equals?: InputMaybe<LevelConditionType>;
  in?: InputMaybe<Array<LevelConditionType>>;
  not?: InputMaybe<NestedEnumLevelConditionTypeFilter>;
  notIn?: InputMaybe<Array<LevelConditionType>>;
};

export type NestedEnumMobileAppVariantFilter = {
  equals?: InputMaybe<MobileAppVariant>;
  in?: InputMaybe<Array<MobileAppVariant>>;
  not?: InputMaybe<NestedEnumMobileAppVariantFilter>;
  notIn?: InputMaybe<Array<MobileAppVariant>>;
};

export type NestedEnumMuscleGroupFilter = {
  equals?: InputMaybe<MuscleGroup>;
  in?: InputMaybe<Array<MuscleGroup>>;
  not?: InputMaybe<NestedEnumMuscleGroupFilter>;
  notIn?: InputMaybe<Array<MuscleGroup>>;
};

export type NestedEnumPartnerChallengeActivityTypeFilter = {
  equals?: InputMaybe<PartnerChallengeActivityType>;
  in?: InputMaybe<Array<PartnerChallengeActivityType>>;
  not?: InputMaybe<NestedEnumPartnerChallengeActivityTypeFilter>;
  notIn?: InputMaybe<Array<PartnerChallengeActivityType>>;
};

export type NestedEnumPartnerChallengeTypeFilter = {
  equals?: InputMaybe<PartnerChallengeType>;
  in?: InputMaybe<Array<PartnerChallengeType>>;
  not?: InputMaybe<NestedEnumPartnerChallengeTypeFilter>;
  notIn?: InputMaybe<Array<PartnerChallengeType>>;
};

export type NestedEnumPartnerChallengeVerificationTypeFilter = {
  equals?: InputMaybe<PartnerChallengeVerificationType>;
  in?: InputMaybe<Array<PartnerChallengeVerificationType>>;
  not?: InputMaybe<NestedEnumPartnerChallengeVerificationTypeFilter>;
  notIn?: InputMaybe<Array<PartnerChallengeVerificationType>>;
};

export type NestedEnumPartnerOfferTypeFilter = {
  equals?: InputMaybe<PartnerOfferType>;
  in?: InputMaybe<Array<PartnerOfferType>>;
  not?: InputMaybe<NestedEnumPartnerOfferTypeFilter>;
  notIn?: InputMaybe<Array<PartnerOfferType>>;
};

export type NestedEnumPushNotificationSendTypeFilter = {
  equals?: InputMaybe<PushNotificationSendType>;
  in?: InputMaybe<Array<PushNotificationSendType>>;
  not?: InputMaybe<NestedEnumPushNotificationSendTypeFilter>;
  notIn?: InputMaybe<Array<PushNotificationSendType>>;
};

export type NestedEnumPushNotificationStatusFilter = {
  equals?: InputMaybe<PushNotificationStatus>;
  in?: InputMaybe<Array<PushNotificationStatus>>;
  not?: InputMaybe<NestedEnumPushNotificationStatusFilter>;
  notIn?: InputMaybe<Array<PushNotificationStatus>>;
};

export type NestedEnumReceivedPointSourceTypeFilter = {
  equals?: InputMaybe<ReceivedPointSourceType>;
  in?: InputMaybe<Array<ReceivedPointSourceType>>;
  not?: InputMaybe<NestedEnumReceivedPointSourceTypeFilter>;
  notIn?: InputMaybe<Array<ReceivedPointSourceType>>;
};

export type NestedEnumShopTypeFilter = {
  equals?: InputMaybe<ShopType>;
  in?: InputMaybe<Array<ShopType>>;
  not?: InputMaybe<NestedEnumShopTypeFilter>;
  notIn?: InputMaybe<Array<ShopType>>;
};

export type NestedEnumSystemTypeFilter = {
  equals?: InputMaybe<SystemType>;
  in?: InputMaybe<Array<SystemType>>;
  not?: InputMaybe<NestedEnumSystemTypeFilter>;
  notIn?: InputMaybe<Array<SystemType>>;
};

export type NestedEnumTransmissionMethodFilter = {
  equals?: InputMaybe<TransmissionMethod>;
  in?: InputMaybe<Array<TransmissionMethod>>;
  not?: InputMaybe<NestedEnumTransmissionMethodFilter>;
  notIn?: InputMaybe<Array<TransmissionMethod>>;
};

export type NestedEnumTransmissionMethodNullableFilter = {
  equals?: InputMaybe<TransmissionMethod>;
  in?: InputMaybe<Array<TransmissionMethod>>;
  not?: InputMaybe<NestedEnumTransmissionMethodNullableFilter>;
  notIn?: InputMaybe<Array<TransmissionMethod>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedUuidFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedUuidFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NestedUuidNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedUuidNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type News = {
  __typename: 'News';
  _count: NewsCount;
  branchOffices?: Maybe<Array<BranchOffice>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The associated image for this news */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** A text for this news */
  text: Scalars['String']['output'];
  /** A title for this news */
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type NewsCount = {
  __typename: 'NewsCount';
  branchOffices: Scalars['Int']['output'];
};

export type NewsCountAggregate = {
  __typename: 'NewsCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['Int']['output'];
  text: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input type for creating a news */
export type NewsCreateInput = {
  branchOffices?: InputMaybe<BranchOfficeCreateNestedManyWithoutNewsInput>;
  image: ImageInput;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type NewsCreateNestedManyWithoutBranchOfficesInput = {
  connect?: InputMaybe<Array<NewsWhereUniqueInput>>;
};

export type NewsListRelationFilter = {
  every?: InputMaybe<NewsWhereInput>;
  none?: InputMaybe<NewsWhereInput>;
  some?: InputMaybe<NewsWhereInput>;
};

export type NewsMaxAggregate = {
  __typename: 'NewsMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type NewsMinAggregate = {
  __typename: 'NewsMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type NewsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type NewsOrderByWithRelationInput = {
  branchOffices?: InputMaybe<BranchOfficeOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  s3Key?: InputMaybe<SortOrderInput>;
  text?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export enum NewsScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Id = 'id',
  ImageUrl = 'imageUrl',
  S3Key = 's3Key',
  Text = 'text',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type NewsScalarWhereInput = {
  AND?: InputMaybe<Array<NewsScalarWhereInput>>;
  NOT?: InputMaybe<Array<NewsScalarWhereInput>>;
  OR?: InputMaybe<Array<NewsScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  s3Key?: InputMaybe<StringNullableFilter>;
  text?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type NewsUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NewsUpdateManyWithWhereWithoutBranchOfficesInput = {
  data: NewsUpdateManyMutationInput;
  where: NewsScalarWhereInput;
};

export type NewsUpdateManyWithoutBranchOfficesNestedInput = {
  connect?: InputMaybe<Array<NewsWhereUniqueInput>>;
  delete?: InputMaybe<Array<NewsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NewsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NewsWhereUniqueInput>>;
  set?: InputMaybe<Array<NewsWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<NewsUpdateManyWithWhereWithoutBranchOfficesInput>>;
};

export type NewsWhereInput = {
  AND?: InputMaybe<Array<NewsWhereInput>>;
  NOT?: InputMaybe<Array<NewsWhereInput>>;
  OR?: InputMaybe<Array<NewsWhereInput>>;
  branchOffices?: InputMaybe<BranchOfficeListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  s3Key?: InputMaybe<StringNullableFilter>;
  text?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type NewsWhereUniqueInput = {
  AND?: InputMaybe<Array<NewsWhereInput>>;
  NOT?: InputMaybe<Array<NewsWhereInput>>;
  OR?: InputMaybe<Array<NewsWhereInput>>;
  branchOffices?: InputMaybe<BranchOfficeListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  s3Key?: InputMaybe<StringNullableFilter>;
  text?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type PaginatedBranchOffice = {
  __typename: 'PaginatedBranchOffice';
  edges?: Maybe<Array<BranchOfficeEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<BranchOffice>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedBranchOfficeCursor = {
  __typename: 'PaginatedBranchOfficeCursor';
  id?: Maybe<Scalars['UUID']['output']>;
};

export type PaginatedBranchOfficeRating = {
  __typename: 'PaginatedBranchOfficeRating';
  edges?: Maybe<Array<BranchOfficeRatingEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<BranchOfficeRating>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedBranchOfficeRatingCursor = {
  __typename: 'PaginatedBranchOfficeRatingCursor';
  id?: Maybe<Scalars['UUID']['output']>;
};

export type PaginatedCustomer = {
  __typename: 'PaginatedCustomer';
  edges?: Maybe<Array<CustomerEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<Customer>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedCustomerCursor = {
  __typename: 'PaginatedCustomerCursor';
  id?: Maybe<Scalars['String']['output']>;
};

export type PaginatedEquipment = {
  __typename: 'PaginatedEquipment';
  edges?: Maybe<Array<EquipmentEdge>>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<Equipment>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedEquipmentCursor = {
  __typename: 'PaginatedEquipmentCursor';
  id?: Maybe<Scalars['UUID']['output']>;
};

/** Base pagination input for magicline queries */
export type PaginationInput = {
  /** Offset from last request */
  offset?: InputMaybe<Scalars['String']['input']>;
  /** Desired size of data chunk. [ 10 .. 100 ]. Defaults to 50 */
  sliceSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Participation state of the customer */
export enum ParticipantStatus {
  NotParticipating = 'NOT_PARTICIPATING',
  Participating = 'PARTICIPATING',
  Unset = 'UNSET'
}

export type Partner = {
  __typename: 'Partner';
  _count: PartnerCount;
  challenge?: Maybe<Array<PartnerChallenge>>;
  city: Scalars['String']['output'];
  companies?: Maybe<Array<Company>>;
  config?: Maybe<PartnerConfig>;
  countryCode: Scalars['CountryCode']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** A combined list of partner rewards and offers */
  deals: Array<PartnerDeal>;
  description?: Maybe<Scalars['String']['output']>;
  email: Scalars['EmailAddress']['output'];
  houseNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** THe latitude of the partner */
  latitude?: Maybe<Scalars['Decimal']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The longitude of the partner */
  longitude?: Maybe<Scalars['Decimal']['output']>;
  name: Scalars['String']['output'];
  offers?: Maybe<Array<PartnerOffer>>;
  organizationName: Scalars['String']['output'];
  partnerConfigId?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['PostalCode']['output'];
  rewards?: Maybe<Array<PartnerReward>>;
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  /** The timezone of the partner */
  timeZone: Scalars['TimeZone']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The partners website url */
  websiteUrl: Scalars['String']['output'];
};

export type PartnerAvgAggregate = {
  __typename: 'PartnerAvgAggregate';
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
};

export type PartnerChallenge = {
  __typename: 'PartnerChallenge';
  _count: PartnerChallengeCount;
  active: Scalars['Boolean']['output'];
  activityType: PartnerChallengeActivityType;
  /** Indicates if a check-in is required to submit a score */
  checkInRequired: Scalars['Boolean']['output'];
  companies?: Maybe<Array<Company>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** 'km', 'steps', etc. */
  goalUnit: Scalars['String']['output'];
  goalValue: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  joinable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  partner: Partner;
  partnerId: Scalars['UUID']['output'];
  periods?: Maybe<Array<PartnerChallengePeriod>>;
  type: PartnerChallengeType;
  updatedAt: Scalars['DateTime']['output'];
  verificationType: PartnerChallengeVerificationType;
  /** The number of winners for this challenge (e.g. number of raffle winners or top X leaderboard positions) */
  winnerCount?: Maybe<Scalars['Int']['output']>;
};


export type PartnerChallengePeriodsArgs = {
  cursor?: InputMaybe<PartnerChallengePeriodWhereUniqueInput>;
  distinct?: InputMaybe<Array<PartnerChallengePeriodScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PartnerChallengePeriodOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PartnerChallengePeriodWhereInput>;
};

/** The type of activity required to complete a challenge */
export enum PartnerChallengeActivityType {
  Calories = 'CALORIES',
  CheckIn = 'CHECK_IN',
  Minutes = 'MINUTES',
  Running = 'RUNNING',
  Sleep = 'SLEEP',
  Steps = 'STEPS',
  Walking = 'WALKING',
  Workout = 'WORKOUT'
}

export type PartnerChallengeAvgAggregate = {
  __typename: 'PartnerChallengeAvgAggregate';
  goalValue?: Maybe<Scalars['Float']['output']>;
  winnerCount?: Maybe<Scalars['Float']['output']>;
};

export type PartnerChallengeCount = {
  __typename: 'PartnerChallengeCount';
  companies: Scalars['Int']['output'];
  periods: Scalars['Int']['output'];
};

export type PartnerChallengeCountAggregate = {
  __typename: 'PartnerChallengeCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  activityType: Scalars['Int']['output'];
  checkInRequired: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  goalUnit: Scalars['Int']['output'];
  goalValue: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['Int']['output'];
  joinable: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  partnerId: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  verificationType: Scalars['Int']['output'];
  winnerCount: Scalars['Int']['output'];
};

export type PartnerChallengeCreateNestedManyWithoutPartnerInput = {
  connect?: InputMaybe<Array<PartnerChallengeWhereUniqueInput>>;
};

export type PartnerChallengeCreateNestedOneWithoutPeriodsInput = {
  connect?: InputMaybe<PartnerChallengeWhereUniqueInput>;
};

/** Input for the partner challenge image */
export type PartnerChallengeImageInput = {
  /** Upload a new challenge image */
  fileUpload?: InputMaybe<Scalars['Upload']['input']>;
  /** The URL of an image */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerChallengeListRelationFilter = {
  every?: InputMaybe<PartnerChallengeWhereInput>;
  none?: InputMaybe<PartnerChallengeWhereInput>;
  some?: InputMaybe<PartnerChallengeWhereInput>;
};

export type PartnerChallengeMaxAggregate = {
  __typename: 'PartnerChallengeMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  activityType?: Maybe<PartnerChallengeActivityType>;
  checkInRequired?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  goalUnit?: Maybe<Scalars['String']['output']>;
  goalValue?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  joinable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<PartnerChallengeType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verificationType?: Maybe<PartnerChallengeVerificationType>;
  winnerCount?: Maybe<Scalars['Int']['output']>;
};

export type PartnerChallengeMinAggregate = {
  __typename: 'PartnerChallengeMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  activityType?: Maybe<PartnerChallengeActivityType>;
  checkInRequired?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  goalUnit?: Maybe<Scalars['String']['output']>;
  goalValue?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  joinable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<PartnerChallengeType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verificationType?: Maybe<PartnerChallengeVerificationType>;
  winnerCount?: Maybe<Scalars['Int']['output']>;
};

export type PartnerChallengeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PartnerChallengeOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  activityType?: InputMaybe<SortOrder>;
  checkInRequired?: InputMaybe<SortOrder>;
  companies?: InputMaybe<CompanyOrderByRelationAggregateInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  goalUnit?: InputMaybe<SortOrder>;
  goalValue?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  joinable?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  partner?: InputMaybe<PartnerOrderByWithRelationInput>;
  partnerId?: InputMaybe<SortOrder>;
  periods?: InputMaybe<PartnerChallengePeriodOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
  verificationType?: InputMaybe<SortOrder>;
  winnerCount?: InputMaybe<SortOrderInput>;
};

export type PartnerChallengeParticipation = {
  __typename: 'PartnerChallengeParticipation';
  customer: PartnerChallengeParticipationCustomer;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isFinished: Scalars['Boolean']['output'];
  isWinner: Scalars['Boolean']['output'];
  lastActivityDate?: Maybe<Scalars['DateTime']['output']>;
  partnerChallengePeriodId: Scalars['UUID']['output'];
  progress: Scalars['Float']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  status: ChallengeStatus;
  totalDuration: Scalars['Int']['output'];
};

export type PartnerChallengeParticipationCustomer = {
  __typename: 'PartnerChallengeParticipationCustomer';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type PartnerChallengePeriod = {
  __typename: 'PartnerChallengePeriod';
  _count: PartnerChallengePeriodCount;
  activeFrom: Scalars['DateTime']['output'];
  activeUntil: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  participations?: Maybe<Array<CustomerPartnerChallenge>>;
  partnerChallenge: PartnerChallenge;
  partnerChallengeId: Scalars['UUID']['output'];
  reward?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type PartnerChallengePeriodParticipationsArgs = {
  cursor?: InputMaybe<CustomerPartnerChallengeWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerPartnerChallengeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerPartnerChallengeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerPartnerChallengeWhereInput>;
};

export type PartnerChallengePeriodCount = {
  __typename: 'PartnerChallengePeriodCount';
  participations: Scalars['Int']['output'];
};

export type PartnerChallengePeriodCountAggregate = {
  __typename: 'PartnerChallengePeriodCountAggregate';
  _all: Scalars['Int']['output'];
  activeFrom: Scalars['Int']['output'];
  activeUntil: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  partnerChallengeId: Scalars['Int']['output'];
  reward: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type PartnerChallengePeriodCreateInput = {
  activeFrom: Scalars['DateTime']['input'];
  activeUntil: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  participations?: InputMaybe<CustomerPartnerChallengeCreateNestedManyWithoutPartnerChallengePeriodInput>;
  partnerChallenge: PartnerChallengeCreateNestedOneWithoutPeriodsInput;
  reward?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerChallengePeriodListRelationFilter = {
  every?: InputMaybe<PartnerChallengePeriodWhereInput>;
  none?: InputMaybe<PartnerChallengePeriodWhereInput>;
  some?: InputMaybe<PartnerChallengePeriodWhereInput>;
};

export type PartnerChallengePeriodMaxAggregate = {
  __typename: 'PartnerChallengePeriodMaxAggregate';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  partnerChallengeId?: Maybe<Scalars['UUID']['output']>;
  reward?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PartnerChallengePeriodMinAggregate = {
  __typename: 'PartnerChallengePeriodMinAggregate';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  partnerChallengeId?: Maybe<Scalars['UUID']['output']>;
  reward?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PartnerChallengePeriodOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PartnerChallengePeriodOrderByWithRelationInput = {
  activeFrom?: InputMaybe<SortOrder>;
  activeUntil?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  participations?: InputMaybe<CustomerPartnerChallengeOrderByRelationAggregateInput>;
  partnerChallenge?: InputMaybe<PartnerChallengeOrderByWithRelationInput>;
  partnerChallengeId?: InputMaybe<SortOrder>;
  reward?: InputMaybe<SortOrderInput>;
};

export type PartnerChallengePeriodRelationFilter = {
  is?: InputMaybe<PartnerChallengePeriodWhereInput>;
  isNot?: InputMaybe<PartnerChallengePeriodWhereInput>;
};

export enum PartnerChallengePeriodScalarFieldEnum {
  ActiveFrom = 'activeFrom',
  ActiveUntil = 'activeUntil',
  CreatedAt = 'createdAt',
  Id = 'id',
  PartnerChallengeId = 'partnerChallengeId',
  Reward = 'reward',
  UpdatedAt = 'updatedAt'
}

export type PartnerChallengePeriodUpdateInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeUntil?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  participations?: InputMaybe<CustomerPartnerChallengeUpdateManyWithoutPartnerChallengePeriodNestedInput>;
  partnerChallenge?: InputMaybe<PartnerChallengeUpdateOneRequiredWithoutPeriodsNestedInput>;
  reward?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerChallengePeriodWhereInput = {
  AND?: InputMaybe<Array<PartnerChallengePeriodWhereInput>>;
  NOT?: InputMaybe<Array<PartnerChallengePeriodWhereInput>>;
  OR?: InputMaybe<Array<PartnerChallengePeriodWhereInput>>;
  activeFrom?: InputMaybe<DateTimeFilter>;
  activeUntil?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  participations?: InputMaybe<CustomerPartnerChallengeListRelationFilter>;
  partnerChallenge?: InputMaybe<PartnerChallengeRelationFilter>;
  partnerChallengeId?: InputMaybe<UuidFilter>;
  reward?: InputMaybe<StringNullableFilter>;
};

export type PartnerChallengePeriodWhereUniqueInput = {
  AND?: InputMaybe<Array<PartnerChallengePeriodWhereInput>>;
  NOT?: InputMaybe<Array<PartnerChallengePeriodWhereInput>>;
  OR?: InputMaybe<Array<PartnerChallengePeriodWhereInput>>;
  activeFrom?: InputMaybe<DateTimeFilter>;
  activeUntil?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  participations?: InputMaybe<CustomerPartnerChallengeListRelationFilter>;
  partnerChallenge?: InputMaybe<PartnerChallengeRelationFilter>;
  partnerChallengeId?: InputMaybe<UuidFilter>;
  reward?: InputMaybe<StringNullableFilter>;
};

export type PartnerChallengeRelationFilter = {
  is?: InputMaybe<PartnerChallengeWhereInput>;
  isNot?: InputMaybe<PartnerChallengeWhereInput>;
};

export enum PartnerChallengeScalarFieldEnum {
  Active = 'active',
  ActivityType = 'activityType',
  CheckInRequired = 'checkInRequired',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  GoalUnit = 'goalUnit',
  GoalValue = 'goalValue',
  Id = 'id',
  ImageUrl = 'imageUrl',
  Joinable = 'joinable',
  Name = 'name',
  PartnerId = 'partnerId',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  VerificationType = 'verificationType',
  WinnerCount = 'winnerCount'
}

export type PartnerChallengeSumAggregate = {
  __typename: 'PartnerChallengeSumAggregate';
  goalValue?: Maybe<Scalars['Float']['output']>;
  winnerCount?: Maybe<Scalars['Int']['output']>;
};

export enum PartnerChallengeType {
  Highscore = 'HIGHSCORE',
  Race = 'RACE',
  Raffle = 'RAFFLE'
}

export type PartnerChallengeUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activityType?: InputMaybe<PartnerChallengeActivityType>;
  checkInRequired?: InputMaybe<Scalars['Boolean']['input']>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  goalUnit?: InputMaybe<Scalars['String']['input']>;
  goalValue?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  joinable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<PartnerUpdateOneRequiredWithoutChallengeNestedInput>;
  type?: InputMaybe<PartnerChallengeType>;
  verificationType?: InputMaybe<PartnerChallengeVerificationType>;
  winnerCount?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerChallengeUpdateOneRequiredWithoutPeriodsNestedInput = {
  connect?: InputMaybe<PartnerChallengeWhereUniqueInput>;
};

/** Defines how the progress or completion of a challenge is verified */
export enum PartnerChallengeVerificationType {
  AppTracking = 'APP_TRACKING',
  ExternalIntegration = 'EXTERNAL_INTEGRATION',
  InternalVerification = 'INTERNAL_VERIFICATION',
  ManualProof = 'MANUAL_PROOF'
}

export type PartnerChallengeWhereInput = {
  AND?: InputMaybe<Array<PartnerChallengeWhereInput>>;
  NOT?: InputMaybe<Array<PartnerChallengeWhereInput>>;
  OR?: InputMaybe<Array<PartnerChallengeWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  activityType?: InputMaybe<EnumPartnerChallengeActivityTypeFilter>;
  checkInRequired?: InputMaybe<BoolFilter>;
  companies?: InputMaybe<CompanyListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  goalUnit?: InputMaybe<StringFilter>;
  goalValue?: InputMaybe<FloatFilter>;
  id?: InputMaybe<UuidFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  joinable?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  partner?: InputMaybe<PartnerRelationFilter>;
  partnerId?: InputMaybe<StringFilter>;
  periods?: InputMaybe<PartnerChallengePeriodListRelationFilter>;
  type?: InputMaybe<EnumPartnerChallengeTypeFilter>;
  verificationType?: InputMaybe<EnumPartnerChallengeVerificationTypeFilter>;
  winnerCount?: InputMaybe<IntNullableFilter>;
};

export type PartnerChallengeWhereUniqueInput = {
  AND?: InputMaybe<Array<PartnerChallengeWhereInput>>;
  NOT?: InputMaybe<Array<PartnerChallengeWhereInput>>;
  OR?: InputMaybe<Array<PartnerChallengeWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  activityType?: InputMaybe<EnumPartnerChallengeActivityTypeFilter>;
  checkInRequired?: InputMaybe<BoolFilter>;
  companies?: InputMaybe<CompanyListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  goalUnit?: InputMaybe<StringFilter>;
  goalValue?: InputMaybe<FloatFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  joinable?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  partner?: InputMaybe<PartnerRelationFilter>;
  partnerId?: InputMaybe<StringFilter>;
  periods?: InputMaybe<PartnerChallengePeriodListRelationFilter>;
  type?: InputMaybe<EnumPartnerChallengeTypeFilter>;
  verificationType?: InputMaybe<EnumPartnerChallengeVerificationTypeFilter>;
  winnerCount?: InputMaybe<IntNullableFilter>;
};

export type PartnerConfig = {
  __typename: 'PartnerConfig';
  /** The API URL to request a discount code */
  apiUrl: Scalars['String']['output'];
  /** The Awin Advertiser ID (Merchant ID) of this partner, if they use Awin */
  awinAdvertiserId?: Maybe<Scalars['String']['output']>;
  /** The amount of the commission for the partner */
  commission: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  partner: Partner;
  partnerId: Scalars['String']['output'];
  /** The Shop type (e.g. Shopify) */
  shopType: ShopType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnerConfigAvgAggregate = {
  __typename: 'PartnerConfigAvgAggregate';
  commission?: Maybe<Scalars['Float']['output']>;
};

export type PartnerConfigCountAggregate = {
  __typename: 'PartnerConfigCountAggregate';
  _all: Scalars['Int']['output'];
  apiUrl: Scalars['Int']['output'];
  awinAdvertiserId: Scalars['Int']['output'];
  commission: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  partnerId: Scalars['Int']['output'];
  shopType: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating a partner configuration */
export type PartnerConfigCreateInput = {
  apiUrl: Scalars['String']['input'];
  commission?: InputMaybe<Scalars['Float']['input']>;
  /** The partner's shop type */
  shopType: ShopType;
};

export type PartnerConfigMaxAggregate = {
  __typename: 'PartnerConfigMaxAggregate';
  apiUrl?: Maybe<Scalars['String']['output']>;
  awinAdvertiserId?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  shopType?: Maybe<ShopType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PartnerConfigMinAggregate = {
  __typename: 'PartnerConfigMinAggregate';
  apiUrl?: Maybe<Scalars['String']['output']>;
  awinAdvertiserId?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  shopType?: Maybe<ShopType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PartnerConfigNullableRelationFilter = {
  is?: InputMaybe<PartnerConfigWhereInput>;
  isNot?: InputMaybe<PartnerConfigWhereInput>;
};

export type PartnerConfigOrderByWithRelationInput = {
  apiUrl?: InputMaybe<SortOrder>;
  awinAdvertiserId?: InputMaybe<SortOrderInput>;
  commission?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  partner?: InputMaybe<PartnerOrderByWithRelationInput>;
  shopType?: InputMaybe<SortOrder>;
};

export enum PartnerConfigScalarFieldEnum {
  ApiUrl = 'apiUrl',
  AwinAdvertiserId = 'awinAdvertiserId',
  Commission = 'commission',
  CreatedAt = 'createdAt',
  Id = 'id',
  PartnerId = 'partnerId',
  ShopType = 'shopType',
  UpdatedAt = 'updatedAt'
}

export type PartnerConfigSumAggregate = {
  __typename: 'PartnerConfigSumAggregate';
  commission?: Maybe<Scalars['Float']['output']>;
};

export type PartnerConfigWhereInput = {
  AND?: InputMaybe<Array<PartnerConfigWhereInput>>;
  NOT?: InputMaybe<Array<PartnerConfigWhereInput>>;
  OR?: InputMaybe<Array<PartnerConfigWhereInput>>;
  apiUrl?: InputMaybe<StringFilter>;
  awinAdvertiserId?: InputMaybe<StringNullableFilter>;
  commission?: InputMaybe<FloatFilter>;
  id?: InputMaybe<UuidFilter>;
  partner?: InputMaybe<PartnerRelationFilter>;
  shopType?: InputMaybe<EnumShopTypeFilter>;
};

export type PartnerConfigWhereUniqueInput = {
  AND?: InputMaybe<Array<PartnerConfigWhereInput>>;
  NOT?: InputMaybe<Array<PartnerConfigWhereInput>>;
  OR?: InputMaybe<Array<PartnerConfigWhereInput>>;
  apiUrl?: InputMaybe<StringFilter>;
  awinAdvertiserId?: InputMaybe<StringNullableFilter>;
  commission?: InputMaybe<FloatFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  partner?: InputMaybe<PartnerRelationFilter>;
  shopType?: InputMaybe<EnumShopTypeFilter>;
};

export type PartnerCount = {
  __typename: 'PartnerCount';
  challenge: Scalars['Int']['output'];
  companies: Scalars['Int']['output'];
  offers: Scalars['Int']['output'];
  rewards: Scalars['Int']['output'];
};

export type PartnerCountAggregate = {
  __typename: 'PartnerCountAggregate';
  _all: Scalars['Int']['output'];
  city: Scalars['Int']['output'];
  countryCode: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  houseNumber: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  latitude: Scalars['Int']['output'];
  logoUrl: Scalars['Int']['output'];
  longitude: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  organizationName: Scalars['Int']['output'];
  partnerConfigId: Scalars['Int']['output'];
  postalCode: Scalars['Int']['output'];
  state: Scalars['Int']['output'];
  street: Scalars['Int']['output'];
  timeZone: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  websiteUrl: Scalars['Int']['output'];
};

/** Input for creating a new partner */
export type PartnerCreateInput = {
  challenge?: InputMaybe<PartnerChallengeCreateNestedManyWithoutPartnerInput>;
  city: Scalars['String']['input'];
  companies?: InputMaybe<CompanyCreateNestedManyWithoutPartnersInput>;
  config: PartnerConfigCreateInput;
  countryCode: Scalars['CountryCode']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['EmailAddress']['input'];
  houseNumber: Scalars['String']['input'];
  id: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  name: Scalars['String']['input'];
  offers?: InputMaybe<PartnerOfferCreateNestedManyWithoutPartnerInput>;
  organizationName: Scalars['String']['input'];
  partnerConfigId?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['PostalCode']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  websiteUrl: Scalars['String']['input'];
};

export type PartnerCreateNestedOneWithoutChallengeInput = {
  connect?: InputMaybe<PartnerWhereUniqueInput>;
};

export type PartnerCreateNestedOneWithoutOffersInput = {
  connect?: InputMaybe<PartnerWhereUniqueInput>;
};

export type PartnerCreateNestedOneWithoutRewardsInput = {
  connect: PartnerWhereUniqueInput;
};

export type PartnerDeal = PartnerOffer | PartnerReward;

export type PartnerListRelationFilter = {
  every?: InputMaybe<PartnerWhereInput>;
  none?: InputMaybe<PartnerWhereInput>;
  some?: InputMaybe<PartnerWhereInput>;
};

export type PartnerLocationCompoundUniqueInput = {
  city: Scalars['String']['input'];
  countryCode: Scalars['CountryCode']['input'];
  houseNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  postalCode: Scalars['PostalCode']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type PartnerMaxAggregate = {
  __typename: 'PartnerMaxAggregate';
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['CountryCode']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Decimal']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  partnerConfigId?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['PostalCode']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['TimeZone']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type PartnerMinAggregate = {
  __typename: 'PartnerMinAggregate';
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['CountryCode']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Decimal']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  partnerConfigId?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['PostalCode']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['TimeZone']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type PartnerOffer = {
  __typename: 'PartnerOffer';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** A description for the offer */
  description?: Maybe<Scalars['String']['output']>;
  /** The static discount code for this offer */
  discountCode?: Maybe<Scalars['String']['output']>;
  /** The discount that the customer gets in percent */
  discountPercent?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  /** The dynamically generated link to the partner shop */
  link: Scalars['String']['output'];
  /** The name of the offer */
  name: Scalars['String']['output'];
  partner: Partner;
  partnerId: Scalars['String']['output'];
  /** The target shop URL (raw url to the shop or product) */
  shopUrl: Scalars['String']['output'];
  /** The type of the offer (determines how the final link is built) */
  type: PartnerOfferType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnerOfferAvgAggregate = {
  __typename: 'PartnerOfferAvgAggregate';
  discountPercent?: Maybe<Scalars['Float']['output']>;
};

export type PartnerOfferCountAggregate = {
  __typename: 'PartnerOfferCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  discountCode: Scalars['Int']['output'];
  discountPercent: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  partnerId: Scalars['Int']['output'];
  shopUrl: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type PartnerOfferCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  discountPercent?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  partner: PartnerCreateNestedOneWithoutOffersInput;
  shopUrl: Scalars['String']['input'];
  type?: InputMaybe<PartnerOfferType>;
};

export type PartnerOfferCreateNestedManyWithoutPartnerInput = {
  connect?: InputMaybe<Array<PartnerOfferWhereUniqueInput>>;
};

export type PartnerOfferListRelationFilter = {
  every?: InputMaybe<PartnerOfferWhereInput>;
  none?: InputMaybe<PartnerOfferWhereInput>;
  some?: InputMaybe<PartnerOfferWhereInput>;
};

export type PartnerOfferMaxAggregate = {
  __typename: 'PartnerOfferMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountCode?: Maybe<Scalars['String']['output']>;
  discountPercent?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  shopUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PartnerOfferType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PartnerOfferMinAggregate = {
  __typename: 'PartnerOfferMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountCode?: Maybe<Scalars['String']['output']>;
  discountPercent?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  shopUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PartnerOfferType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PartnerOfferOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PartnerOfferOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  discountCode?: InputMaybe<SortOrderInput>;
  discountPercent?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  partner?: InputMaybe<PartnerOrderByWithRelationInput>;
  shopUrl?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum PartnerOfferScalarFieldEnum {
  Active = 'active',
  CreatedAt = 'createdAt',
  Description = 'description',
  DiscountCode = 'discountCode',
  DiscountPercent = 'discountPercent',
  Id = 'id',
  Name = 'name',
  PartnerId = 'partnerId',
  ShopUrl = 'shopUrl',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type PartnerOfferSumAggregate = {
  __typename: 'PartnerOfferSumAggregate';
  discountPercent?: Maybe<Scalars['Int']['output']>;
};

export enum PartnerOfferType {
  Awin = 'AWIN',
  DiscountCode = 'DISCOUNT_CODE'
}

export type PartnerOfferUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  discountPercent?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<PartnerUpdateOneRequiredWithoutOffersNestedInput>;
  shopUrl?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PartnerOfferType>;
};

export type PartnerOfferWhereInput = {
  AND?: InputMaybe<Array<PartnerOfferWhereInput>>;
  NOT?: InputMaybe<Array<PartnerOfferWhereInput>>;
  OR?: InputMaybe<Array<PartnerOfferWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  description?: InputMaybe<StringNullableFilter>;
  discountCode?: InputMaybe<StringNullableFilter>;
  discountPercent?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  partner?: InputMaybe<PartnerRelationFilter>;
  shopUrl?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumPartnerOfferTypeFilter>;
};

export type PartnerOfferWhereUniqueInput = {
  AND?: InputMaybe<Array<PartnerOfferWhereInput>>;
  NOT?: InputMaybe<Array<PartnerOfferWhereInput>>;
  OR?: InputMaybe<Array<PartnerOfferWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  description?: InputMaybe<StringNullableFilter>;
  discountCode?: InputMaybe<StringNullableFilter>;
  discountPercent?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<StringFilter>;
  partner?: InputMaybe<PartnerRelationFilter>;
  shopUrl?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumPartnerOfferTypeFilter>;
};

export type PartnerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PartnerOrderByWithRelationInput = {
  challenge?: InputMaybe<PartnerChallengeOrderByRelationAggregateInput>;
  city?: InputMaybe<SortOrder>;
  companies?: InputMaybe<CompanyOrderByRelationAggregateInput>;
  config?: InputMaybe<PartnerConfigOrderByWithRelationInput>;
  countryCode?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrder>;
  houseNumber?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrderInput>;
  logoUrl?: InputMaybe<SortOrderInput>;
  longitude?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  offers?: InputMaybe<PartnerOfferOrderByRelationAggregateInput>;
  organizationName?: InputMaybe<SortOrder>;
  partnerConfigId?: InputMaybe<SortOrderInput>;
  postalCode?: InputMaybe<SortOrder>;
  rewards?: InputMaybe<PartnerRewardOrderByRelationAggregateInput>;
  state?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
  websiteUrl?: InputMaybe<SortOrder>;
};

export type PartnerRelationFilter = {
  is?: InputMaybe<PartnerWhereInput>;
  isNot?: InputMaybe<PartnerWhereInput>;
};

export type PartnerReward = {
  __typename: 'PartnerReward';
  _count: PartnerRewardCount;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A description for the reward */
  description?: Maybe<Scalars['String']['output']>;
  /** The discount ammount that the customer gets */
  discountAmount?: Maybe<Scalars['Decimal']['output']>;
  /** The discount that the customer gets in percent */
  discountPercent?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  /** The minimum purchase amount to make the discount valid */
  minPurchaseAmount?: Maybe<Scalars['Decimal']['output']>;
  /** The name of the reward */
  name: Scalars['String']['output'];
  partner: Partner;
  partnerId: Scalars['String']['output'];
  redemptions?: Maybe<Array<RedeemedPartnerReward>>;
  /** The required points to redeem this reward */
  requiredPoints: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The number of days the discount is valid. Set to 0 if you want the discount to be valid indefinitely */
  validityDays: Scalars['Int']['output'];
};

export type PartnerRewardAvgAggregate = {
  __typename: 'PartnerRewardAvgAggregate';
  discountAmount?: Maybe<Scalars['Decimal']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  minPurchaseAmount?: Maybe<Scalars['Decimal']['output']>;
  requiredPoints?: Maybe<Scalars['Float']['output']>;
  validityDays?: Maybe<Scalars['Float']['output']>;
};

export type PartnerRewardCount = {
  __typename: 'PartnerRewardCount';
  redemptions: Scalars['Int']['output'];
};

export type PartnerRewardCountAggregate = {
  __typename: 'PartnerRewardCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  discountAmount: Scalars['Int']['output'];
  discountPercent: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  minPurchaseAmount: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  partnerId: Scalars['Int']['output'];
  requiredPoints: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  validityDays: Scalars['Int']['output'];
};

/** Input for creating a partner reward */
export type PartnerRewardCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discountPercent?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  partner: PartnerCreateNestedOneWithoutRewardsInput;
  requiredPoints: Scalars['Int']['input'];
};

export type PartnerRewardCreateNestedOneWithoutRedemptionsInput = {
  connect?: InputMaybe<PartnerRewardWhereUniqueInput>;
};

export type PartnerRewardListRelationFilter = {
  every?: InputMaybe<PartnerRewardWhereInput>;
  none?: InputMaybe<PartnerRewardWhereInput>;
  some?: InputMaybe<PartnerRewardWhereInput>;
};

export type PartnerRewardMaxAggregate = {
  __typename: 'PartnerRewardMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Decimal']['output']>;
  discountPercent?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  minPurchaseAmount?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  requiredPoints?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validityDays?: Maybe<Scalars['Int']['output']>;
};

export type PartnerRewardMinAggregate = {
  __typename: 'PartnerRewardMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Decimal']['output']>;
  discountPercent?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  minPurchaseAmount?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  requiredPoints?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validityDays?: Maybe<Scalars['Int']['output']>;
};

export type PartnerRewardOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PartnerRewardOrderByWithRelationInput = {
  deletedAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  discountAmount?: InputMaybe<SortOrderInput>;
  discountPercent?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  minPurchaseAmount?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  partner?: InputMaybe<PartnerOrderByWithRelationInput>;
  redemptions?: InputMaybe<RedeemedPartnerRewardOrderByRelationAggregateInput>;
  requiredPoints?: InputMaybe<SortOrder>;
  validityDays?: InputMaybe<SortOrder>;
};

export type PartnerRewardRelationFilter = {
  is?: InputMaybe<PartnerRewardWhereInput>;
  isNot?: InputMaybe<PartnerRewardWhereInput>;
};

export enum PartnerRewardScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  DiscountAmount = 'discountAmount',
  DiscountPercent = 'discountPercent',
  Id = 'id',
  MinPurchaseAmount = 'minPurchaseAmount',
  Name = 'name',
  PartnerId = 'partnerId',
  RequiredPoints = 'requiredPoints',
  UpdatedAt = 'updatedAt',
  ValidityDays = 'validityDays'
}

export type PartnerRewardSumAggregate = {
  __typename: 'PartnerRewardSumAggregate';
  discountAmount?: Maybe<Scalars['Decimal']['output']>;
  discountPercent?: Maybe<Scalars['Int']['output']>;
  minPurchaseAmount?: Maybe<Scalars['Decimal']['output']>;
  requiredPoints?: Maybe<Scalars['Int']['output']>;
  validityDays?: Maybe<Scalars['Int']['output']>;
};

export type PartnerRewardWhereInput = {
  AND?: InputMaybe<Array<PartnerRewardWhereInput>>;
  NOT?: InputMaybe<Array<PartnerRewardWhereInput>>;
  OR?: InputMaybe<Array<PartnerRewardWhereInput>>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  discountAmount?: InputMaybe<DecimalNullableFilter>;
  discountPercent?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  minPurchaseAmount?: InputMaybe<DecimalNullableFilter>;
  name?: InputMaybe<StringFilter>;
  partner?: InputMaybe<PartnerRelationFilter>;
  redemptions?: InputMaybe<RedeemedPartnerRewardListRelationFilter>;
  requiredPoints?: InputMaybe<IntFilter>;
  validityDays?: InputMaybe<IntFilter>;
};

export type PartnerRewardWhereUniqueInput = {
  AND?: InputMaybe<Array<PartnerRewardWhereInput>>;
  NOT?: InputMaybe<Array<PartnerRewardWhereInput>>;
  OR?: InputMaybe<Array<PartnerRewardWhereInput>>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  discountAmount?: InputMaybe<DecimalNullableFilter>;
  discountPercent?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  minPurchaseAmount?: InputMaybe<DecimalNullableFilter>;
  name?: InputMaybe<StringFilter>;
  partner?: InputMaybe<PartnerRelationFilter>;
  redemptions?: InputMaybe<RedeemedPartnerRewardListRelationFilter>;
  requiredPoints?: InputMaybe<IntFilter>;
  validityDays?: InputMaybe<IntFilter>;
};

export enum PartnerScalarFieldEnum {
  City = 'city',
  CountryCode = 'countryCode',
  CreatedAt = 'createdAt',
  Description = 'description',
  Email = 'email',
  HouseNumber = 'houseNumber',
  Id = 'id',
  Latitude = 'latitude',
  LogoUrl = 'logoUrl',
  Longitude = 'longitude',
  Name = 'name',
  OrganizationName = 'organizationName',
  PartnerConfigId = 'partnerConfigId',
  PostalCode = 'postalCode',
  State = 'state',
  Street = 'street',
  TimeZone = 'timeZone',
  UpdatedAt = 'updatedAt',
  WebsiteUrl = 'websiteUrl'
}

export type PartnerSumAggregate = {
  __typename: 'PartnerSumAggregate';
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
};

export type PartnerUpdateOneRequiredWithoutChallengeNestedInput = {
  connect?: InputMaybe<PartnerWhereUniqueInput>;
};

export type PartnerUpdateOneRequiredWithoutOffersNestedInput = {
  connect?: InputMaybe<PartnerWhereUniqueInput>;
};

export type PartnerWhereInput = {
  AND?: InputMaybe<Array<PartnerWhereInput>>;
  NOT?: InputMaybe<Array<PartnerWhereInput>>;
  OR?: InputMaybe<Array<PartnerWhereInput>>;
  challenge?: InputMaybe<PartnerChallengeListRelationFilter>;
  city?: InputMaybe<StringFilter>;
  companies?: InputMaybe<CompanyListRelationFilter>;
  config?: InputMaybe<PartnerConfigNullableRelationFilter>;
  countryCode?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  latitude?: InputMaybe<DecimalNullableFilter>;
  logoUrl?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<DecimalNullableFilter>;
  name?: InputMaybe<StringFilter>;
  offers?: InputMaybe<PartnerOfferListRelationFilter>;
  organizationName?: InputMaybe<StringFilter>;
  partnerConfigId?: InputMaybe<UuidNullableFilter>;
  postalCode?: InputMaybe<StringFilter>;
  rewards?: InputMaybe<PartnerRewardListRelationFilter>;
  state?: InputMaybe<StringFilter>;
  street?: InputMaybe<StringFilter>;
  timeZone?: InputMaybe<StringFilter>;
  websiteUrl?: InputMaybe<StringFilter>;
};

export type PartnerWhereUniqueInput = {
  AND?: InputMaybe<Array<PartnerWhereInput>>;
  NOT?: InputMaybe<Array<PartnerWhereInput>>;
  OR?: InputMaybe<Array<PartnerWhereInput>>;
  challenge?: InputMaybe<PartnerChallengeListRelationFilter>;
  city?: InputMaybe<StringFilter>;
  companies?: InputMaybe<CompanyListRelationFilter>;
  config?: InputMaybe<PartnerConfigNullableRelationFilter>;
  countryCode?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  houseNumber?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<DecimalNullableFilter>;
  location?: InputMaybe<PartnerLocationCompoundUniqueInput>;
  logoUrl?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<DecimalNullableFilter>;
  name?: InputMaybe<StringFilter>;
  offers?: InputMaybe<PartnerOfferListRelationFilter>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  partnerConfigId?: InputMaybe<UuidNullableFilter>;
  postalCode?: InputMaybe<StringFilter>;
  rewards?: InputMaybe<PartnerRewardListRelationFilter>;
  state?: InputMaybe<StringFilter>;
  street?: InputMaybe<StringFilter>;
  timeZone?: InputMaybe<StringFilter>;
  websiteUrl?: InputMaybe<StringFilter>;
};

/** Input for activation of passive points challenges */
export type PassivePointsChallengeActivateInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  branchOffice?: InputMaybe<BranchOfficeCreateNestedOneWithoutChallengesInput>;
  /** Optional parameter to connect a challenge to a specific company */
  company?: InputMaybe<CompanyCreateNestedOneWithoutChallengesInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Configure the challenge image by uploading an image or specify and image URL */
  image?: InputMaybe<ChallengeImageInput>;
  name: Scalars['String']['input'];
  pointsCredit: Scalars['Int']['input'];
  trainingGoal: Scalars['Int']['input'];
};

/** Pending amendment for customer payment data */
export type PaymentDataAmendment = {
  __typename: 'PaymentDataAmendment';
  /** The account holder of the bank account */
  accountHolder?: Maybe<Scalars['String']['output']>;
  /** Name of the bank */
  bankName?: Maybe<Scalars['String']['output']>;
  /** BIC of the client's account */
  bic?: Maybe<Scalars['String']['output']>;
  /** IBAN of the client's account */
  iban?: Maybe<Scalars['String']['output']>;
  /** Amendment proposal id */
  id?: Maybe<Scalars['Int']['output']>;
  /** Is customer signature required to make amendment */
  requireSignature?: Maybe<Scalars['Boolean']['output']>;
};

/** Customer payment amendment data */
export type PaymentDataAmendmentInput = {
  /** The account holder of the bank account */
  accountHolder: Scalars['String']['input'];
  /** Name of the bank */
  bankName: Scalars['String']['input'];
  /** BIC of the client's account */
  bic: Scalars['String']['input'];
  /** IBAN of the client's account */
  iban: Scalars['String']['input'];
  /** Signature of the customer */
  signature?: InputMaybe<SignatureInput>;
};

/** Represents the payment frequency of an additional module */
export type PaymentFrequency = {
  __typename: 'PaymentFrequency';
  /** Unique ID of the payment frequency */
  id?: Maybe<Scalars['Int']['output']>;
  /** Month day to prices list (used for MONTH_DAY frequency) */
  monthDaysToPrices?: Maybe<Array<MonthDayToPrice>>;
  /** Base price for RECURRING frequencies */
  price?: Maybe<Money>;
  /** Term information if applicable */
  term?: Maybe<Term>;
  /** Terms to prices list (used for TERM_BASED frequency) */
  termsToPrices?: Maybe<Array<TermToPrice>>;
  /** Payment frequency type of the additional module */
  type?: Maybe<AdditionalModulePaymentFrequencyType>;
};

export type PlatformCompany = {
  __typename: 'PlatformCompany';
  /** TODO (GYM-DEALS Integration): HideField for backward compatibility -> See register-company.input.ts and company.service.ts */
  appConnectionName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
};

export type PointSystem = {
  __typename: 'PointSystem';
  calculationRuleEntries: Scalars['Int']['output'];
  company: Company;
  companyId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  pointSystemType: PointSystemType;
  pointSystemTypeId: Scalars['UUID']['output'];
  scanLimit: Scalars['Int']['output'];
};

export type PointSystemAvgAggregate = {
  __typename: 'PointSystemAvgAggregate';
  calculationRuleEntries?: Maybe<Scalars['Float']['output']>;
  scanLimit?: Maybe<Scalars['Float']['output']>;
};

export type PointSystemCountAggregate = {
  __typename: 'PointSystemCountAggregate';
  _all: Scalars['Int']['output'];
  calculationRuleEntries: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  pointSystemTypeId: Scalars['Int']['output'];
  scanLimit: Scalars['Int']['output'];
};

/** Input for creation of point system */
export type PointSystemCreateInput = {
  pointSystemType: PointSystemTypeCreateNestedOneWithoutPointSystemInput;
  /** Only allowed for system type VISIT_BASED. In combination with other system types, an error will be thrown */
  scanLimit?: InputMaybe<Scalars['Float']['input']>;
};

export type PointSystemCreateNestedManyWithoutPointSystemTypeInput = {
  connect?: InputMaybe<Array<PointSystemWhereUniqueInput>>;
};

export type PointSystemListRelationFilter = {
  every?: InputMaybe<PointSystemWhereInput>;
  none?: InputMaybe<PointSystemWhereInput>;
  some?: InputMaybe<PointSystemWhereInput>;
};

export type PointSystemMaxAggregate = {
  __typename: 'PointSystemMaxAggregate';
  calculationRuleEntries?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  pointSystemTypeId?: Maybe<Scalars['UUID']['output']>;
  scanLimit?: Maybe<Scalars['Int']['output']>;
};

export type PointSystemMinAggregate = {
  __typename: 'PointSystemMinAggregate';
  calculationRuleEntries?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  pointSystemTypeId?: Maybe<Scalars['UUID']['output']>;
  scanLimit?: Maybe<Scalars['Int']['output']>;
};

export type PointSystemNullableRelationFilter = {
  is?: InputMaybe<PointSystemWhereInput>;
  isNot?: InputMaybe<PointSystemWhereInput>;
};

export type PointSystemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PointSystemOrderByWithRelationInput = {
  calculationRuleEntries?: InputMaybe<SortOrder>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  id?: InputMaybe<SortOrder>;
  pointSystemType?: InputMaybe<PointSystemTypeOrderByWithRelationInput>;
  scanLimit?: InputMaybe<SortOrder>;
};

export enum PointSystemScalarFieldEnum {
  CalculationRuleEntries = 'calculationRuleEntries',
  CompanyId = 'companyId',
  Id = 'id',
  PointSystemTypeId = 'pointSystemTypeId',
  ScanLimit = 'scanLimit'
}

export type PointSystemScalarWhereInput = {
  AND?: InputMaybe<Array<PointSystemScalarWhereInput>>;
  NOT?: InputMaybe<Array<PointSystemScalarWhereInput>>;
  OR?: InputMaybe<Array<PointSystemScalarWhereInput>>;
  calculationRuleEntries?: InputMaybe<IntFilter>;
  id?: InputMaybe<UuidFilter>;
  scanLimit?: InputMaybe<IntFilter>;
};

export type PointSystemSumAggregate = {
  __typename: 'PointSystemSumAggregate';
  calculationRuleEntries?: Maybe<Scalars['Int']['output']>;
  scanLimit?: Maybe<Scalars['Int']['output']>;
};

export type PointSystemType = {
  __typename: 'PointSystemType';
  _count: PointSystemTypeCount;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  pointSystem?: Maybe<Array<PointSystem>>;
  type: SystemType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PointSystemTypeCount = {
  __typename: 'PointSystemTypeCount';
  pointSystem: Scalars['Int']['output'];
};

export type PointSystemTypeCountAggregate = {
  __typename: 'PointSystemTypeCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type PointSystemTypeCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  pointSystem?: InputMaybe<PointSystemCreateNestedManyWithoutPointSystemTypeInput>;
  type?: InputMaybe<SystemType>;
};

export type PointSystemTypeCreateNestedOneWithoutPointSystemInput = {
  connect?: InputMaybe<PointSystemTypeWhereUniqueInput>;
};

export type PointSystemTypeMaxAggregate = {
  __typename: 'PointSystemTypeMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<SystemType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PointSystemTypeMinAggregate = {
  __typename: 'PointSystemTypeMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<SystemType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PointSystemTypeOrderByWithRelationInput = {
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  pointSystem?: InputMaybe<PointSystemOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
};

export type PointSystemTypeRelationFilter = {
  is?: InputMaybe<PointSystemTypeWhereInput>;
  isNot?: InputMaybe<PointSystemTypeWhereInput>;
};

export enum PointSystemTypeScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type PointSystemTypeUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  pointSystem?: InputMaybe<PointSystemUpdateManyWithoutPointSystemTypeNestedInput>;
  type?: InputMaybe<SystemType>;
};

export type PointSystemTypeUpdateOneRequiredWithoutPointSystemNestedInput = {
  connect?: InputMaybe<PointSystemTypeWhereUniqueInput>;
};

export type PointSystemTypeWhereInput = {
  AND?: InputMaybe<Array<PointSystemTypeWhereInput>>;
  NOT?: InputMaybe<Array<PointSystemTypeWhereInput>>;
  OR?: InputMaybe<Array<PointSystemTypeWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  pointSystem?: InputMaybe<PointSystemListRelationFilter>;
  type?: InputMaybe<EnumSystemTypeFilter>;
};

export type PointSystemTypeWhereUniqueInput = {
  AND?: InputMaybe<Array<PointSystemTypeWhereInput>>;
  NOT?: InputMaybe<Array<PointSystemTypeWhereInput>>;
  OR?: InputMaybe<Array<PointSystemTypeWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  pointSystem?: InputMaybe<PointSystemListRelationFilter>;
  type?: InputMaybe<SystemType>;
};

export type PointSystemUpdateInput = {
  calculationRuleEntries?: InputMaybe<Scalars['Int']['input']>;
  company?: InputMaybe<CompanyUpdateOneRequiredWithoutPointSystemNestedInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  pointSystemType?: InputMaybe<PointSystemTypeUpdateOneRequiredWithoutPointSystemNestedInput>;
  scanLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type PointSystemUpdateManyMutationInput = {
  calculationRuleEntries?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  scanLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type PointSystemUpdateManyWithWhereWithoutPointSystemTypeInput = {
  data: PointSystemUpdateManyMutationInput;
  where: PointSystemScalarWhereInput;
};

export type PointSystemUpdateManyWithoutPointSystemTypeNestedInput = {
  connect?: InputMaybe<Array<PointSystemWhereUniqueInput>>;
  delete?: InputMaybe<Array<PointSystemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PointSystemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PointSystemWhereUniqueInput>>;
  set?: InputMaybe<Array<PointSystemWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<PointSystemUpdateManyWithWhereWithoutPointSystemTypeInput>>;
};

export type PointSystemWhereInput = {
  AND?: InputMaybe<Array<PointSystemWhereInput>>;
  NOT?: InputMaybe<Array<PointSystemWhereInput>>;
  OR?: InputMaybe<Array<PointSystemWhereInput>>;
  calculationRuleEntries?: InputMaybe<IntFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  pointSystemType?: InputMaybe<PointSystemTypeRelationFilter>;
  scanLimit?: InputMaybe<IntFilter>;
};

export type PointSystemWhereUniqueInput = {
  AND?: InputMaybe<Array<PointSystemWhereInput>>;
  NOT?: InputMaybe<Array<PointSystemWhereInput>>;
  OR?: InputMaybe<Array<PointSystemWhereInput>>;
  calculationRuleEntries?: InputMaybe<IntFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  pointSystemType?: InputMaybe<PointSystemTypeRelationFilter>;
  scanLimit?: InputMaybe<IntFilter>;
};

export type Popup = {
  __typename: 'Popup';
  _count: PopupCount;
  /** Indicator whether this popup is currently active */
  active: Scalars['Boolean']['output'];
  /** The URL the user will be redirected to after clicking the popup */
  clickUrl?: Maybe<Scalars['String']['output']>;
  /** The relation to the company that owns this popup */
  company: Company;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** An optional description for view in the management portal */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** The URL to the image for this popup */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** An optional name for view in the management portal */
  name?: Maybe<Scalars['String']['output']>;
  /** The periods of this popup */
  periods?: Maybe<Array<PopupPeriod>>;
  updatedAt: Scalars['DateTime']['output'];
};


export type PopupPeriodsArgs = {
  cursor?: InputMaybe<PopupPeriodWhereUniqueInput>;
  distinct?: InputMaybe<Array<PopupPeriodScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PopupPeriodOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PopupPeriodWhereInput>;
};

export type PopupCompanyPopupUniqueCompoundUniqueInput = {
  name: Scalars['String']['input'];
};

export type PopupCount = {
  __typename: 'PopupCount';
  periods: Scalars['Int']['output'];
};

export type PopupCountAggregate = {
  __typename: 'PopupCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  clickUrl: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating one popup */
export type PopupCreateInput = {
  clickUrl?: InputMaybe<Scalars['String']['input']>;
  /** Optionally specify the company for this popup */
  company?: InputMaybe<CompanyCreateNestedOneWithoutPopupsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Input for uploading or linking an image for this popup */
  image: PopupImageInput;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify the period for this popup */
  period: PopupPeriodCreateInput;
};

export type PopupCreateNestedOneWithoutPeriodsInput = {
  connect: PopupWhereUniqueInput;
};

/** Input for the popup image */
export type PopupImageInput = {
  /** Upload a new popup image */
  fileUpload?: InputMaybe<Scalars['Upload']['input']>;
  /** The URL of an image */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PopupListRelationFilter = {
  every?: InputMaybe<PopupWhereInput>;
  none?: InputMaybe<PopupWhereInput>;
  some?: InputMaybe<PopupWhereInput>;
};

export type PopupMaxAggregate = {
  __typename: 'PopupMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  clickUrl?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PopupMinAggregate = {
  __typename: 'PopupMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  clickUrl?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PopupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PopupOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  clickUrl?: InputMaybe<SortOrderInput>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrderInput>;
  periods?: InputMaybe<PopupPeriodOrderByRelationAggregateInput>;
};

export type PopupPeriod = {
  __typename: 'PopupPeriod';
  /** The startdate at which this popup should be visible */
  activeFrom: Scalars['DateTime']['output'];
  /** The enddate of this popup to be visible */
  activeUntil: Scalars['DateTime']['output'];
  /** The current number of clicks for this popup */
  clicks: Scalars['Int']['output'];
  /** The current number of closes for this popup */
  closes: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  popup: Popup;
  popupId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The current number of total views for this popup */
  views: Scalars['Int']['output'];
};

export type PopupPeriodAvgAggregate = {
  __typename: 'PopupPeriodAvgAggregate';
  clicks?: Maybe<Scalars['Float']['output']>;
  closes?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

export type PopupPeriodCountAggregate = {
  __typename: 'PopupPeriodCountAggregate';
  _all: Scalars['Int']['output'];
  activeFrom: Scalars['Int']['output'];
  activeUntil: Scalars['Int']['output'];
  clicks: Scalars['Int']['output'];
  closes: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  popupId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

/** Input for creating a popup period */
export type PopupPeriodCreateInput = {
  activeFrom: Scalars['DateTime']['input'];
  activeUntil: Scalars['DateTime']['input'];
};

/** Input for creating a popup period */
export type PopupPeriodCreateNextInput = {
  activeFrom: Scalars['DateTime']['input'];
  activeUntil: Scalars['DateTime']['input'];
  popup: PopupCreateNestedOneWithoutPeriodsInput;
};

export type PopupPeriodListRelationFilter = {
  every?: InputMaybe<PopupPeriodWhereInput>;
  none?: InputMaybe<PopupPeriodWhereInput>;
  some?: InputMaybe<PopupPeriodWhereInput>;
};

export type PopupPeriodMaxAggregate = {
  __typename: 'PopupPeriodMaxAggregate';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  clicks?: Maybe<Scalars['Int']['output']>;
  closes?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  popupId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type PopupPeriodMinAggregate = {
  __typename: 'PopupPeriodMinAggregate';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  clicks?: Maybe<Scalars['Int']['output']>;
  closes?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  popupId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type PopupPeriodOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PopupPeriodOrderByWithRelationInput = {
  activeFrom?: InputMaybe<SortOrder>;
  activeUntil?: InputMaybe<SortOrder>;
  clicks?: InputMaybe<SortOrder>;
  closes?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  popup?: InputMaybe<PopupOrderByWithRelationInput>;
  popupId?: InputMaybe<SortOrder>;
  views?: InputMaybe<SortOrder>;
};

export enum PopupPeriodScalarFieldEnum {
  ActiveFrom = 'activeFrom',
  ActiveUntil = 'activeUntil',
  Clicks = 'clicks',
  Closes = 'closes',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Id = 'id',
  PopupId = 'popupId',
  UpdatedAt = 'updatedAt',
  Views = 'views'
}

/** Possible statistic types for a popup period */
export enum PopupPeriodStatisticType {
  Click = 'CLICK',
  Close = 'CLOSE'
}

/** Input for updating statistics of popup period */
export type PopupPeriodStatisticUpdateInput = {
  statisticType: PopupPeriodStatisticType;
};

export type PopupPeriodSumAggregate = {
  __typename: 'PopupPeriodSumAggregate';
  clicks?: Maybe<Scalars['Int']['output']>;
  closes?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

/** Input for updating a popup period */
export type PopupPeriodUpdateInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PopupPeriodWhereInput = {
  AND?: InputMaybe<Array<PopupPeriodWhereInput>>;
  NOT?: InputMaybe<Array<PopupPeriodWhereInput>>;
  OR?: InputMaybe<Array<PopupPeriodWhereInput>>;
  activeFrom?: InputMaybe<DateTimeFilter>;
  activeUntil?: InputMaybe<DateTimeFilter>;
  clicks?: InputMaybe<IntFilter>;
  closes?: InputMaybe<IntFilter>;
  id?: InputMaybe<UuidFilter>;
  popup?: InputMaybe<PopupRelationFilter>;
  popupId?: InputMaybe<UuidFilter>;
  views?: InputMaybe<IntFilter>;
};

export type PopupPeriodWhereUniqueInput = {
  AND?: InputMaybe<Array<PopupPeriodWhereInput>>;
  NOT?: InputMaybe<Array<PopupPeriodWhereInput>>;
  OR?: InputMaybe<Array<PopupPeriodWhereInput>>;
  activeFrom?: InputMaybe<DateTimeFilter>;
  activeUntil?: InputMaybe<DateTimeFilter>;
  clicks?: InputMaybe<IntFilter>;
  closes?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  popup?: InputMaybe<PopupRelationFilter>;
  popupId?: InputMaybe<UuidFilter>;
  views?: InputMaybe<IntFilter>;
};

export type PopupRelationFilter = {
  is?: InputMaybe<PopupWhereInput>;
  isNot?: InputMaybe<PopupWhereInput>;
};

export enum PopupScalarFieldEnum {
  Active = 'active',
  ClickUrl = 'clickUrl',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Id = 'id',
  ImageUrl = 'imageUrl',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type PopupWhereInput = {
  AND?: InputMaybe<Array<PopupWhereInput>>;
  NOT?: InputMaybe<Array<PopupWhereInput>>;
  OR?: InputMaybe<Array<PopupWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  clickUrl?: InputMaybe<StringNullableFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  periods?: InputMaybe<PopupPeriodListRelationFilter>;
};

export type PopupWhereUniqueInput = {
  AND?: InputMaybe<Array<PopupWhereInput>>;
  NOT?: InputMaybe<Array<PopupWhereInput>>;
  OR?: InputMaybe<Array<PopupWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  clickUrl?: InputMaybe<StringNullableFilter>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyPopupUnique?: InputMaybe<PopupCompanyPopupUniqueCompoundUniqueInput>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  periods?: InputMaybe<PopupPeriodListRelationFilter>;
};

export type PreferredLanguage = {
  __typename: 'PreferredLanguage';
  countryCode: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
};

/** Price details of the contract */
export type PriceDetails = {
  __typename: 'PriceDetails';
  /** Base price of the contract */
  basePrice: Money;
  /** Current price including adjustments */
  currentPrice: Money;
  /** Payment frequency of the contract */
  paymentFrequency: PaymentFrequency;
};

export type Promotion = {
  __typename: 'Promotion';
  _count: PromotionCount;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  periods?: Maybe<Array<PromotionPeriod>>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PromotionCount = {
  __typename: 'PromotionCount';
  periods: Scalars['Int']['output'];
};

export type PromotionCountAggregate = {
  __typename: 'PromotionCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  promotionCode: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creation a promotion */
export type PromotionCreateInput = {
  /** The description for the promotion */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The period for the promotion */
  period?: InputMaybe<CreatePromotionPeriodInput>;
  promotionCode?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type PromotionCreateNestedOneWithoutPeriodsInput = {
  connect?: InputMaybe<PromotionWhereUniqueInput>;
};

export type PromotionListRelationFilter = {
  every?: InputMaybe<PromotionWhereInput>;
  none?: InputMaybe<PromotionWhereInput>;
  some?: InputMaybe<PromotionWhereInput>;
};

export type PromotionMaxAggregate = {
  __typename: 'PromotionMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PromotionMinAggregate = {
  __typename: 'PromotionMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PromotionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PromotionOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  periods?: InputMaybe<PromotionPeriodOrderByRelationAggregateInput>;
  promotionCode?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrder>;
};

export type PromotionPeriod = {
  __typename: 'PromotionPeriod';
  activeFrom: Scalars['DateTime']['output'];
  activeUntil: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  promotion: Promotion;
  promotionId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PromotionPeriodCountAggregate = {
  __typename: 'PromotionPeriodCountAggregate';
  _all: Scalars['Int']['output'];
  activeFrom: Scalars['Int']['output'];
  activeUntil: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  promotionId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type PromotionPeriodCreateInput = {
  activeFrom: Scalars['DateTime']['input'];
  activeUntil: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  promotion: PromotionCreateNestedOneWithoutPeriodsInput;
};

export type PromotionPeriodListRelationFilter = {
  every?: InputMaybe<PromotionPeriodWhereInput>;
  none?: InputMaybe<PromotionPeriodWhereInput>;
  some?: InputMaybe<PromotionPeriodWhereInput>;
};

export type PromotionPeriodMaxAggregate = {
  __typename: 'PromotionPeriodMaxAggregate';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  promotionId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PromotionPeriodMinAggregate = {
  __typename: 'PromotionPeriodMinAggregate';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeUntil?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  promotionId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PromotionPeriodOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PromotionPeriodOrderByWithRelationInput = {
  activeFrom?: InputMaybe<SortOrder>;
  activeUntil?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  promotion?: InputMaybe<PromotionOrderByWithRelationInput>;
  promotionId?: InputMaybe<SortOrder>;
};

export enum PromotionPeriodScalarFieldEnum {
  ActiveFrom = 'activeFrom',
  ActiveUntil = 'activeUntil',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Id = 'id',
  PromotionId = 'promotionId',
  UpdatedAt = 'updatedAt'
}

/** Unique input for promotion period */
export type PromotionPeriodUniqueInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for updating a promotion period */
export type PromotionPeriodUpdateInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PromotionPeriodWhereInput = {
  AND?: InputMaybe<Array<PromotionPeriodWhereInput>>;
  NOT?: InputMaybe<Array<PromotionPeriodWhereInput>>;
  OR?: InputMaybe<Array<PromotionPeriodWhereInput>>;
  activeFrom?: InputMaybe<DateTimeFilter>;
  activeUntil?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  promotion?: InputMaybe<PromotionRelationFilter>;
  promotionId?: InputMaybe<UuidFilter>;
};

export type PromotionPeriodWhereUniqueInput = {
  AND?: InputMaybe<Array<PromotionPeriodWhereInput>>;
  NOT?: InputMaybe<Array<PromotionPeriodWhereInput>>;
  OR?: InputMaybe<Array<PromotionPeriodWhereInput>>;
  activeFrom?: InputMaybe<DateTimeFilter>;
  activeUntil?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  promotion?: InputMaybe<PromotionRelationFilter>;
  promotionId?: InputMaybe<UuidFilter>;
};

export type PromotionRelationFilter = {
  is?: InputMaybe<PromotionWhereInput>;
  isNot?: InputMaybe<PromotionWhereInput>;
};

export enum PromotionScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  PromotionCode = 'promotionCode',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type PromotionWhereInput = {
  AND?: InputMaybe<Array<PromotionWhereInput>>;
  NOT?: InputMaybe<Array<PromotionWhereInput>>;
  OR?: InputMaybe<Array<PromotionWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  periods?: InputMaybe<PromotionPeriodListRelationFilter>;
  promotionCode?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PromotionWhereUniqueInput = {
  AND?: InputMaybe<Array<PromotionWhereInput>>;
  NOT?: InputMaybe<Array<PromotionWhereInput>>;
  OR?: InputMaybe<Array<PromotionWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  periods?: InputMaybe<PromotionPeriodListRelationFilter>;
  promotionCode?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
};

/** Input for creating a promotional coupon */
export type PromotionalCouponCreateInput = {
  /** Optionally specify the company of the coupon */
  company?: InputMaybe<CompanyCreateNestedOneWithoutCouponsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** The period the coupon is active at */
  period: CreateCouponPeriodInput;
  transmissionMethod?: InputMaybe<TransmissionMethod>;
};

export type PublicBranchOffice = {
  __typename: 'PublicBranchOffice';
  companyId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type PublicEquipment = {
  __typename: 'PublicEquipment';
  branchOffice: PublicBranchOffice;
  id: Scalars['UUID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  manufacturer: Scalars['String']['output'];
  name: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
  status: EquipmentStatus;
  type: EquipmentType;
};

export type PurchaseAdditionalContractResult = {
  __typename: 'PurchaseAdditionalContractResult';
  /** Unique ID of the additional contract */
  id?: Maybe<Scalars['Float']['output']>;
};

export type PushNotification = {
  __typename: 'PushNotification';
  _count: PushNotificationCount;
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  /** The cron expression for the scheduler of notifications of type RECURRING */
  cronExpression?: Maybe<Scalars['String']['output']>;
  cronInterval?: Maybe<CronInterval>;
  /** The date at which the cron should be executed the first time */
  cronStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** The history of sendings of an push notification */
  history?: Maybe<Array<PushNotificationHistory>>;
  id: Scalars['UUID']['output'];
  /** The message of the push notification */
  message: Scalars['String']['output'];
  /** The send date for notifications of type SCHEDULED_ONCE */
  sendAt?: Maybe<Scalars['DateTime']['output']>;
  /** The status of the push notification */
  status: PushNotificationStatus;
  /** The title of the push notification */
  title: Scalars['String']['output'];
  /** The send type for the push notification */
  type: PushNotificationSendType;
};

export type PushNotificationCount = {
  __typename: 'PushNotificationCount';
  history: Scalars['Int']['output'];
};

export type PushNotificationCountAggregate = {
  __typename: 'PushNotificationCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  cronExpression: Scalars['Int']['output'];
  cronInterval: Scalars['Int']['output'];
  cronStartDate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['Int']['output'];
  sendAt: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
};

/** Input for creating a push notification */
export type PushNotificationCreateInput = {
  /** Optionally specify the company this notification should be created for */
  company?: InputMaybe<CompanyCreateNestedOneWithoutPushNotificationsInput>;
  /** The expression for the scheduler. Needs to be in format: 'minutes hours day-of-month month day-of-week year'. Example for a cron that runs each month on the 15th: "0 0 15 * ? *". Only needs to be specified if the type of notification is SCHEDULED_ONCE or RECURRING */
  cronExpression?: InputMaybe<Scalars['CronExpression']['input']>;
  cronInterval?: InputMaybe<CronInterval>;
  cronStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  message: Scalars['String']['input'];
  sendAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally specify studio ID's. Only customers who have interactions with these studios will get the message. Currently only supported for IMMEDIATE notificaiton. */
  studioIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  type: PushNotificationSendType;
};

export type PushNotificationHistory = {
  __typename: 'PushNotificationHistory';
  affectedCustomers: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  pushNotification: PushNotification;
  pushNotificationId: Scalars['String']['output'];
  sendAt: Scalars['DateTime']['output'];
};

export type PushNotificationHistoryAvgAggregate = {
  __typename: 'PushNotificationHistoryAvgAggregate';
  affectedCustomers?: Maybe<Scalars['Float']['output']>;
};

export type PushNotificationHistoryCountAggregate = {
  __typename: 'PushNotificationHistoryCountAggregate';
  _all: Scalars['Int']['output'];
  affectedCustomers: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  pushNotificationId: Scalars['Int']['output'];
  sendAt: Scalars['Int']['output'];
};

export type PushNotificationHistoryListRelationFilter = {
  every?: InputMaybe<PushNotificationHistoryWhereInput>;
  none?: InputMaybe<PushNotificationHistoryWhereInput>;
  some?: InputMaybe<PushNotificationHistoryWhereInput>;
};

export type PushNotificationHistoryMaxAggregate = {
  __typename: 'PushNotificationHistoryMaxAggregate';
  affectedCustomers?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  pushNotificationId?: Maybe<Scalars['String']['output']>;
  sendAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PushNotificationHistoryMinAggregate = {
  __typename: 'PushNotificationHistoryMinAggregate';
  affectedCustomers?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  pushNotificationId?: Maybe<Scalars['String']['output']>;
  sendAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PushNotificationHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PushNotificationHistoryOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  pushNotification?: InputMaybe<PushNotificationOrderByWithRelationInput>;
  pushNotificationId?: InputMaybe<SortOrder>;
};

export enum PushNotificationHistoryScalarFieldEnum {
  AffectedCustomers = 'affectedCustomers',
  CompanyId = 'companyId',
  Id = 'id',
  PushNotificationId = 'pushNotificationId',
  SendAt = 'sendAt'
}

export type PushNotificationHistorySumAggregate = {
  __typename: 'PushNotificationHistorySumAggregate';
  affectedCustomers?: Maybe<Scalars['Int']['output']>;
};

export type PushNotificationHistoryWhereInput = {
  AND?: InputMaybe<Array<PushNotificationHistoryWhereInput>>;
  NOT?: InputMaybe<Array<PushNotificationHistoryWhereInput>>;
  OR?: InputMaybe<Array<PushNotificationHistoryWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  pushNotification?: InputMaybe<PushNotificationRelationFilter>;
  pushNotificationId?: InputMaybe<UuidFilter>;
};

export type PushNotificationHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<PushNotificationHistoryWhereInput>>;
  NOT?: InputMaybe<Array<PushNotificationHistoryWhereInput>>;
  OR?: InputMaybe<Array<PushNotificationHistoryWhereInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  pushNotification?: InputMaybe<PushNotificationRelationFilter>;
  pushNotificationId?: InputMaybe<UuidFilter>;
};

export type PushNotificationListRelationFilter = {
  every?: InputMaybe<PushNotificationWhereInput>;
  none?: InputMaybe<PushNotificationWhereInput>;
  some?: InputMaybe<PushNotificationWhereInput>;
};

export type PushNotificationMaxAggregate = {
  __typename: 'PushNotificationMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cronExpression?: Maybe<Scalars['String']['output']>;
  cronInterval?: Maybe<CronInterval>;
  cronStartDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sendAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<PushNotificationStatus>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PushNotificationSendType>;
};

export type PushNotificationMinAggregate = {
  __typename: 'PushNotificationMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cronExpression?: Maybe<Scalars['String']['output']>;
  cronInterval?: Maybe<CronInterval>;
  cronStartDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sendAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<PushNotificationStatus>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PushNotificationSendType>;
};

export type PushNotificationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PushNotificationOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  cronExpression?: InputMaybe<SortOrderInput>;
  cronInterval?: InputMaybe<SortOrderInput>;
  cronStartDate?: InputMaybe<SortOrderInput>;
  history?: InputMaybe<PushNotificationHistoryOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  sendAt?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type PushNotificationRelationFilter = {
  is?: InputMaybe<PushNotificationWhereInput>;
  isNot?: InputMaybe<PushNotificationWhereInput>;
};

export enum PushNotificationScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CronExpression = 'cronExpression',
  CronInterval = 'cronInterval',
  CronStartDate = 'cronStartDate',
  Id = 'id',
  Message = 'message',
  SendAt = 'sendAt',
  Status = 'status',
  Title = 'title',
  Type = 'type'
}

/** The available types of push notifications. */
export enum PushNotificationSendType {
  Immediate = 'IMMEDIATE',
  Recurring = 'RECURRING',
  ScheduledOnce = 'SCHEDULED_ONCE'
}

/** The different status of push notifications based on their types */
export enum PushNotificationStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT'
}

export type PushNotificationWhereInput = {
  AND?: InputMaybe<Array<PushNotificationWhereInput>>;
  NOT?: InputMaybe<Array<PushNotificationWhereInput>>;
  OR?: InputMaybe<Array<PushNotificationWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  cronExpression?: InputMaybe<StringNullableFilter>;
  cronInterval?: InputMaybe<EnumCronIntervalNullableFilter>;
  cronStartDate?: InputMaybe<DateTimeNullableFilter>;
  history?: InputMaybe<PushNotificationHistoryListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  message?: InputMaybe<StringFilter>;
  sendAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumPushNotificationStatusFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumPushNotificationSendTypeFilter>;
};

export type PushNotificationWhereUniqueInput = {
  AND?: InputMaybe<Array<PushNotificationWhereInput>>;
  NOT?: InputMaybe<Array<PushNotificationWhereInput>>;
  OR?: InputMaybe<Array<PushNotificationWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  cronExpression?: InputMaybe<StringNullableFilter>;
  cronInterval?: InputMaybe<EnumCronIntervalNullableFilter>;
  cronStartDate?: InputMaybe<DateTimeNullableFilter>;
  history?: InputMaybe<PushNotificationHistoryListRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<StringFilter>;
  sendAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumPushNotificationStatusFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumPushNotificationSendTypeFilter>;
};

export type Query = {
  __typename: 'Query';
  about: AboutModel;
  achievements: Array<CustomerAchievement>;
  activeDefectReports: Array<ActiveDefectReportGroup>;
  aggregateReceivedPoint: AggregateReceivedPoint;
  appointmentBookings: Array<AppointmentBooking>;
  appointmentSlots: Array<AppointmentSlot>;
  appointments: AppointmentResult;
  balance: Balance;
  balances: Array<Balance>;
  branchOffice: BranchOffice;
  branchOfficeCrmConfig: BranchOfficeCrmConfig;
  branchOfficeCrmConfigs: Array<BranchOfficeCrmConfig>;
  branchOfficeRating: BranchOfficeRating;
  branchOfficeRatings: Array<BranchOfficeRating>;
  branchOfficeTopRating: Array<BranchOfficeTopRating>;
  branchOffices: Array<BranchOffice>;
  calculationRule: CalculationRule;
  calculationRules: Array<CalculationRule>;
  challenge: Challenge;
  challengePeriod: ChallengePeriod;
  challengePeriods: Array<ChallengePeriod>;
  challenges: Array<Challenge>;
  class: Class;
  classSlots: ClassSlotResult;
  classes: ClassResult;
  companies: Array<Company>;
  company: Company;
  companyCrmConfig: CompanyCrmConfig;
  companyCrmConfigs: Array<CompanyCrmConfig>;
  companyLogo?: Maybe<CompanyLogo>;
  companyReferralConfig?: Maybe<CompanyReferralConfig>;
  companyReferralConfigs: Array<CompanyReferralConfig>;
  countCustomer: Scalars['Float']['output'];
  countDefectReport: Scalars['Float']['output'];
  countDistinctDefectReporters: Scalars['Float']['output'];
  countEquipment: Scalars['Float']['output'];
  countRedeemedPoint: Scalars['Float']['output'];
  coupon: Coupon;
  couponPeriod: CouponPeriod;
  couponPeriods: Array<CouponPeriod>;
  coupons: Array<Coupon>;
  crmCustomer: CrmCustomer;
  customer: Customer;
  customerAccessCode: CustomerAccessCode;
  customerAddressData: CustomerAddressData;
  customerChallenge: CustomerChallenge;
  customerChallenges: Array<CustomerChallenge>;
  customerCheckInHistory: CustomerCheckInHistoryResult;
  customerClassBookings: Array<CustomerClassBookingCustom>;
  customerContactData: CustomerContactData;
  customerContract: Array<Contract>;
  customerCrmConfig: CustomerCrmConfig;
  customerCrmConfigs: Array<CustomerCrmConfig>;
  customerMasterData: CustomerMasterData;
  customerPartnerChallenge: CustomerPartnerChallenge;
  customerPartnerChallenges: Array<CustomerPartnerChallenge>;
  customerPartnerOrder: CustomerPartnerOrder;
  customerPartnerOrders: Array<CustomerPartnerOrder>;
  customerPastTransactions: CustomerTransactionResult;
  customerPaymentData: CustomerPaymentData;
  customerRanking?: Maybe<CustomerRanking>;
  customerReferral: CustomerReferral;
  customerReferrals: Array<CustomerReferral>;
  customerSeries: CustomerTrainingSeries;
  customerStatistic: CustomerStatistic;
  customerStatistics: Array<CustomerStatistic>;
  customerTopRanking: Array<CustomerTopRanking>;
  customerTrainingOverview: Array<CustomerTrainingOverview>;
  customerTrend: TrendMetric;
  customerUpcomingTransactions: CustomerTransactionResult;
  customers: Array<Customer>;
  defectReport: DefectReport;
  defectReports: Array<DefectReport>;
  employee: Employee;
  employees: Array<Employee>;
  equipment: Equipment;
  equipments: Array<Equipment>;
  exercise: Exercise;
  exercises: Array<Exercise>;
  filteredCoupons: ActiveCouponModel;
  franchisePlatformCompanies: Array<PlatformCompany>;
  friend: Friend;
  friendReceivedPoint: FriendReceivedPoint;
  friendReceivedPoints: Array<FriendReceivedPoint>;
  friendRedeemedPoint: FriendRedeemedPoint;
  friendRedeemedPoints: Array<FriendRedeemedPoint>;
  friendRequest: FriendRequest;
  friendRequests: Array<FriendRequest>;
  friendSeries: CustomerTrainingSeries;
  friendStatistic: FriendStatistic;
  friendTrainingOverview: Array<CustomerTrainingOverview>;
  friends: Array<Friend>;
  friendship: Friendship;
  friendships: Array<Friendship>;
  generalStudioInformation: StudioInformation;
  gymAccessDevices: Gym;
  imageTemplate: ImageTemplate;
  imageTemplates: Array<ImageTemplate>;
  level: Level;
  levelCondition: LevelCondition;
  levelConditions: Array<LevelCondition>;
  levels: Array<Level>;
  myPartnerChallengeRank?: Maybe<Scalars['Int']['output']>;
  news: Array<News>;
  paginatedBranchOfficeRating: PaginatedBranchOfficeRating;
  paginatedBranchOffices: PaginatedBranchOffice;
  paginatedCustomers: PaginatedCustomer;
  paginatedEquipments: PaginatedEquipment;
  participatingPartnerChallenges: Array<PartnerChallenge>;
  partner: Partner;
  partnerChallenge: PartnerChallenge;
  partnerChallengeLeaderboard: Array<PartnerChallengeParticipation>;
  partnerChallengePeriod: PartnerChallengePeriod;
  partnerChallengePeriods: Array<PartnerChallengePeriod>;
  partnerChallenges: Array<PartnerChallenge>;
  partnerConfig: PartnerConfig;
  partnerConfigs: Array<PartnerConfig>;
  partnerOffer: PartnerOffer;
  partnerOffers: Array<PartnerOffer>;
  partnerReward: PartnerReward;
  partnerRewards: Array<PartnerReward>;
  partners: Array<Partner>;
  pastPartnerChallengeLeaderboard: Array<PartnerChallengeParticipation>;
  platformCompanies: Array<PlatformCompany>;
  pointSystem?: Maybe<PointSystem>;
  pointSystemType: PointSystemType;
  pointSystemTypes: Array<PointSystemType>;
  pointSystems: Array<PointSystem>;
  popup: Popup;
  popupPeriod: PopupPeriod;
  popupPeriods: Array<PopupPeriod>;
  popups: Array<Popup>;
  promotion: Promotion;
  promotionPeriod: PromotionPeriod;
  promotionPeriods: Array<PromotionPeriod>;
  promotions: Array<Promotion>;
  /** Promotions are only returned for companies that are visible!! If filtered on a location, only active promotions in this location will be returned. If no location filter is configured, the active flag can be used to either return only active promotions, or all promotions. Setting of active flag in combination with the location filter does not take any effect. Running this without any input will return all promotions */
  promotionsByLocation: Array<Promotion>;
  publicBranchOffices: Array<BranchOffice>;
  publicEquipment: PublicEquipment;
  purchasableAdditionalContracts: Array<AdditionalContract>;
  pushNotification: PushNotification;
  pushNotificationHistories: Array<PushNotificationHistory>;
  pushNotificationHistory: PushNotificationHistory;
  pushNotifications: Array<PushNotification>;
  ratingQuestion: RatingQuestion;
  ratingQuestions: Array<RatingQuestion>;
  receivedPoint: ReceivedPoint;
  receivedPointTrend: TrendMetric;
  receivedPoints: Array<ReceivedPoint>;
  receivedVisitBasedPointsPerDay: Array<DateGroupedCount>;
  redeemedCoupon: RedeemedCoupon;
  redeemedCouponByTypeCount: Array<RedeemedCouponByTypeCount>;
  redeemedCoupons: Array<RedeemedCoupon>;
  redeemedPartnerReward: RedeemedPartnerReward;
  redeemedPartnerRewards: Array<RedeemedPartnerReward>;
  redeemedPoint: RedeemedPoint;
  redeemedPointTrend: TrendMetric;
  redeemedPoints: Array<RedeemedPoint>;
  reward: Reward;
  rewards: Array<Reward>;
  singleNews: News;
  statusHistories: Array<StatusHistory>;
  statusHistory: StatusHistory;
  studioUtilization: StudioUtilization;
  summarizedFriendRewardRedemptions: Array<SummarizedRewardRedemptions>;
  /** @deprecated Use rewards query instead */
  summarizedRedeemedPoints: Array<SummarizedRedeemedPointModel>;
  summarizedRewardRedemptions: Array<SummarizedRewardRedemptions>;
  trainingPlan: TrainingPlan;
  trainingPlans: Array<TrainingPlan>;
  workoutSession: WorkoutSession;
  workoutSessions: Array<WorkoutSession>;
  workoutSet: WorkoutSet;
};


export type QueryAchievementsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryActiveDefectReportsArgs = {
  orderBy?: InputMaybe<ActiveDefectReportGroupOrderByInput>;
};


export type QueryAggregateReceivedPointArgs = {
  _avg?: InputMaybe<ReceivedPointAvgAggregateInput>;
  _count?: InputMaybe<ReceivedPointCountAggregateInput>;
  _max?: InputMaybe<ReceivedPointMaxAggregateInput>;
  _min?: InputMaybe<ReceivedPointMinAggregateInput>;
  _sum?: InputMaybe<ReceivedPointSumAggregateInput>;
  cursor?: InputMaybe<ReceivedPointWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ReceivedPointOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReceivedPointWhereInput>;
};


export type QueryAppointmentBookingsArgs = {
  branchOfficeId: Scalars['String']['input'];
};


export type QueryAppointmentSlotsArgs = {
  branchOfficeId: Scalars['String']['input'];
  data: AppointmentSlotFilter;
};


export type QueryAppointmentsArgs = {
  branchOfficeId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryBalanceArgs = {
  where: BalanceWhereUniqueInput;
};


export type QueryBalancesArgs = {
  cursor?: InputMaybe<BalanceWhereUniqueInput>;
  distinct?: InputMaybe<Array<BalanceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BalanceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BalanceWhereInput>;
};


export type QueryBranchOfficeArgs = {
  where: BranchOfficeWhereUniqueInput;
};


export type QueryBranchOfficeCrmConfigArgs = {
  where: BranchOfficeCrmConfigWhereUniqueInput;
};


export type QueryBranchOfficeCrmConfigsArgs = {
  cursor?: InputMaybe<BranchOfficeCrmConfigWhereUniqueInput>;
  distinct?: InputMaybe<Array<BranchOfficeCrmConfigScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BranchOfficeCrmConfigOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BranchOfficeCrmConfigWhereInput>;
};


export type QueryBranchOfficeRatingArgs = {
  where: BranchOfficeRatingWhereUniqueInput;
};


export type QueryBranchOfficeRatingsArgs = {
  cursor?: InputMaybe<BranchOfficeRatingWhereUniqueInput>;
  distinct?: InputMaybe<Array<BranchOfficeRatingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BranchOfficeRatingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BranchOfficeRatingWhereInput>;
};


export type QueryBranchOfficeTopRatingArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryBranchOfficesArgs = {
  cursor?: InputMaybe<BranchOfficeWhereUniqueInput>;
  distinct?: InputMaybe<Array<BranchOfficeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BranchOfficeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BranchOfficeWhereInput>;
};


export type QueryCalculationRuleArgs = {
  where: CalculationRuleWhereUniqueInput;
};


export type QueryCalculationRulesArgs = {
  cursor?: InputMaybe<CalculationRuleWhereUniqueInput>;
  distinct?: InputMaybe<Array<CalculationRuleScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CalculationRuleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CalculationRuleWhereInput>;
};


export type QueryChallengeArgs = {
  where: ChallengeWhereUniqueInput;
};


export type QueryChallengePeriodArgs = {
  where: ChallengePeriodWhereUniqueInput;
};


export type QueryChallengePeriodsArgs = {
  cursor?: InputMaybe<ChallengePeriodWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChallengePeriodScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChallengePeriodOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChallengePeriodWhereInput>;
};


export type QueryChallengesArgs = {
  cursor?: InputMaybe<ChallengeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChallengeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChallengeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChallengeWhereInput>;
};


export type QueryClassArgs = {
  branchOfficeId: Scalars['String']['input'];
  classId: Scalars['String']['input'];
};


export type QueryClassSlotsArgs = {
  branchOfficeId: Scalars['String']['input'];
  data?: InputMaybe<ClassSlotFilterInput>;
};


export type QueryClassesArgs = {
  branchOfficeId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCompaniesArgs = {
  cursor?: InputMaybe<CompanyWhereUniqueInput>;
  distinct?: InputMaybe<Array<CompanyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CompanyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CompanyWhereInput>;
};


export type QueryCompanyArgs = {
  where?: InputMaybe<CompanyUniqueInput>;
};


export type QueryCompanyCrmConfigArgs = {
  where: CompanyCrmConfigWhereUniqueInput;
};


export type QueryCompanyCrmConfigsArgs = {
  cursor?: InputMaybe<CompanyCrmConfigWhereUniqueInput>;
  distinct?: InputMaybe<Array<CompanyCrmConfigScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CompanyCrmConfigOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CompanyCrmConfigWhereInput>;
};


export type QueryCompanyLogoArgs = {
  where?: InputMaybe<CompanyUniqueInput>;
};


export type QueryCompanyReferralConfigArgs = {
  where?: InputMaybe<CompanyReferralConfigWhereUniqueInput>;
};


export type QueryCompanyReferralConfigsArgs = {
  cursor?: InputMaybe<CompanyReferralConfigWhereUniqueInput>;
  distinct?: InputMaybe<Array<CompanyReferralConfigScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CompanyReferralConfigOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CompanyReferralConfigWhereInput>;
};


export type QueryCountCustomerArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryCountDefectReportArgs = {
  cursor?: InputMaybe<DefectReportWhereUniqueInput>;
  orderBy?: InputMaybe<Array<DefectReportOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefectReportWhereInput>;
};


export type QueryCountDistinctDefectReportersArgs = {
  cursor?: InputMaybe<DefectReportWhereUniqueInput>;
  orderBy?: InputMaybe<Array<DefectReportOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefectReportWhereInput>;
};


export type QueryCountEquipmentArgs = {
  cursor?: InputMaybe<EquipmentWhereUniqueInput>;
  orderBy?: InputMaybe<Array<EquipmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EquipmentWhereInput>;
};


export type QueryCountRedeemedPointArgs = {
  cursor?: InputMaybe<RedeemedPointWhereUniqueInput>;
  orderBy?: InputMaybe<Array<RedeemedPointOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RedeemedPointWhereInput>;
};


export type QueryCouponArgs = {
  where: CouponWhereUniqueInput;
};


export type QueryCouponPeriodArgs = {
  where: CouponPeriodWhereUniqueInput;
};


export type QueryCouponPeriodsArgs = {
  cursor?: InputMaybe<CouponPeriodWhereUniqueInput>;
  distinct?: InputMaybe<Array<CouponPeriodScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CouponPeriodOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CouponPeriodWhereInput>;
};


export type QueryCouponsArgs = {
  cursor?: InputMaybe<CouponWhereUniqueInput>;
  distinct?: InputMaybe<Array<CouponScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CouponOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CouponWhereInput>;
};


export type QueryCrmCustomerArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  where: CrmCustomerWhereUniqueInput;
};


export type QueryCustomerArgs = {
  where: CustomerWhereUniqueInput;
};


export type QueryCustomerAccessCodeArgs = {
  branchOfficeId: Scalars['String']['input'];
};


export type QueryCustomerChallengeArgs = {
  where: CustomerChallengeWhereUniqueInput;
};


export type QueryCustomerChallengesArgs = {
  cursor?: InputMaybe<CustomerChallengeWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerChallengeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerChallengeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerChallengeWhereInput>;
};


export type QueryCustomerCheckInHistoryArgs = {
  data?: InputMaybe<CheckInHistoryFilterInput>;
};


export type QueryCustomerClassBookingsArgs = {
  cursor?: InputMaybe<CustomerClassBookingWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerClassBookingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerClassBookingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerClassBookingWhereInput>;
};


export type QueryCustomerContractArgs = {
  data?: InputMaybe<ContractInput>;
};


export type QueryCustomerCrmConfigArgs = {
  where: CustomerCrmConfigWhereUniqueInput;
};


export type QueryCustomerCrmConfigsArgs = {
  cursor?: InputMaybe<CustomerCrmConfigWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerCrmConfigScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerCrmConfigOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerCrmConfigWhereInput>;
};


export type QueryCustomerPartnerChallengeArgs = {
  where: CustomerPartnerChallengeWhereUniqueInput;
};


export type QueryCustomerPartnerChallengesArgs = {
  cursor?: InputMaybe<CustomerPartnerChallengeWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerPartnerChallengeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerPartnerChallengeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerPartnerChallengeWhereInput>;
};


export type QueryCustomerPartnerOrderArgs = {
  where: CustomerPartnerOrderWhereUniqueInput;
};


export type QueryCustomerPartnerOrdersArgs = {
  cursor?: InputMaybe<CustomerPartnerOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerPartnerOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerPartnerOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerPartnerOrderWhereInput>;
};


export type QueryCustomerPastTransactionsArgs = {
  pagination?: InputMaybe<CustomerTransactionPaginationInput>;
};


export type QueryCustomerReferralArgs = {
  where: CustomerReferralWhereUniqueInput;
};


export type QueryCustomerReferralsArgs = {
  cursor?: InputMaybe<CustomerReferralWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerReferralScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerReferralOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerReferralWhereInput>;
};


export type QueryCustomerSeriesArgs = {
  where: CustomerWhereUniqueInput;
};


export type QueryCustomerStatisticArgs = {
  where: CustomerStatisticWhereUniqueInput;
};


export type QueryCustomerStatisticsArgs = {
  cursor?: InputMaybe<CustomerStatisticWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerStatisticScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerStatisticOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerStatisticWhereInput>;
};


export type QueryCustomerTopRankingArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryCustomerTrainingOverviewArgs = {
  where: CustomerWhereUniqueInput;
};


export type QueryCustomerTrendArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['TimeZone']['input'];
};


export type QueryCustomerUpcomingTransactionsArgs = {
  pagination?: InputMaybe<CustomerTransactionPaginationInput>;
};


export type QueryCustomersArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryDefectReportArgs = {
  where: DefectReportWhereUniqueInput;
};


export type QueryDefectReportsArgs = {
  cursor?: InputMaybe<DefectReportWhereUniqueInput>;
  distinct?: InputMaybe<Array<DefectReportScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DefectReportOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefectReportWhereInput>;
};


export type QueryEmployeeArgs = {
  where: EmployeeWhereUniqueInput;
};


export type QueryEmployeesArgs = {
  cursor?: InputMaybe<EmployeeWhereUniqueInput>;
  distinct?: InputMaybe<Array<EmployeeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EmployeeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmployeeWhereInput>;
};


export type QueryEquipmentArgs = {
  where: EquipmentWhereUniqueInput;
};


export type QueryEquipmentsArgs = {
  cursor?: InputMaybe<EquipmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<EquipmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EquipmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EquipmentWhereInput>;
};


export type QueryExerciseArgs = {
  where: ExerciseWhereUniqueInput;
};


export type QueryExercisesArgs = {
  cursor?: InputMaybe<ExerciseWhereUniqueInput>;
  distinct?: InputMaybe<Array<ExerciseScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ExerciseOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExerciseWhereInput>;
};


export type QueryFilteredCouponsArgs = {
  data: ActiveCouponFilterInput;
};


export type QueryFranchisePlatformCompaniesArgs = {
  franchise: Scalars['String']['input'];
};


export type QueryFriendArgs = {
  where: CustomerWhereUniqueInput;
};


export type QueryFriendReceivedPointArgs = {
  where: ReceivedPointWhereUniqueInput;
};


export type QueryFriendReceivedPointsArgs = {
  cursor?: InputMaybe<ReceivedPointWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReceivedPointScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReceivedPointOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReceivedPointWhereInput>;
};


export type QueryFriendRedeemedPointArgs = {
  where: RedeemedPointWhereUniqueInput;
};


export type QueryFriendRedeemedPointsArgs = {
  cursor?: InputMaybe<RedeemedPointWhereUniqueInput>;
  distinct?: InputMaybe<Array<RedeemedPointScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RedeemedPointOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RedeemedPointWhereInput>;
};


export type QueryFriendRequestArgs = {
  where: FriendRequestWhereUniqueInput;
};


export type QueryFriendRequestsArgs = {
  cursor?: InputMaybe<FriendRequestWhereUniqueInput>;
  distinct?: InputMaybe<Array<FriendRequestScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FriendRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FriendRequestWhereInput>;
};


export type QueryFriendSeriesArgs = {
  where: CustomerWhereUniqueInput;
};


export type QueryFriendStatisticArgs = {
  where: CustomerWhereUniqueInput;
};


export type QueryFriendTrainingOverviewArgs = {
  where: CustomerWhereUniqueInput;
};


export type QueryFriendshipArgs = {
  where: FriendshipWhereUniqueInput;
};


export type QueryFriendshipsArgs = {
  cursor?: InputMaybe<FriendshipWhereUniqueInput>;
  distinct?: InputMaybe<Array<FriendshipScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FriendshipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FriendshipWhereInput>;
};


export type QueryGeneralStudioInformationArgs = {
  branchOfficeId: Scalars['String']['input'];
};


export type QueryGymAccessDevicesArgs = {
  branchOfficeId: Scalars['String']['input'];
};


export type QueryImageTemplateArgs = {
  where: ImageTemplateWhereUniqueInput;
};


export type QueryImageTemplatesArgs = {
  cursor?: InputMaybe<ImageTemplateWhereUniqueInput>;
  distinct?: InputMaybe<Array<ImageTemplateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ImageTemplateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageTemplateWhereInput>;
};


export type QueryLevelArgs = {
  where: LevelWhereUniqueInput;
};


export type QueryLevelConditionArgs = {
  where: LevelConditionWhereUniqueInput;
};


export type QueryLevelConditionsArgs = {
  cursor?: InputMaybe<LevelConditionWhereUniqueInput>;
  distinct?: InputMaybe<Array<LevelConditionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LevelConditionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LevelConditionWhereInput>;
};


export type QueryLevelsArgs = {
  cursor?: InputMaybe<LevelWhereUniqueInput>;
  distinct?: InputMaybe<Array<LevelScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LevelOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LevelWhereInput>;
};


export type QueryMyPartnerChallengeRankArgs = {
  partnerChallengeId: Scalars['ID']['input'];
};


export type QueryNewsArgs = {
  cursor?: InputMaybe<NewsWhereUniqueInput>;
  distinct?: InputMaybe<Array<NewsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NewsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NewsWhereInput>;
};


export type QueryPaginatedBranchOfficeRatingArgs = {
  cursor?: InputMaybe<BranchOfficeRatingWhereUniqueInput>;
  distinct?: InputMaybe<Array<BranchOfficeRatingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BranchOfficeRatingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BranchOfficeRatingWhereInput>;
};


export type QueryPaginatedBranchOfficesArgs = {
  cursor?: InputMaybe<BranchOfficeWhereUniqueInput>;
  distinct?: InputMaybe<Array<BranchOfficeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BranchOfficeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BranchOfficeWhereInput>;
};


export type QueryPaginatedCustomersArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryPaginatedEquipmentsArgs = {
  cursor?: InputMaybe<EquipmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<EquipmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EquipmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EquipmentWhereInput>;
};


export type QueryPartnerArgs = {
  where: PartnerWhereUniqueInput;
};


export type QueryPartnerChallengeArgs = {
  where: PartnerChallengeWhereUniqueInput;
};


export type QueryPartnerChallengeLeaderboardArgs = {
  partnerChallengeId: Scalars['ID']['input'];
};


export type QueryPartnerChallengePeriodArgs = {
  where: PartnerChallengePeriodWhereUniqueInput;
};


export type QueryPartnerChallengePeriodsArgs = {
  cursor?: InputMaybe<PartnerChallengePeriodWhereUniqueInput>;
  distinct?: InputMaybe<Array<PartnerChallengePeriodScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PartnerChallengePeriodOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PartnerChallengePeriodWhereInput>;
};


export type QueryPartnerChallengesArgs = {
  cursor?: InputMaybe<PartnerChallengeWhereUniqueInput>;
  distinct?: InputMaybe<Array<PartnerChallengeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PartnerChallengeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PartnerChallengeWhereInput>;
};


export type QueryPartnerConfigArgs = {
  where: PartnerConfigWhereUniqueInput;
};


export type QueryPartnerConfigsArgs = {
  cursor?: InputMaybe<PartnerConfigWhereUniqueInput>;
  distinct?: InputMaybe<Array<PartnerConfigScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PartnerConfigOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PartnerConfigWhereInput>;
};


export type QueryPartnerOfferArgs = {
  where: PartnerOfferWhereUniqueInput;
};


export type QueryPartnerOffersArgs = {
  cursor?: InputMaybe<PartnerOfferWhereUniqueInput>;
  distinct?: InputMaybe<Array<PartnerOfferScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PartnerOfferOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PartnerOfferWhereInput>;
};


export type QueryPartnerRewardArgs = {
  where: PartnerRewardWhereUniqueInput;
};


export type QueryPartnerRewardsArgs = {
  cursor?: InputMaybe<PartnerRewardWhereUniqueInput>;
  distinct?: InputMaybe<Array<PartnerRewardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PartnerRewardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PartnerRewardWhereInput>;
};


export type QueryPartnersArgs = {
  cursor?: InputMaybe<PartnerWhereUniqueInput>;
  distinct?: InputMaybe<Array<PartnerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PartnerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PartnerWhereInput>;
};


export type QueryPastPartnerChallengeLeaderboardArgs = {
  periodId: Scalars['ID']['input'];
};


export type QueryPointSystemTypeArgs = {
  where: PointSystemTypeWhereUniqueInput;
};


export type QueryPointSystemTypesArgs = {
  cursor?: InputMaybe<PointSystemTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<PointSystemTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PointSystemTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PointSystemTypeWhereInput>;
};


export type QueryPointSystemsArgs = {
  cursor?: InputMaybe<PointSystemWhereUniqueInput>;
  distinct?: InputMaybe<Array<PointSystemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PointSystemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PointSystemWhereInput>;
};


export type QueryPopupArgs = {
  where: PopupWhereUniqueInput;
};


export type QueryPopupPeriodArgs = {
  where: PopupPeriodWhereUniqueInput;
};


export type QueryPopupPeriodsArgs = {
  cursor?: InputMaybe<PopupPeriodWhereUniqueInput>;
  distinct?: InputMaybe<Array<PopupPeriodScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PopupPeriodOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PopupPeriodWhereInput>;
};


export type QueryPopupsArgs = {
  cursor?: InputMaybe<PopupWhereUniqueInput>;
  distinct?: InputMaybe<Array<PopupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PopupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PopupWhereInput>;
};


export type QueryPromotionArgs = {
  where: PromotionWhereUniqueInput;
};


export type QueryPromotionPeriodArgs = {
  where: PromotionPeriodWhereUniqueInput;
};


export type QueryPromotionPeriodsArgs = {
  cursor?: InputMaybe<PromotionPeriodWhereUniqueInput>;
  distinct?: InputMaybe<Array<PromotionPeriodScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PromotionPeriodOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromotionPeriodWhereInput>;
};


export type QueryPromotionsArgs = {
  cursor?: InputMaybe<PromotionWhereUniqueInput>;
  distinct?: InputMaybe<Array<PromotionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PromotionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromotionWhereInput>;
};


export type QueryPromotionsByLocationArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['String']['input'];
  filterInput?: InputMaybe<LocationFilterInput>;
};


export type QueryPublicBranchOfficesArgs = {
  cursor?: InputMaybe<BranchOfficeWhereUniqueInput>;
  distinct?: InputMaybe<Array<BranchOfficeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BranchOfficeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BranchOfficeWhereInput>;
};


export type QueryPublicEquipmentArgs = {
  where: EquipmentWhereUniqueInput;
};


export type QueryPurchasableAdditionalContractsArgs = {
  data?: InputMaybe<ContractInput>;
};


export type QueryPushNotificationArgs = {
  where: PushNotificationWhereUniqueInput;
};


export type QueryPushNotificationHistoriesArgs = {
  cursor?: InputMaybe<PushNotificationHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<PushNotificationHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PushNotificationHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushNotificationHistoryWhereInput>;
};


export type QueryPushNotificationHistoryArgs = {
  where: PushNotificationHistoryWhereUniqueInput;
};


export type QueryPushNotificationsArgs = {
  cursor?: InputMaybe<PushNotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<PushNotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PushNotificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushNotificationWhereInput>;
};


export type QueryRatingQuestionArgs = {
  where: RatingQuestionWhereUniqueInput;
};


export type QueryRatingQuestionsArgs = {
  cursor?: InputMaybe<RatingQuestionWhereUniqueInput>;
  distinct?: InputMaybe<Array<RatingQuestionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RatingQuestionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RatingQuestionWhereInput>;
};


export type QueryReceivedPointArgs = {
  where: ReceivedPointWhereUniqueInput;
};


export type QueryReceivedPointTrendArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['TimeZone']['input'];
};


export type QueryReceivedPointsArgs = {
  cursor?: InputMaybe<ReceivedPointWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReceivedPointScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReceivedPointOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReceivedPointWhereInput>;
};


export type QueryReceivedVisitBasedPointsPerDayArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryRedeemedCouponArgs = {
  where: RedeemedCouponWhereUniqueInput;
};


export type QueryRedeemedCouponsArgs = {
  cursor?: InputMaybe<RedeemedCouponWhereUniqueInput>;
  distinct?: InputMaybe<Array<RedeemedCouponScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RedeemedCouponOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RedeemedCouponWhereInput>;
};


export type QueryRedeemedPartnerRewardArgs = {
  where: RedeemedPartnerRewardWhereUniqueInput;
};


export type QueryRedeemedPartnerRewardsArgs = {
  cursor?: InputMaybe<RedeemedPartnerRewardWhereUniqueInput>;
  distinct?: InputMaybe<Array<RedeemedPartnerRewardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RedeemedPartnerRewardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RedeemedPartnerRewardWhereInput>;
};


export type QueryRedeemedPointArgs = {
  where: RedeemedPointWhereUniqueInput;
};


export type QueryRedeemedPointTrendArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  timezone?: Scalars['TimeZone']['input'];
};


export type QueryRedeemedPointsArgs = {
  cursor?: InputMaybe<RedeemedPointWhereUniqueInput>;
  distinct?: InputMaybe<Array<RedeemedPointScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RedeemedPointOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RedeemedPointWhereInput>;
};


export type QueryRewardArgs = {
  where: RewardWhereUniqueInput;
};


export type QueryRewardsArgs = {
  cursor?: InputMaybe<RewardWhereUniqueInput>;
  distinct?: InputMaybe<Array<RewardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RewardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RewardWhereInput>;
};


export type QuerySingleNewsArgs = {
  where: NewsWhereUniqueInput;
};


export type QueryStatusHistoriesArgs = {
  cursor?: InputMaybe<StatusHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<StatusHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StatusHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StatusHistoryWhereInput>;
};


export type QueryStatusHistoryArgs = {
  where: StatusHistoryWhereUniqueInput;
};


export type QueryStudioUtilizationArgs = {
  branchOfficeId: Scalars['String']['input'];
};


export type QuerySummarizedFriendRewardRedemptionsArgs = {
  where: CustomerWhereUniqueInput;
};


export type QuerySummarizedRedeemedPointsArgs = {
  cursor?: InputMaybe<RedeemedPointWhereUniqueInput>;
  distinct?: InputMaybe<Array<RedeemedPointScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RedeemedPointOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RedeemedPointWhereInput>;
};


export type QuerySummarizedRewardRedemptionsArgs = {
  where: CustomerWhereUniqueInput;
};


export type QueryTrainingPlanArgs = {
  where: TrainingPlanWhereUniqueInput;
};


export type QueryTrainingPlansArgs = {
  cursor?: InputMaybe<TrainingPlanWhereUniqueInput>;
  distinct?: InputMaybe<Array<TrainingPlanScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TrainingPlanOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TrainingPlanWhereInput>;
};


export type QueryWorkoutSessionArgs = {
  where: WorkoutSessionWhereUniqueInput;
};


export type QueryWorkoutSessionsArgs = {
  cursor?: InputMaybe<WorkoutSessionWhereUniqueInput>;
  distinct?: InputMaybe<Array<WorkoutSessionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WorkoutSessionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WorkoutSessionWhereInput>;
};


export type QueryWorkoutSetArgs = {
  where: WorkoutSetWhereUniqueInput;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

/** Represents a rate code */
export type RateCode = {
  __typename: 'RateCode';
  /** Unique identifier for the rate code */
  identifier: Scalars['String']['output'];
  /** The name of the rate code */
  name: Scalars['String']['output'];
};

export type RatingQuestion = {
  __typename: 'RatingQuestion';
  _count: RatingQuestionCount;
  averageRating: Scalars['Float']['output'];
  company: Company;
  /** The identifier of the company who created the question */
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** Indicates whether the question is currently active and shown */
  isActive: Scalars['Boolean']['output'];
  /** The text of the rating question shown to customers */
  question: Scalars['String']['output'];
  ratings?: Maybe<Array<BranchOfficeRating>>;
  updatedAt: Scalars['DateTime']['output'];
};


export type RatingQuestionAverageRatingArgs = {
  branchOfficeId?: InputMaybe<Scalars['UUID']['input']>;
};

export type RatingQuestionActiveStatusUpdateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RatingQuestionCount = {
  __typename: 'RatingQuestionCount';
  ratings: Scalars['Int']['output'];
};

export type RatingQuestionCountAggregate = {
  __typename: 'RatingQuestionCountAggregate';
  _all: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Int']['output'];
  question: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type RatingQuestionCreateInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  question: Scalars['String']['input'];
  ratings?: InputMaybe<BranchOfficeRatingCreateNestedManyWithoutRatingQuestionInput>;
};

export type RatingQuestionCreateManyInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  question: Scalars['String']['input'];
};

export type RatingQuestionListRelationFilter = {
  every?: InputMaybe<RatingQuestionWhereInput>;
  none?: InputMaybe<RatingQuestionWhereInput>;
  some?: InputMaybe<RatingQuestionWhereInput>;
};

export type RatingQuestionMaxAggregate = {
  __typename: 'RatingQuestionMaxAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RatingQuestionMinAggregate = {
  __typename: 'RatingQuestionMinAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RatingQuestionNullableRelationFilter = {
  is?: InputMaybe<RatingQuestionWhereInput>;
  isNot?: InputMaybe<RatingQuestionWhereInput>;
};

export type RatingQuestionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RatingQuestionOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  question?: InputMaybe<SortOrder>;
  ratings?: InputMaybe<BranchOfficeRatingOrderByRelationAggregateInput>;
};

export enum RatingQuestionScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  Question = 'question',
  UpdatedAt = 'updatedAt'
}

export type RatingQuestionWhereInput = {
  AND?: InputMaybe<Array<RatingQuestionWhereInput>>;
  NOT?: InputMaybe<Array<RatingQuestionWhereInput>>;
  OR?: InputMaybe<Array<RatingQuestionWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isActive?: InputMaybe<BoolFilter>;
  question?: InputMaybe<StringFilter>;
  ratings?: InputMaybe<BranchOfficeRatingListRelationFilter>;
};

export type RatingQuestionWhereUniqueInput = {
  AND?: InputMaybe<Array<RatingQuestionWhereInput>>;
  NOT?: InputMaybe<Array<RatingQuestionWhereInput>>;
  OR?: InputMaybe<Array<RatingQuestionWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<BoolFilter>;
  question?: InputMaybe<StringFilter>;
  ratings?: InputMaybe<BranchOfficeRatingListRelationFilter>;
};

export type ReceivedPoint = {
  __typename: 'ReceivedPoint';
  company: Company;
  companyId: Scalars['String']['output'];
  count?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerChallenge?: Maybe<CustomerChallenge>;
  customerChallengeId?: Maybe<Scalars['UUID']['output']>;
  customerId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  redeemedCoupon?: Maybe<RedeemedCoupon>;
  redeemedCouponId?: Maybe<Scalars['UUID']['output']>;
  sourceType: ReceivedPointSourceType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReceivedPointAvgAggregate = {
  __typename: 'ReceivedPointAvgAggregate';
  count?: Maybe<Scalars['Float']['output']>;
};

export type ReceivedPointAvgAggregateInput = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReceivedPointCountAggregate = {
  __typename: 'ReceivedPointCountAggregate';
  _all: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerChallengeId: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  redeemedCouponId: Scalars['Int']['output'];
  sourceType: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ReceivedPointCountAggregateInput = {
  _all?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  sourceType?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReceivedPointCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<ReceivedPointWhereUniqueInput>>;
};

export type ReceivedPointListRelationFilter = {
  every?: InputMaybe<ReceivedPointWhereInput>;
  none?: InputMaybe<ReceivedPointWhereInput>;
  some?: InputMaybe<ReceivedPointWhereInput>;
};

export type ReceivedPointMaxAggregate = {
  __typename: 'ReceivedPointMaxAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerChallengeId?: Maybe<Scalars['UUID']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  redeemedCouponId?: Maybe<Scalars['UUID']['output']>;
  sourceType?: Maybe<ReceivedPointSourceType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReceivedPointMaxAggregateInput = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  sourceType?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReceivedPointMinAggregate = {
  __typename: 'ReceivedPointMinAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerChallengeId?: Maybe<Scalars['UUID']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  redeemedCouponId?: Maybe<Scalars['UUID']['output']>;
  sourceType?: Maybe<ReceivedPointSourceType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReceivedPointMinAggregateInput = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  sourceType?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReceivedPointNullableRelationFilter = {
  is?: InputMaybe<ReceivedPointWhereInput>;
  isNot?: InputMaybe<ReceivedPointWhereInput>;
};

export type ReceivedPointOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ReceivedPointOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  count?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerChallenge?: InputMaybe<CustomerChallengeOrderByWithRelationInput>;
  id?: InputMaybe<SortOrder>;
  redeemedCoupon?: InputMaybe<RedeemedCouponOrderByWithRelationInput>;
  sourceType?: InputMaybe<SortOrder>;
};

export enum ReceivedPointScalarFieldEnum {
  CompanyId = 'companyId',
  Count = 'count',
  CreatedAt = 'createdAt',
  CustomerChallengeId = 'customerChallengeId',
  CustomerId = 'customerId',
  Id = 'id',
  RedeemedCouponId = 'redeemedCouponId',
  SourceType = 'sourceType',
  UpdatedAt = 'updatedAt'
}

export type ReceivedPointScalarWhereInput = {
  AND?: InputMaybe<Array<ReceivedPointScalarWhereInput>>;
  NOT?: InputMaybe<Array<ReceivedPointScalarWhereInput>>;
  OR?: InputMaybe<Array<ReceivedPointScalarWhereInput>>;
  count?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  sourceType?: InputMaybe<EnumReceivedPointSourceTypeFilter>;
};

export enum ReceivedPointSourceType {
  Challenge = 'CHALLENGE',
  Coupon = 'COUPON',
  Manually = 'MANUALLY',
  Referral = 'REFERRAL',
  ValueBased = 'VALUE_BASED',
  VisitBased = 'VISIT_BASED'
}

export type ReceivedPointSumAggregate = {
  __typename: 'ReceivedPointSumAggregate';
  count?: Maybe<Scalars['Int']['output']>;
};

export type ReceivedPointSumAggregateInput = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReceivedPointUpdateInput = {
  company?: InputMaybe<CompanyUpdateOneRequiredWithoutReceivedPointsNestedInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutReceivedPointsNestedInput>;
  customerChallenge?: InputMaybe<CustomerChallengeUpdateOneWithoutReceivedPointNestedInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  redeemedCoupon?: InputMaybe<RedeemedCouponUpdateOneWithoutReceivedPointNestedInput>;
  sourceType?: InputMaybe<ReceivedPointSourceType>;
};

export type ReceivedPointUpdateManyMutationInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  sourceType?: InputMaybe<ReceivedPointSourceType>;
};

export type ReceivedPointUpdateManyWithWhereWithoutCustomerInput = {
  data: ReceivedPointUpdateManyMutationInput;
  where: ReceivedPointScalarWhereInput;
};

export type ReceivedPointUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<ReceivedPointWhereUniqueInput>>;
  delete?: InputMaybe<Array<ReceivedPointWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReceivedPointScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReceivedPointWhereUniqueInput>>;
  set?: InputMaybe<Array<ReceivedPointWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<ReceivedPointUpdateManyWithWhereWithoutCustomerInput>>;
};

export type ReceivedPointWhereInput = {
  AND?: InputMaybe<Array<ReceivedPointWhereInput>>;
  NOT?: InputMaybe<Array<ReceivedPointWhereInput>>;
  OR?: InputMaybe<Array<ReceivedPointWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  count?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerChallenge?: InputMaybe<CustomerChallengeNullableRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  redeemedCoupon?: InputMaybe<RedeemedCouponNullableRelationFilter>;
  sourceType?: InputMaybe<EnumReceivedPointSourceTypeFilter>;
};

export type ReceivedPointWhereUniqueInput = {
  AND?: InputMaybe<Array<ReceivedPointWhereInput>>;
  NOT?: InputMaybe<Array<ReceivedPointWhereInput>>;
  OR?: InputMaybe<Array<ReceivedPointWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  count?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerChallenge?: InputMaybe<CustomerChallengeNullableRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  redeemedCoupon?: InputMaybe<RedeemedCouponNullableRelationFilter>;
  sourceType?: InputMaybe<EnumReceivedPointSourceTypeFilter>;
};

export type RedeemedCoupon = {
  __typename: 'RedeemedCoupon';
  _count: RedeemedCouponCount;
  coupon: Coupon;
  couponId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  period?: Maybe<CouponPeriod>;
  periodId?: Maybe<Scalars['String']['output']>;
  receivedPoint?: Maybe<Array<ReceivedPoint>>;
  status: CouponStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type RedeemedCouponByTypeCount = {
  __typename: 'RedeemedCouponByTypeCount';
  count: Scalars['Float']['output'];
  type: CouponType;
};

export type RedeemedCouponCount = {
  __typename: 'RedeemedCouponCount';
  receivedPoint: Scalars['Int']['output'];
};

export type RedeemedCouponCountAggregate = {
  __typename: 'RedeemedCouponCountAggregate';
  _all: Scalars['Int']['output'];
  couponId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  periodId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type RedeemedCouponCouponIdCustomerIdPeriodIdCompoundUniqueInput = {
  couponId: Scalars['UUID']['input'];
  customerId: Scalars['String']['input'];
  periodId: Scalars['String']['input'];
};

export type RedeemedCouponCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<RedeemedCouponWhereUniqueInput>>;
};

export type RedeemedCouponCreateNestedManyWithoutPeriodInput = {
  connect?: InputMaybe<Array<RedeemedCouponWhereUniqueInput>>;
};

export type RedeemedCouponListRelationFilter = {
  every?: InputMaybe<RedeemedCouponWhereInput>;
  none?: InputMaybe<RedeemedCouponWhereInput>;
  some?: InputMaybe<RedeemedCouponWhereInput>;
};

export type RedeemedCouponMaxAggregate = {
  __typename: 'RedeemedCouponMaxAggregate';
  couponId?: Maybe<Scalars['UUID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  periodId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CouponStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RedeemedCouponMinAggregate = {
  __typename: 'RedeemedCouponMinAggregate';
  couponId?: Maybe<Scalars['UUID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  periodId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CouponStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RedeemedCouponNullableRelationFilter = {
  is?: InputMaybe<RedeemedCouponWhereInput>;
  isNot?: InputMaybe<RedeemedCouponWhereInput>;
};

export type RedeemedCouponOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RedeemedCouponOrderByWithRelationInput = {
  coupon?: InputMaybe<CouponOrderByWithRelationInput>;
  couponId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  period?: InputMaybe<CouponPeriodOrderByWithRelationInput>;
  periodId?: InputMaybe<SortOrderInput>;
  receivedPoint?: InputMaybe<ReceivedPointOrderByRelationAggregateInput>;
  status?: InputMaybe<SortOrder>;
};

export enum RedeemedCouponScalarFieldEnum {
  CompanyId = 'companyId',
  CouponId = 'couponId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  PeriodId = 'periodId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type RedeemedCouponScalarWhereInput = {
  AND?: InputMaybe<Array<RedeemedCouponScalarWhereInput>>;
  NOT?: InputMaybe<Array<RedeemedCouponScalarWhereInput>>;
  OR?: InputMaybe<Array<RedeemedCouponScalarWhereInput>>;
  couponId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  periodId?: InputMaybe<UuidNullableFilter>;
  status?: InputMaybe<EnumCouponStatusFilter>;
};

export type RedeemedCouponUpdateManyMutationInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<CouponStatus>;
};

export type RedeemedCouponUpdateManyWithWhereWithoutCouponInput = {
  data: RedeemedCouponUpdateManyMutationInput;
  where: RedeemedCouponScalarWhereInput;
};

export type RedeemedCouponUpdateManyWithWhereWithoutCustomerInput = {
  data: RedeemedCouponUpdateManyMutationInput;
  where: RedeemedCouponScalarWhereInput;
};

export type RedeemedCouponUpdateManyWithWhereWithoutPeriodInput = {
  data: RedeemedCouponUpdateManyMutationInput;
  where: RedeemedCouponScalarWhereInput;
};

export type RedeemedCouponUpdateManyWithoutCouponNestedInput = {
  connect?: InputMaybe<Array<RedeemedCouponWhereUniqueInput>>;
  delete?: InputMaybe<Array<RedeemedCouponWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RedeemedCouponScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RedeemedCouponWhereUniqueInput>>;
  set?: InputMaybe<Array<RedeemedCouponWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<RedeemedCouponUpdateManyWithWhereWithoutCouponInput>>;
};

export type RedeemedCouponUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<RedeemedCouponWhereUniqueInput>>;
  delete?: InputMaybe<Array<RedeemedCouponWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RedeemedCouponScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RedeemedCouponWhereUniqueInput>>;
  set?: InputMaybe<Array<RedeemedCouponWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<RedeemedCouponUpdateManyWithWhereWithoutCustomerInput>>;
};

export type RedeemedCouponUpdateManyWithoutPeriodNestedInput = {
  connect?: InputMaybe<Array<RedeemedCouponWhereUniqueInput>>;
  delete?: InputMaybe<Array<RedeemedCouponWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RedeemedCouponScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RedeemedCouponWhereUniqueInput>>;
  set?: InputMaybe<Array<RedeemedCouponWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<RedeemedCouponUpdateManyWithWhereWithoutPeriodInput>>;
};

export type RedeemedCouponUpdateOneWithoutReceivedPointNestedInput = {
  connect?: InputMaybe<RedeemedCouponWhereUniqueInput>;
  delete?: InputMaybe<RedeemedCouponWhereInput>;
  disconnect?: InputMaybe<RedeemedCouponWhereInput>;
};

export type RedeemedCouponWhereInput = {
  AND?: InputMaybe<Array<RedeemedCouponWhereInput>>;
  NOT?: InputMaybe<Array<RedeemedCouponWhereInput>>;
  OR?: InputMaybe<Array<RedeemedCouponWhereInput>>;
  coupon?: InputMaybe<CouponRelationFilter>;
  couponId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  period?: InputMaybe<CouponPeriodNullableRelationFilter>;
  periodId?: InputMaybe<UuidNullableFilter>;
  receivedPoint?: InputMaybe<ReceivedPointListRelationFilter>;
  status?: InputMaybe<EnumCouponStatusFilter>;
};

export type RedeemedCouponWhereUniqueInput = {
  AND?: InputMaybe<Array<RedeemedCouponWhereInput>>;
  NOT?: InputMaybe<Array<RedeemedCouponWhereInput>>;
  OR?: InputMaybe<Array<RedeemedCouponWhereInput>>;
  coupon?: InputMaybe<CouponRelationFilter>;
  couponId?: InputMaybe<UuidFilter>;
  couponId_customerId_periodId?: InputMaybe<RedeemedCouponCouponIdCustomerIdPeriodIdCompoundUniqueInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  period?: InputMaybe<CouponPeriodNullableRelationFilter>;
  periodId?: InputMaybe<UuidNullableFilter>;
  receivedPoint?: InputMaybe<ReceivedPointListRelationFilter>;
  status?: InputMaybe<EnumCouponStatusFilter>;
};

export type RedeemedPartnerReward = {
  __typename: 'RedeemedPartnerReward';
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  /** The discount code obtained for the redeeemd reward */
  discountCode: Scalars['String']['output'];
  /** The expiration date for this redeemed reward discount code. If not set, the discount runs indefinitely */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier of the discount object in the external system (e.g. the discount code ID at Shopify) */
  externalDiscountId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  order?: Maybe<CustomerPartnerOrder>;
  partnerReward: PartnerReward;
  partnerRewardId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RedeemedPartnerRewardCountAggregate = {
  __typename: 'RedeemedPartnerRewardCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  discountCode: Scalars['Int']['output'];
  expiresAt: Scalars['Int']['output'];
  externalDiscountId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  partnerRewardId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Input for creating a redeemed partner reward */
export type RedeemedPartnerRewardCreateInput = {
  partnerReward: PartnerRewardCreateNestedOneWithoutRedemptionsInput;
};

export type RedeemedPartnerRewardCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<RedeemedPartnerRewardWhereUniqueInput>>;
};

export type RedeemedPartnerRewardListRelationFilter = {
  every?: InputMaybe<RedeemedPartnerRewardWhereInput>;
  none?: InputMaybe<RedeemedPartnerRewardWhereInput>;
  some?: InputMaybe<RedeemedPartnerRewardWhereInput>;
};

export type RedeemedPartnerRewardMaxAggregate = {
  __typename: 'RedeemedPartnerRewardMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  discountCode?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  externalDiscountId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  partnerRewardId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RedeemedPartnerRewardMinAggregate = {
  __typename: 'RedeemedPartnerRewardMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  discountCode?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  externalDiscountId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  partnerRewardId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RedeemedPartnerRewardOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RedeemedPartnerRewardOrderByWithRelationInput = {
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  discountCode?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrderInput>;
  externalDiscountId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<CustomerPartnerOrderOrderByWithRelationInput>;
  partnerReward?: InputMaybe<PartnerRewardOrderByWithRelationInput>;
};

export type RedeemedPartnerRewardRelationFilter = {
  is?: InputMaybe<RedeemedPartnerRewardWhereInput>;
  isNot?: InputMaybe<RedeemedPartnerRewardWhereInput>;
};

export enum RedeemedPartnerRewardScalarFieldEnum {
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  DiscountCode = 'discountCode',
  ExpiresAt = 'expiresAt',
  ExternalDiscountId = 'externalDiscountId',
  Id = 'id',
  PartnerRewardId = 'partnerRewardId',
  UpdatedAt = 'updatedAt'
}

export type RedeemedPartnerRewardScalarWhereInput = {
  AND?: InputMaybe<Array<RedeemedPartnerRewardScalarWhereInput>>;
  NOT?: InputMaybe<Array<RedeemedPartnerRewardScalarWhereInput>>;
  OR?: InputMaybe<Array<RedeemedPartnerRewardScalarWhereInput>>;
  discountCode?: InputMaybe<StringFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  externalDiscountId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
};

export type RedeemedPartnerRewardUpdateManyMutationInput = {
  discountCode?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalDiscountId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type RedeemedPartnerRewardUpdateManyWithWhereWithoutCustomerInput = {
  data: RedeemedPartnerRewardUpdateManyMutationInput;
  where: RedeemedPartnerRewardScalarWhereInput;
};

export type RedeemedPartnerRewardUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<RedeemedPartnerRewardWhereUniqueInput>>;
  delete?: InputMaybe<Array<RedeemedPartnerRewardWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RedeemedPartnerRewardScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RedeemedPartnerRewardWhereUniqueInput>>;
  set?: InputMaybe<Array<RedeemedPartnerRewardWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<RedeemedPartnerRewardUpdateManyWithWhereWithoutCustomerInput>>;
};

export type RedeemedPartnerRewardWhereInput = {
  AND?: InputMaybe<Array<RedeemedPartnerRewardWhereInput>>;
  NOT?: InputMaybe<Array<RedeemedPartnerRewardWhereInput>>;
  OR?: InputMaybe<Array<RedeemedPartnerRewardWhereInput>>;
  customer?: InputMaybe<CustomerRelationFilter>;
  discountCode?: InputMaybe<StringFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  externalDiscountId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  order?: InputMaybe<CustomerPartnerOrderNullableRelationFilter>;
  partnerReward?: InputMaybe<PartnerRewardRelationFilter>;
};

export type RedeemedPartnerRewardWhereUniqueInput = {
  AND?: InputMaybe<Array<RedeemedPartnerRewardWhereInput>>;
  NOT?: InputMaybe<Array<RedeemedPartnerRewardWhereInput>>;
  OR?: InputMaybe<Array<RedeemedPartnerRewardWhereInput>>;
  customer?: InputMaybe<CustomerRelationFilter>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  externalDiscountId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  order?: InputMaybe<CustomerPartnerOrderNullableRelationFilter>;
  partnerReward?: InputMaybe<PartnerRewardRelationFilter>;
};

export type RedeemedPoint = {
  __typename: 'RedeemedPoint';
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  reward: Reward;
  rewardId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RedeemedPointCountAggregate = {
  __typename: 'RedeemedPointCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  rewardId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Custom input for creating redeemed points */
export type RedeemedPointCreateInput = {
  /** Optionally create redeemed point for a specific customer */
  customer?: InputMaybe<CustomerCreateNestedOneWithoutRedeemedPointsInput>;
  reward: RewardCreateNestedOneWithoutRedeemedPointsInput;
};

export type RedeemedPointCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<RedeemedPointWhereUniqueInput>>;
};

export type RedeemedPointListRelationFilter = {
  every?: InputMaybe<RedeemedPointWhereInput>;
  none?: InputMaybe<RedeemedPointWhereInput>;
  some?: InputMaybe<RedeemedPointWhereInput>;
};

export type RedeemedPointMaxAggregate = {
  __typename: 'RedeemedPointMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  rewardId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RedeemedPointMinAggregate = {
  __typename: 'RedeemedPointMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  rewardId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RedeemedPointOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RedeemedPointOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  id?: InputMaybe<SortOrder>;
  reward?: InputMaybe<RewardOrderByWithRelationInput>;
};

export enum RedeemedPointScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  RewardId = 'rewardId',
  UpdatedAt = 'updatedAt'
}

export type RedeemedPointScalarWhereInput = {
  AND?: InputMaybe<Array<RedeemedPointScalarWhereInput>>;
  NOT?: InputMaybe<Array<RedeemedPointScalarWhereInput>>;
  OR?: InputMaybe<Array<RedeemedPointScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
};

export type RedeemedPointUpdateInput = {
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutRedeemedPointsNestedInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  reward?: InputMaybe<RewardUpdateOneRequiredWithoutRedeemedPointsNestedInput>;
};

export type RedeemedPointUpdateManyMutationInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type RedeemedPointUpdateManyWithWhereWithoutCustomerInput = {
  data: RedeemedPointUpdateManyMutationInput;
  where: RedeemedPointScalarWhereInput;
};

export type RedeemedPointUpdateManyWithWhereWithoutRewardInput = {
  data: RedeemedPointUpdateManyMutationInput;
  where: RedeemedPointScalarWhereInput;
};

export type RedeemedPointUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<RedeemedPointWhereUniqueInput>>;
  delete?: InputMaybe<Array<RedeemedPointWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RedeemedPointScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RedeemedPointWhereUniqueInput>>;
  set?: InputMaybe<Array<RedeemedPointWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<RedeemedPointUpdateManyWithWhereWithoutCustomerInput>>;
};

export type RedeemedPointUpdateManyWithoutRewardNestedInput = {
  connect?: InputMaybe<Array<RedeemedPointWhereUniqueInput>>;
  delete?: InputMaybe<Array<RedeemedPointWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RedeemedPointScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RedeemedPointWhereUniqueInput>>;
  set?: InputMaybe<Array<RedeemedPointWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<RedeemedPointUpdateManyWithWhereWithoutRewardInput>>;
};

export type RedeemedPointWhereInput = {
  AND?: InputMaybe<Array<RedeemedPointWhereInput>>;
  NOT?: InputMaybe<Array<RedeemedPointWhereInput>>;
  OR?: InputMaybe<Array<RedeemedPointWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  reward?: InputMaybe<RewardRelationFilter>;
};

export type RedeemedPointWhereUniqueInput = {
  AND?: InputMaybe<Array<RedeemedPointWhereInput>>;
  NOT?: InputMaybe<Array<RedeemedPointWhereInput>>;
  OR?: InputMaybe<Array<RedeemedPointWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  reward?: InputMaybe<RewardRelationFilter>;
};

/** Input registering a company with crm config */
export type RegisterCompanyCrmConfigCreateInput = {
  /** The api key for the crm system */
  apiKey: Scalars['String']['input'];
  apiUrl: Scalars['String']['input'];
  branchOfficeCrmConfigs?: InputMaybe<BranchOfficeCrmConfigCreateNestedManyWithoutCompanyCrmConfigInput>;
  crmTenant: Scalars['String']['input'];
  customerCrmConfigs?: InputMaybe<CustomerCrmConfigCreateNestedManyWithoutCompanyCrmConfigInput>;
  redemptionTransmissionUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Custom input for registration of companies */
export type RegisterCompanyInput = {
  city: Scalars['String']['input'];
  countryCode: Scalars['CountryCode']['input'];
  /** Optional crm configuration */
  crmConfig?: InputMaybe<RegisterCompanyCrmConfigCreateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['EmailAddress']['input'];
  houseNumber: Scalars['String']['input'];
  id: Scalars['String']['input'];
  integrationType?: InputMaybe<IntegrationType>;
  mobileAppVariant?: InputMaybe<MobileAppVariant>;
  name: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  owner: NestedEmployeeCreateWithoutCompanyInput;
  postalCode: Scalars['PostalCode']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

/** Input for registering an invited employee */
export type RegisterEmployeeInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the employees auth0 account */
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  statusHistory?: InputMaybe<StatusHistoryCreateNestedManyWithoutChangedByInput>;
};

/** Result of starting registration flow */
export type RegistrationFlowModel = {
  __typename: 'RegistrationFlowModel';
  /** The arn of executed state machine */
  executionArn: Scalars['String']['output'];
  /** Start date of execution */
  startDate: Scalars['DateTime']['output'];
};

export type Reward = {
  __typename: 'Reward';
  _count: RewardCount;
  company: Company;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  imageKey?: Maybe<Scalars['String']['output']>;
  imageTemplate?: Maybe<ImageTemplate>;
  imageTemplateId?: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  redeemedPoints?: Maybe<Array<RedeemedPoint>>;
  requiredPoints: Scalars['Int']['output'];
  saving: Scalars['Float']['output'];
  /** The method that is used to transmission the reward redemtion to the company */
  transmissionMethod: TransmissionMethod;
  updatedAt: Scalars['DateTime']['output'];
};

export type RewardAvgAggregate = {
  __typename: 'RewardAvgAggregate';
  requiredPoints?: Maybe<Scalars['Float']['output']>;
  saving?: Maybe<Scalars['Float']['output']>;
};

export type RewardCount = {
  __typename: 'RewardCount';
  redeemedPoints: Scalars['Int']['output'];
};

export type RewardCountAggregate = {
  __typename: 'RewardCountAggregate';
  _all: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageKey: Scalars['Int']['output'];
  imageTemplateId: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  requiredPoints: Scalars['Int']['output'];
  saving: Scalars['Int']['output'];
  transmissionMethod: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type RewardCreateNestedManyWithoutImageTemplateInput = {
  connect?: InputMaybe<Array<RewardWhereUniqueInput>>;
};

export type RewardCreateNestedOneWithoutRedeemedPointsInput = {
  connect?: InputMaybe<RewardWhereUniqueInput>;
};

export type RewardListRelationFilter = {
  every?: InputMaybe<RewardWhereInput>;
  none?: InputMaybe<RewardWhereInput>;
  some?: InputMaybe<RewardWhereInput>;
};

export type RewardMaxAggregate = {
  __typename: 'RewardMaxAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageKey?: Maybe<Scalars['String']['output']>;
  imageTemplateId?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requiredPoints?: Maybe<Scalars['Int']['output']>;
  saving?: Maybe<Scalars['Float']['output']>;
  transmissionMethod?: Maybe<TransmissionMethod>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RewardMinAggregate = {
  __typename: 'RewardMinAggregate';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageKey?: Maybe<Scalars['String']['output']>;
  imageTemplateId?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requiredPoints?: Maybe<Scalars['Int']['output']>;
  saving?: Maybe<Scalars['Float']['output']>;
  transmissionMethod?: Maybe<TransmissionMethod>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RewardOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RewardOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imageKey?: InputMaybe<SortOrderInput>;
  imageTemplate?: InputMaybe<ImageTemplateOrderByWithRelationInput>;
  name?: InputMaybe<SortOrder>;
  redeemedPoints?: InputMaybe<RedeemedPointOrderByRelationAggregateInput>;
  requiredPoints?: InputMaybe<SortOrder>;
  saving?: InputMaybe<SortOrder>;
  transmissionMethod?: InputMaybe<SortOrder>;
};

export type RewardRelationFilter = {
  is?: InputMaybe<RewardWhereInput>;
  isNot?: InputMaybe<RewardWhereInput>;
};

export enum RewardScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Id = 'id',
  ImageKey = 'imageKey',
  ImageTemplateId = 'imageTemplateId',
  Name = 'name',
  RequiredPoints = 'requiredPoints',
  Saving = 'saving',
  TransmissionMethod = 'transmissionMethod',
  UpdatedAt = 'updatedAt'
}

export type RewardScalarWhereInput = {
  AND?: InputMaybe<Array<RewardScalarWhereInput>>;
  NOT?: InputMaybe<Array<RewardScalarWhereInput>>;
  OR?: InputMaybe<Array<RewardScalarWhereInput>>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  imageKey?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  requiredPoints?: InputMaybe<IntFilter>;
  saving?: InputMaybe<FloatFilter>;
  transmissionMethod?: InputMaybe<EnumTransmissionMethodFilter>;
};

/** Enum of status of rewards */
export enum RewardStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type RewardSumAggregate = {
  __typename: 'RewardSumAggregate';
  requiredPoints?: Maybe<Scalars['Int']['output']>;
  saving?: Maybe<Scalars['Float']['output']>;
};

export type RewardUpdateInput = {
  company?: InputMaybe<CompanyUpdateOneRequiredWithoutRewardsNestedInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageKey?: InputMaybe<Scalars['String']['input']>;
  imageTemplate?: InputMaybe<ImageTemplateUpdateOneWithoutRewardsNestedInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  redeemedPoints?: InputMaybe<RedeemedPointUpdateManyWithoutRewardNestedInput>;
  requiredPoints?: InputMaybe<Scalars['Int']['input']>;
  saving?: InputMaybe<Scalars['Float']['input']>;
  transmissionMethod?: InputMaybe<TransmissionMethod>;
};

export type RewardUpdateManyMutationInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageKey?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredPoints?: InputMaybe<Scalars['Int']['input']>;
  saving?: InputMaybe<Scalars['Float']['input']>;
  transmissionMethod?: InputMaybe<TransmissionMethod>;
};

export type RewardUpdateManyWithWhereWithoutImageTemplateInput = {
  data: RewardUpdateManyMutationInput;
  where: RewardScalarWhereInput;
};

export type RewardUpdateManyWithoutImageTemplateNestedInput = {
  connect?: InputMaybe<Array<RewardWhereUniqueInput>>;
  delete?: InputMaybe<Array<RewardWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RewardScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RewardWhereUniqueInput>>;
  set?: InputMaybe<Array<RewardWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<RewardUpdateManyWithWhereWithoutImageTemplateInput>>;
};

export type RewardUpdateOneRequiredWithoutRedeemedPointsNestedInput = {
  connect?: InputMaybe<RewardWhereUniqueInput>;
};

export type RewardWhereInput = {
  AND?: InputMaybe<Array<RewardWhereInput>>;
  NOT?: InputMaybe<Array<RewardWhereInput>>;
  OR?: InputMaybe<Array<RewardWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  imageKey?: InputMaybe<StringNullableFilter>;
  imageTemplate?: InputMaybe<ImageTemplateNullableRelationFilter>;
  name?: InputMaybe<StringFilter>;
  redeemedPoints?: InputMaybe<RedeemedPointListRelationFilter>;
  requiredPoints?: InputMaybe<IntFilter>;
  saving?: InputMaybe<FloatFilter>;
  transmissionMethod?: InputMaybe<EnumTransmissionMethodFilter>;
};

export type RewardWhereUniqueInput = {
  AND?: InputMaybe<Array<RewardWhereInput>>;
  NOT?: InputMaybe<Array<RewardWhereInput>>;
  OR?: InputMaybe<Array<RewardWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageKey?: InputMaybe<StringNullableFilter>;
  imageTemplate?: InputMaybe<ImageTemplateNullableRelationFilter>;
  name?: InputMaybe<StringFilter>;
  redeemedPoints?: InputMaybe<RedeemedPointListRelationFilter>;
  requiredPoints?: InputMaybe<IntFilter>;
  saving?: InputMaybe<FloatFilter>;
  transmissionMethod?: InputMaybe<EnumTransmissionMethodFilter>;
};

export enum ShopType {
  Custom = 'CUSTOM',
  Shopify = 'SHOPIFY'
}

/** Representing customer signature */
export type SignatureInput = {
  /** Customer confirmation signature SVG value as base64 string */
  base64SvgSignature: Scalars['String']['input'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type StatusHistory = {
  __typename: 'StatusHistory';
  changedBy?: Maybe<Employee>;
  changedById?: Maybe<Scalars['String']['output']>;
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  equipment: Equipment;
  equipmentId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  newStatus: EquipmentStatus;
  oldStatus: EquipmentStatus;
};

export type StatusHistoryCountAggregate = {
  __typename: 'StatusHistoryCountAggregate';
  _all: Scalars['Int']['output'];
  changedById: Scalars['Int']['output'];
  comment: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  equipmentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  newStatus: Scalars['Int']['output'];
  oldStatus: Scalars['Int']['output'];
};

export type StatusHistoryCreateNestedManyWithoutChangedByInput = {
  connect?: InputMaybe<Array<StatusHistoryWhereUniqueInput>>;
};

export type StatusHistoryCreateNestedManyWithoutEquipmentInput = {
  connect?: InputMaybe<Array<StatusHistoryWhereUniqueInput>>;
};

export type StatusHistoryListRelationFilter = {
  every?: InputMaybe<StatusHistoryWhereInput>;
  none?: InputMaybe<StatusHistoryWhereInput>;
  some?: InputMaybe<StatusHistoryWhereInput>;
};

export type StatusHistoryMaxAggregate = {
  __typename: 'StatusHistoryMaxAggregate';
  changedById?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  equipmentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  newStatus?: Maybe<EquipmentStatus>;
  oldStatus?: Maybe<EquipmentStatus>;
};

export type StatusHistoryMinAggregate = {
  __typename: 'StatusHistoryMinAggregate';
  changedById?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  equipmentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  newStatus?: Maybe<EquipmentStatus>;
  oldStatus?: Maybe<EquipmentStatus>;
};

export type StatusHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StatusHistoryOrderByWithRelationInput = {
  changedBy?: InputMaybe<EmployeeOrderByWithRelationInput>;
  changedById?: InputMaybe<SortOrderInput>;
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  equipment?: InputMaybe<EquipmentOrderByWithRelationInput>;
  equipmentId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  newStatus?: InputMaybe<SortOrder>;
  oldStatus?: InputMaybe<SortOrder>;
};

export enum StatusHistoryScalarFieldEnum {
  ChangedById = 'changedById',
  Comment = 'comment',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  EquipmentId = 'equipmentId',
  Id = 'id',
  NewStatus = 'newStatus',
  OldStatus = 'oldStatus'
}

export type StatusHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<StatusHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<StatusHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<StatusHistoryScalarWhereInput>>;
  changedById?: InputMaybe<StringNullableFilter>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  equipmentId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  newStatus?: InputMaybe<EnumEquipmentStatusFilter>;
  oldStatus?: InputMaybe<EnumEquipmentStatusFilter>;
};

export type StatusHistoryUpdateManyMutationInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  newStatus?: InputMaybe<EquipmentStatus>;
  oldStatus?: InputMaybe<EquipmentStatus>;
};

export type StatusHistoryUpdateManyWithWhereWithoutEquipmentInput = {
  data: StatusHistoryUpdateManyMutationInput;
  where: StatusHistoryScalarWhereInput;
};

export type StatusHistoryUpdateManyWithoutEquipmentNestedInput = {
  connect?: InputMaybe<Array<StatusHistoryWhereUniqueInput>>;
  delete?: InputMaybe<Array<StatusHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StatusHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StatusHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<StatusHistoryWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<StatusHistoryUpdateManyWithWhereWithoutEquipmentInput>>;
};

export type StatusHistoryWhereInput = {
  AND?: InputMaybe<Array<StatusHistoryWhereInput>>;
  NOT?: InputMaybe<Array<StatusHistoryWhereInput>>;
  OR?: InputMaybe<Array<StatusHistoryWhereInput>>;
  changedBy?: InputMaybe<EmployeeNullableRelationFilter>;
  changedById?: InputMaybe<StringNullableFilter>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  equipment?: InputMaybe<EquipmentRelationFilter>;
  equipmentId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  newStatus?: InputMaybe<EnumEquipmentStatusFilter>;
  oldStatus?: InputMaybe<EnumEquipmentStatusFilter>;
};

export type StatusHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<StatusHistoryWhereInput>>;
  NOT?: InputMaybe<Array<StatusHistoryWhereInput>>;
  OR?: InputMaybe<Array<StatusHistoryWhereInput>>;
  changedBy?: InputMaybe<EmployeeNullableRelationFilter>;
  changedById?: InputMaybe<StringNullableFilter>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  equipment?: InputMaybe<EquipmentRelationFilter>;
  equipmentId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  newStatus?: InputMaybe<EnumEquipmentStatusFilter>;
  oldStatus?: InputMaybe<EnumEquipmentStatusFilter>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** Studio access code configuration */
export type StudioAccessCodeConfiguration = {
  __typename: 'StudioAccessCodeConfiguration';
  /** Whether or not the access code is enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Interval during which studio is closed */
export type StudioClosingHours = {
  __typename: 'StudioClosingHours';
  /** Start of the range closing hours */
  dateTimeFrom?: Maybe<Scalars['String']['output']>;
  /** End of the range closing hours */
  dateTimeTo?: Maybe<Scalars['String']['output']>;
  /** Reason of closure */
  reason?: Maybe<Scalars['String']['output']>;
};

/** General studio information visible for user */
export type StudioInformation = {
  __typename: 'StudioInformation';
  /** Studio access code configuration */
  accessCodeConfiguration: StudioAccessCodeConfiguration;
  /** Studio address' city */
  city?: Maybe<Scalars['String']['output']>;
  /** Studio closing date */
  closingDate?: Maybe<Scalars['String']['output']>;
  /** Studio closing hours */
  closingHours?: Maybe<Array<StudioClosingHours>>;
  /** Studio address' country */
  country?: Maybe<Scalars['String']['output']>;
  /** Studio address' country code */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Studio description */
  description?: Maybe<Scalars['String']['output']>;
  /** Studio email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Studio address' house number */
  houseNumber?: Maybe<Scalars['String']['output']>;
  /** Images of the studio */
  images?: Maybe<Array<BranchOfficeImage>>;
  /** Studio location */
  location?: Maybe<StudioLocation>;
  /** URL to studio logo */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Studio name */
  name?: Maybe<Scalars['String']['output']>;
  /** Studio opening date */
  openingDate?: Maybe<Scalars['String']['output']>;
  /** Studio internal opening hours */
  openingHours?: Maybe<Array<StudioOpeningHours>>;
  /** Studio opening hours categories with time restrictions */
  openingHoursCategories?: Maybe<Array<StudioOpeningHoursCategory>>;
  /** Studio public opening hours */
  publicOpeningHours?: Maybe<Array<StudioOpeningHours>>;
  /** Studio address' street */
  street?: Maybe<Scalars['String']['output']>;
  /** Studio Id */
  studioId: Scalars['Int']['output'];
  /** Tags associated with the studio */
  studioTags?: Maybe<Array<Tag>>;
  /** Studio telephone */
  telephone?: Maybe<Scalars['String']['output']>;
  /** Studio website URL */
  website?: Maybe<Scalars['String']['output']>;
  /** Studio address' zip code */
  zip?: Maybe<Scalars['String']['output']>;
};

/** Location of a Studio */
export type StudioLocation = {
  __typename: 'StudioLocation';
  /** Latitude of the studio */
  latitude: Scalars['Float']['output'];
  /** Longitude of the studio */
  longitude: Scalars['Float']['output'];
};

/** Studio opening hours range */
export type StudioOpeningHours = {
  __typename: 'StudioOpeningHours';
  /** Start day of given range opening hours */
  dayOfWeekFrom: DayOfWeek;
  /** End day of given range opening hours */
  dayOfWeekTo: DayOfWeek;
  /** Start hour of the range in ISO-8601 format */
  timeFrom?: Maybe<Scalars['String']['output']>;
  /** End hour of the range in ISO-8601 format */
  timeTo?: Maybe<Scalars['String']['output']>;
};

/** Opening hours category with specific time restrictions */
export type StudioOpeningHoursCategory = {
  __typename: 'StudioOpeningHoursCategory';
  /** ID of the opening hours category */
  categoryId: Scalars['Int']['output'];
  /** Name of the opening hours category */
  name: Scalars['String']['output'];
  /** List of opening hours for this category */
  openingHours: Array<StudioOpeningHours>;
};

/** Utilization over a time window */
export type StudioUtilization = {
  __typename: 'StudioUtilization';
  /** End time of the window */
  endTime?: Maybe<Scalars['String']['output']>;
  /** List of utilization items */
  items: Array<UtilizationItemDto>;
  /** Start time of the window */
  startTime?: Maybe<Scalars['String']['output']>;
};

/** Subcontract of the parent contract */
export type SubContract = {
  __typename: 'SubContract';
  cancellationDate?: Maybe<Scalars['String']['output']>;
  cancellationReceiptDate?: Maybe<Scalars['String']['output']>;
  cancelled: Scalars['Boolean']['output'];
  contractStatus: ContractStatus;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  paymentFrequency: PaymentFrequency;
  /** @deprecated Deprecated in API spec */
  price: Scalars['Float']['output'];
  priceDetails: PriceDetails;
  rateName: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

/** Model for summarized redeemed points by reward */
export type SummarizedRedeemedPointModel = {
  __typename: 'SummarizedRedeemedPointModel';
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  reward: Reward;
  rewardId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SummarizedRewardRedemptions = {
  __typename: 'SummarizedRewardRedemptions';
  count: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  requiredPoints: Scalars['Int']['output'];
  saving: Scalars['Float']['output'];
};

/** Input to change coupon status */
export type SwitchCouponStatusInput = {
  /** The new status for the coupon */
  status: CouponState;
};

/** Input type to soft delete or reactivate a reward */
export type SwitchRewardStatusInput = {
  /** The ID of the reward to switch the status of */
  rewardId: Scalars['String']['input'];
  /** The status the reward should be changed to (set deletedAt based on the status) */
  status: RewardStatus;
};

export enum SystemType {
  Percentage = 'PERCENTAGE',
  Staggered = 'STAGGERED',
  VisitBased = 'VISIT_BASED'
}

/** Tag information used for categorization or grouping */
export type Tag = {
  __typename: 'Tag';
  /** Unique name of a tag */
  name: Scalars['String']['output'];
};

/** Represents a term */
export type Term = {
  __typename: 'Term';
  /** Represents a temporal unit */
  unit: TermUnit;
  /** The value of the term */
  value: Scalars['Int']['output'];
};

/** Term information of the additional module */
export type TermInformation = {
  __typename: 'TermInformation';
  /** Cancelation period for the module */
  cancelationPeriod?: Maybe<Term>;
  /** Extension information if applicable */
  extension?: Maybe<Extension>;
  /** Term of the module */
  term: Term;
};

/** Represents a mapping from a term to a price for an additional module */
export type TermToPrice = {
  __typename: 'TermToPrice';
  /** Price for this term */
  price: Money;
  /** Term of the mapping */
  term: Term;
};

/** Represents a temporal unit */
export enum TermUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** Represents a time period */
export type TimePeriod = {
  __typename: 'TimePeriod';
  /** Unit of the period */
  periodUnit: TimePeriodUnit;
  /** Defines how many units a given period lasts */
  periodValue: Scalars['Int']['output'];
};

/** Unit of the period */
export enum TimePeriodUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type TrainingPlan = {
  __typename: 'TrainingPlan';
  _count: TrainingPlanCount;
  company: Company;
  copies?: Maybe<Array<TrainingPlan>>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exercises?: Maybe<Array<TrainingPlanExercise>>;
  id: Scalars['UUID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isTemplate: Scalars['Boolean']['output'];
  parentPlan?: Maybe<TrainingPlan>;
  parentPlanId?: Maybe<Scalars['String']['output']>;
  sessions?: Maybe<Array<WorkoutSession>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TrainingPlanCount = {
  __typename: 'TrainingPlanCount';
  copies: Scalars['Int']['output'];
  exercises: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
};

export type TrainingPlanCountAggregate = {
  __typename: 'TrainingPlanCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['Int']['output'];
  isTemplate: Scalars['Int']['output'];
  parentPlanId: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type TrainingPlanCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  exercises: Array<TrainingPlanExerciseCreateInput>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type TrainingPlanCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<TrainingPlanWhereUniqueInput>>;
};

export type TrainingPlanExercise = {
  __typename: 'TrainingPlanExercise';
  _count: TrainingPlanExerciseCount;
  createdAt: Scalars['DateTime']['output'];
  exercise: Exercise;
  exerciseId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  plan: TrainingPlan;
  restTimeSec?: Maybe<Scalars['Int']['output']>;
  sets?: Maybe<Array<TrainingPlanSet>>;
  trainingPlanId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TrainingPlanExerciseAvgAggregate = {
  __typename: 'TrainingPlanExerciseAvgAggregate';
  order?: Maybe<Scalars['Float']['output']>;
  restTimeSec?: Maybe<Scalars['Float']['output']>;
};

export type TrainingPlanExerciseCount = {
  __typename: 'TrainingPlanExerciseCount';
  sets: Scalars['Int']['output'];
};

export type TrainingPlanExerciseCountAggregate = {
  __typename: 'TrainingPlanExerciseCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  exerciseId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  notes: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  restTimeSec: Scalars['Int']['output'];
  trainingPlanId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type TrainingPlanExerciseCreateInput = {
  exerciseId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  restTimeSec?: InputMaybe<Scalars['Int']['input']>;
  sets: Array<TrainingPlanSetCreateInput>;
};

export type TrainingPlanExerciseListRelationFilter = {
  every?: InputMaybe<TrainingPlanExerciseWhereInput>;
  none?: InputMaybe<TrainingPlanExerciseWhereInput>;
  some?: InputMaybe<TrainingPlanExerciseWhereInput>;
};

export type TrainingPlanExerciseMaxAggregate = {
  __typename: 'TrainingPlanExerciseMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  exerciseId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  restTimeSec?: Maybe<Scalars['Int']['output']>;
  trainingPlanId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TrainingPlanExerciseMinAggregate = {
  __typename: 'TrainingPlanExerciseMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  exerciseId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  restTimeSec?: Maybe<Scalars['Int']['output']>;
  trainingPlanId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TrainingPlanExerciseOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TrainingPlanExerciseRelationFilter = {
  is?: InputMaybe<TrainingPlanExerciseWhereInput>;
  isNot?: InputMaybe<TrainingPlanExerciseWhereInput>;
};

export type TrainingPlanExerciseSumAggregate = {
  __typename: 'TrainingPlanExerciseSumAggregate';
  order?: Maybe<Scalars['Int']['output']>;
  restTimeSec?: Maybe<Scalars['Int']['output']>;
};

export type TrainingPlanExerciseWhereInput = {
  AND?: InputMaybe<Array<TrainingPlanExerciseWhereInput>>;
  NOT?: InputMaybe<Array<TrainingPlanExerciseWhereInput>>;
  OR?: InputMaybe<Array<TrainingPlanExerciseWhereInput>>;
  exercise?: InputMaybe<ExerciseRelationFilter>;
  exerciseId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<IntFilter>;
  plan?: InputMaybe<TrainingPlanRelationFilter>;
  restTimeSec?: InputMaybe<IntNullableFilter>;
  sets?: InputMaybe<TrainingPlanSetListRelationFilter>;
  trainingPlanId?: InputMaybe<UuidFilter>;
};

export type TrainingPlanListRelationFilter = {
  every?: InputMaybe<TrainingPlanWhereInput>;
  none?: InputMaybe<TrainingPlanWhereInput>;
  some?: InputMaybe<TrainingPlanWhereInput>;
};

export type TrainingPlanMaxAggregate = {
  __typename: 'TrainingPlanMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  parentPlanId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TrainingPlanMinAggregate = {
  __typename: 'TrainingPlanMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  parentPlanId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TrainingPlanNullableRelationFilter = {
  is?: InputMaybe<TrainingPlanWhereInput>;
  isNot?: InputMaybe<TrainingPlanWhereInput>;
};

export type TrainingPlanOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TrainingPlanOrderByWithRelationInput = {
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  copies?: InputMaybe<TrainingPlanOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  exercises?: InputMaybe<TrainingPlanExerciseOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  isTemplate?: InputMaybe<SortOrder>;
  parentPlan?: InputMaybe<TrainingPlanOrderByWithRelationInput>;
  parentPlanId?: InputMaybe<SortOrderInput>;
  sessions?: InputMaybe<WorkoutSessionOrderByRelationAggregateInput>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TrainingPlanRelationFilter = {
  is?: InputMaybe<TrainingPlanWhereInput>;
  isNot?: InputMaybe<TrainingPlanWhereInput>;
};

export enum TrainingPlanScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Description = 'description',
  Id = 'id',
  ImageUrl = 'imageUrl',
  IsTemplate = 'isTemplate',
  ParentPlanId = 'parentPlanId',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type TrainingPlanScalarWhereInput = {
  AND?: InputMaybe<Array<TrainingPlanScalarWhereInput>>;
  NOT?: InputMaybe<Array<TrainingPlanScalarWhereInput>>;
  OR?: InputMaybe<Array<TrainingPlanScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  isTemplate?: InputMaybe<BoolFilter>;
  parentPlanId?: InputMaybe<UuidNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TrainingPlanSet = {
  __typename: 'TrainingPlanSet';
  _count: TrainingPlanSetCount;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  planExercise: TrainingPlanExercise;
  setNumber: Scalars['Int']['output'];
  targetReps?: Maybe<Scalars['Int']['output']>;
  targetWeight?: Maybe<Scalars['Decimal']['output']>;
  trainingPlanExerciseId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workoutSets?: Maybe<Array<WorkoutSet>>;
};

export type TrainingPlanSetAvgAggregate = {
  __typename: 'TrainingPlanSetAvgAggregate';
  setNumber?: Maybe<Scalars['Float']['output']>;
  targetReps?: Maybe<Scalars['Float']['output']>;
  targetWeight?: Maybe<Scalars['Decimal']['output']>;
};

export type TrainingPlanSetCount = {
  __typename: 'TrainingPlanSetCount';
  workoutSets: Scalars['Int']['output'];
};

export type TrainingPlanSetCountAggregate = {
  __typename: 'TrainingPlanSetCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  setNumber: Scalars['Int']['output'];
  targetReps: Scalars['Int']['output'];
  targetWeight: Scalars['Int']['output'];
  trainingPlanExerciseId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type TrainingPlanSetCreateInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  setNumber: Scalars['Int']['input'];
  targetReps?: InputMaybe<Scalars['Int']['input']>;
  targetWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type TrainingPlanSetCreateNestedOneWithoutWorkoutSetsInput = {
  connect?: InputMaybe<TrainingPlanSetWhereUniqueInput>;
};

export type TrainingPlanSetListRelationFilter = {
  every?: InputMaybe<TrainingPlanSetWhereInput>;
  none?: InputMaybe<TrainingPlanSetWhereInput>;
  some?: InputMaybe<TrainingPlanSetWhereInput>;
};

export type TrainingPlanSetMaxAggregate = {
  __typename: 'TrainingPlanSetMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  setNumber?: Maybe<Scalars['Int']['output']>;
  targetReps?: Maybe<Scalars['Int']['output']>;
  targetWeight?: Maybe<Scalars['Decimal']['output']>;
  trainingPlanExerciseId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TrainingPlanSetMinAggregate = {
  __typename: 'TrainingPlanSetMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  setNumber?: Maybe<Scalars['Int']['output']>;
  targetReps?: Maybe<Scalars['Int']['output']>;
  targetWeight?: Maybe<Scalars['Decimal']['output']>;
  trainingPlanExerciseId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TrainingPlanSetNullableRelationFilter = {
  is?: InputMaybe<TrainingPlanSetWhereInput>;
  isNot?: InputMaybe<TrainingPlanSetWhereInput>;
};

export type TrainingPlanSetSumAggregate = {
  __typename: 'TrainingPlanSetSumAggregate';
  setNumber?: Maybe<Scalars['Int']['output']>;
  targetReps?: Maybe<Scalars['Int']['output']>;
  targetWeight?: Maybe<Scalars['Decimal']['output']>;
};

export type TrainingPlanSetTrainingPlanExerciseIdSetNumberCompoundUniqueInput = {
  setNumber: Scalars['Int']['input'];
  trainingPlanExerciseId: Scalars['String']['input'];
};

export type TrainingPlanSetUpdateOneWithoutWorkoutSetsNestedInput = {
  connect?: InputMaybe<TrainingPlanSetWhereUniqueInput>;
  delete?: InputMaybe<TrainingPlanSetWhereInput>;
  disconnect?: InputMaybe<TrainingPlanSetWhereInput>;
};

export type TrainingPlanSetWhereInput = {
  AND?: InputMaybe<Array<TrainingPlanSetWhereInput>>;
  NOT?: InputMaybe<Array<TrainingPlanSetWhereInput>>;
  OR?: InputMaybe<Array<TrainingPlanSetWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  planExercise?: InputMaybe<TrainingPlanExerciseRelationFilter>;
  setNumber?: InputMaybe<IntFilter>;
  targetReps?: InputMaybe<IntNullableFilter>;
  targetWeight?: InputMaybe<DecimalNullableFilter>;
  trainingPlanExerciseId?: InputMaybe<UuidFilter>;
  workoutSets?: InputMaybe<WorkoutSetListRelationFilter>;
};

export type TrainingPlanSetWhereUniqueInput = {
  AND?: InputMaybe<Array<TrainingPlanSetWhereInput>>;
  NOT?: InputMaybe<Array<TrainingPlanSetWhereInput>>;
  OR?: InputMaybe<Array<TrainingPlanSetWhereInput>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  planExercise?: InputMaybe<TrainingPlanExerciseRelationFilter>;
  setNumber?: InputMaybe<IntFilter>;
  targetReps?: InputMaybe<IntNullableFilter>;
  targetWeight?: InputMaybe<DecimalNullableFilter>;
  trainingPlanExerciseId?: InputMaybe<UuidFilter>;
  trainingPlanExerciseId_setNumber?: InputMaybe<TrainingPlanSetTrainingPlanExerciseIdSetNumberCompoundUniqueInput>;
  workoutSets?: InputMaybe<WorkoutSetListRelationFilter>;
};

export type TrainingPlanUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  exercises: Array<TrainingPlanExerciseCreateInput>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TrainingPlanUpdateManyMutationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TrainingPlanUpdateManyWithWhereWithoutCustomerInput = {
  data: TrainingPlanUpdateManyMutationInput;
  where: TrainingPlanScalarWhereInput;
};

export type TrainingPlanUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<TrainingPlanWhereUniqueInput>>;
  delete?: InputMaybe<Array<TrainingPlanWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TrainingPlanScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TrainingPlanWhereUniqueInput>>;
  set?: InputMaybe<Array<TrainingPlanWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<TrainingPlanUpdateManyWithWhereWithoutCustomerInput>>;
};

export type TrainingPlanUpdateOneWithoutSessionsNestedInput = {
  connect?: InputMaybe<TrainingPlanWhereUniqueInput>;
  delete?: InputMaybe<TrainingPlanWhereInput>;
  disconnect?: InputMaybe<TrainingPlanWhereInput>;
};

export type TrainingPlanWhereInput = {
  AND?: InputMaybe<Array<TrainingPlanWhereInput>>;
  NOT?: InputMaybe<Array<TrainingPlanWhereInput>>;
  OR?: InputMaybe<Array<TrainingPlanWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  copies?: InputMaybe<TrainingPlanListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerNullableRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  exercises?: InputMaybe<TrainingPlanExerciseListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  isTemplate?: InputMaybe<BoolFilter>;
  parentPlan?: InputMaybe<TrainingPlanNullableRelationFilter>;
  parentPlanId?: InputMaybe<UuidNullableFilter>;
  sessions?: InputMaybe<WorkoutSessionListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TrainingPlanWhereUniqueInput = {
  AND?: InputMaybe<Array<TrainingPlanWhereInput>>;
  NOT?: InputMaybe<Array<TrainingPlanWhereInput>>;
  OR?: InputMaybe<Array<TrainingPlanWhereInput>>;
  company?: InputMaybe<CompanyRelationFilter>;
  copies?: InputMaybe<TrainingPlanListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerNullableRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  exercises?: InputMaybe<TrainingPlanExerciseListRelationFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  isTemplate?: InputMaybe<BoolFilter>;
  parentPlan?: InputMaybe<TrainingPlanNullableRelationFilter>;
  parentPlanId?: InputMaybe<UuidNullableFilter>;
  sessions?: InputMaybe<WorkoutSessionListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum TransmissionMethod {
  Crm = 'CRM',
  Mail = 'MAIL'
}

export type TrendMetric = {
  __typename: 'TrendMetric';
  dateGroupedCount: Array<DateGroupedCount>;
  periodCount: Scalars['Float']['output'];
  previousPeriodCount: Scalars['Float']['output'];
  trend: Scalars['Float']['output'];
};

/** Represents the trial period config of an additional module */
export type TrialPeriodConfig = {
  __typename: 'TrialPeriodConfig';
  /** Description of the trial period config */
  description?: Maybe<Scalars['String']['output']>;
  /** Term of the trial period */
  term: Term;
};

/** Input for updating information about a company */
export type UpdateCompanyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating information of employee */
export type UpdateEmployeeInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePartnerChallengeProgressInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** Batch upsert input for multiple branch office utilizations */
export type UpsertBranchOfficeUtilizationInput = {
  /** Branch office identifier */
  branchOfficeId: Scalars['String']['input'];
  /** The companyId for rls performance */
  companyId: Scalars['String']['input'];
  /** List of utilization slots for the branch office */
  utilizationItems: Array<UtilizationItemInput>;
};

/** Utilization item within a time slot */
export type UtilizationItemDto = {
  __typename: 'UtilizationItemDto';
  /** End time of this utilization item */
  endTime: Scalars['String']['output'];
  /** Whether this is the current utilization */
  isCurrent: Scalars['Boolean']['output'];
  /** Level of utilization */
  level: UtilizationLevel;
  /** Utilization percentage */
  percentage: Scalars['Int']['output'];
  /** Start time of this utilization item */
  startTime: Scalars['String']['output'];
};

/** Upsert input for branch office utilization */
export type UtilizationItemInput = {
  /** End time of this utilization item */
  endTime: Scalars['String']['input'];
  /** Whether this is the current utilization */
  isCurrent: Scalars['Boolean']['input'];
  /** Level of utilization */
  level: UtilizationLevel;
  /** Utilization percentage */
  percentage: Scalars['Int']['input'];
  /** Start time of this utilization item */
  startTime: Scalars['String']['input'];
};

/** Utilization level for a given time slot */
export enum UtilizationLevel {
  High = 'HIGH',
  Low = 'LOW',
  Normal = 'NORMAL'
}

export type UuidFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedUuidFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UuidNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedUuidNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents appointment booking request */
export type ValidateAppointmentBookingInput = {
  /** Unique ID of the bookable appointment */
  bookableAppointmentId: Scalars['Int']['input'];
  /** End date time of the bookable appointment slot */
  endDateTime: Scalars['DateTime']['input'];
  /** Instructor ID list of the bookable appointment slot */
  instructorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Start date time of the bookable appointment slot */
  startDateTime: Scalars['DateTime']['input'];
};

export type VisitBasedInput = {
  branchOfficeId: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a coupon */
export type WelcomeCouponCreateInput = {
  /** The ID of the company this coupon should be created for */
  companyId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  pointsCredit?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkoutSession = {
  __typename: 'WorkoutSession';
  _count: WorkoutSessionCount;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<TrainingPlan>;
  sets?: Maybe<Array<WorkoutSet>>;
  trainedAt: Scalars['DateTime']['output'];
  trainingPlan?: Maybe<TrainingPlan>;
  trainingPlanId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type WorkoutSessionCount = {
  __typename: 'WorkoutSessionCount';
  sets: Scalars['Int']['output'];
};

export type WorkoutSessionCountAggregate = {
  __typename: 'WorkoutSessionCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  finishedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  notes: Scalars['Int']['output'];
  trainedAt: Scalars['Int']['output'];
  trainingPlanId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type WorkoutSessionCreateInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  trainingPlanId?: InputMaybe<Scalars['UUID']['input']>;
};

export type WorkoutSessionCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<WorkoutSessionWhereUniqueInput>>;
};

export type WorkoutSessionCreateNestedOneWithoutSetsInput = {
  connect?: InputMaybe<WorkoutSessionWhereUniqueInput>;
};

export type WorkoutSessionListRelationFilter = {
  every?: InputMaybe<WorkoutSessionWhereInput>;
  none?: InputMaybe<WorkoutSessionWhereInput>;
  some?: InputMaybe<WorkoutSessionWhereInput>;
};

export type WorkoutSessionMaxAggregate = {
  __typename: 'WorkoutSessionMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  trainedAt?: Maybe<Scalars['DateTime']['output']>;
  trainingPlanId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WorkoutSessionMinAggregate = {
  __typename: 'WorkoutSessionMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  trainedAt?: Maybe<Scalars['DateTime']['output']>;
  trainingPlanId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WorkoutSessionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type WorkoutSessionOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  finishedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrderInput>;
  plan?: InputMaybe<TrainingPlanOrderByWithRelationInput>;
  sets?: InputMaybe<WorkoutSetOrderByRelationAggregateInput>;
  trainedAt?: InputMaybe<SortOrder>;
  trainingPlanId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type WorkoutSessionRelationFilter = {
  is?: InputMaybe<WorkoutSessionWhereInput>;
  isNot?: InputMaybe<WorkoutSessionWhereInput>;
};

export enum WorkoutSessionScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  FinishedAt = 'finishedAt',
  Id = 'id',
  Notes = 'notes',
  TrainedAt = 'trainedAt',
  TrainingPlanId = 'trainingPlanId',
  UpdatedAt = 'updatedAt'
}

export type WorkoutSessionScalarWhereInput = {
  AND?: InputMaybe<Array<WorkoutSessionScalarWhereInput>>;
  NOT?: InputMaybe<Array<WorkoutSessionScalarWhereInput>>;
  OR?: InputMaybe<Array<WorkoutSessionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringFilter>;
  finishedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  trainedAt?: InputMaybe<DateTimeFilter>;
  trainingPlanId?: InputMaybe<UuidNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type WorkoutSessionUpdateInput = {
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutWorkoutSessionsNestedInput>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<TrainingPlanUpdateOneWithoutSessionsNestedInput>;
  sets?: InputMaybe<WorkoutSetUpdateManyWithoutSessionNestedInput>;
  trainedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkoutSessionUpdateManyMutationInput = {
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  trainedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkoutSessionUpdateManyWithWhereWithoutCustomerInput = {
  data: WorkoutSessionUpdateManyMutationInput;
  where: WorkoutSessionScalarWhereInput;
};

export type WorkoutSessionUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<WorkoutSessionWhereUniqueInput>>;
  delete?: InputMaybe<Array<WorkoutSessionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkoutSessionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkoutSessionWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkoutSessionWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<WorkoutSessionUpdateManyWithWhereWithoutCustomerInput>>;
};

export type WorkoutSessionUpdateOneRequiredWithoutSetsNestedInput = {
  connect?: InputMaybe<WorkoutSessionWhereUniqueInput>;
};

export type WorkoutSessionWhereInput = {
  AND?: InputMaybe<Array<WorkoutSessionWhereInput>>;
  NOT?: InputMaybe<Array<WorkoutSessionWhereInput>>;
  OR?: InputMaybe<Array<WorkoutSessionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  finishedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  plan?: InputMaybe<TrainingPlanNullableRelationFilter>;
  sets?: InputMaybe<WorkoutSetListRelationFilter>;
  trainedAt?: InputMaybe<DateTimeFilter>;
  trainingPlanId?: InputMaybe<UuidNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type WorkoutSessionWhereUniqueInput = {
  AND?: InputMaybe<Array<WorkoutSessionWhereInput>>;
  NOT?: InputMaybe<Array<WorkoutSessionWhereInput>>;
  OR?: InputMaybe<Array<WorkoutSessionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  finishedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notes?: InputMaybe<StringNullableFilter>;
  plan?: InputMaybe<TrainingPlanNullableRelationFilter>;
  sets?: InputMaybe<WorkoutSetListRelationFilter>;
  trainedAt?: InputMaybe<DateTimeFilter>;
  trainingPlanId?: InputMaybe<UuidNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type WorkoutSet = {
  __typename: 'WorkoutSet';
  actualReps: Scalars['Int']['output'];
  actualWeight: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  exercise: Exercise;
  exerciseId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  planSet?: Maybe<TrainingPlanSet>;
  session: WorkoutSession;
  setNumber: Scalars['Int']['output'];
  /**
   * Optional reference to the planned set for "Target vs. Actual" (Soll vs. Ist) comparison.
   * If null, this set was either a free workout or an extra set added by the user during a plan workout.
   */
  trainingPlanSetId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workoutSessionId: Scalars['String']['output'];
};

export type WorkoutSetAvgAggregate = {
  __typename: 'WorkoutSetAvgAggregate';
  actualReps?: Maybe<Scalars['Float']['output']>;
  actualWeight?: Maybe<Scalars['Decimal']['output']>;
  setNumber?: Maybe<Scalars['Float']['output']>;
};

export type WorkoutSetCountAggregate = {
  __typename: 'WorkoutSetCountAggregate';
  _all: Scalars['Int']['output'];
  actualReps: Scalars['Int']['output'];
  actualWeight: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  exerciseId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  setNumber: Scalars['Int']['output'];
  trainingPlanSetId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  workoutSessionId: Scalars['Int']['output'];
};

export type WorkoutSetCreateInput = {
  actualReps: Scalars['Int']['input'];
  actualWeight: Scalars['Decimal']['input'];
  exercise: ExerciseCreateNestedOneWithoutWorkoutSetsInput;
  id?: InputMaybe<Scalars['UUID']['input']>;
  planSet?: InputMaybe<TrainingPlanSetCreateNestedOneWithoutWorkoutSetsInput>;
  session: WorkoutSessionCreateNestedOneWithoutSetsInput;
  setNumber: Scalars['Int']['input'];
};

export type WorkoutSetListRelationFilter = {
  every?: InputMaybe<WorkoutSetWhereInput>;
  none?: InputMaybe<WorkoutSetWhereInput>;
  some?: InputMaybe<WorkoutSetWhereInput>;
};

export type WorkoutSetMaxAggregate = {
  __typename: 'WorkoutSetMaxAggregate';
  actualReps?: Maybe<Scalars['Int']['output']>;
  actualWeight?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  exerciseId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  setNumber?: Maybe<Scalars['Int']['output']>;
  trainingPlanSetId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workoutSessionId?: Maybe<Scalars['String']['output']>;
};

export type WorkoutSetMinAggregate = {
  __typename: 'WorkoutSetMinAggregate';
  actualReps?: Maybe<Scalars['Int']['output']>;
  actualWeight?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  exerciseId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  setNumber?: Maybe<Scalars['Int']['output']>;
  trainingPlanSetId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workoutSessionId?: Maybe<Scalars['String']['output']>;
};

export type WorkoutSetOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type WorkoutSetScalarWhereInput = {
  AND?: InputMaybe<Array<WorkoutSetScalarWhereInput>>;
  NOT?: InputMaybe<Array<WorkoutSetScalarWhereInput>>;
  OR?: InputMaybe<Array<WorkoutSetScalarWhereInput>>;
  actualReps?: InputMaybe<IntFilter>;
  actualWeight?: InputMaybe<DecimalFilter>;
  exerciseId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  setNumber?: InputMaybe<IntFilter>;
  trainingPlanSetId?: InputMaybe<UuidNullableFilter>;
  workoutSessionId?: InputMaybe<UuidFilter>;
};

export type WorkoutSetSumAggregate = {
  __typename: 'WorkoutSetSumAggregate';
  actualReps?: Maybe<Scalars['Int']['output']>;
  actualWeight?: Maybe<Scalars['Decimal']['output']>;
  setNumber?: Maybe<Scalars['Int']['output']>;
};

export type WorkoutSetUpdateInput = {
  actualReps?: InputMaybe<Scalars['Int']['input']>;
  actualWeight?: InputMaybe<Scalars['Decimal']['input']>;
  exercise?: InputMaybe<ExerciseUpdateOneRequiredWithoutWorkoutSetsNestedInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  planSet?: InputMaybe<TrainingPlanSetUpdateOneWithoutWorkoutSetsNestedInput>;
  session?: InputMaybe<WorkoutSessionUpdateOneRequiredWithoutSetsNestedInput>;
  setNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkoutSetUpdateManyMutationInput = {
  actualReps?: InputMaybe<Scalars['Int']['input']>;
  actualWeight?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  setNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkoutSetUpdateManyWithWhereWithoutSessionInput = {
  data: WorkoutSetUpdateManyMutationInput;
  where: WorkoutSetScalarWhereInput;
};

export type WorkoutSetUpdateManyWithoutSessionNestedInput = {
  connect?: InputMaybe<Array<WorkoutSetWhereUniqueInput>>;
  delete?: InputMaybe<Array<WorkoutSetWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkoutSetScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkoutSetWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkoutSetWhereUniqueInput>>;
  updateMany?: InputMaybe<Array<WorkoutSetUpdateManyWithWhereWithoutSessionInput>>;
};

export type WorkoutSetWhereInput = {
  AND?: InputMaybe<Array<WorkoutSetWhereInput>>;
  NOT?: InputMaybe<Array<WorkoutSetWhereInput>>;
  OR?: InputMaybe<Array<WorkoutSetWhereInput>>;
  actualReps?: InputMaybe<IntFilter>;
  actualWeight?: InputMaybe<DecimalFilter>;
  exercise?: InputMaybe<ExerciseRelationFilter>;
  exerciseId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  planSet?: InputMaybe<TrainingPlanSetNullableRelationFilter>;
  session?: InputMaybe<WorkoutSessionRelationFilter>;
  setNumber?: InputMaybe<IntFilter>;
  trainingPlanSetId?: InputMaybe<UuidNullableFilter>;
  workoutSessionId?: InputMaybe<UuidFilter>;
};

export type WorkoutSetWhereUniqueInput = {
  AND?: InputMaybe<Array<WorkoutSetWhereInput>>;
  NOT?: InputMaybe<Array<WorkoutSetWhereInput>>;
  OR?: InputMaybe<Array<WorkoutSetWhereInput>>;
  actualReps?: InputMaybe<IntFilter>;
  actualWeight?: InputMaybe<DecimalFilter>;
  exercise?: InputMaybe<ExerciseRelationFilter>;
  exerciseId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  planSet?: InputMaybe<TrainingPlanSetNullableRelationFilter>;
  session?: InputMaybe<WorkoutSessionRelationFilter>;
  setNumber?: InputMaybe<IntFilter>;
  trainingPlanSetId?: InputMaybe<UuidNullableFilter>;
  workoutSessionId?: InputMaybe<UuidFilter>;
  workoutSessionId_exerciseId_setNumber?: InputMaybe<WorkoutSetWorkoutSessionIdExerciseIdSetNumberCompoundUniqueInput>;
};

export type WorkoutSetWorkoutSessionIdExerciseIdSetNumberCompoundUniqueInput = {
  exerciseId: Scalars['String']['input'];
  setNumber: Scalars['Int']['input'];
  workoutSessionId: Scalars['String']['input'];
};

export type BalanceFieldsFragment = { __typename: 'Balance', updatedAt: Date | string, createdAt: Date | string, count: number };

export type BranchOfficeCountFieldsFragment = { __typename: 'BranchOffice', id: string };

export type BranchOfficeImagesFieldsFragment = { __typename: 'BranchOffice', images?: Array<{ __typename: 'BranchOfficeImage', imageUrl: string, createdAt: Date | string }> | null };

export type BranchOfficeRatingFieldsFragment = { __typename: 'BranchOfficeRating', id: string, rating: number, comment?: string | null, createdAt: Date | string, updatedAt: Date | string, customer: { __typename: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email: string, deletedAt?: Date | string | null } };

export type BranchOfficeTopRatingFieldsFragment = { __typename: 'BranchOfficeTopRating', id: string, name: string, overallTotalRating: number };

export type BranchOfficeFieldsFragment = { __typename: 'BranchOffice', id: string, name: string, companyId: string, description?: string | null, latitude: number, longitude: number, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string, updatedAt: Date | string, createdAt: Date | string, countRatings: number, averageRating: number, crmConfig?: { __typename: 'BranchOfficeCrmConfig', crmStudioId: string } | null };

export type CalculationRuleFieldsFragment = { __typename: 'CalculationRule', id: string, points: number, value: number };

export type ChallengePeriodWithoutChallengeFieldsFragment = { __typename: 'ChallengePeriod', id: string, participants: number, activeFrom: Date | string, activeUntil: Date | string };

export type ChallengePeriodFieldsFragment = { __typename: 'ChallengePeriod', id: string, activeFrom: Date | string, activeUntil: Date | string, participants: number, challenge: { __typename: 'Challenge', id: string, name: string, pointsCredit: number, trainingGoal: number, maxParticipants?: number | null, branchOffice?: { __typename: 'BranchOffice', name: string } | null } };

export type ChallengeFieldsFragment = { __typename: 'Challenge', id: string, name: string, description?: string | null, maxParticipants?: number | null, imageUrl?: string | null, active: boolean, pointsCredit: number, trainingGoal: number, createdAt: Date | string, updatedAt: Date | string, stoppedAt?: Date | string | null, deletedAt?: Date | string | null, periods?: Array<{ __typename: 'ChallengePeriod', id: string, participants: number, activeFrom: Date | string, activeUntil: Date | string }> | null, company: { __typename: 'Company', logoUrl?: string | null }, branchOffice?: { __typename: 'BranchOffice', id: string, name: string } | null };

export type CompanyAddressFieldsFragment = { __typename: 'Company', street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string };

export type CompanyContextFieldsFragment = { __typename: 'Company', id: string, integrationType: IntegrationType, studioApp: boolean };

export type CompanyInformationFieldsFragment = { __typename: 'Company', visible: boolean, name: string, email: string, description?: string | null, id: string, logoUrl?: string | null, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string };

export type CompanyReferralConfigFieldsFragment = { __typename: 'CompanyReferralConfig', id: string, text?: string | null, link: string, pointsCredit: number, active: boolean, createdAt: Date | string, updatedAt: Date | string };

export type CompanyFieldsFragment = { __typename: 'Company', id: string, logoUrl?: string | null, visible: boolean };

export type ContactFieldsFragment = { __typename: 'Contact', id: string, requestId?: string | null };

export type CouponPeriodFieldsFragment = { __typename: 'CouponPeriod', id: string, activeFrom: Date | string, activeUntil: Date | string, createdAt: Date | string, updatedAt: Date | string, redemptionCount: number, coupon: { __typename: 'Coupon', id: string, name: string, description?: string | null, type: CouponType, active: boolean, maxRedemptions?: number | null, createdAt: Date | string, updatedAt: Date | string, pointsCredit?: number | null, branchOffices?: Array<{ __typename: 'BranchOffice', id: string, name: string, companyId: string, description?: string | null, latitude: number, longitude: number, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string, updatedAt: Date | string, createdAt: Date | string, countRatings: number, averageRating: number, crmConfig?: { __typename: 'BranchOfficeCrmConfig', crmStudioId: string } | null }> | null, _count: { __typename: 'CouponCount', redemptions: number, periods: number } } };

export type CouponFieldsFragment = { __typename: 'Coupon', id: string, name: string, description?: string | null, type: CouponType, active: boolean, maxRedemptions?: number | null, createdAt: Date | string, updatedAt: Date | string, pointsCredit?: number | null, branchOffices?: Array<{ __typename: 'BranchOffice', id: string, name: string, companyId: string, description?: string | null, latitude: number, longitude: number, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string, updatedAt: Date | string, createdAt: Date | string, countRatings: number, averageRating: number, crmConfig?: { __typename: 'BranchOfficeCrmConfig', crmStudioId: string } | null }> | null, _count: { __typename: 'CouponCount', redemptions: number, periods: number } };

export type CreateDefectReportFieldsFragment = { __typename: 'DefectReport', id: string, category: DefectCategory, message?: string | null, createdAt: Date | string, fixedAt?: Date | string | null };

export type CustomerDetailsFieldsFragment = { __typename: 'Customer', firstName?: string | null, lastName?: string | null, email: string, street?: string | null, houseNumber?: string | null, city?: string | null, postalCode?: string | null, birthDate?: Date | string | null, pushToken?: string | null, createdAt: Date | string, deletedAt?: Date | string | null };

export type CustomerTopRankingFieldsFragment = { __typename: 'CustomerTopRanking', firstName?: string | null, lastName?: string | null, email: string, redeemedPointsTotal: number, receivedPointsTotal: number };

export type CustomerFieldsFragment = { __typename: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email: string, deletedAt?: Date | string | null };

export type ActiveDefectReportGroupFieldsFragment = { __typename: 'ActiveDefectReportGroup', reportCount: number, latestReportCategory: DefectCategory, latestReportAt: Date | string, equipment: { __typename: 'ActiveDefectReportGroupEquipment', id: string, name: string, branchOffice: { __typename: 'ActiveDefectReportGroupBranchOffice', name: string } } };

export type DefectReportFieldsFragment = { __typename: 'DefectReport', id: string, category: DefectCategory, message?: string | null, createdAt: Date | string, fixedAt?: Date | string | null, equipment: { __typename: 'Equipment', id: string, name: string, manufacturer: string, updatedAt: Date | string, status: EquipmentStatus, branchOffice: { __typename: 'BranchOffice', name: string } }, reporter?: { __typename: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email: string } | null };

export type EmployeeFieldsFragment = { __typename: 'Employee', id?: string | null, firstName?: string | null, lastName?: string | null, email: string, userType: CompanyUserType, status: EmployeeStatus, updatedAt: Date | string, createdAt: Date | string };

export type EquipmentFieldsFragment = { __typename: 'Equipment', id: string, manufacturer: string, name: string, type: EquipmentType, serialNumber: string, status: EquipmentStatus, lastDefectAt?: Date | string | null, deletedAt?: Date | string | null, createdAt: Date | string, updatedAt: Date | string, imageUrl?: string | null, branchOffice: { __typename: 'BranchOffice', id: string, name: string, companyId: string } };

export type NewsFieldsFragment = { __typename: 'News', id: string, title: string, text: string, imageUrl?: string | null, createdAt: Date | string, updatedAt: Date | string, branchOffices?: Array<{ __typename: 'BranchOffice', id: string, name: string, companyId: string }> | null };

export type PaginatedBranchOfficeRatingFieldsFragment = { __typename: 'PaginatedBranchOfficeRating', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'BranchOfficeRating', id: string, rating: number, comment?: string | null, createdAt: Date | string, updatedAt: Date | string, customer: { __typename: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email: string, deletedAt?: Date | string | null } }>, edges?: Array<{ __typename: 'BranchOfficeRatingEdge', cursor: { __typename: 'PaginatedBranchOfficeRatingCursor', id?: string | null } }> | null };

export type PaginatedCustomerFieldsFragment = { __typename: 'PaginatedCustomer', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email: string, deletedAt?: Date | string | null }>, edges?: Array<{ __typename: 'CustomerEdge', cursor: { __typename: 'PaginatedCustomerCursor', id?: string | null } }> | null };

export type PaginatedEquipmentFieldsFragment = { __typename: 'PaginatedEquipment', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'Equipment', id: string, manufacturer: string, name: string, type: EquipmentType, serialNumber: string, status: EquipmentStatus, lastDefectAt?: Date | string | null, deletedAt?: Date | string | null, createdAt: Date | string, updatedAt: Date | string, imageUrl?: string | null, branchOffice: { __typename: 'BranchOffice', id: string, name: string, companyId: string } }>, edges?: Array<{ __typename: 'EquipmentEdge', cursor: { __typename: 'PaginatedEquipmentCursor', id?: string | null } }> | null };

export type PointSystemCheckFieldsFragment = { __typename: 'PointSystem', pointSystemType: { __typename: 'PointSystemType', type: SystemType } };

export type PointSystemFieldsFragment = { __typename: 'PointSystem', id: string, calculationRuleEntries: number, scanLimit: number, company: { __typename: 'Company', calculationRules?: Array<{ __typename: 'CalculationRule', id: string, points: number, value: number }> | null }, pointSystemType: { __typename: 'PointSystemType', id: string, type: SystemType } };

export type PointSystemTypeFieldsFragment = { __typename: 'PointSystemType', id: string, type: SystemType };

export type PopupPeriodFieldsFragment = { __typename: 'PopupPeriod', id: string, activeFrom: Date | string, activeUntil: Date | string, clicks: number, views: number, closes: number, popup: { __typename: 'Popup', id: string, name?: string | null, description?: string | null, active: boolean } };

export type PopupFieldsFragment = { __typename: 'Popup', id: string, name?: string | null, description?: string | null, imageUrl?: string | null, active: boolean, deletedAt?: Date | string | null, periods?: Array<{ __typename: 'PopupPeriod', id: string, activeFrom: Date | string, activeUntil: Date | string, clicks: number, views: number, closes: number, popup: { __typename: 'Popup', id: string, name?: string | null, description?: string | null, active: boolean } }> | null };

export type PromotionPeriodFieldsFragment = { __typename: 'PromotionPeriod', id: string, updatedAt: Date | string, createdAt: Date | string, activeFrom: Date | string, activeUntil: Date | string, promotion: { __typename: 'Promotion', id: string, title: string, description?: string | null, promotionCode?: string | null, createdAt: Date | string, updatedAt: Date | string } };

export type PromotionFieldsFragment = { __typename: 'Promotion', id: string, title: string, description?: string | null, promotionCode?: string | null, createdAt: Date | string, updatedAt: Date | string };

export type PushNotificationHistoryFieldsFragment = { __typename: 'PushNotificationHistory', id: string, affectedCustomers: number, sendAt: Date | string, pushNotification: { __typename: 'PushNotification', title: string, message: string, type: PushNotificationSendType } };

export type PushNotificationFieldsFragment = { __typename: 'PushNotification', id: string, title: string, message: string, type: PushNotificationSendType, status: PushNotificationStatus, cronExpression?: string | null, cronStartDate?: Date | string | null, cronInterval?: CronInterval | null, sendAt?: Date | string | null, createdAt: Date | string };

export type RatingQuestionFieldsFragment = { __typename: 'RatingQuestion', id: string, question: string, isActive: boolean, averageRating: number, createdAt: Date | string, updatedAt: Date | string };

export type ReceivedPointFieldsFragment = { __typename: 'ReceivedPoint', id: string, count?: number | null, createdAt: Date | string, updatedAt: Date | string, sourceType: ReceivedPointSourceType };

export type RedeemedPointFieldsFragment = { __typename: 'RedeemedPoint', id: string, createdAt: Date | string, updatedAt: Date | string, reward: { __typename: 'Reward', id: string, name: string, description?: string | null, requiredPoints: number, saving: number, imageKey?: string | null, transmissionMethod: TransmissionMethod, updatedAt: Date | string, createdAt: Date | string } };

export type RewardFieldsFragment = { __typename: 'Reward', id: string, name: string, description?: string | null, requiredPoints: number, saving: number, imageKey?: string | null, transmissionMethod: TransmissionMethod, updatedAt: Date | string, createdAt: Date | string };

export type RewardsChartFieldsFragment = { __typename: 'Reward', id: string, name: string, description?: string | null, requiredPoints: number, saving: number, imageKey?: string | null, transmissionMethod: TransmissionMethod, updatedAt: Date | string, createdAt: Date | string, _count: { __typename: 'RewardCount', redeemedPoints: number } };

export type StatusHistoryFieldsFragment = { __typename: 'StatusHistory', id: string, createdAt: Date | string, oldStatus: EquipmentStatus, newStatus: EquipmentStatus, comment: string, equipment: { __typename: 'Equipment', id: string }, changedBy?: { __typename: 'Employee', id?: string | null, firstName?: string | null, lastName?: string | null } | null };

export type TrendMetricFieldsFragment = { __typename: 'TrendMetric', periodCount: number, previousPeriodCount: number, trend: number, dateGroupedCount: Array<{ __typename: 'DateGroupedCount', date: Date | string, count: number }> };

export type CreateBranchOfficeImageMutationVariables = Exact<{
  data: BranchOfficeImageCreateInput;
}>;


export type CreateBranchOfficeImageMutation = { __typename: 'Mutation', createBranchOfficeImage: { __typename: 'BranchOfficeImage', id: string, imageUrl: string } };

export type CreateBranchOfficeMutationVariables = Exact<{
  data: BranchOfficeCreateInput;
}>;


export type CreateBranchOfficeMutation = { __typename: 'Mutation', createBranchOffice: { __typename: 'BranchOffice', id: string, name: string, companyId: string, description?: string | null, latitude: number, longitude: number, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string, updatedAt: Date | string, createdAt: Date | string, countRatings: number, averageRating: number, crmConfig?: { __typename: 'BranchOfficeCrmConfig', crmStudioId: string } | null } };

export type DeleteBranchOfficeMutationVariables = Exact<{
  where: BranchOfficeUniqueInput;
}>;


export type DeleteBranchOfficeMutation = { __typename: 'Mutation', deleteBranchOffice: { __typename: 'BranchOffice', id: string } };

export type UpdateBranchOfficeMutationVariables = Exact<{
  data: BranchOfficeUpdateInput;
  where: BranchOfficeWhereUniqueInput;
}>;


export type UpdateBranchOfficeMutation = { __typename: 'Mutation', updateBranchOffice: { __typename: 'BranchOffice', id: string, name: string, companyId: string, description?: string | null, latitude: number, longitude: number, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string, updatedAt: Date | string, createdAt: Date | string, countRatings: number, averageRating: number, crmConfig?: { __typename: 'BranchOfficeCrmConfig', crmStudioId: string } | null } };

export type CreateOrChangeCalculationRuleMutationVariables = Exact<{
  data: CreateOrChangeCalculationRuleInput;
}>;


export type CreateOrChangeCalculationRuleMutation = { __typename: 'Mutation', createOrChangeCalculationRule: Array<{ __typename: 'CalculationRule', id: string, points: number, value: number }> };

export type CreateChallengePeriodMutationVariables = Exact<{
  data: ChallengePeriodCreateInput;
}>;


export type CreateChallengePeriodMutation = { __typename: 'Mutation', createChallengePeriod: { __typename: 'ChallengePeriod', id: string, activeFrom: Date | string, activeUntil: Date | string, participants: number, challenge: { __typename: 'Challenge', id: string, name: string, pointsCredit: number, trainingGoal: number, maxParticipants?: number | null, branchOffice?: { __typename: 'BranchOffice', name: string } | null } } };

export type DeleteChallengePeriodMutationVariables = Exact<{
  where: ChallengePeriodWhereUniqueInput;
}>;


export type DeleteChallengePeriodMutation = { __typename: 'Mutation', deleteChallengePeriod: { __typename: 'ChallengePeriod', id: string } };

export type UpdateChallengePeriodMutationVariables = Exact<{
  where: ChallengePeriodWhereUniqueInput;
  data: ChallengePeriodUpdateInput;
}>;


export type UpdateChallengePeriodMutation = { __typename: 'Mutation', updateChallengePeriod: { __typename: 'ChallengePeriod', id: string, activeFrom: Date | string, activeUntil: Date | string, participants: number, challenge: { __typename: 'Challenge', id: string, name: string, pointsCredit: number, trainingGoal: number, maxParticipants?: number | null, branchOffice?: { __typename: 'BranchOffice', name: string } | null } } };

export type ActivatePassivePointsChallengeMutationVariables = Exact<{
  activateArgs: PassivePointsChallengeActivateInput;
}>;


export type ActivatePassivePointsChallengeMutation = { __typename: 'Mutation', activatePassivePointsChallenge: { __typename: 'Challenge', id: string } };

export type CreateChallengeMutationVariables = Exact<{
  data: ChallengeCreateInput;
}>;


export type CreateChallengeMutation = { __typename: 'Mutation', createChallenge: { __typename: 'Challenge', id: string, name: string, description?: string | null, maxParticipants?: number | null, imageUrl?: string | null, active: boolean, pointsCredit: number, trainingGoal: number, createdAt: Date | string, updatedAt: Date | string, stoppedAt?: Date | string | null, deletedAt?: Date | string | null, periods?: Array<{ __typename: 'ChallengePeriod', id: string, participants: number, activeFrom: Date | string, activeUntil: Date | string }> | null, company: { __typename: 'Company', logoUrl?: string | null }, branchOffice?: { __typename: 'BranchOffice', id: string, name: string } | null } };

export type DeleteChallengeMutationVariables = Exact<{
  where: ChallengeWhereUniqueInput;
}>;


export type DeleteChallengeMutation = { __typename: 'Mutation', deleteChallenge: { __typename: 'Challenge', id: string } };

export type StopPassivePointsChallengeMutationVariables = Exact<{
  uniqueInput: ChallengeWhereUniqueInput;
}>;


export type StopPassivePointsChallengeMutation = { __typename: 'Mutation', stopPassivePointsChallenge: { __typename: 'Challenge', id: string } };

export type UpdateChallengeImageMutationVariables = Exact<{
  where: ChallengeWhereUniqueInput;
  data: ChallengeImageInput;
}>;


export type UpdateChallengeImageMutation = { __typename: 'Mutation', updateChallengeImage: { __typename: 'Challenge', id: string } };

export type CreateCompanyReferralConfigMutationVariables = Exact<{
  data: CompanyReferralConfigCreateInput;
}>;


export type CreateCompanyReferralConfigMutation = { __typename: 'Mutation', createCompanyReferralConfig: { __typename: 'CompanyReferralConfig', id: string, text?: string | null, link: string, pointsCredit: number, active: boolean, createdAt: Date | string, updatedAt: Date | string } };

export type UpdateCompanyReferralConfigMutationVariables = Exact<{
  where: CompanyReferralConfigWhereUniqueInput;
  data: CompanyReferralConfigUpdateInput;
}>;


export type UpdateCompanyReferralConfigMutation = { __typename: 'Mutation', updateCompanyReferralConfig: { __typename: 'CompanyReferralConfig', id: string, text?: string | null, link: string, pointsCredit: number, active: boolean, createdAt: Date | string, updatedAt: Date | string } };

export type ChangeVisibilityMutationVariables = Exact<{
  visible: Scalars['Boolean']['input'];
}>;


export type ChangeVisibilityMutation = { __typename: 'Mutation', changeVisibility: { __typename: 'Company', id: string, logoUrl?: string | null, visible: boolean } };

export type UpdateCompanyMutationVariables = Exact<{
  data: UpdateCompanyInput;
  where?: InputMaybe<CompanyUniqueInput>;
}>;


export type UpdateCompanyMutation = { __typename: 'Mutation', updateCompany: { __typename: 'Company', visible: boolean, name: string, email: string, description?: string | null, id: string, logoUrl?: string | null, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string } };

export type ContactSupportMutationVariables = Exact<{
  data: ContactSupportInput;
}>;


export type ContactSupportMutation = { __typename: 'Mutation', contactSupport: { __typename: 'Contact', id: string, requestId?: string | null } };

export type CreateCouponPeriodMutationVariables = Exact<{
  data: CouponPeriodCreateInput;
}>;


export type CreateCouponPeriodMutation = { __typename: 'Mutation', createCouponPeriod: { __typename: 'CouponPeriod', id: string, activeFrom: Date | string, activeUntil: Date | string, createdAt: Date | string, updatedAt: Date | string, redemptionCount: number, coupon: { __typename: 'Coupon', id: string, name: string, description?: string | null, type: CouponType, active: boolean, maxRedemptions?: number | null, createdAt: Date | string, updatedAt: Date | string, pointsCredit?: number | null, branchOffices?: Array<{ __typename: 'BranchOffice', id: string, name: string, companyId: string, description?: string | null, latitude: number, longitude: number, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string, updatedAt: Date | string, createdAt: Date | string, countRatings: number, averageRating: number, crmConfig?: { __typename: 'BranchOfficeCrmConfig', crmStudioId: string } | null }> | null, _count: { __typename: 'CouponCount', redemptions: number, periods: number } } } };

export type DeleteCouponPeriodMutationVariables = Exact<{
  where: CouponPeriodWhereUniqueInput;
}>;


export type DeleteCouponPeriodMutation = { __typename: 'Mutation', deleteCouponPeriod: { __typename: 'CouponPeriod', id: string } };

export type UpdateCouponPeriodMutationVariables = Exact<{
  where: CouponPeriodWhereUniqueInput;
  data: CouponPeriodUpdateInput;
}>;


export type UpdateCouponPeriodMutation = { __typename: 'Mutation', updateCouponPeriod: { __typename: 'CouponPeriod', id: string, activeFrom: Date | string, activeUntil: Date | string, createdAt: Date | string, updatedAt: Date | string, redemptionCount: number, coupon: { __typename: 'Coupon', id: string, name: string, description?: string | null, type: CouponType, active: boolean, maxRedemptions?: number | null, createdAt: Date | string, updatedAt: Date | string, pointsCredit?: number | null, branchOffices?: Array<{ __typename: 'BranchOffice', id: string, name: string, companyId: string, description?: string | null, latitude: number, longitude: number, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string, updatedAt: Date | string, createdAt: Date | string, countRatings: number, averageRating: number, crmConfig?: { __typename: 'BranchOfficeCrmConfig', crmStudioId: string } | null }> | null, _count: { __typename: 'CouponCount', redemptions: number, periods: number } } } };

export type CreateCouponMutationVariables = Exact<{
  data: CouponCreateInput;
}>;


export type CreateCouponMutation = { __typename: 'Mutation', createCoupon: { __typename: 'Coupon', id: string, name: string, description?: string | null, type: CouponType, active: boolean, maxRedemptions?: number | null, createdAt: Date | string, updatedAt: Date | string, pointsCredit?: number | null, branchOffices?: Array<{ __typename: 'BranchOffice', id: string, name: string, companyId: string, description?: string | null, latitude: number, longitude: number, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string, updatedAt: Date | string, createdAt: Date | string, countRatings: number, averageRating: number, crmConfig?: { __typename: 'BranchOfficeCrmConfig', crmStudioId: string } | null }> | null, _count: { __typename: 'CouponCount', redemptions: number, periods: number } } };

export type CreateWelcomeCouponMutationVariables = Exact<{
  data: WelcomeCouponCreateInput;
}>;


export type CreateWelcomeCouponMutation = { __typename: 'Mutation', createWelcomeCoupon: { __typename: 'Coupon', id: string, name: string, description?: string | null, type: CouponType, active: boolean, maxRedemptions?: number | null, createdAt: Date | string, updatedAt: Date | string, pointsCredit?: number | null, branchOffices?: Array<{ __typename: 'BranchOffice', id: string, name: string, companyId: string, description?: string | null, latitude: number, longitude: number, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string, updatedAt: Date | string, createdAt: Date | string, countRatings: number, averageRating: number, crmConfig?: { __typename: 'BranchOfficeCrmConfig', crmStudioId: string } | null }> | null, _count: { __typename: 'CouponCount', redemptions: number, periods: number } } };

export type DeleteCouponMutationVariables = Exact<{
  where: CouponWhereUniqueInput;
}>;


export type DeleteCouponMutation = { __typename: 'Mutation', deleteCoupon: { __typename: 'Coupon', id: string } };

export type SwitchCouponStatusMutationVariables = Exact<{
  where: CouponUniqueInput;
  data: SwitchCouponStatusInput;
}>;


export type SwitchCouponStatusMutation = { __typename: 'Mutation', switchCouponStatus: { __typename: 'Coupon', id: string, name: string, description?: string | null, type: CouponType, active: boolean, maxRedemptions?: number | null, createdAt: Date | string, updatedAt: Date | string, pointsCredit?: number | null, branchOffices?: Array<{ __typename: 'BranchOffice', id: string, name: string, companyId: string, description?: string | null, latitude: number, longitude: number, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string, updatedAt: Date | string, createdAt: Date | string, countRatings: number, averageRating: number, crmConfig?: { __typename: 'BranchOfficeCrmConfig', crmStudioId: string } | null }> | null, _count: { __typename: 'CouponCount', redemptions: number, periods: number } } };

export type CreateDefectReportMutationVariables = Exact<{
  data: DefectReportCreateInput;
}>;


export type CreateDefectReportMutation = { __typename: 'Mutation', createDefectReport: { __typename: 'DefectReport', id: string, category: DefectCategory, message?: string | null, createdAt: Date | string, fixedAt?: Date | string | null } };

export type MarkDefectReportFixedMutationVariables = Exact<{
  where: DefectReportWhereUniqueInput;
}>;


export type MarkDefectReportFixedMutation = { __typename: 'Mutation', markDefectReportFixed: { __typename: 'DefectReport', id: string, fixedAt?: Date | string | null } };

export type DeleteEmployeeMutationVariables = Exact<{
  where: EmployeeIdentifierInput;
}>;


export type DeleteEmployeeMutation = { __typename: 'Mutation', deleteEmployee: { __typename: 'Employee', id?: string | null } };

export type InviteEmployeeMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type InviteEmployeeMutation = { __typename: 'Mutation', inviteEmployee: { __typename: 'Employee', id?: string | null, firstName?: string | null, lastName?: string | null, email: string, userType: CompanyUserType, status: EmployeeStatus, updatedAt: Date | string, createdAt: Date | string } };

export type SendPasswordChangeEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type SendPasswordChangeEmailMutation = { __typename: 'Mutation', sendPasswordChangeEmail: { __typename: 'Employee', id?: string | null, firstName?: string | null, lastName?: string | null, email: string, userType: CompanyUserType, status: EmployeeStatus, updatedAt: Date | string, createdAt: Date | string } };

export type UpdateEmployeeMutationVariables = Exact<{
  data: UpdateEmployeeInput;
  where?: InputMaybe<EmployeeUniqueInput>;
}>;


export type UpdateEmployeeMutation = { __typename: 'Mutation', updateEmployee: { __typename: 'Employee', id?: string | null, firstName?: string | null, lastName?: string | null, email: string, userType: CompanyUserType, status: EmployeeStatus, updatedAt: Date | string, createdAt: Date | string } };

export type ChangeEquipmentStatusMutationVariables = Exact<{
  data: EquipmentStatusChangeInput;
  where: EquipmentWhereUniqueInput;
}>;


export type ChangeEquipmentStatusMutation = { __typename: 'Mutation', changeEquipmentStatus: { __typename: 'StatusHistory', id: string, oldStatus: EquipmentStatus, newStatus: EquipmentStatus, comment: string, createdAt: Date | string } };

export type CreateEquipmentMutationVariables = Exact<{
  data: EquipmentCreateInput;
}>;


export type CreateEquipmentMutation = { __typename: 'Mutation', createEquipment: { __typename: 'Equipment', id: string, manufacturer: string, name: string, type: EquipmentType, serialNumber: string, status: EquipmentStatus, lastDefectAt?: Date | string | null, deletedAt?: Date | string | null, createdAt: Date | string, updatedAt: Date | string, imageUrl?: string | null, branchOffice: { __typename: 'BranchOffice', id: string, name: string, companyId: string } } };

export type RemoveEquipmentImageMutationVariables = Exact<{
  where: EquipmentWhereUniqueInput;
}>;


export type RemoveEquipmentImageMutation = { __typename: 'Mutation', removeEquipmentImage: { __typename: 'Equipment', id: string } };

export type SoftDeleteEquipmentMutationVariables = Exact<{
  where: EquipmentWhereUniqueInput;
}>;


export type SoftDeleteEquipmentMutation = { __typename: 'Mutation', softDeleteEquipment: { __typename: 'Equipment', id: string, deletedAt?: Date | string | null } };

export type UpdateEquipmentImageMutationVariables = Exact<{
  where: EquipmentWhereUniqueInput;
  data: EquipmentImageInput;
}>;


export type UpdateEquipmentImageMutation = { __typename: 'Mutation', updateEquipmentImage: { __typename: 'Equipment', id: string } };

export type UpdateEquipmentMutationVariables = Exact<{
  data: EquipmentUpdateInput;
  where: EquipmentWhereUniqueInput;
}>;


export type UpdateEquipmentMutation = { __typename: 'Mutation', updateEquipment: { __typename: 'Equipment', id: string, manufacturer: string, name: string, type: EquipmentType, serialNumber: string, status: EquipmentStatus, lastDefectAt?: Date | string | null, deletedAt?: Date | string | null, createdAt: Date | string, updatedAt: Date | string, imageUrl?: string | null, branchOffice: { __typename: 'BranchOffice', id: string, name: string, companyId: string } } };

export type CreateNewsMutationVariables = Exact<{
  data: NewsCreateInput;
}>;


export type CreateNewsMutation = { __typename: 'Mutation', createNews: { __typename: 'News', id: string, title: string, text: string, imageUrl?: string | null, createdAt: Date | string, updatedAt: Date | string, branchOffices?: Array<{ __typename: 'BranchOffice', id: string, name: string, companyId: string }> | null } };

export type DeleteNewsMutationVariables = Exact<{
  where: NewsWhereUniqueInput;
}>;


export type DeleteNewsMutation = { __typename: 'Mutation', deleteNews: { __typename: 'News', id: string } };

export type ChangePointSystemMutationVariables = Exact<{
  input: ChangePointSystemInput;
}>;


export type ChangePointSystemMutation = { __typename: 'Mutation', changePointSystem: { __typename: 'PointSystem', id: string, calculationRuleEntries: number, scanLimit: number, company: { __typename: 'Company', calculationRules?: Array<{ __typename: 'CalculationRule', id: string, points: number, value: number }> | null }, pointSystemType: { __typename: 'PointSystemType', id: string, type: SystemType } } };

export type CreatePointSystemMutationVariables = Exact<{
  createInput: PointSystemCreateInput;
}>;


export type CreatePointSystemMutation = { __typename: 'Mutation', createPointSystem: { __typename: 'PointSystem', id: string, calculationRuleEntries: number, scanLimit: number, company: { __typename: 'Company', calculationRules?: Array<{ __typename: 'CalculationRule', id: string, points: number, value: number }> | null }, pointSystemType: { __typename: 'PointSystemType', id: string, type: SystemType } } };

export type CreatePopupPeriodMutationVariables = Exact<{
  data: PopupPeriodCreateNextInput;
}>;


export type CreatePopupPeriodMutation = { __typename: 'Mutation', createPopupPeriod: { __typename: 'PopupPeriod', id: string } };

export type DeletePopupPeriodMutationVariables = Exact<{
  where: PopupPeriodWhereUniqueInput;
}>;


export type DeletePopupPeriodMutation = { __typename: 'Mutation', deletePopupPeriod: { __typename: 'PopupPeriod', id: string } };

export type UpdatePopupPeriodMutationVariables = Exact<{
  where: PopupPeriodWhereUniqueInput;
  data: PopupPeriodUpdateInput;
}>;


export type UpdatePopupPeriodMutation = { __typename: 'Mutation', updatePopupPeriod: { __typename: 'PopupPeriod', id: string } };

export type CreatePopupMutationVariables = Exact<{
  data: PopupCreateInput;
}>;


export type CreatePopupMutation = { __typename: 'Mutation', createPopup: { __typename: 'Popup', id: string, name?: string | null, description?: string | null, imageUrl?: string | null, active: boolean, deletedAt?: Date | string | null, periods?: Array<{ __typename: 'PopupPeriod', id: string, activeFrom: Date | string, activeUntil: Date | string, clicks: number, views: number, closes: number, popup: { __typename: 'Popup', id: string, name?: string | null, description?: string | null, active: boolean } }> | null } };

export type DeletePopupMutationVariables = Exact<{
  where: PopupWhereUniqueInput;
}>;


export type DeletePopupMutation = { __typename: 'Mutation', deletePopup: { __typename: 'Popup', id: string } };

export type CreatePromotionPeriodMutationVariables = Exact<{
  data: PromotionPeriodCreateInput;
}>;


export type CreatePromotionPeriodMutation = { __typename: 'Mutation', createPromotionPeriod: { __typename: 'PromotionPeriod', id: string, updatedAt: Date | string, createdAt: Date | string, activeFrom: Date | string, activeUntil: Date | string, promotion: { __typename: 'Promotion', id: string, title: string, description?: string | null, promotionCode?: string | null, createdAt: Date | string, updatedAt: Date | string } } };

export type DeletePromotionPeriodMutationVariables = Exact<{
  where: PromotionPeriodWhereUniqueInput;
}>;


export type DeletePromotionPeriodMutation = { __typename: 'Mutation', deletePromotionPeriod: { __typename: 'PromotionPeriod', id: string } };

export type UpdatePromotionPeriodMutationVariables = Exact<{
  where: PromotionPeriodUniqueInput;
  data: PromotionPeriodUpdateInput;
}>;


export type UpdatePromotionPeriodMutation = { __typename: 'Mutation', updatePromotionPeriod: { __typename: 'PromotionPeriod', id: string, updatedAt: Date | string, createdAt: Date | string, activeFrom: Date | string, activeUntil: Date | string, promotion: { __typename: 'Promotion', id: string, title: string, description?: string | null, promotionCode?: string | null, createdAt: Date | string, updatedAt: Date | string } } };

export type CreatePromotionMutationVariables = Exact<{
  data: PromotionCreateInput;
}>;


export type CreatePromotionMutation = { __typename: 'Mutation', createPromotion: { __typename: 'Promotion', id: string, title: string, description?: string | null, promotionCode?: string | null, createdAt: Date | string, updatedAt: Date | string } };

export type DeletePromotionMutationVariables = Exact<{
  where: PromotionWhereUniqueInput;
}>;


export type DeletePromotionMutation = { __typename: 'Mutation', deletePromotion: { __typename: 'Promotion', id: string } };

export type CreatePushNotificationMutationVariables = Exact<{
  createInput: PushNotificationCreateInput;
}>;


export type CreatePushNotificationMutation = { __typename: 'Mutation', createPushNotification: { __typename: 'PushNotification', id: string, title: string, message: string, type: PushNotificationSendType, status: PushNotificationStatus, cronExpression?: string | null, cronStartDate?: Date | string | null, cronInterval?: CronInterval | null, sendAt?: Date | string | null, createdAt: Date | string } };

export type DeletePushNotificationMutationVariables = Exact<{
  where: PushNotificationWhereUniqueInput;
}>;


export type DeletePushNotificationMutation = { __typename: 'Mutation', deletePushNotification: { __typename: 'PushNotification', id: string } };

export type DisablePushNotificationMutationVariables = Exact<{
  pushNotificationId: Scalars['String']['input'];
}>;


export type DisablePushNotificationMutation = { __typename: 'Mutation', disablePushNotification: { __typename: 'PushNotification', id: string } };

export type CreateRatingQuestionMutationVariables = Exact<{
  data: RatingQuestionCreateInput;
  branchOfficeId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CreateRatingQuestionMutation = { __typename: 'Mutation', createRatingQuestion: { __typename: 'RatingQuestion', id: string, question: string, isActive: boolean, averageRating: number, createdAt: Date | string, updatedAt: Date | string } };

export type DeleteRatingQuestionMutationVariables = Exact<{
  where: RatingQuestionWhereUniqueInput;
  branchOfficeId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type DeleteRatingQuestionMutation = { __typename: 'Mutation', deleteRatingQuestion: { __typename: 'RatingQuestion', id: string, question: string, isActive: boolean, averageRating: number, createdAt: Date | string, updatedAt: Date | string } };

export type UpdateRatingQuestionActiveStatusMutationVariables = Exact<{
  where: RatingQuestionWhereUniqueInput;
  data: RatingQuestionActiveStatusUpdateInput;
  branchOfficeId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type UpdateRatingQuestionActiveStatusMutation = { __typename: 'Mutation', updateRatingQuestionActiveStatus: { __typename: 'RatingQuestion', id: string, question: string, isActive: boolean, averageRating: number, createdAt: Date | string, updatedAt: Date | string } };

export type CreateManuallyReceivedPointMutationVariables = Exact<{
  customer: CustomerWhereUniqueInput;
  count: Scalars['Float']['input'];
}>;


export type CreateManuallyReceivedPointMutation = { __typename: 'Mutation', createManuallyReceivedPoint: { __typename: 'ReceivedPoint', id: string, count?: number | null, createdAt: Date | string, updatedAt: Date | string, sourceType: ReceivedPointSourceType } };

export type CreateRewardMutationVariables = Exact<{
  data: CreateRewardInput;
}>;


export type CreateRewardMutation = { __typename: 'Mutation', createReward: { __typename: 'Reward', id: string, name: string, description?: string | null, requiredPoints: number, saving: number, imageKey?: string | null, transmissionMethod: TransmissionMethod, updatedAt: Date | string, createdAt: Date | string } };

export type SwitchRewardStatusMutationVariables = Exact<{
  input: SwitchRewardStatusInput;
}>;


export type SwitchRewardStatusMutation = { __typename: 'Mutation', switchRewardStatus: { __typename: 'Reward', id: string } };

export type UpdateRewardMutationVariables = Exact<{
  data: RewardUpdateInput;
  where: RewardWhereUniqueInput;
}>;


export type UpdateRewardMutation = { __typename: 'Mutation', updateReward: { __typename: 'Reward', id: string, name: string, description?: string | null, requiredPoints: number, saving: number, imageKey?: string | null, transmissionMethod: TransmissionMethod, updatedAt: Date | string, createdAt: Date | string } };

export type BranchOfficeRatingsQueryVariables = Exact<{
  where?: InputMaybe<BranchOfficeRatingWhereInput>;
  oderBy?: InputMaybe<Array<BranchOfficeRatingOrderByWithRelationInput> | BranchOfficeRatingOrderByWithRelationInput>;
  cursor?: InputMaybe<BranchOfficeRatingWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<BranchOfficeRatingScalarFieldEnum> | BranchOfficeRatingScalarFieldEnum>;
}>;


export type BranchOfficeRatingsQuery = { __typename: 'Query', branchOfficeRatings: Array<{ __typename: 'BranchOfficeRating', id: string, rating: number, comment?: string | null, createdAt: Date | string, updatedAt: Date | string, customer: { __typename: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email: string, deletedAt?: Date | string | null } }> };

export type PaginatedBranchOfficeRatingsQueryVariables = Exact<{
  where?: InputMaybe<BranchOfficeRatingWhereInput>;
  orderBy?: InputMaybe<Array<BranchOfficeRatingOrderByWithRelationInput> | BranchOfficeRatingOrderByWithRelationInput>;
  cursor?: InputMaybe<BranchOfficeRatingWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<BranchOfficeRatingScalarFieldEnum> | BranchOfficeRatingScalarFieldEnum>;
}>;


export type PaginatedBranchOfficeRatingsQuery = { __typename: 'Query', paginatedBranchOfficeRating: { __typename: 'PaginatedBranchOfficeRating', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'BranchOfficeRating', id: string, rating: number, comment?: string | null, createdAt: Date | string, updatedAt: Date | string, customer: { __typename: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email: string, deletedAt?: Date | string | null } }>, edges?: Array<{ __typename: 'BranchOfficeRatingEdge', cursor: { __typename: 'PaginatedBranchOfficeRatingCursor', id?: string | null } }> | null } };

export type BranchOfficeTopRatingQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type BranchOfficeTopRatingQuery = { __typename: 'Query', branchOfficeTopRating: Array<{ __typename: 'BranchOfficeTopRating', id: string, name: string, overallTotalRating: number }> };

export type BranchOfficesWithImagesQueryVariables = Exact<{
  where?: InputMaybe<BranchOfficeWhereInput>;
  orderBy?: InputMaybe<Array<BranchOfficeOrderByWithRelationInput> | BranchOfficeOrderByWithRelationInput>;
  cursor?: InputMaybe<BranchOfficeWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<BranchOfficeScalarFieldEnum> | BranchOfficeScalarFieldEnum>;
}>;


export type BranchOfficesWithImagesQuery = { __typename: 'Query', branchOffices: Array<{ __typename: 'BranchOffice', id: string, name: string, companyId: string, description?: string | null, latitude: number, longitude: number, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string, updatedAt: Date | string, createdAt: Date | string, countRatings: number, averageRating: number, crmConfig?: { __typename: 'BranchOfficeCrmConfig', crmStudioId: string } | null, images?: Array<{ __typename: 'BranchOfficeImage', imageUrl: string, createdAt: Date | string }> | null }> };

export type BranchOfficesQueryVariables = Exact<{
  where?: InputMaybe<BranchOfficeWhereInput>;
  orderBy?: InputMaybe<Array<BranchOfficeOrderByWithRelationInput> | BranchOfficeOrderByWithRelationInput>;
  cursor?: InputMaybe<BranchOfficeWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<BranchOfficeScalarFieldEnum> | BranchOfficeScalarFieldEnum>;
}>;


export type BranchOfficesQuery = { __typename: 'Query', branchOffices: Array<{ __typename: 'BranchOffice', id: string, name: string, companyId: string, description?: string | null, latitude: number, longitude: number, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string, updatedAt: Date | string, createdAt: Date | string, countRatings: number, averageRating: number, crmConfig?: { __typename: 'BranchOfficeCrmConfig', crmStudioId: string } | null }> };

export type ChallengePeriodsQueryVariables = Exact<{
  where?: InputMaybe<ChallengePeriodWhereInput>;
  orderBy?: InputMaybe<Array<ChallengePeriodOrderByWithRelationInput> | ChallengePeriodOrderByWithRelationInput>;
  cursor?: InputMaybe<ChallengePeriodWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<ChallengePeriodScalarFieldEnum> | ChallengePeriodScalarFieldEnum>;
}>;


export type ChallengePeriodsQuery = { __typename: 'Query', challengePeriods: Array<{ __typename: 'ChallengePeriod', id: string, activeFrom: Date | string, activeUntil: Date | string, participants: number, challenge: { __typename: 'Challenge', id: string, name: string, pointsCredit: number, trainingGoal: number, maxParticipants?: number | null, branchOffice?: { __typename: 'BranchOffice', name: string } | null } }> };

export type ChallengesQueryVariables = Exact<{
  where?: InputMaybe<ChallengeWhereInput>;
  orderBy?: InputMaybe<Array<ChallengeOrderByWithRelationInput> | ChallengeOrderByWithRelationInput>;
  cursor?: InputMaybe<ChallengeWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<ChallengeScalarFieldEnum> | ChallengeScalarFieldEnum>;
}>;


export type ChallengesQuery = { __typename: 'Query', challenges: Array<{ __typename: 'Challenge', id: string, name: string, description?: string | null, maxParticipants?: number | null, imageUrl?: string | null, active: boolean, pointsCredit: number, trainingGoal: number, createdAt: Date | string, updatedAt: Date | string, stoppedAt?: Date | string | null, deletedAt?: Date | string | null, periods?: Array<{ __typename: 'ChallengePeriod', id: string, participants: number, activeFrom: Date | string, activeUntil: Date | string }> | null, company: { __typename: 'Company', logoUrl?: string | null }, branchOffice?: { __typename: 'BranchOffice', id: string, name: string } | null }> };

export type CompanyReferralConfigQueryVariables = Exact<{
  where?: InputMaybe<CompanyReferralConfigWhereUniqueInput>;
}>;


export type CompanyReferralConfigQuery = { __typename: 'Query', companyReferralConfig?: { __typename: 'CompanyReferralConfig', id: string, text?: string | null, link: string, pointsCredit: number, active: boolean, createdAt: Date | string, updatedAt: Date | string } | null };

export type CompanyContextQueryVariables = Exact<{
  where?: InputMaybe<CompanyUniqueInput>;
}>;


export type CompanyContextQuery = { __typename: 'Query', company: { __typename: 'Company', id: string, integrationType: IntegrationType, studioApp: boolean } };

export type CompanyInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyInformationQuery = { __typename: 'Query', company: { __typename: 'Company', visible: boolean, name: string, email: string, description?: string | null, id: string, logoUrl?: string | null, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string } };

export type CompanyQueryVariables = Exact<{
  where?: InputMaybe<CompanyUniqueInput>;
}>;


export type CompanyQuery = { __typename: 'Query', company: { __typename: 'Company', id: string, logoUrl?: string | null, visible: boolean } };

export type CurrentUsageAmountQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUsageAmountQuery = { __typename: 'Query', company: { __typename: 'Company', id: string, _count: { __typename: 'CompanyCount', branchOffices: number, employees: number, rewards: number, calculationRules: number } } };

export type CouponPeriodsQueryVariables = Exact<{
  where?: InputMaybe<CouponPeriodWhereInput>;
  orderBy?: InputMaybe<Array<CouponPeriodOrderByWithRelationInput> | CouponPeriodOrderByWithRelationInput>;
  cursor?: InputMaybe<CouponPeriodWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CouponPeriodScalarFieldEnum> | CouponPeriodScalarFieldEnum>;
}>;


export type CouponPeriodsQuery = { __typename: 'Query', couponPeriods: Array<{ __typename: 'CouponPeriod', id: string, activeFrom: Date | string, activeUntil: Date | string, createdAt: Date | string, updatedAt: Date | string, redemptionCount: number, coupon: { __typename: 'Coupon', id: string, name: string, description?: string | null, type: CouponType, active: boolean, maxRedemptions?: number | null, createdAt: Date | string, updatedAt: Date | string, pointsCredit?: number | null, branchOffices?: Array<{ __typename: 'BranchOffice', id: string, name: string, companyId: string, description?: string | null, latitude: number, longitude: number, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string, updatedAt: Date | string, createdAt: Date | string, countRatings: number, averageRating: number, crmConfig?: { __typename: 'BranchOfficeCrmConfig', crmStudioId: string } | null }> | null, _count: { __typename: 'CouponCount', redemptions: number, periods: number } } }> };

export type CouponsQueryVariables = Exact<{
  where?: InputMaybe<CouponWhereInput>;
  orderBy?: InputMaybe<Array<CouponOrderByWithRelationInput> | CouponOrderByWithRelationInput>;
  cursor?: InputMaybe<CouponWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CouponScalarFieldEnum> | CouponScalarFieldEnum>;
}>;


export type CouponsQuery = { __typename: 'Query', coupons: Array<{ __typename: 'Coupon', id: string, name: string, description?: string | null, type: CouponType, active: boolean, maxRedemptions?: number | null, createdAt: Date | string, updatedAt: Date | string, pointsCredit?: number | null, branchOffices?: Array<{ __typename: 'BranchOffice', id: string, name: string, companyId: string, description?: string | null, latitude: number, longitude: number, street: string, houseNumber: string, city: string, state: string, postalCode: string, countryCode: string, updatedAt: Date | string, createdAt: Date | string, countRatings: number, averageRating: number, crmConfig?: { __typename: 'BranchOfficeCrmConfig', crmStudioId: string } | null }> | null, _count: { __typename: 'CouponCount', redemptions: number, periods: number } }> };

export type CustomerAgeDistributionQueryVariables = Exact<{
  whereYoungerThan30: CustomerWhereInput;
  whereBetween30And50: CustomerWhereInput;
  whereOlderThan50: CustomerWhereInput;
}>;


export type CustomerAgeDistributionQuery = { __typename: 'Query', youngerThan30: number, between30And50: number, olderThan50: number };

export type CustomerDetailsQueryVariables = Exact<{
  where: CustomerWhereUniqueInput;
}>;


export type CustomerDetailsQuery = { __typename: 'Query', customer: { __typename: 'Customer', firstName?: string | null, lastName?: string | null, email: string, street?: string | null, houseNumber?: string | null, city?: string | null, postalCode?: string | null, birthDate?: Date | string | null, pushToken?: string | null, createdAt: Date | string, deletedAt?: Date | string | null } };

export type CustomerNewVsReturningQueryVariables = Exact<{
  whereNew: CustomerWhereInput;
  whereReturning: CustomerWhereInput;
}>;


export type CustomerNewVsReturningQuery = { __typename: 'Query', newCustomers: number, returningCustomers: number };

export type CustomerTopRankingQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CustomerTopRankingQuery = { __typename: 'Query', customerTopRanking: Array<{ __typename: 'CustomerTopRanking', firstName?: string | null, lastName?: string | null, email: string, redeemedPointsTotal: number, receivedPointsTotal: number }> };

export type CustomerTrendQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  timezone: Scalars['TimeZone']['input'];
}>;


export type CustomerTrendQuery = { __typename: 'Query', customerTrend: { __typename: 'TrendMetric', periodCount: number, previousPeriodCount: number, trend: number, dateGroupedCount: Array<{ __typename: 'DateGroupedCount', date: Date | string, count: number }> } };

export type PaginatedCustomersQueryVariables = Exact<{
  where?: InputMaybe<CustomerWhereInput>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput> | CustomerOrderByWithRelationInput>;
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CustomerScalarFieldEnum> | CustomerScalarFieldEnum>;
}>;


export type PaginatedCustomersQuery = { __typename: 'Query', paginatedCustomers: { __typename: 'PaginatedCustomer', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email: string, deletedAt?: Date | string | null }>, edges?: Array<{ __typename: 'CustomerEdge', cursor: { __typename: 'PaginatedCustomerCursor', id?: string | null } }> | null } };

export type DashboardOverviewQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  countCustomerWhere?: InputMaybe<CustomerWhereInput>;
}>;


export type DashboardOverviewQuery = { __typename: 'Query', countCustomer: number, countRedeemedPoint: number, aggregateReceivedPoint: { __typename: 'AggregateReceivedPoint', _sum?: { __typename: 'ReceivedPointSumAggregate', count?: number | null } | null }, redeemedCouponByTypeCount: Array<{ __typename: 'RedeemedCouponByTypeCount', type: CouponType, count: number }>, receivedVisitBasedPointsPerDay: Array<{ __typename: 'DateGroupedCount', date: Date | string, count: number }> };

export type DefectReportsActiveQueryVariables = Exact<{
  orderBy?: InputMaybe<ActiveDefectReportGroupOrderByInput>;
}>;


export type DefectReportsActiveQuery = { __typename: 'Query', activeDefectReports: Array<{ __typename: 'ActiveDefectReportGroup', reportCount: number, latestReportCategory: DefectCategory, latestReportAt: Date | string, equipment: { __typename: 'ActiveDefectReportGroupEquipment', id: string, name: string, branchOffice: { __typename: 'ActiveDefectReportGroupBranchOffice', name: string } } }> };

export type DefectReportsCountQueryVariables = Exact<{
  where?: InputMaybe<DefectReportWhereInput>;
}>;


export type DefectReportsCountQuery = { __typename: 'Query', countDefectReport: number };

export type DefectReportsUniqueReporterCountQueryVariables = Exact<{ [key: string]: never; }>;


export type DefectReportsUniqueReporterCountQuery = { __typename: 'Query', countDistinctDefectReporters: number };

export type DefectReportsQueryVariables = Exact<{
  where?: InputMaybe<DefectReportWhereInput>;
  orderBy?: InputMaybe<Array<DefectReportOrderByWithRelationInput> | DefectReportOrderByWithRelationInput>;
  cursor?: InputMaybe<DefectReportWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<DefectReportScalarFieldEnum> | DefectReportScalarFieldEnum>;
}>;


export type DefectReportsQuery = { __typename: 'Query', defectReports: Array<{ __typename: 'DefectReport', id: string, category: DefectCategory, message?: string | null, createdAt: Date | string, fixedAt?: Date | string | null, equipment: { __typename: 'Equipment', id: string, name: string, manufacturer: string, updatedAt: Date | string, status: EquipmentStatus, branchOffice: { __typename: 'BranchOffice', name: string } }, reporter?: { __typename: 'Customer', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }> };

export type EmployeesQueryVariables = Exact<{
  where?: InputMaybe<EmployeeWhereInput>;
  orderBy?: InputMaybe<Array<EmployeeOrderByWithRelationInput> | EmployeeOrderByWithRelationInput>;
  cursor?: InputMaybe<EmployeeWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<EmployeeScalarFieldEnum> | EmployeeScalarFieldEnum>;
}>;


export type EmployeesQuery = { __typename: 'Query', employees: Array<{ __typename: 'Employee', id?: string | null, firstName?: string | null, lastName?: string | null, email: string, userType: CompanyUserType, status: EmployeeStatus, updatedAt: Date | string, createdAt: Date | string }> };

export type EquipmentsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type EquipmentsCountQuery = { __typename: 'Query', countEquipment: number };

export type EquipmentsQueryVariables = Exact<{
  where?: InputMaybe<EquipmentWhereInput>;
  orderBy?: InputMaybe<Array<EquipmentOrderByWithRelationInput> | EquipmentOrderByWithRelationInput>;
  cursor?: InputMaybe<EquipmentWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<EquipmentScalarFieldEnum> | EquipmentScalarFieldEnum>;
}>;


export type EquipmentsQuery = { __typename: 'Query', equipments: Array<{ __typename: 'Equipment', id: string, manufacturer: string, name: string, type: EquipmentType, serialNumber: string, status: EquipmentStatus, lastDefectAt?: Date | string | null, deletedAt?: Date | string | null, createdAt: Date | string, updatedAt: Date | string, imageUrl?: string | null, branchOffice: { __typename: 'BranchOffice', id: string, name: string, companyId: string } }> };

export type PaginatedEquipmentsQueryVariables = Exact<{
  where?: InputMaybe<EquipmentWhereInput>;
  orderBy?: InputMaybe<Array<EquipmentOrderByWithRelationInput> | EquipmentOrderByWithRelationInput>;
  cursor?: InputMaybe<EquipmentWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<EquipmentScalarFieldEnum> | EquipmentScalarFieldEnum>;
}>;


export type PaginatedEquipmentsQuery = { __typename: 'Query', paginatedEquipments: { __typename: 'PaginatedEquipment', hasNextPage: boolean, totalCount: number, nodes: Array<{ __typename: 'Equipment', id: string, manufacturer: string, name: string, type: EquipmentType, serialNumber: string, status: EquipmentStatus, lastDefectAt?: Date | string | null, deletedAt?: Date | string | null, createdAt: Date | string, updatedAt: Date | string, imageUrl?: string | null, branchOffice: { __typename: 'BranchOffice', id: string, name: string, companyId: string } }>, edges?: Array<{ __typename: 'EquipmentEdge', cursor: { __typename: 'PaginatedEquipmentCursor', id?: string | null } }> | null } };

export type NewsQueryVariables = Exact<{
  where?: InputMaybe<NewsWhereInput>;
  orderBy?: InputMaybe<Array<NewsOrderByWithRelationInput> | NewsOrderByWithRelationInput>;
  cursor?: InputMaybe<NewsWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<NewsScalarFieldEnum> | NewsScalarFieldEnum>;
}>;


export type NewsQuery = { __typename: 'Query', news: Array<{ __typename: 'News', id: string, title: string, text: string, imageUrl?: string | null, createdAt: Date | string, updatedAt: Date | string, branchOffices?: Array<{ __typename: 'BranchOffice', id: string, name: string, companyId: string }> | null }> };

export type PointSystemCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type PointSystemCheckQuery = { __typename: 'Query', pointSystem?: { __typename: 'PointSystem', pointSystemType: { __typename: 'PointSystemType', type: SystemType } } | null };

export type PointSystemQueryVariables = Exact<{ [key: string]: never; }>;


export type PointSystemQuery = { __typename: 'Query', pointSystem?: { __typename: 'PointSystem', id: string, calculationRuleEntries: number, scanLimit: number, company: { __typename: 'Company', calculationRules?: Array<{ __typename: 'CalculationRule', id: string, points: number, value: number }> | null }, pointSystemType: { __typename: 'PointSystemType', id: string, type: SystemType } } | null };

export type PopupPeriodsQueryVariables = Exact<{
  where?: InputMaybe<PopupPeriodWhereInput>;
}>;


export type PopupPeriodsQuery = { __typename: 'Query', popupPeriods: Array<{ __typename: 'PopupPeriod', id: string, activeFrom: Date | string, activeUntil: Date | string, clicks: number, views: number, closes: number, popup: { __typename: 'Popup', id: string, name?: string | null, description?: string | null, active: boolean } }> };

export type PopupsQueryVariables = Exact<{
  where?: InputMaybe<PopupWhereInput>;
}>;


export type PopupsQuery = { __typename: 'Query', popups: Array<{ __typename: 'Popup', id: string, name?: string | null, description?: string | null, imageUrl?: string | null, active: boolean, deletedAt?: Date | string | null, periods?: Array<{ __typename: 'PopupPeriod', id: string, activeFrom: Date | string, activeUntil: Date | string, clicks: number, views: number, closes: number, popup: { __typename: 'Popup', id: string, name?: string | null, description?: string | null, active: boolean } }> | null }> };

export type PromotionPeriodsQueryVariables = Exact<{
  where?: InputMaybe<PromotionPeriodWhereInput>;
  orderBy?: InputMaybe<Array<PromotionPeriodOrderByWithRelationInput> | PromotionPeriodOrderByWithRelationInput>;
  cursor?: InputMaybe<PromotionPeriodWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<PromotionPeriodScalarFieldEnum> | PromotionPeriodScalarFieldEnum>;
}>;


export type PromotionPeriodsQuery = { __typename: 'Query', promotionPeriods: Array<{ __typename: 'PromotionPeriod', id: string, updatedAt: Date | string, createdAt: Date | string, activeFrom: Date | string, activeUntil: Date | string, promotion: { __typename: 'Promotion', id: string, title: string, description?: string | null, promotionCode?: string | null, createdAt: Date | string, updatedAt: Date | string } }> };

export type PromotionsQueryVariables = Exact<{
  where?: InputMaybe<PromotionWhereInput>;
  orderBy?: InputMaybe<Array<PromotionOrderByWithRelationInput> | PromotionOrderByWithRelationInput>;
  cursor?: InputMaybe<PromotionWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<PromotionScalarFieldEnum> | PromotionScalarFieldEnum>;
}>;


export type PromotionsQuery = { __typename: 'Query', promotions: Array<{ __typename: 'Promotion', id: string, title: string, description?: string | null, promotionCode?: string | null, createdAt: Date | string, updatedAt: Date | string }> };

export type PushNotificationHistoriesQueryVariables = Exact<{
  where?: InputMaybe<PushNotificationHistoryWhereInput>;
  orderBy?: InputMaybe<Array<PushNotificationHistoryOrderByWithRelationInput> | PushNotificationHistoryOrderByWithRelationInput>;
  cursor?: InputMaybe<PushNotificationHistoryWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<PushNotificationHistoryScalarFieldEnum> | PushNotificationHistoryScalarFieldEnum>;
}>;


export type PushNotificationHistoriesQuery = { __typename: 'Query', pushNotificationHistories: Array<{ __typename: 'PushNotificationHistory', id: string, affectedCustomers: number, sendAt: Date | string, pushNotification: { __typename: 'PushNotification', title: string, message: string, type: PushNotificationSendType } }> };

export type PushNotificationsQueryVariables = Exact<{
  where?: InputMaybe<PushNotificationWhereInput>;
  orderBy?: InputMaybe<Array<PushNotificationOrderByWithRelationInput> | PushNotificationOrderByWithRelationInput>;
  cursor?: InputMaybe<PushNotificationWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<PushNotificationScalarFieldEnum> | PushNotificationScalarFieldEnum>;
}>;


export type PushNotificationsQuery = { __typename: 'Query', pushNotifications: Array<{ __typename: 'PushNotification', id: string, title: string, message: string, type: PushNotificationSendType, status: PushNotificationStatus, cronExpression?: string | null, cronStartDate?: Date | string | null, cronInterval?: CronInterval | null, sendAt?: Date | string | null, createdAt: Date | string }> };

export type RatingQuestionsQueryVariables = Exact<{
  where?: InputMaybe<RatingQuestionWhereInput>;
  orderBy?: InputMaybe<Array<RatingQuestionOrderByWithRelationInput> | RatingQuestionOrderByWithRelationInput>;
  cursor?: InputMaybe<RatingQuestionWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<RatingQuestionScalarFieldEnum> | RatingQuestionScalarFieldEnum>;
  branchOfficeId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type RatingQuestionsQuery = { __typename: 'Query', ratingQuestions: Array<{ __typename: 'RatingQuestion', id: string, question: string, isActive: boolean, averageRating: number, createdAt: Date | string, updatedAt: Date | string }> };

export type ReceivedPointTrendQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  timezone: Scalars['TimeZone']['input'];
}>;


export type ReceivedPointTrendQuery = { __typename: 'Query', receivedPointTrend: { __typename: 'TrendMetric', periodCount: number, previousPeriodCount: number, trend: number, dateGroupedCount: Array<{ __typename: 'DateGroupedCount', date: Date | string, count: number }> } };

export type ReceivedPointsQueryVariables = Exact<{
  where?: InputMaybe<ReceivedPointWhereInput>;
  orderBy?: InputMaybe<Array<ReceivedPointOrderByWithRelationInput> | ReceivedPointOrderByWithRelationInput>;
  cursor?: InputMaybe<ReceivedPointWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<ReceivedPointScalarFieldEnum> | ReceivedPointScalarFieldEnum>;
}>;


export type ReceivedPointsQuery = { __typename: 'Query', receivedPoints: Array<{ __typename: 'ReceivedPoint', id: string, count?: number | null, createdAt: Date | string, updatedAt: Date | string, sourceType: ReceivedPointSourceType }> };

export type RedeemedPointTrendQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  timezone: Scalars['TimeZone']['input'];
}>;


export type RedeemedPointTrendQuery = { __typename: 'Query', redeemedPointTrend: { __typename: 'TrendMetric', periodCount: number, previousPeriodCount: number, trend: number, dateGroupedCount: Array<{ __typename: 'DateGroupedCount', date: Date | string, count: number }> } };

export type RedeemedPointsQueryVariables = Exact<{
  where?: InputMaybe<RedeemedPointWhereInput>;
  orderBy?: InputMaybe<Array<RedeemedPointOrderByWithRelationInput> | RedeemedPointOrderByWithRelationInput>;
  cursor?: InputMaybe<RedeemedPointWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<RedeemedPointScalarFieldEnum> | RedeemedPointScalarFieldEnum>;
}>;


export type RedeemedPointsQuery = { __typename: 'Query', redeemedPoints: Array<{ __typename: 'RedeemedPoint', id: string, createdAt: Date | string, updatedAt: Date | string, reward: { __typename: 'Reward', id: string, name: string, description?: string | null, requiredPoints: number, saving: number, imageKey?: string | null, transmissionMethod: TransmissionMethod, updatedAt: Date | string, createdAt: Date | string } }> };

export type RewardsChartQueryVariables = Exact<{
  where?: InputMaybe<RewardWhereInput>;
}>;


export type RewardsChartQuery = { __typename: 'Query', rewards: Array<{ __typename: 'Reward', id: string, name: string, description?: string | null, requiredPoints: number, saving: number, imageKey?: string | null, transmissionMethod: TransmissionMethod, updatedAt: Date | string, createdAt: Date | string, _count: { __typename: 'RewardCount', redeemedPoints: number } }> };

export type RewardsQueryVariables = Exact<{
  where?: InputMaybe<RewardWhereInput>;
  orderBy?: InputMaybe<Array<RewardOrderByWithRelationInput> | RewardOrderByWithRelationInput>;
  cursor?: InputMaybe<RewardWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<RewardScalarFieldEnum> | RewardScalarFieldEnum>;
}>;


export type RewardsQuery = { __typename: 'Query', rewards: Array<{ __typename: 'Reward', id: string, name: string, description?: string | null, requiredPoints: number, saving: number, imageKey?: string | null, transmissionMethod: TransmissionMethod, updatedAt: Date | string, createdAt: Date | string }> };

export type StatusHistoriesQueryVariables = Exact<{
  where?: InputMaybe<StatusHistoryWhereInput>;
  orderBy?: InputMaybe<Array<StatusHistoryOrderByWithRelationInput> | StatusHistoryOrderByWithRelationInput>;
  cursor?: InputMaybe<StatusHistoryWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<StatusHistoryScalarFieldEnum> | StatusHistoryScalarFieldEnum>;
}>;


export type StatusHistoriesQuery = { __typename: 'Query', statusHistories: Array<{ __typename: 'StatusHistory', id: string, createdAt: Date | string, oldStatus: EquipmentStatus, newStatus: EquipmentStatus, comment: string, equipment: { __typename: 'Equipment', id: string }, changedBy?: { __typename: 'Employee', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> };

export type ValidateBaseConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type ValidateBaseConfigurationQuery = { __typename: 'Query', calculationRules: Array<{ __typename: 'CalculationRule', id: string, points: number, value: number }>, pointSystem?: { __typename: 'PointSystem', pointSystemType: { __typename: 'PointSystemType', type: SystemType } } | null, branchOffices: Array<{ __typename: 'BranchOffice', id: string }> };

export const BalanceFieldsFragmentDoc = gql`
    fragment BalanceFields on Balance {
  updatedAt
  createdAt
  count
}
    `;
export const BranchOfficeCountFieldsFragmentDoc = gql`
    fragment BranchOfficeCountFields on BranchOffice {
  id
}
    `;
export const BranchOfficeImagesFieldsFragmentDoc = gql`
    fragment BranchOfficeImagesFields on BranchOffice {
  images {
    imageUrl
    createdAt
  }
}
    `;
export const BranchOfficeTopRatingFieldsFragmentDoc = gql`
    fragment BranchOfficeTopRatingFields on BranchOfficeTopRating {
  id
  name
  overallTotalRating
}
    `;
export const ChallengePeriodFieldsFragmentDoc = gql`
    fragment ChallengePeriodFields on ChallengePeriod {
  id
  activeFrom
  activeUntil
  participants
  challenge {
    id
    name
    pointsCredit
    trainingGoal
    maxParticipants
    branchOffice {
      name
    }
  }
}
    `;
export const ChallengePeriodWithoutChallengeFieldsFragmentDoc = gql`
    fragment ChallengePeriodWithoutChallengeFields on ChallengePeriod {
  id
  participants
  activeFrom
  activeUntil
}
    `;
export const ChallengeFieldsFragmentDoc = gql`
    fragment ChallengeFields on Challenge {
  id
  name
  description
  maxParticipants
  imageUrl
  active
  pointsCredit
  trainingGoal
  createdAt
  updatedAt
  stoppedAt
  deletedAt
  periods {
    ...ChallengePeriodWithoutChallengeFields
  }
  company {
    logoUrl
  }
  branchOffice {
    id
    name
  }
}
    ${ChallengePeriodWithoutChallengeFieldsFragmentDoc}`;
export const CompanyContextFieldsFragmentDoc = gql`
    fragment CompanyContextFields on Company {
  id
  integrationType
  studioApp
}
    `;
export const CompanyFieldsFragmentDoc = gql`
    fragment CompanyFields on Company {
  id
  logoUrl
  visible
}
    `;
export const CompanyAddressFieldsFragmentDoc = gql`
    fragment CompanyAddressFields on Company {
  street
  houseNumber
  city
  state
  postalCode
  countryCode
}
    `;
export const CompanyInformationFieldsFragmentDoc = gql`
    fragment CompanyInformationFields on Company {
  ...CompanyFields
  ...CompanyAddressFields
  visible
  name
  email
  description
}
    ${CompanyFieldsFragmentDoc}
${CompanyAddressFieldsFragmentDoc}`;
export const CompanyReferralConfigFieldsFragmentDoc = gql`
    fragment CompanyReferralConfigFields on CompanyReferralConfig {
  id
  text
  link
  pointsCredit
  active
  createdAt
  updatedAt
}
    `;
export const ContactFieldsFragmentDoc = gql`
    fragment ContactFields on Contact {
  id
  requestId
}
    `;
export const BranchOfficeFieldsFragmentDoc = gql`
    fragment BranchOfficeFields on BranchOffice {
  id
  name
  companyId
  description
  latitude
  longitude
  street
  houseNumber
  city
  state
  postalCode
  countryCode
  updatedAt
  createdAt
  countRatings
  averageRating
  crmConfig {
    crmStudioId
  }
}
    `;
export const CouponFieldsFragmentDoc = gql`
    fragment CouponFields on Coupon {
  id
  name
  description
  type
  active
  maxRedemptions
  createdAt
  updatedAt
  pointsCredit
  branchOffices {
    ...BranchOfficeFields
  }
  _count {
    redemptions
    periods
  }
}
    ${BranchOfficeFieldsFragmentDoc}`;
export const CouponPeriodFieldsFragmentDoc = gql`
    fragment CouponPeriodFields on CouponPeriod {
  id
  activeFrom
  activeUntil
  createdAt
  updatedAt
  redemptionCount
  coupon {
    ...CouponFields
  }
}
    ${CouponFieldsFragmentDoc}`;
export const CreateDefectReportFieldsFragmentDoc = gql`
    fragment CreateDefectReportFields on DefectReport {
  id
  category
  message
  createdAt
  fixedAt
}
    `;
export const CustomerDetailsFieldsFragmentDoc = gql`
    fragment CustomerDetailsFields on Customer {
  firstName
  lastName
  email
  street
  houseNumber
  city
  postalCode
  birthDate
  pushToken
  createdAt
  deletedAt
}
    `;
export const CustomerTopRankingFieldsFragmentDoc = gql`
    fragment CustomerTopRankingFields on CustomerTopRanking {
  firstName
  lastName
  email
  redeemedPointsTotal
  receivedPointsTotal
}
    `;
export const ActiveDefectReportGroupFieldsFragmentDoc = gql`
    fragment ActiveDefectReportGroupFields on ActiveDefectReportGroup {
  reportCount
  latestReportCategory
  latestReportAt
  equipment {
    id
    name
    branchOffice {
      name
    }
  }
}
    `;
export const DefectReportFieldsFragmentDoc = gql`
    fragment DefectReportFields on DefectReport {
  id
  category
  message
  createdAt
  fixedAt
  equipment {
    id
    name
    manufacturer
    updatedAt
    status
    branchOffice {
      name
    }
  }
  reporter {
    id
    firstName
    lastName
    email
  }
}
    `;
export const EmployeeFieldsFragmentDoc = gql`
    fragment EmployeeFields on Employee {
  id
  firstName
  lastName
  email
  userType
  status
  updatedAt
  createdAt
}
    `;
export const NewsFieldsFragmentDoc = gql`
    fragment NewsFields on News {
  id
  title
  text
  imageUrl
  createdAt
  updatedAt
  branchOffices {
    id
    name
    companyId
  }
}
    `;
export const CustomerFieldsFragmentDoc = gql`
    fragment CustomerFields on Customer {
  id
  firstName
  lastName
  email
  deletedAt
}
    `;
export const BranchOfficeRatingFieldsFragmentDoc = gql`
    fragment BranchOfficeRatingFields on BranchOfficeRating {
  id
  rating
  comment
  createdAt
  updatedAt
  customer {
    ...CustomerFields
  }
}
    ${CustomerFieldsFragmentDoc}`;
export const PaginatedBranchOfficeRatingFieldsFragmentDoc = gql`
    fragment PaginatedBranchOfficeRatingFields on PaginatedBranchOfficeRating {
  nodes {
    ...BranchOfficeRatingFields
  }
  hasNextPage
  totalCount
  edges {
    cursor {
      id
    }
  }
}
    ${BranchOfficeRatingFieldsFragmentDoc}`;
export const PaginatedCustomerFieldsFragmentDoc = gql`
    fragment PaginatedCustomerFields on PaginatedCustomer {
  nodes {
    ...CustomerFields
  }
  hasNextPage
  totalCount
  edges {
    cursor {
      id
    }
  }
}
    ${CustomerFieldsFragmentDoc}`;
export const EquipmentFieldsFragmentDoc = gql`
    fragment EquipmentFields on Equipment {
  id
  manufacturer
  name
  type
  serialNumber
  status
  lastDefectAt
  deletedAt
  createdAt
  updatedAt
  imageUrl
  branchOffice {
    id
    name
    companyId
  }
}
    `;
export const PaginatedEquipmentFieldsFragmentDoc = gql`
    fragment PaginatedEquipmentFields on PaginatedEquipment {
  nodes {
    ...EquipmentFields
  }
  hasNextPage
  totalCount
  edges {
    cursor {
      id
    }
  }
}
    ${EquipmentFieldsFragmentDoc}`;
export const PointSystemCheckFieldsFragmentDoc = gql`
    fragment PointSystemCheckFields on PointSystem {
  pointSystemType {
    type
  }
}
    `;
export const CalculationRuleFieldsFragmentDoc = gql`
    fragment CalculationRuleFields on CalculationRule {
  id
  points
  value
}
    `;
export const PointSystemTypeFieldsFragmentDoc = gql`
    fragment PointSystemTypeFields on PointSystemType {
  id
  type
}
    `;
export const PointSystemFieldsFragmentDoc = gql`
    fragment PointSystemFields on PointSystem {
  id
  company {
    calculationRules {
      ...CalculationRuleFields
    }
  }
  calculationRuleEntries
  pointSystemType {
    ...PointSystemTypeFields
  }
  scanLimit
}
    ${CalculationRuleFieldsFragmentDoc}
${PointSystemTypeFieldsFragmentDoc}`;
export const PopupPeriodFieldsFragmentDoc = gql`
    fragment PopupPeriodFields on PopupPeriod {
  id
  activeFrom
  activeUntil
  clicks
  views
  closes
  popup {
    id
    name
    description
    active
  }
}
    `;
export const PopupFieldsFragmentDoc = gql`
    fragment PopupFields on Popup {
  id
  name
  description
  imageUrl
  active
  deletedAt
  periods {
    ...PopupPeriodFields
  }
}
    ${PopupPeriodFieldsFragmentDoc}`;
export const PromotionFieldsFragmentDoc = gql`
    fragment PromotionFields on Promotion {
  id
  title
  description
  promotionCode
  createdAt
  updatedAt
}
    `;
export const PromotionPeriodFieldsFragmentDoc = gql`
    fragment PromotionPeriodFields on PromotionPeriod {
  id
  updatedAt
  createdAt
  activeFrom
  activeUntil
  promotion {
    ...PromotionFields
  }
}
    ${PromotionFieldsFragmentDoc}`;
export const PushNotificationHistoryFieldsFragmentDoc = gql`
    fragment PushNotificationHistoryFields on PushNotificationHistory {
  id
  affectedCustomers
  pushNotification {
    title
    message
    type
  }
  sendAt
}
    `;
export const PushNotificationFieldsFragmentDoc = gql`
    fragment PushNotificationFields on PushNotification {
  id
  title
  message
  type
  status
  cronExpression
  cronStartDate
  cronInterval
  sendAt
  createdAt
}
    `;
export const RatingQuestionFieldsFragmentDoc = gql`
    fragment RatingQuestionFields on RatingQuestion {
  id
  question
  isActive
  averageRating(branchOfficeId: $branchOfficeId)
  createdAt
  updatedAt
}
    `;
export const ReceivedPointFieldsFragmentDoc = gql`
    fragment ReceivedPointFields on ReceivedPoint {
  id
  count
  createdAt
  updatedAt
  sourceType
}
    `;
export const RewardFieldsFragmentDoc = gql`
    fragment RewardFields on Reward {
  id
  name
  description
  requiredPoints
  saving
  imageKey
  transmissionMethod
  updatedAt
  createdAt
}
    `;
export const RedeemedPointFieldsFragmentDoc = gql`
    fragment RedeemedPointFields on RedeemedPoint {
  id
  createdAt
  updatedAt
  reward {
    ...RewardFields
  }
}
    ${RewardFieldsFragmentDoc}`;
export const RewardsChartFieldsFragmentDoc = gql`
    fragment RewardsChartFields on Reward {
  ...RewardFields
  _count {
    redeemedPoints
  }
}
    ${RewardFieldsFragmentDoc}`;
export const StatusHistoryFieldsFragmentDoc = gql`
    fragment StatusHistoryFields on StatusHistory {
  id
  createdAt
  oldStatus
  newStatus
  comment
  equipment {
    id
  }
  changedBy {
    id
    firstName
    lastName
  }
}
    `;
export const TrendMetricFieldsFragmentDoc = gql`
    fragment TrendMetricFields on TrendMetric {
  periodCount
  previousPeriodCount
  dateGroupedCount {
    date
    count
  }
  trend
}
    `;
export const CreateBranchOfficeImageDocument = gql`
    mutation CreateBranchOfficeImage($data: BranchOfficeImageCreateInput!) {
  createBranchOfficeImage(data: $data) {
    id
    imageUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBranchOfficeImageGQL extends Apollo.Mutation<CreateBranchOfficeImageMutation, CreateBranchOfficeImageMutationVariables> {
    override document = CreateBranchOfficeImageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateBranchOfficeDocument = gql`
    mutation CreateBranchOffice($data: BranchOfficeCreateInput!) {
  createBranchOffice(data: $data) {
    ...BranchOfficeFields
  }
}
    ${BranchOfficeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBranchOfficeGQL extends Apollo.Mutation<CreateBranchOfficeMutation, CreateBranchOfficeMutationVariables> {
    override document = CreateBranchOfficeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteBranchOfficeDocument = gql`
    mutation DeleteBranchOffice($where: BranchOfficeUniqueInput!) {
  deleteBranchOffice(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteBranchOfficeGQL extends Apollo.Mutation<DeleteBranchOfficeMutation, DeleteBranchOfficeMutationVariables> {
    override document = DeleteBranchOfficeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBranchOfficeDocument = gql`
    mutation UpdateBranchOffice($data: BranchOfficeUpdateInput!, $where: BranchOfficeWhereUniqueInput!) {
  updateBranchOffice(where: $where, data: $data) {
    ...BranchOfficeFields
  }
}
    ${BranchOfficeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBranchOfficeGQL extends Apollo.Mutation<UpdateBranchOfficeMutation, UpdateBranchOfficeMutationVariables> {
    override document = UpdateBranchOfficeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrChangeCalculationRuleDocument = gql`
    mutation CreateOrChangeCalculationRule($data: CreateOrChangeCalculationRuleInput!) {
  createOrChangeCalculationRule(data: $data) {
    ...CalculationRuleFields
  }
}
    ${CalculationRuleFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrChangeCalculationRuleGQL extends Apollo.Mutation<CreateOrChangeCalculationRuleMutation, CreateOrChangeCalculationRuleMutationVariables> {
    override document = CreateOrChangeCalculationRuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateChallengePeriodDocument = gql`
    mutation CreateChallengePeriod($data: ChallengePeriodCreateInput!) {
  createChallengePeriod(data: $data) {
    ...ChallengePeriodFields
  }
}
    ${ChallengePeriodFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateChallengePeriodGQL extends Apollo.Mutation<CreateChallengePeriodMutation, CreateChallengePeriodMutationVariables> {
    override document = CreateChallengePeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteChallengePeriodDocument = gql`
    mutation DeleteChallengePeriod($where: ChallengePeriodWhereUniqueInput!) {
  deleteChallengePeriod(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteChallengePeriodGQL extends Apollo.Mutation<DeleteChallengePeriodMutation, DeleteChallengePeriodMutationVariables> {
    override document = DeleteChallengePeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateChallengePeriodDocument = gql`
    mutation UpdateChallengePeriod($where: ChallengePeriodWhereUniqueInput!, $data: ChallengePeriodUpdateInput!) {
  updateChallengePeriod(where: $where, data: $data) {
    ...ChallengePeriodFields
  }
}
    ${ChallengePeriodFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateChallengePeriodGQL extends Apollo.Mutation<UpdateChallengePeriodMutation, UpdateChallengePeriodMutationVariables> {
    override document = UpdateChallengePeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActivatePassivePointsChallengeDocument = gql`
    mutation ActivatePassivePointsChallenge($activateArgs: PassivePointsChallengeActivateInput!) {
  activatePassivePointsChallenge(data: $activateArgs) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActivatePassivePointsChallengeGQL extends Apollo.Mutation<ActivatePassivePointsChallengeMutation, ActivatePassivePointsChallengeMutationVariables> {
    override document = ActivatePassivePointsChallengeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateChallengeDocument = gql`
    mutation CreateChallenge($data: ChallengeCreateInput!) {
  createChallenge(data: $data) {
    ...ChallengeFields
  }
}
    ${ChallengeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateChallengeGQL extends Apollo.Mutation<CreateChallengeMutation, CreateChallengeMutationVariables> {
    override document = CreateChallengeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteChallengeDocument = gql`
    mutation DeleteChallenge($where: ChallengeWhereUniqueInput!) {
  deleteChallenge(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteChallengeGQL extends Apollo.Mutation<DeleteChallengeMutation, DeleteChallengeMutationVariables> {
    override document = DeleteChallengeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StopPassivePointsChallengeDocument = gql`
    mutation StopPassivePointsChallenge($uniqueInput: ChallengeWhereUniqueInput!) {
  stopPassivePointsChallenge(where: $uniqueInput) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StopPassivePointsChallengeGQL extends Apollo.Mutation<StopPassivePointsChallengeMutation, StopPassivePointsChallengeMutationVariables> {
    override document = StopPassivePointsChallengeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateChallengeImageDocument = gql`
    mutation UpdateChallengeImage($where: ChallengeWhereUniqueInput!, $data: ChallengeImageInput!) {
  updateChallengeImage(where: $where, data: $data) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateChallengeImageGQL extends Apollo.Mutation<UpdateChallengeImageMutation, UpdateChallengeImageMutationVariables> {
    override document = UpdateChallengeImageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCompanyReferralConfigDocument = gql`
    mutation CreateCompanyReferralConfig($data: CompanyReferralConfigCreateInput!) {
  createCompanyReferralConfig(data: $data) {
    ...CompanyReferralConfigFields
  }
}
    ${CompanyReferralConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCompanyReferralConfigGQL extends Apollo.Mutation<CreateCompanyReferralConfigMutation, CreateCompanyReferralConfigMutationVariables> {
    override document = CreateCompanyReferralConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyReferralConfigDocument = gql`
    mutation UpdateCompanyReferralConfig($where: CompanyReferralConfigWhereUniqueInput!, $data: CompanyReferralConfigUpdateInput!) {
  updateCompanyReferralConfig(where: $where, data: $data) {
    ...CompanyReferralConfigFields
  }
}
    ${CompanyReferralConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyReferralConfigGQL extends Apollo.Mutation<UpdateCompanyReferralConfigMutation, UpdateCompanyReferralConfigMutationVariables> {
    override document = UpdateCompanyReferralConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeVisibilityDocument = gql`
    mutation ChangeVisibility($visible: Boolean!) {
  changeVisibility(visible: $visible) {
    ...CompanyFields
  }
}
    ${CompanyFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeVisibilityGQL extends Apollo.Mutation<ChangeVisibilityMutation, ChangeVisibilityMutationVariables> {
    override document = ChangeVisibilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($data: UpdateCompanyInput!, $where: CompanyUniqueInput) {
  updateCompany(data: $data, where: $where) {
    ...CompanyInformationFields
  }
}
    ${CompanyInformationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyGQL extends Apollo.Mutation<UpdateCompanyMutation, UpdateCompanyMutationVariables> {
    override document = UpdateCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContactSupportDocument = gql`
    mutation ContactSupport($data: ContactSupportInput!) {
  contactSupport(data: $data) {
    ...ContactFields
  }
}
    ${ContactFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ContactSupportGQL extends Apollo.Mutation<ContactSupportMutation, ContactSupportMutationVariables> {
    override document = ContactSupportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCouponPeriodDocument = gql`
    mutation CreateCouponPeriod($data: CouponPeriodCreateInput!) {
  createCouponPeriod(data: $data) {
    ...CouponPeriodFields
  }
}
    ${CouponPeriodFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCouponPeriodGQL extends Apollo.Mutation<CreateCouponPeriodMutation, CreateCouponPeriodMutationVariables> {
    override document = CreateCouponPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCouponPeriodDocument = gql`
    mutation DeleteCouponPeriod($where: CouponPeriodWhereUniqueInput!) {
  deleteCouponPeriod(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCouponPeriodGQL extends Apollo.Mutation<DeleteCouponPeriodMutation, DeleteCouponPeriodMutationVariables> {
    override document = DeleteCouponPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCouponPeriodDocument = gql`
    mutation UpdateCouponPeriod($where: CouponPeriodWhereUniqueInput!, $data: CouponPeriodUpdateInput!) {
  updateCouponPeriod(where: $where, data: $data) {
    ...CouponPeriodFields
  }
}
    ${CouponPeriodFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCouponPeriodGQL extends Apollo.Mutation<UpdateCouponPeriodMutation, UpdateCouponPeriodMutationVariables> {
    override document = UpdateCouponPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCouponDocument = gql`
    mutation CreateCoupon($data: CouponCreateInput!) {
  createCoupon(data: $data) {
    ...CouponFields
  }
}
    ${CouponFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCouponGQL extends Apollo.Mutation<CreateCouponMutation, CreateCouponMutationVariables> {
    override document = CreateCouponDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateWelcomeCouponDocument = gql`
    mutation CreateWelcomeCoupon($data: WelcomeCouponCreateInput!) {
  createWelcomeCoupon(data: $data) {
    ...CouponFields
  }
}
    ${CouponFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateWelcomeCouponGQL extends Apollo.Mutation<CreateWelcomeCouponMutation, CreateWelcomeCouponMutationVariables> {
    override document = CreateWelcomeCouponDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCouponDocument = gql`
    mutation DeleteCoupon($where: CouponWhereUniqueInput!) {
  deleteCoupon(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCouponGQL extends Apollo.Mutation<DeleteCouponMutation, DeleteCouponMutationVariables> {
    override document = DeleteCouponDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SwitchCouponStatusDocument = gql`
    mutation SwitchCouponStatus($where: CouponUniqueInput!, $data: SwitchCouponStatusInput!) {
  switchCouponStatus(where: $where, data: $data) {
    ...CouponFields
  }
}
    ${CouponFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SwitchCouponStatusGQL extends Apollo.Mutation<SwitchCouponStatusMutation, SwitchCouponStatusMutationVariables> {
    override document = SwitchCouponStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDefectReportDocument = gql`
    mutation CreateDefectReport($data: DefectReportCreateInput!) {
  createDefectReport(data: $data) {
    ...CreateDefectReportFields
  }
}
    ${CreateDefectReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDefectReportGQL extends Apollo.Mutation<CreateDefectReportMutation, CreateDefectReportMutationVariables> {
    override document = CreateDefectReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkDefectReportFixedDocument = gql`
    mutation MarkDefectReportFixed($where: DefectReportWhereUniqueInput!) {
  markDefectReportFixed(where: $where) {
    id
    fixedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkDefectReportFixedGQL extends Apollo.Mutation<MarkDefectReportFixedMutation, MarkDefectReportFixedMutationVariables> {
    override document = MarkDefectReportFixedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEmployeeDocument = gql`
    mutation DeleteEmployee($where: EmployeeIdentifierInput!) {
  deleteEmployee(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEmployeeGQL extends Apollo.Mutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables> {
    override document = DeleteEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InviteEmployeeDocument = gql`
    mutation InviteEmployee($email: String!) {
  inviteEmployee(email: $email) {
    ...EmployeeFields
  }
}
    ${EmployeeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InviteEmployeeGQL extends Apollo.Mutation<InviteEmployeeMutation, InviteEmployeeMutationVariables> {
    override document = InviteEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendPasswordChangeEmailDocument = gql`
    mutation SendPasswordChangeEmail {
  sendPasswordChangeEmail {
    ...EmployeeFields
  }
}
    ${EmployeeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SendPasswordChangeEmailGQL extends Apollo.Mutation<SendPasswordChangeEmailMutation, SendPasswordChangeEmailMutationVariables> {
    override document = SendPasswordChangeEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEmployeeDocument = gql`
    mutation UpdateEmployee($data: UpdateEmployeeInput!, $where: EmployeeUniqueInput) {
  updateEmployee(data: $data, where: $where) {
    ...EmployeeFields
  }
}
    ${EmployeeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEmployeeGQL extends Apollo.Mutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables> {
    override document = UpdateEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeEquipmentStatusDocument = gql`
    mutation ChangeEquipmentStatus($data: EquipmentStatusChangeInput!, $where: EquipmentWhereUniqueInput!) {
  changeEquipmentStatus(data: $data, where: $where) {
    id
    oldStatus
    newStatus
    comment
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeEquipmentStatusGQL extends Apollo.Mutation<ChangeEquipmentStatusMutation, ChangeEquipmentStatusMutationVariables> {
    override document = ChangeEquipmentStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEquipmentDocument = gql`
    mutation CreateEquipment($data: EquipmentCreateInput!) {
  createEquipment(data: $data) {
    ...EquipmentFields
  }
}
    ${EquipmentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEquipmentGQL extends Apollo.Mutation<CreateEquipmentMutation, CreateEquipmentMutationVariables> {
    override document = CreateEquipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveEquipmentImageDocument = gql`
    mutation RemoveEquipmentImage($where: EquipmentWhereUniqueInput!) {
  removeEquipmentImage(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveEquipmentImageGQL extends Apollo.Mutation<RemoveEquipmentImageMutation, RemoveEquipmentImageMutationVariables> {
    override document = RemoveEquipmentImageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SoftDeleteEquipmentDocument = gql`
    mutation SoftDeleteEquipment($where: EquipmentWhereUniqueInput!) {
  softDeleteEquipment(where: $where) {
    id
    deletedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SoftDeleteEquipmentGQL extends Apollo.Mutation<SoftDeleteEquipmentMutation, SoftDeleteEquipmentMutationVariables> {
    override document = SoftDeleteEquipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEquipmentImageDocument = gql`
    mutation UpdateEquipmentImage($where: EquipmentWhereUniqueInput!, $data: EquipmentImageInput!) {
  updateEquipmentImage(where: $where, data: $data) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEquipmentImageGQL extends Apollo.Mutation<UpdateEquipmentImageMutation, UpdateEquipmentImageMutationVariables> {
    override document = UpdateEquipmentImageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEquipmentDocument = gql`
    mutation UpdateEquipment($data: EquipmentUpdateInput!, $where: EquipmentWhereUniqueInput!) {
  updateEquipment(where: $where, data: $data) {
    ...EquipmentFields
  }
}
    ${EquipmentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEquipmentGQL extends Apollo.Mutation<UpdateEquipmentMutation, UpdateEquipmentMutationVariables> {
    override document = UpdateEquipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateNewsDocument = gql`
    mutation CreateNews($data: NewsCreateInput!) {
  createNews(data: $data) {
    ...NewsFields
  }
}
    ${NewsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateNewsGQL extends Apollo.Mutation<CreateNewsMutation, CreateNewsMutationVariables> {
    override document = CreateNewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteNewsDocument = gql`
    mutation DeleteNews($where: NewsWhereUniqueInput!) {
  deleteNews(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteNewsGQL extends Apollo.Mutation<DeleteNewsMutation, DeleteNewsMutationVariables> {
    override document = DeleteNewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangePointSystemDocument = gql`
    mutation ChangePointSystem($input: ChangePointSystemInput!) {
  changePointSystem(input: $input) {
    ...PointSystemFields
  }
}
    ${PointSystemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangePointSystemGQL extends Apollo.Mutation<ChangePointSystemMutation, ChangePointSystemMutationVariables> {
    override document = ChangePointSystemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePointSystemDocument = gql`
    mutation CreatePointSystem($createInput: PointSystemCreateInput!) {
  createPointSystem(createInput: $createInput) {
    ...PointSystemFields
  }
}
    ${PointSystemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePointSystemGQL extends Apollo.Mutation<CreatePointSystemMutation, CreatePointSystemMutationVariables> {
    override document = CreatePointSystemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePopupPeriodDocument = gql`
    mutation CreatePopupPeriod($data: PopupPeriodCreateNextInput!) {
  createPopupPeriod(data: $data) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePopupPeriodGQL extends Apollo.Mutation<CreatePopupPeriodMutation, CreatePopupPeriodMutationVariables> {
    override document = CreatePopupPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePopupPeriodDocument = gql`
    mutation DeletePopupPeriod($where: PopupPeriodWhereUniqueInput!) {
  deletePopupPeriod(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePopupPeriodGQL extends Apollo.Mutation<DeletePopupPeriodMutation, DeletePopupPeriodMutationVariables> {
    override document = DeletePopupPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePopupPeriodDocument = gql`
    mutation UpdatePopupPeriod($where: PopupPeriodWhereUniqueInput!, $data: PopupPeriodUpdateInput!) {
  updatePopupPeriod(where: $where, data: $data) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePopupPeriodGQL extends Apollo.Mutation<UpdatePopupPeriodMutation, UpdatePopupPeriodMutationVariables> {
    override document = UpdatePopupPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePopupDocument = gql`
    mutation CreatePopup($data: PopupCreateInput!) {
  createPopup(data: $data) {
    ...PopupFields
  }
}
    ${PopupFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePopupGQL extends Apollo.Mutation<CreatePopupMutation, CreatePopupMutationVariables> {
    override document = CreatePopupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePopupDocument = gql`
    mutation DeletePopup($where: PopupWhereUniqueInput!) {
  deletePopup(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePopupGQL extends Apollo.Mutation<DeletePopupMutation, DeletePopupMutationVariables> {
    override document = DeletePopupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePromotionPeriodDocument = gql`
    mutation CreatePromotionPeriod($data: PromotionPeriodCreateInput!) {
  createPromotionPeriod(data: $data) {
    ...PromotionPeriodFields
  }
}
    ${PromotionPeriodFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePromotionPeriodGQL extends Apollo.Mutation<CreatePromotionPeriodMutation, CreatePromotionPeriodMutationVariables> {
    override document = CreatePromotionPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePromotionPeriodDocument = gql`
    mutation DeletePromotionPeriod($where: PromotionPeriodWhereUniqueInput!) {
  deletePromotionPeriod(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePromotionPeriodGQL extends Apollo.Mutation<DeletePromotionPeriodMutation, DeletePromotionPeriodMutationVariables> {
    override document = DeletePromotionPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePromotionPeriodDocument = gql`
    mutation UpdatePromotionPeriod($where: PromotionPeriodUniqueInput!, $data: PromotionPeriodUpdateInput!) {
  updatePromotionPeriod(where: $where, data: $data) {
    ...PromotionPeriodFields
  }
}
    ${PromotionPeriodFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePromotionPeriodGQL extends Apollo.Mutation<UpdatePromotionPeriodMutation, UpdatePromotionPeriodMutationVariables> {
    override document = UpdatePromotionPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePromotionDocument = gql`
    mutation CreatePromotion($data: PromotionCreateInput!) {
  createPromotion(data: $data) {
    ...PromotionFields
  }
}
    ${PromotionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePromotionGQL extends Apollo.Mutation<CreatePromotionMutation, CreatePromotionMutationVariables> {
    override document = CreatePromotionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePromotionDocument = gql`
    mutation DeletePromotion($where: PromotionWhereUniqueInput!) {
  deletePromotion(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePromotionGQL extends Apollo.Mutation<DeletePromotionMutation, DeletePromotionMutationVariables> {
    override document = DeletePromotionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePushNotificationDocument = gql`
    mutation CreatePushNotification($createInput: PushNotificationCreateInput!) {
  createPushNotification(data: $createInput) {
    ...PushNotificationFields
  }
}
    ${PushNotificationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePushNotificationGQL extends Apollo.Mutation<CreatePushNotificationMutation, CreatePushNotificationMutationVariables> {
    override document = CreatePushNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePushNotificationDocument = gql`
    mutation DeletePushNotification($where: PushNotificationWhereUniqueInput!) {
  deletePushNotification(where: $where) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePushNotificationGQL extends Apollo.Mutation<DeletePushNotificationMutation, DeletePushNotificationMutationVariables> {
    override document = DeletePushNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisablePushNotificationDocument = gql`
    mutation DisablePushNotification($pushNotificationId: String!) {
  disablePushNotification(pushNotificationId: $pushNotificationId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisablePushNotificationGQL extends Apollo.Mutation<DisablePushNotificationMutation, DisablePushNotificationMutationVariables> {
    override document = DisablePushNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRatingQuestionDocument = gql`
    mutation CreateRatingQuestion($data: RatingQuestionCreateInput!, $branchOfficeId: UUID = null) {
  createRatingQuestion(data: $data) {
    ...RatingQuestionFields
  }
}
    ${RatingQuestionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRatingQuestionGQL extends Apollo.Mutation<CreateRatingQuestionMutation, CreateRatingQuestionMutationVariables> {
    override document = CreateRatingQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRatingQuestionDocument = gql`
    mutation DeleteRatingQuestion($where: RatingQuestionWhereUniqueInput!, $branchOfficeId: UUID = null) {
  deleteRatingQuestion(where: $where) {
    ...RatingQuestionFields
  }
}
    ${RatingQuestionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRatingQuestionGQL extends Apollo.Mutation<DeleteRatingQuestionMutation, DeleteRatingQuestionMutationVariables> {
    override document = DeleteRatingQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRatingQuestionActiveStatusDocument = gql`
    mutation UpdateRatingQuestionActiveStatus($where: RatingQuestionWhereUniqueInput!, $data: RatingQuestionActiveStatusUpdateInput!, $branchOfficeId: UUID = null) {
  updateRatingQuestionActiveStatus(where: $where, data: $data) {
    ...RatingQuestionFields
  }
}
    ${RatingQuestionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRatingQuestionActiveStatusGQL extends Apollo.Mutation<UpdateRatingQuestionActiveStatusMutation, UpdateRatingQuestionActiveStatusMutationVariables> {
    override document = UpdateRatingQuestionActiveStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateManuallyReceivedPointDocument = gql`
    mutation CreateManuallyReceivedPoint($customer: CustomerWhereUniqueInput!, $count: Float!) {
  createManuallyReceivedPoint(count: $count, customer: $customer) {
    ...ReceivedPointFields
  }
}
    ${ReceivedPointFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateManuallyReceivedPointGQL extends Apollo.Mutation<CreateManuallyReceivedPointMutation, CreateManuallyReceivedPointMutationVariables> {
    override document = CreateManuallyReceivedPointDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRewardDocument = gql`
    mutation CreateReward($data: CreateRewardInput!) {
  createReward(data: $data) {
    ...RewardFields
  }
}
    ${RewardFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRewardGQL extends Apollo.Mutation<CreateRewardMutation, CreateRewardMutationVariables> {
    override document = CreateRewardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SwitchRewardStatusDocument = gql`
    mutation SwitchRewardStatus($input: SwitchRewardStatusInput!) {
  switchRewardStatus(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SwitchRewardStatusGQL extends Apollo.Mutation<SwitchRewardStatusMutation, SwitchRewardStatusMutationVariables> {
    override document = SwitchRewardStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRewardDocument = gql`
    mutation UpdateReward($data: RewardUpdateInput!, $where: RewardWhereUniqueInput!) {
  updateReward(data: $data, where: $where) {
    ...RewardFields
  }
}
    ${RewardFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRewardGQL extends Apollo.Mutation<UpdateRewardMutation, UpdateRewardMutationVariables> {
    override document = UpdateRewardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BranchOfficeRatingsDocument = gql`
    query BranchOfficeRatings($where: BranchOfficeRatingWhereInput, $oderBy: [BranchOfficeRatingOrderByWithRelationInput!], $cursor: BranchOfficeRatingWhereUniqueInput, $take: Int, $skip: Int, $distinct: [BranchOfficeRatingScalarFieldEnum!]) {
  branchOfficeRatings(
    where: $where
    orderBy: $oderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...BranchOfficeRatingFields
  }
}
    ${BranchOfficeRatingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BranchOfficeRatingsGQL extends Apollo.Query<BranchOfficeRatingsQuery, BranchOfficeRatingsQueryVariables> {
    override document = BranchOfficeRatingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedBranchOfficeRatingsDocument = gql`
    query PaginatedBranchOfficeRatings($where: BranchOfficeRatingWhereInput, $orderBy: [BranchOfficeRatingOrderByWithRelationInput!], $cursor: BranchOfficeRatingWhereUniqueInput, $take: Int, $skip: Int, $distinct: [BranchOfficeRatingScalarFieldEnum!]) {
  paginatedBranchOfficeRating(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...PaginatedBranchOfficeRatingFields
  }
}
    ${PaginatedBranchOfficeRatingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedBranchOfficeRatingsGQL extends Apollo.Query<PaginatedBranchOfficeRatingsQuery, PaginatedBranchOfficeRatingsQueryVariables> {
    override document = PaginatedBranchOfficeRatingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BranchOfficeTopRatingDocument = gql`
    query BranchOfficeTopRating($startDate: DateTime, $endDate: DateTime) {
  branchOfficeTopRating(startDate: $startDate, endDate: $endDate) {
    ...BranchOfficeTopRatingFields
  }
}
    ${BranchOfficeTopRatingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BranchOfficeTopRatingGQL extends Apollo.Query<BranchOfficeTopRatingQuery, BranchOfficeTopRatingQueryVariables> {
    override document = BranchOfficeTopRatingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BranchOfficesWithImagesDocument = gql`
    query BranchOfficesWithImages($where: BranchOfficeWhereInput, $orderBy: [BranchOfficeOrderByWithRelationInput!], $cursor: BranchOfficeWhereUniqueInput, $take: Int, $skip: Int, $distinct: [BranchOfficeScalarFieldEnum!]) {
  branchOffices(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...BranchOfficeFields
    ...BranchOfficeImagesFields
  }
}
    ${BranchOfficeFieldsFragmentDoc}
${BranchOfficeImagesFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BranchOfficesWithImagesGQL extends Apollo.Query<BranchOfficesWithImagesQuery, BranchOfficesWithImagesQueryVariables> {
    override document = BranchOfficesWithImagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BranchOfficesDocument = gql`
    query BranchOffices($where: BranchOfficeWhereInput, $orderBy: [BranchOfficeOrderByWithRelationInput!], $cursor: BranchOfficeWhereUniqueInput, $take: Int, $skip: Int, $distinct: [BranchOfficeScalarFieldEnum!]) {
  branchOffices(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...BranchOfficeFields
  }
}
    ${BranchOfficeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BranchOfficesGQL extends Apollo.Query<BranchOfficesQuery, BranchOfficesQueryVariables> {
    override document = BranchOfficesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChallengePeriodsDocument = gql`
    query ChallengePeriods($where: ChallengePeriodWhereInput, $orderBy: [ChallengePeriodOrderByWithRelationInput!], $cursor: ChallengePeriodWhereUniqueInput, $take: Int, $skip: Int, $distinct: [ChallengePeriodScalarFieldEnum!]) {
  challengePeriods(
    where: $where
    cursor: $cursor
    distinct: $distinct
    orderBy: $orderBy
    skip: $skip
    take: $take
  ) {
    ...ChallengePeriodFields
  }
}
    ${ChallengePeriodFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ChallengePeriodsGQL extends Apollo.Query<ChallengePeriodsQuery, ChallengePeriodsQueryVariables> {
    override document = ChallengePeriodsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChallengesDocument = gql`
    query Challenges($where: ChallengeWhereInput, $orderBy: [ChallengeOrderByWithRelationInput!], $cursor: ChallengeWhereUniqueInput, $take: Int, $skip: Int, $distinct: [ChallengeScalarFieldEnum!]) {
  challenges(
    where: $where
    cursor: $cursor
    distinct: $distinct
    orderBy: $orderBy
    skip: $skip
    take: $take
  ) {
    ...ChallengeFields
  }
}
    ${ChallengeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ChallengesGQL extends Apollo.Query<ChallengesQuery, ChallengesQueryVariables> {
    override document = ChallengesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyReferralConfigDocument = gql`
    query CompanyReferralConfig($where: CompanyReferralConfigWhereUniqueInput) {
  companyReferralConfig(where: $where) {
    ...CompanyReferralConfigFields
  }
}
    ${CompanyReferralConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyReferralConfigGQL extends Apollo.Query<CompanyReferralConfigQuery, CompanyReferralConfigQueryVariables> {
    override document = CompanyReferralConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyContextDocument = gql`
    query CompanyContext($where: CompanyUniqueInput) {
  company(where: $where) {
    ...CompanyContextFields
  }
}
    ${CompanyContextFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyContextGQL extends Apollo.Query<CompanyContextQuery, CompanyContextQueryVariables> {
    override document = CompanyContextDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyInformationDocument = gql`
    query CompanyInformation {
  company {
    ...CompanyInformationFields
  }
}
    ${CompanyInformationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyInformationGQL extends Apollo.Query<CompanyInformationQuery, CompanyInformationQueryVariables> {
    override document = CompanyInformationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyDocument = gql`
    query Company($where: CompanyUniqueInput) {
  company(where: $where) {
    ...CompanyFields
  }
}
    ${CompanyFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyGQL extends Apollo.Query<CompanyQuery, CompanyQueryVariables> {
    override document = CompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUsageAmountDocument = gql`
    query CurrentUsageAmount {
  company {
    id
    _count(onlyActiveRewards: true) {
      branchOffices
      employees
      rewards
      calculationRules
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUsageAmountGQL extends Apollo.Query<CurrentUsageAmountQuery, CurrentUsageAmountQueryVariables> {
    override document = CurrentUsageAmountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CouponPeriodsDocument = gql`
    query CouponPeriods($where: CouponPeriodWhereInput, $orderBy: [CouponPeriodOrderByWithRelationInput!], $cursor: CouponPeriodWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CouponPeriodScalarFieldEnum!]) {
  couponPeriods(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CouponPeriodFields
  }
}
    ${CouponPeriodFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CouponPeriodsGQL extends Apollo.Query<CouponPeriodsQuery, CouponPeriodsQueryVariables> {
    override document = CouponPeriodsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CouponsDocument = gql`
    query Coupons($where: CouponWhereInput, $orderBy: [CouponOrderByWithRelationInput!], $cursor: CouponWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CouponScalarFieldEnum!]) {
  coupons(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...CouponFields
  }
}
    ${CouponFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CouponsGQL extends Apollo.Query<CouponsQuery, CouponsQueryVariables> {
    override document = CouponsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerAgeDistributionDocument = gql`
    query CustomerAgeDistribution($whereYoungerThan30: CustomerWhereInput!, $whereBetween30And50: CustomerWhereInput!, $whereOlderThan50: CustomerWhereInput!) {
  youngerThan30: countCustomer(where: $whereYoungerThan30)
  between30And50: countCustomer(where: $whereBetween30And50)
  olderThan50: countCustomer(where: $whereOlderThan50)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerAgeDistributionGQL extends Apollo.Query<CustomerAgeDistributionQuery, CustomerAgeDistributionQueryVariables> {
    override document = CustomerAgeDistributionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerDetailsDocument = gql`
    query CustomerDetails($where: CustomerWhereUniqueInput!) {
  customer(where: $where) {
    ...CustomerDetailsFields
  }
}
    ${CustomerDetailsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerDetailsGQL extends Apollo.Query<CustomerDetailsQuery, CustomerDetailsQueryVariables> {
    override document = CustomerDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerNewVsReturningDocument = gql`
    query CustomerNewVsReturning($whereNew: CustomerWhereInput!, $whereReturning: CustomerWhereInput!) {
  newCustomers: countCustomer(where: $whereNew)
  returningCustomers: countCustomer(where: $whereReturning)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerNewVsReturningGQL extends Apollo.Query<CustomerNewVsReturningQuery, CustomerNewVsReturningQueryVariables> {
    override document = CustomerNewVsReturningDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerTopRankingDocument = gql`
    query CustomerTopRanking($startDate: DateTime, $endDate: DateTime) {
  customerTopRanking(startDate: $startDate, endDate: $endDate) {
    ...CustomerTopRankingFields
  }
}
    ${CustomerTopRankingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerTopRankingGQL extends Apollo.Query<CustomerTopRankingQuery, CustomerTopRankingQueryVariables> {
    override document = CustomerTopRankingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerTrendDocument = gql`
    query CustomerTrend($startDate: DateTime!, $endDate: DateTime!, $timezone: TimeZone!) {
  customerTrend(startDate: $startDate, endDate: $endDate, timezone: $timezone) {
    ...TrendMetricFields
  }
}
    ${TrendMetricFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerTrendGQL extends Apollo.Query<CustomerTrendQuery, CustomerTrendQueryVariables> {
    override document = CustomerTrendDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedCustomersDocument = gql`
    query PaginatedCustomers($where: CustomerWhereInput, $orderBy: [CustomerOrderByWithRelationInput!], $cursor: CustomerWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CustomerScalarFieldEnum!]) {
  paginatedCustomers(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...PaginatedCustomerFields
  }
}
    ${PaginatedCustomerFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedCustomersGQL extends Apollo.Query<PaginatedCustomersQuery, PaginatedCustomersQueryVariables> {
    override document = PaginatedCustomersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DashboardOverviewDocument = gql`
    query DashboardOverview($startDate: DateTime!, $endDate: DateTime!, $countCustomerWhere: CustomerWhereInput) {
  countCustomer(where: $countCustomerWhere)
  aggregateReceivedPoint(_sum: {count: true}) {
    _sum {
      count
    }
  }
  countRedeemedPoint
  redeemedCouponByTypeCount {
    type
    count
  }
  receivedVisitBasedPointsPerDay(startDate: $startDate, endDate: $endDate) {
    date
    count
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DashboardOverviewGQL extends Apollo.Query<DashboardOverviewQuery, DashboardOverviewQueryVariables> {
    override document = DashboardOverviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DefectReportsActiveDocument = gql`
    query DefectReportsActive($orderBy: ActiveDefectReportGroupOrderByInput) {
  activeDefectReports(orderBy: $orderBy) {
    ...ActiveDefectReportGroupFields
  }
}
    ${ActiveDefectReportGroupFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DefectReportsActiveGQL extends Apollo.Query<DefectReportsActiveQuery, DefectReportsActiveQueryVariables> {
    override document = DefectReportsActiveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DefectReportsCountDocument = gql`
    query DefectReportsCount($where: DefectReportWhereInput) {
  countDefectReport(where: $where)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DefectReportsCountGQL extends Apollo.Query<DefectReportsCountQuery, DefectReportsCountQueryVariables> {
    override document = DefectReportsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DefectReportsUniqueReporterCountDocument = gql`
    query DefectReportsUniqueReporterCount {
  countDistinctDefectReporters
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DefectReportsUniqueReporterCountGQL extends Apollo.Query<DefectReportsUniqueReporterCountQuery, DefectReportsUniqueReporterCountQueryVariables> {
    override document = DefectReportsUniqueReporterCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DefectReportsDocument = gql`
    query DefectReports($where: DefectReportWhereInput, $orderBy: [DefectReportOrderByWithRelationInput!], $cursor: DefectReportWhereUniqueInput, $take: Int, $skip: Int, $distinct: [DefectReportScalarFieldEnum!]) {
  defectReports(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...DefectReportFields
  }
}
    ${DefectReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DefectReportsGQL extends Apollo.Query<DefectReportsQuery, DefectReportsQueryVariables> {
    override document = DefectReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EmployeesDocument = gql`
    query Employees($where: EmployeeWhereInput, $orderBy: [EmployeeOrderByWithRelationInput!], $cursor: EmployeeWhereUniqueInput, $take: Int, $skip: Int, $distinct: [EmployeeScalarFieldEnum!]) {
  employees(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...EmployeeFields
  }
}
    ${EmployeeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EmployeesGQL extends Apollo.Query<EmployeesQuery, EmployeesQueryVariables> {
    override document = EmployeesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EquipmentsCountDocument = gql`
    query EquipmentsCount {
  countEquipment
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EquipmentsCountGQL extends Apollo.Query<EquipmentsCountQuery, EquipmentsCountQueryVariables> {
    override document = EquipmentsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EquipmentsDocument = gql`
    query Equipments($where: EquipmentWhereInput, $orderBy: [EquipmentOrderByWithRelationInput!], $cursor: EquipmentWhereUniqueInput, $take: Int, $skip: Int, $distinct: [EquipmentScalarFieldEnum!]) {
  equipments(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...EquipmentFields
  }
}
    ${EquipmentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EquipmentsGQL extends Apollo.Query<EquipmentsQuery, EquipmentsQueryVariables> {
    override document = EquipmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedEquipmentsDocument = gql`
    query PaginatedEquipments($where: EquipmentWhereInput, $orderBy: [EquipmentOrderByWithRelationInput!], $cursor: EquipmentWhereUniqueInput, $take: Int, $skip: Int, $distinct: [EquipmentScalarFieldEnum!]) {
  paginatedEquipments(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...PaginatedEquipmentFields
  }
}
    ${PaginatedEquipmentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedEquipmentsGQL extends Apollo.Query<PaginatedEquipmentsQuery, PaginatedEquipmentsQueryVariables> {
    override document = PaginatedEquipmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NewsDocument = gql`
    query News($where: NewsWhereInput, $orderBy: [NewsOrderByWithRelationInput!], $cursor: NewsWhereUniqueInput, $take: Int, $skip: Int, $distinct: [NewsScalarFieldEnum!]) {
  news(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...NewsFields
  }
}
    ${NewsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class NewsGQL extends Apollo.Query<NewsQuery, NewsQueryVariables> {
    override document = NewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PointSystemCheckDocument = gql`
    query PointSystemCheck {
  pointSystem {
    ...PointSystemCheckFields
  }
}
    ${PointSystemCheckFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PointSystemCheckGQL extends Apollo.Query<PointSystemCheckQuery, PointSystemCheckQueryVariables> {
    override document = PointSystemCheckDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PointSystemDocument = gql`
    query PointSystem {
  pointSystem {
    ...PointSystemFields
  }
}
    ${PointSystemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PointSystemGQL extends Apollo.Query<PointSystemQuery, PointSystemQueryVariables> {
    override document = PointSystemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PopupPeriodsDocument = gql`
    query PopupPeriods($where: PopupPeriodWhereInput) {
  popupPeriods(where: $where) {
    ...PopupPeriodFields
  }
}
    ${PopupPeriodFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PopupPeriodsGQL extends Apollo.Query<PopupPeriodsQuery, PopupPeriodsQueryVariables> {
    override document = PopupPeriodsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PopupsDocument = gql`
    query Popups($where: PopupWhereInput) {
  popups(where: $where) {
    ...PopupFields
  }
}
    ${PopupFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PopupsGQL extends Apollo.Query<PopupsQuery, PopupsQueryVariables> {
    override document = PopupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PromotionPeriodsDocument = gql`
    query PromotionPeriods($where: PromotionPeriodWhereInput, $orderBy: [PromotionPeriodOrderByWithRelationInput!], $cursor: PromotionPeriodWhereUniqueInput, $take: Int, $skip: Int, $distinct: [PromotionPeriodScalarFieldEnum!]) {
  promotionPeriods(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...PromotionPeriodFields
  }
}
    ${PromotionPeriodFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PromotionPeriodsGQL extends Apollo.Query<PromotionPeriodsQuery, PromotionPeriodsQueryVariables> {
    override document = PromotionPeriodsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PromotionsDocument = gql`
    query Promotions($where: PromotionWhereInput, $orderBy: [PromotionOrderByWithRelationInput!], $cursor: PromotionWhereUniqueInput, $take: Int, $skip: Int, $distinct: [PromotionScalarFieldEnum!]) {
  promotions(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...PromotionFields
  }
}
    ${PromotionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PromotionsGQL extends Apollo.Query<PromotionsQuery, PromotionsQueryVariables> {
    override document = PromotionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PushNotificationHistoriesDocument = gql`
    query PushNotificationHistories($where: PushNotificationHistoryWhereInput, $orderBy: [PushNotificationHistoryOrderByWithRelationInput!], $cursor: PushNotificationHistoryWhereUniqueInput, $take: Int, $skip: Int, $distinct: [PushNotificationHistoryScalarFieldEnum!]) {
  pushNotificationHistories(
    where: $where
    cursor: $cursor
    distinct: $distinct
    orderBy: $orderBy
    skip: $skip
    take: $take
  ) {
    ...PushNotificationHistoryFields
  }
}
    ${PushNotificationHistoryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PushNotificationHistoriesGQL extends Apollo.Query<PushNotificationHistoriesQuery, PushNotificationHistoriesQueryVariables> {
    override document = PushNotificationHistoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PushNotificationsDocument = gql`
    query PushNotifications($where: PushNotificationWhereInput, $orderBy: [PushNotificationOrderByWithRelationInput!], $cursor: PushNotificationWhereUniqueInput, $take: Int, $skip: Int, $distinct: [PushNotificationScalarFieldEnum!]) {
  pushNotifications(
    where: $where
    cursor: $cursor
    distinct: $distinct
    orderBy: $orderBy
    skip: $skip
    take: $take
  ) {
    ...PushNotificationFields
  }
}
    ${PushNotificationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PushNotificationsGQL extends Apollo.Query<PushNotificationsQuery, PushNotificationsQueryVariables> {
    override document = PushNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RatingQuestionsDocument = gql`
    query RatingQuestions($where: RatingQuestionWhereInput, $orderBy: [RatingQuestionOrderByWithRelationInput!], $cursor: RatingQuestionWhereUniqueInput, $take: Int, $skip: Int, $distinct: [RatingQuestionScalarFieldEnum!], $branchOfficeId: UUID = null) {
  ratingQuestions(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...RatingQuestionFields
  }
}
    ${RatingQuestionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RatingQuestionsGQL extends Apollo.Query<RatingQuestionsQuery, RatingQuestionsQueryVariables> {
    override document = RatingQuestionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReceivedPointTrendDocument = gql`
    query ReceivedPointTrend($startDate: DateTime!, $endDate: DateTime!, $timezone: TimeZone!) {
  receivedPointTrend(
    startDate: $startDate
    endDate: $endDate
    timezone: $timezone
  ) {
    ...TrendMetricFields
  }
}
    ${TrendMetricFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReceivedPointTrendGQL extends Apollo.Query<ReceivedPointTrendQuery, ReceivedPointTrendQueryVariables> {
    override document = ReceivedPointTrendDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReceivedPointsDocument = gql`
    query ReceivedPoints($where: ReceivedPointWhereInput, $orderBy: [ReceivedPointOrderByWithRelationInput!], $cursor: ReceivedPointWhereUniqueInput, $take: Int, $skip: Int, $distinct: [ReceivedPointScalarFieldEnum!]) {
  receivedPoints(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...ReceivedPointFields
  }
}
    ${ReceivedPointFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReceivedPointsGQL extends Apollo.Query<ReceivedPointsQuery, ReceivedPointsQueryVariables> {
    override document = ReceivedPointsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RedeemedPointTrendDocument = gql`
    query RedeemedPointTrend($startDate: DateTime!, $endDate: DateTime!, $timezone: TimeZone!) {
  redeemedPointTrend(
    startDate: $startDate
    endDate: $endDate
    timezone: $timezone
  ) {
    ...TrendMetricFields
  }
}
    ${TrendMetricFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RedeemedPointTrendGQL extends Apollo.Query<RedeemedPointTrendQuery, RedeemedPointTrendQueryVariables> {
    override document = RedeemedPointTrendDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RedeemedPointsDocument = gql`
    query RedeemedPoints($where: RedeemedPointWhereInput, $orderBy: [RedeemedPointOrderByWithRelationInput!], $cursor: RedeemedPointWhereUniqueInput, $take: Int, $skip: Int, $distinct: [RedeemedPointScalarFieldEnum!]) {
  redeemedPoints(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...RedeemedPointFields
  }
}
    ${RedeemedPointFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RedeemedPointsGQL extends Apollo.Query<RedeemedPointsQuery, RedeemedPointsQueryVariables> {
    override document = RedeemedPointsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RewardsChartDocument = gql`
    query RewardsChart($where: RewardWhereInput) {
  rewards(where: $where) {
    ...RewardsChartFields
  }
}
    ${RewardsChartFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RewardsChartGQL extends Apollo.Query<RewardsChartQuery, RewardsChartQueryVariables> {
    override document = RewardsChartDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RewardsDocument = gql`
    query Rewards($where: RewardWhereInput, $orderBy: [RewardOrderByWithRelationInput!], $cursor: RewardWhereUniqueInput, $take: Int, $skip: Int, $distinct: [RewardScalarFieldEnum!]) {
  rewards(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...RewardFields
  }
}
    ${RewardFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RewardsGQL extends Apollo.Query<RewardsQuery, RewardsQueryVariables> {
    override document = RewardsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StatusHistoriesDocument = gql`
    query StatusHistories($where: StatusHistoryWhereInput, $orderBy: [StatusHistoryOrderByWithRelationInput!], $cursor: StatusHistoryWhereUniqueInput, $take: Int, $skip: Int, $distinct: [StatusHistoryScalarFieldEnum!]) {
  statusHistories(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...StatusHistoryFields
  }
}
    ${StatusHistoryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class StatusHistoriesGQL extends Apollo.Query<StatusHistoriesQuery, StatusHistoriesQueryVariables> {
    override document = StatusHistoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ValidateBaseConfigurationDocument = gql`
    query ValidateBaseConfiguration {
  calculationRules {
    ...CalculationRuleFields
  }
  pointSystem {
    ...PointSystemCheckFields
  }
  branchOffices {
    ...BranchOfficeCountFields
  }
}
    ${CalculationRuleFieldsFragmentDoc}
${PointSystemCheckFieldsFragmentDoc}
${BranchOfficeCountFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateBaseConfigurationGQL extends Apollo.Query<ValidateBaseConfigurationQuery, ValidateBaseConfigurationQueryVariables> {
    override document = ValidateBaseConfigurationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }